import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `BigInt` scalar type represents non-fractional whole numeric values.
   * `BigInt` is not constrained to 32-bit like the `Int` type and thus is a less
   * compatible type.
   */
  BigInt: { input: any; output: any; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: string; output: string; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: string; output: string; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: number; output: number; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: string; output: string; }
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: { input: any; output: any; }
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: string; output: string; }
};

export type AcceptApplication = {
  readonly __typename?: 'AcceptApplication';
  readonly application?: Maybe<ApplicationNode>;
};

export type AcceptAsanaPendingTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly pendingId: Scalars['UUID']['input'];
};

export type AcceptAsanaPendingTaskPayload = {
  readonly __typename?: 'AcceptAsanaPendingTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly pending?: Maybe<AsanaPendingTaskNode>;
  readonly task?: Maybe<TaskNode>;
};

export type AcceptBlockGroupSuggestionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptBlockGroupSuggestionPayload = {
  readonly __typename?: 'AcceptBlockGroupSuggestionPayload';
  readonly blockGroupSuggestion?: Maybe<BlockGroupSuggestionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type AcceptBlockSuggestionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Accept a suggestion, creating a block or folding homes into an existing one.
 *
 * Requires both ``create`` and ``edit``. The body only creates a block when
 * no block of the same name already exists in the community; otherwise it
 * calls ``block.homes.add(...)`` on the existing one, which is an edit.
 * Gating on ``create`` alone would let a community-scoped deny override on
 * ``edit`` be bypassed through this mutation.
 */
export type AcceptBlockSuggestionPayload = {
  readonly __typename?: 'AcceptBlockSuggestionPayload';
  readonly blockSuggestion?: Maybe<BlockSuggestionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type AcceptFeatureAnnouncementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly featureAnnouncementId: Scalars['UUID']['input'];
};

export type AcceptFeatureAnnouncementPayload = {
  readonly __typename?: 'AcceptFeatureAnnouncementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly featureAnnouncementView?: Maybe<FeatureAnnouncementViewNode>;
};

export type AcceptMessageSuggestionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionId: Scalars['UUID']['input'];
};

export type AcceptMessageSuggestionPayload = {
  readonly __typename?: 'AcceptMessageSuggestionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type AcceptServiceChargeWaiverInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly serviceChargeWaiverAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AcceptServiceChargeWaiverPayload = {
  readonly __typename?: 'AcceptServiceChargeWaiverPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly leaseholder?: Maybe<LeaseholderNode>;
};

export type AcceptTermsAndConditionsInput = {
  readonly acceptedAt: Scalars['DateTime']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptTermsAndConditionsPayload = {
  readonly __typename?: 'AcceptTermsAndConditionsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type AcceptWaiverInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly type: Scalars['String']['input'];
};

export type AcceptWaiverPayload = {
  readonly __typename?: 'AcceptWaiverPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly waiver?: Maybe<WaiverNode>;
};

export type AccountTransactionNode = {
  readonly __typename?: 'AccountTransactionNode';
  readonly account?: Maybe<PaymentAccountNode>;
  readonly amount: Scalars['BigInt']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly status: PaymentsPaymentStatusChoices;
};

export type AccountTransactionNodeConnection = {
  readonly __typename?: 'AccountTransactionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AccountTransactionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AccountTransactionNode` and its cursor. */
export type AccountTransactionNodeEdge = {
  readonly __typename?: 'AccountTransactionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AccountTransactionNode>;
};

export type ActionObject = AmenityReservationNode | ApplicationNode | CommunityEventNode | CommunityProductPurchaseNode | CommunityUpdateCommentNode | CommunityUpdateLikeType | GroupChatMessageNode | KeyholderNode | MarketplaceItemCommentNode | MarketplaceItemNode | MarketplaceItemThreadMessageNode | SafetyReviewAttemptNode;

export type ActionSourceRegionNode = {
  readonly __typename?: 'ActionSourceRegionNode';
  readonly region: SourceRegionNode;
  readonly role: Scalars['String']['output'];
};

export type ActivateGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateGroupPayload = {
  readonly __typename?: 'ActivateGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityGroup?: Maybe<CommunityGroupNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ActivateSafetyComplianceV2 = {
  readonly __typename?: 'ActivateSafetyComplianceV2';
  readonly community?: Maybe<CommunityNode>;
  readonly readiness: SafetyComplianceReadinessType;
};

export type ActivateSafetyResponderToken = {
  readonly __typename?: 'ActivateSafetyResponderToken';
  readonly pack?: Maybe<SafetyResponderPackNode>;
};

export type Actor = ApplicantNode | CommunityNode | ConciergeNode | HomeNode | ResidentNode | TenancyApplicantNode | UserType;

export type AddApplicationCommunity = {
  readonly __typename?: 'AddApplicationCommunity';
  readonly application?: Maybe<ApplicationNode>;
};

export type AddApplicationHome = {
  readonly __typename?: 'AddApplicationHome';
  readonly application?: Maybe<ApplicationNode>;
};

export type AddApplicationOwnershipType = {
  readonly __typename?: 'AddApplicationOwnershipType';
  readonly application?: Maybe<ApplicationNode>;
};

export type AddContractorToClientContractorCompanyInput = {
  readonly clientContractorCompanyId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type AddContractorToClientContractorCompanyPayload = {
  readonly __typename?: 'AddContractorToClientContractorCompanyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type AddDocumentSentStatus = {
  readonly __typename?: 'AddDocumentSentStatus';
  readonly application?: Maybe<ApplicationNode>;
};

export type AddFeatureToClientInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly featureNames: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type AddFeatureToClientPayload = {
  readonly __typename?: 'AddFeatureToClientPayload';
  readonly client?: Maybe<ClientType>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AddMemberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly role: Scalars['String']['input'];
};

export type AddMemberPayload = {
  readonly __typename?: 'AddMemberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientUser?: Maybe<ClientUserNode>;
  readonly communities?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly createdUserId?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly role?: Maybe<Scalars['String']['output']>;
};

export type AddMessageToThreadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly message: Scalars['String']['input'];
  readonly thread: Scalars['String']['input'];
};

export type AddMessageToThreadPayload = {
  readonly __typename?: 'AddMessageToThreadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly thread?: Maybe<Scalars['String']['output']>;
};

export type AddPackageToHomeInput = {
  readonly addressee?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly home: Scalars['UUID']['input'];
  readonly manualHomeSearchQuery?: InputMaybe<Scalars['String']['input']>;
  readonly scanOutput?: InputMaybe<Scalars['String']['input']>;
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AddPackageToHomePayload = {
  readonly __typename?: 'AddPackageToHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly package?: Maybe<PackageNode>;
};

export type AddTaskCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly objectId?: InputMaybe<Scalars['String']['input']>;
  readonly task: Scalars['String']['input'];
};

export type AddTaskCommentPayload = {
  readonly __typename?: 'AddTaskCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskUpdate?: Maybe<TaskUpdateNode>;
};

export type AddTeamMembersInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
  readonly users: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
};

export type AddTeamMembersPayload = {
  readonly __typename?: 'AddTeamMembersPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type AddUnknownCommunityStatus = {
  readonly __typename?: 'AddUnknownCommunityStatus';
  readonly application?: Maybe<ApplicationNode>;
};

export type AgreeEes = {
  readonly __typename?: 'AgreeEes';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type AgreementSignatureNode = {
  readonly __typename?: 'AgreementSignatureNode';
  readonly agreement: GeneratedAgreementNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly signatureType: AstGeneratorAgreementSignatureSignatureTypeChoices;
  readonly signedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly status: AstGeneratorAgreementSignatureStatusChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type AgreementSignatureNodeConnection = {
  readonly __typename?: 'AgreementSignatureNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AgreementSignatureNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AgreementSignatureNode` and its cursor. */
export type AgreementSignatureNodeEdge = {
  readonly __typename?: 'AgreementSignatureNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AgreementSignatureNode>;
};

export type AgreementSignatureOutput = {
  readonly __typename?: 'AgreementSignatureOutput';
  readonly email: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
};

export type AgreementSignaturesTenant = {
  readonly email: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
};

export type AgreementTenantNode = {
  readonly __typename?: 'AgreementTenantNode';
  readonly agreement: GeneratedAgreementNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly mobile: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type AgreementTenantNodeConnection = {
  readonly __typename?: 'AgreementTenantNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AgreementTenantNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AgreementTenantNode` and its cursor. */
export type AgreementTenantNodeEdge = {
  readonly __typename?: 'AgreementTenantNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AgreementTenantNode>;
};

export type AicoDailyAverageReadingNode = {
  readonly __typename?: 'AicoDailyAverageReadingNode';
  readonly averageCarbonDioxide?: Maybe<Scalars['Float']['output']>;
  readonly averageHumidity?: Maybe<Scalars['Float']['output']>;
  readonly averageTemperature?: Maybe<Scalars['Float']['output']>;
  readonly date: Scalars['Date']['output'];
  readonly maxCarbonDioxide?: Maybe<Scalars['Float']['output']>;
  readonly maxHumidity?: Maybe<Scalars['Float']['output']>;
  readonly maxTemperature?: Maybe<Scalars['Float']['output']>;
  readonly minCarbonDioxide?: Maybe<Scalars['Float']['output']>;
  readonly minHumidity?: Maybe<Scalars['Float']['output']>;
  readonly minTemperature?: Maybe<Scalars['Float']['output']>;
};

export type AicoEnvironmentAdviceContentNode = {
  readonly __typename?: 'AicoEnvironmentAdviceContentNode';
  readonly advice?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly moreInfo?: Maybe<Scalars['String']['output']>;
  readonly reasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type AicoEnvironmentAdviceNode = {
  readonly __typename?: 'AicoEnvironmentAdviceNode';
  readonly highCarbonDioxide?: Maybe<AicoEnvironmentAdviceContentNode>;
  readonly highHumidity?: Maybe<AicoEnvironmentAdviceContentNode>;
  readonly highTemperature?: Maybe<AicoEnvironmentAdviceContentNode>;
  readonly lowHumidity?: Maybe<AicoEnvironmentAdviceContentNode>;
  readonly lowTemperature?: Maybe<AicoEnvironmentAdviceContentNode>;
};

export type AicoEnvironmentThresholdsNode = {
  readonly __typename?: 'AicoEnvironmentThresholdsNode';
  readonly maxCarbonDioxide?: Maybe<Scalars['Float']['output']>;
  readonly maxHumidity?: Maybe<Scalars['Float']['output']>;
  readonly maxTemperature?: Maybe<Scalars['Float']['output']>;
  readonly minHumidity?: Maybe<Scalars['Float']['output']>;
  readonly minTemperature?: Maybe<Scalars['Float']['output']>;
};

export type AicoLatestAverageReadingNode = {
  readonly __typename?: 'AicoLatestAverageReadingNode';
  readonly averageCarbonDioxide?: Maybe<Scalars['Float']['output']>;
  readonly averageHumidity?: Maybe<Scalars['Float']['output']>;
  readonly averageTemperature?: Maybe<Scalars['Float']['output']>;
  readonly carbonDioxideRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly humidityRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly temperatureRecordedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AmenityNode = {
  readonly __typename?: 'AmenityNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly communities?: Maybe<ReadonlyArray<Maybe<CommunityNode>>>;
  readonly community?: Maybe<CommunityNode>;
  readonly daysAvailable: ReadonlyArray<Scalars['String']['output']>;
  readonly description: Scalars['String']['output'];
  readonly endTime: Scalars['DateTime']['output'];
  readonly exclusive: Scalars['Boolean']['output'];
  readonly groups: CommunityGroupNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly isCurrentlyReservable: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  /** Meeting or external links for this amenity (e.g. Google Meet, Teams, Zoom). */
  readonly links?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly live: Scalars['Boolean']['output'];
  readonly maxAdvanceReservationDays: Scalars['Int']['output'];
  readonly maxCapacity?: Maybe<Scalars['Int']['output']>;
  readonly maxHours?: Maybe<Scalars['Int']['output']>;
  /** The maximum reservation duration in seconds */
  readonly maxReservationDuration?: Maybe<Scalars['Int']['output']>;
  readonly maxReservations?: Maybe<Scalars['Int']['output']>;
  /** The maximum time in seconds */
  readonly maxTime?: Maybe<Scalars['Int']['output']>;
  /** Minimum time in seconds before the start time that a user must book this amenity. */
  readonly minBookingNotice?: Maybe<Scalars['Int']['output']>;
  /** The minimum reservation duration in seconds */
  readonly minReservationDuration?: Maybe<Scalars['Int']['output']>;
  /** The minimum time in seconds */
  readonly minTime?: Maybe<Scalars['Int']['output']>;
  readonly name: Scalars['String']['output'];
  readonly operatingTimes: AmenityOperatingTimesNodeConnection;
  readonly reservable: Scalars['Boolean']['output'];
  readonly reservations: AmenityReservationNodeConnection;
  readonly startDate?: Maybe<Scalars['DateTime']['output']>;
  readonly startTime: Scalars['DateTime']['output'];
  readonly status: AmenityStatusEnum;
  readonly todaysBookingCount: Scalars['Int']['output'];
  readonly type?: Maybe<ResidentialManagementAmenityTypeChoices>;
  readonly unpaginatedReservations?: Maybe<AmenityReservationNodeConnection>;
};


export type AmenityNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type AmenityNodeOperatingTimesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AmenityNodeReservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amenity?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type AmenityNodeUnpaginatedReservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amenity?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};

export type AmenityNodeConnection = {
  readonly __typename?: 'AmenityNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AmenityNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AmenityNode` and its cursor. */
export type AmenityNodeEdge = {
  readonly __typename?: 'AmenityNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AmenityNode>;
};

export type AmenityOperatingTimesNode = {
  readonly __typename?: 'AmenityOperatingTimesNode';
  readonly amenity: AmenityNode;
  readonly endTime?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActivated: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly startTime?: Maybe<Scalars['DateTime']['output']>;
  readonly weekDay: Scalars['Int']['output'];
};

export type AmenityOperatingTimesNodeConnection = {
  readonly __typename?: 'AmenityOperatingTimesNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AmenityOperatingTimesNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AmenityOperatingTimesNode` and its cursor. */
export type AmenityOperatingTimesNodeEdge = {
  readonly __typename?: 'AmenityOperatingTimesNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AmenityOperatingTimesNode>;
};

export type AmenityReservationNode = {
  readonly __typename?: 'AmenityReservationNode';
  readonly additionalAttendance: Scalars['Int']['output'];
  readonly amenity?: Maybe<AmenityNode>;
  readonly cancellationMessage?: Maybe<Scalars['String']['output']>;
  readonly end: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isManager: Scalars['Boolean']['output'];
  readonly isMine?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly reason?: Maybe<Scalars['String']['output']>;
  readonly start: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};

export type AmenityReservationNodeConnection = {
  readonly __typename?: 'AmenityReservationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AmenityReservationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AmenityReservationNode` and its cursor. */
export type AmenityReservationNodeEdge = {
  readonly __typename?: 'AmenityReservationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AmenityReservationNode>;
};

/** An enumeration. */
export enum AmenityStatusEnum {
  Available = 'Available',
  Bookable = 'Bookable',
  NotAvailable = 'NotAvailable'
}

export type ApplicantNode = {
  readonly __typename?: 'ApplicantNode';
  readonly applications: ApplicationNodeConnection;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly user: UserType;
};


export type ApplicantNodeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type Applicants = {
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationAttemptNode = {
  readonly __typename?: 'ApplicationAttemptNode';
  readonly application: ApplicationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly proofOfAddress?: Maybe<Scalars['String']['output']>;
  readonly rejectedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly rejectionReason?: Maybe<Scalars['String']['output']>;
  readonly reviewer?: Maybe<ManagerType>;
  readonly reviewerUser?: Maybe<UserType>;
  readonly verificationResult?: Maybe<DocumentVerificationResultNode>;
};

export type ApplicationAttemptNodeConnection = {
  readonly __typename?: 'ApplicationAttemptNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationAttemptNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationAttemptNode` and its cursor. */
export type ApplicationAttemptNodeEdge = {
  readonly __typename?: 'ApplicationAttemptNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationAttemptNode>;
};

export type ApplicationAuditLogNode = {
  readonly __typename?: 'ApplicationAuditLogNode';
  readonly actor?: Maybe<UserType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly eventType: ResidentialManagementApplicationAuditLogEventTypeChoices;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly metadata: Scalars['JSONString']['output'];
};

export type ApplicationAuditLogNodeConnection = {
  readonly __typename?: 'ApplicationAuditLogNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationAuditLogNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationAuditLogNode` and its cursor. */
export type ApplicationAuditLogNodeEdge = {
  readonly __typename?: 'ApplicationAuditLogNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationAuditLogNode>;
};

export type ApplicationDecisionStatsType = {
  readonly __typename?: 'ApplicationDecisionStatsType';
  readonly aiAccuracyRate?: Maybe<Scalars['Float']['output']>;
  readonly approvalCount?: Maybe<Scalars['Int']['output']>;
  readonly approvalRate?: Maybe<Scalars['Float']['output']>;
  readonly averageTimeToDecision?: Maybe<Scalars['Int']['output']>;
  readonly rejectionCount?: Maybe<Scalars['Int']['output']>;
  readonly rejectionRate?: Maybe<Scalars['Float']['output']>;
  readonly reminderCount?: Maybe<Scalars['Int']['output']>;
  readonly reminderRate?: Maybe<Scalars['Float']['output']>;
  readonly totalDecisions?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationHomeSearchNode = {
  readonly __typename?: 'ApplicationHomeSearchNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type ApplicationHomeSearchNodeConnection = {
  readonly __typename?: 'ApplicationHomeSearchNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationHomeSearchNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationHomeSearchNode` and its cursor. */
export type ApplicationHomeSearchNodeEdge = {
  readonly __typename?: 'ApplicationHomeSearchNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationHomeSearchNode>;
};

export type ApplicationNode = {
  readonly __typename?: 'ApplicationNode';
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  readonly applicant: ApplicantNode;
  readonly applicationAttempts: ApplicationAttemptNodeConnection;
  readonly approvedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly auditLogs: ApplicationAuditLogNodeConnection;
  readonly closestCommunities?: Maybe<ReadonlyArray<NewCommunityOption>>;
  readonly community?: Maybe<CommunityNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly findCommunities?: Maybe<CommunityNodeConnection>;
  readonly findHomes?: Maybe<ApplicationHomeSearchNodeConnection>;
  readonly home?: Maybe<HomeNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isResident: Scalars['Boolean']['output'];
  readonly lastRejectionReason?: Maybe<Scalars['String']['output']>;
  readonly ownershipType?: Maybe<ResidentialManagementApplicationOwnershipTypeChoices>;
  readonly postcode: Scalars['String']['output'];
  readonly region?: Maybe<Scalars['String']['output']>;
  readonly source: ResidentialManagementApplicationSourceChoices;
  readonly status: ResidentialManagementApplicationStatusChoices;
  readonly thread?: Maybe<ApplicationThreadNode>;
  readonly townOrCity?: Maybe<Scalars['String']['output']>;
};


export type ApplicationNodeApplicationAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type ApplicationNodeAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type ApplicationNodeFindCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ApplicationNodeFindHomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationNodeConnection = {
  readonly __typename?: 'ApplicationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationNode` and its cursor. */
export type ApplicationNodeEdge = {
  readonly __typename?: 'ApplicationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationNode>;
};

export type ApplicationReportingCountNode = {
  readonly __typename?: 'ApplicationReportingCountNode';
  readonly byDay: ReadonlyArray<ApplicationReportingDayCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationReportingDayCountNode = {
  readonly __typename?: 'ApplicationReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type ApplicationReportingDayDurationNode = {
  readonly __typename?: 'ApplicationReportingDayDurationNode';
  readonly day: Scalars['Date']['output'];
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type ApplicationReportingDurationNode = {
  readonly __typename?: 'ApplicationReportingDurationNode';
  readonly byDay: ReadonlyArray<ApplicationReportingDayDurationNode>;
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type ApplicationReportingFlowLinkNode = {
  readonly __typename?: 'ApplicationReportingFlowLinkNode';
  readonly count: Scalars['Int']['output'];
  readonly source: ApplicationReportingFlowStage;
  readonly target: ApplicationReportingFlowStage;
};

/** An enumeration. */
export enum ApplicationReportingFlowStage {
  Approved = 'APPROVED',
  ProofRequested = 'PROOF_REQUESTED',
  Received = 'RECEIVED',
  Rejected = 'REJECTED',
  Undecided = 'UNDECIDED',
  WithoutProof = 'WITHOUT_PROOF',
  WithProof = 'WITH_PROOF'
}

/** An enumeration. */
export enum ApplicationReportingFunnelStage {
  Approved = 'APPROVED',
  DocumentSent = 'DOCUMENT_SENT',
  Received = 'RECEIVED'
}

export type ApplicationReportingFunnelStageNode = {
  readonly __typename?: 'ApplicationReportingFunnelStageNode';
  readonly count: Scalars['Int']['output'];
  readonly stage: ApplicationReportingFunnelStage;
};

export type ApplicationReportingNode = {
  readonly __typename?: 'ApplicationReportingNode';
  readonly approved: ApplicationReportingCountNode;
  readonly approvedByProof: ReadonlyArray<ApplicationReportingProofCountNode>;
  readonly bySubmissionSource: ReadonlyArray<ApplicationReportingSubmissionSourceCountNode>;
  readonly flow: ReadonlyArray<ApplicationReportingFlowLinkNode>;
  readonly funnel: ReadonlyArray<ApplicationReportingFunnelStageNode>;
  readonly outcomes: ApplicationReportingOutcomesNode;
  readonly pending: ApplicationReportingPendingNode;
  readonly pendingByWait: ReadonlyArray<ApplicationReportingWaitBucketNode>;
  readonly received: ApplicationReportingCountNode;
  readonly receivedWithMultipleAttempts: Scalars['Int']['output'];
  readonly rejectionReasons: ReadonlyArray<ApplicationReportingRejectionReasonCountNode>;
  readonly resubmissions: ApplicationReportingResubmissionsNode;
  readonly timeToApproval: ApplicationReportingDurationNode;
};

export type ApplicationReportingOutcomesNode = {
  readonly __typename?: 'ApplicationReportingOutcomesNode';
  readonly approvalRate?: Maybe<Scalars['Float']['output']>;
  readonly byStatus: ReadonlyArray<ApplicationReportingStatusCountNode>;
  readonly decidedCount: Scalars['Int']['output'];
};

export type ApplicationReportingPendingNode = {
  readonly __typename?: 'ApplicationReportingPendingNode';
  readonly atEnd?: Maybe<ApplicationReportingDayCountNode>;
  readonly byDay: ReadonlyArray<ApplicationReportingDayCountNode>;
};

export type ApplicationReportingProofCountNode = {
  readonly __typename?: 'ApplicationReportingProofCountNode';
  readonly count: Scalars['Int']['output'];
  readonly hasProofOfAddress?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicationReportingRejectionReasonCountNode = {
  readonly __typename?: 'ApplicationReportingRejectionReasonCountNode';
  readonly count: Scalars['Int']['output'];
  readonly reason?: Maybe<Scalars['String']['output']>;
};

export type ApplicationReportingResubmissionsNode = {
  readonly __typename?: 'ApplicationReportingResubmissionsNode';
  readonly approvedCount: Scalars['Int']['output'];
  readonly attemptsPerApproval?: Maybe<Scalars['Float']['output']>;
  readonly medianAttemptsPerApproval?: Maybe<Scalars['Float']['output']>;
  readonly resubmittedCount: Scalars['Int']['output'];
};

/** An enumeration. */
export enum ApplicationReportingStatus {
  Approved = 'APPROVED',
  CommunityKnown = 'COMMUNITY_KNOWN',
  DocumentSent = 'DOCUMENT_SENT',
  MultipleCommunities = 'MULTIPLE_COMMUNITIES',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  UnknownCommunity = 'UNKNOWN_COMMUNITY'
}

export type ApplicationReportingStatusCountNode = {
  readonly __typename?: 'ApplicationReportingStatusCountNode';
  readonly count: Scalars['Int']['output'];
  readonly status: ApplicationReportingStatus;
};

/** An enumeration. */
export enum ApplicationReportingSubmissionSource {
  Applicant = 'APPLICANT',
  Concierge = 'CONCIERGE'
}

export type ApplicationReportingSubmissionSourceCountNode = {
  readonly __typename?: 'ApplicationReportingSubmissionSourceCountNode';
  readonly count: Scalars['Int']['output'];
  readonly submissionSource?: Maybe<ApplicationReportingSubmissionSource>;
};

export type ApplicationReportingWaitBucketNode = {
  readonly __typename?: 'ApplicationReportingWaitBucketNode';
  readonly count: Scalars['Int']['output'];
  readonly maxDays?: Maybe<Scalars['Int']['output']>;
  readonly minDays: Scalars['Int']['output'];
};

export type ApplicationSupportMessageNode = {
  readonly __typename?: 'ApplicationSupportMessageNode';
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly sender: ResidentialManagementApplicationSupportMessageSenderChoices;
  readonly senderDisplay?: Maybe<Scalars['String']['output']>;
};

export type ApplicationSupportMessageNodeConnection = {
  readonly __typename?: 'ApplicationSupportMessageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationSupportMessageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationSupportMessageNode` and its cursor. */
export type ApplicationSupportMessageNodeEdge = {
  readonly __typename?: 'ApplicationSupportMessageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationSupportMessageNode>;
};

export type ApplicationSupportThreadNode = {
  readonly __typename?: 'ApplicationSupportThreadNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastMessage?: Maybe<ApplicationSupportMessageNode>;
  readonly messages: ApplicationSupportMessageNodeConnection;
};


export type ApplicationSupportThreadNodeMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ApplicationThreadMediaNode = {
  readonly __typename?: 'ApplicationThreadMediaNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly readAt?: Maybe<Scalars['DateTime']['output']>;
  readonly sender: ResidentialManagementApplicationThreadMediaSenderChoices;
  readonly senderDisplay?: Maybe<Scalars['String']['output']>;
  readonly user: UserType;
};

export type ApplicationThreadMediaNodeConnection = {
  readonly __typename?: 'ApplicationThreadMediaNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationThreadMediaNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationThreadMediaNode` and its cursor. */
export type ApplicationThreadMediaNodeEdge = {
  readonly __typename?: 'ApplicationThreadMediaNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationThreadMediaNode>;
};

export type ApplicationThreadMessageNode = {
  readonly __typename?: 'ApplicationThreadMessageNode';
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly readAt?: Maybe<Scalars['DateTime']['output']>;
  readonly sender: ResidentialManagementApplicationThreadMessageSenderChoices;
  readonly senderDisplay?: Maybe<Scalars['String']['output']>;
  readonly user: UserType;
};

export type ApplicationThreadMessageNodeConnection = {
  readonly __typename?: 'ApplicationThreadMessageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationThreadMessageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationThreadMessageNode` and its cursor. */
export type ApplicationThreadMessageNodeEdge = {
  readonly __typename?: 'ApplicationThreadMessageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationThreadMessageNode>;
};

export type ApplicationThreadNode = {
  readonly __typename?: 'ApplicationThreadNode';
  readonly application: ApplicationNode;
  readonly applicationId?: Maybe<Scalars['UUID']['output']>;
  readonly closedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastMessage?: Maybe<ApplicationThreadMessageNode>;
  readonly media: ApplicationThreadMediaNodeConnection;
  readonly messages: ApplicationThreadMessageNodeConnection;
  readonly migratedConversation?: Maybe<ConversationNode>;
  readonly unreadCount?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type ApplicationThreadNodeMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ApplicationThreadNodeMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ArchiveAllNotificationsOnTargetInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

export type ArchiveAllNotificationsOnTargetPayload = {
  readonly __typename?: 'ArchiveAllNotificationsOnTargetPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly notifications: NotificationNodeConnection;
};


export type ArchiveAllNotificationsOnTargetPayloadNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveApplicationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveApplicationPayload = {
  readonly __typename?: 'ArchiveApplicationPayload';
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ArchiveCommunityEventInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveCommunityEventPayload = {
  readonly __typename?: 'ArchiveCommunityEventPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityEvent?: Maybe<CommunityEventNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ArchiveContactNoteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveContactNotePayload = {
  readonly __typename?: 'ArchiveContactNotePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contactNote?: Maybe<ContactNoteNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ArchiveKeyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveKeyPayload = {
  readonly __typename?: 'ArchiveKeyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type ArchiveKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveKeyholderPayload = {
  readonly __typename?: 'ArchiveKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type ArchiveMarketplaceItemInput = {
  readonly archivedReason?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveMarketplaceItemPayload = {
  readonly __typename?: 'ArchiveMarketplaceItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly marketplaceItem?: Maybe<MarketplaceItemNode>;
};

export type ArchiveNotificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveNotificationPayload = {
  readonly __typename?: 'ArchiveNotificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly notification?: Maybe<NotificationNode>;
};

export type ArchiveSafetyCenterDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveSafetyCenterDocumentPayload = {
  readonly __typename?: 'ArchiveSafetyCenterDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
};

export type ArchiveSafetySubjectInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveSafetySubjectPayload = {
  readonly __typename?: 'ArchiveSafetySubjectPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type ArchiveTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveTagPayload = {
  readonly __typename?: 'ArchiveTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly tag?: Maybe<TagNode>;
};

export type ArchiveTaskGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveTaskGroupPayload = {
  readonly __typename?: 'ArchiveTaskGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskGroup?: Maybe<TaskGroupNode>;
};

export type ArchiveTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveTaskPayload = {
  readonly __typename?: 'ArchiveTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type ArchiveTaskTemplateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type ArchiveTaskTemplatePayload = {
  readonly __typename?: 'ArchiveTaskTemplatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
};

export type ArchivedContactNode = {
  readonly __typename?: 'ArchivedContactNode';
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly removalDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ArchivedContactNodeConnection = {
  readonly __typename?: 'ArchivedContactNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ArchivedContactNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ArchivedContactNode` and its cursor. */
export type ArchivedContactNodeEdge = {
  readonly __typename?: 'ArchivedContactNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ArchivedContactNode>;
};

export type AsanaPendingTaskNode = {
  readonly __typename?: 'AsanaPendingTaskNode';
  readonly acceptedTask?: Maybe<TaskNode>;
  readonly asanaCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly asanaCreatedByGid?: Maybe<Scalars['String']['output']>;
  readonly asanaCreatedByUser?: Maybe<UserType>;
  readonly asanaId: Scalars['String']['output'];
  readonly asanaUrl: Scalars['String']['output'];
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes: Scalars['String']['output'];
  readonly resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly resolvedBy?: Maybe<UserType>;
  readonly status: TasksAsanaPendingTaskStatusChoices;
};

export type AsanaPendingTaskNodeConnection = {
  readonly __typename?: 'AsanaPendingTaskNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AsanaPendingTaskNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AsanaPendingTaskNode` and its cursor. */
export type AsanaPendingTaskNodeEdge = {
  readonly __typename?: 'AsanaPendingTaskNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AsanaPendingTaskNode>;
};

export type AsanaTaskSearchResultType = {
  readonly __typename?: 'AsanaTaskSearchResultType';
  readonly gid?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly permalinkUrl?: Maybe<Scalars['String']['output']>;
};

export type AssignChecklistItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly itemId: Scalars['UUID']['input'];
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AssignChecklistItemPayload = {
  readonly __typename?: 'AssignChecklistItemPayload';
  readonly checklistItem?: Maybe<TaskChecklistItemNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AssignChecklistSectionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly sectionId: Scalars['UUID']['input'];
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AssignChecklistSectionPayload = {
  readonly __typename?: 'AssignChecklistSectionPayload';
  readonly checklistSection?: Maybe<TaskChecklistSectionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AssignClientTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type AssignClientTagPayload = {
  readonly __typename?: 'AssignClientTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
};

export type AssignClientTagToCommunityDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documentId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type AssignClientTagToCommunityDocumentPayload = {
  readonly __typename?: 'AssignClientTagToCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
};

export type AssignClientTagToTaskDefinitionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly tagId: Scalars['UUID']['input'];
  readonly taskDefinitionId: Scalars['UUID']['input'];
};

export type AssignClientTagToTaskDefinitionPayload = {
  readonly __typename?: 'AssignClientTagToTaskDefinitionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type AssignClientTagToUserDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documentId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type AssignClientTagToUserDocumentPayload = {
  readonly __typename?: 'AssignClientTagToUserDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
};

export type AssignCommunityStaffRoleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityId: Scalars['UUID']['input'];
  readonly roleSlug: Scalars['String']['input'];
  readonly userId: Scalars['UUID']['input'];
};

export type AssignCommunityStaffRolePayload = {
  readonly __typename?: 'AssignCommunityStaffRolePayload';
  readonly assignment: CommunityStaffRoleType;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AssignContractorToTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contractorCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  readonly contractorUserIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  readonly taskId: Scalars['UUID']['input'];
};

export type AssignContractorToTaskPayload = {
  readonly __typename?: 'AssignContractorToTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
};

export type AssignTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly taskId: Scalars['UUID']['input'];
  readonly teamId?: InputMaybe<Scalars['UUID']['input']>;
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AssignTaskPayload = {
  readonly __typename?: 'AssignTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
};

export type AssignTeamInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly teamId: Scalars['UUID']['input'];
};

export type AssignTeamPayload = {
  readonly __typename?: 'AssignTeamPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  readonly teamAssignment?: Maybe<TeamAssignmentNode>;
};

export type AssociateAgreementWithClient = {
  readonly __typename?: 'AssociateAgreementWithClient';
  readonly agreement?: Maybe<GeneratedAgreementType>;
  readonly homeId?: Maybe<Scalars['String']['output']>;
};

export type AssociateAgreementWithClientInput = {
  readonly id: Scalars['String']['input'];
};

export type AssociateSection21WithClient = {
  readonly __typename?: 'AssociateSection21WithClient';
  readonly homeId?: Maybe<Scalars['String']['output']>;
  readonly section21?: Maybe<GeneratedSection21Type>;
};

export type AssociateSection21WithClientInput = {
  readonly id: Scalars['String']['input'];
};

/** An enumeration. */
export enum AstGeneratorAgreementSignatureSignatureTypeChoices {
  /** Landlord */
  La = 'LA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum AstGeneratorAgreementSignatureStatusChoices {
  /** Signed */
  Si = 'SI',
  /** Void */
  Vo = 'VO',
  /** Waiting */
  Wa = 'WA'
}

/** An enumeration. */
export enum AstGeneratorGeneratedAgreementFurnishedChoices {
  /** Fully furnished */
  Ff = 'FF',
  /** Partially furnished */
  Pf = 'PF',
  /** Unfurnished */
  Uf = 'UF'
}

/** An enumeration. */
export enum AstGeneratorGeneratedAgreementPaymentFrequencyChoices {
  /** Monthly */
  Mo = 'MO',
  /** Weekly */
  We = 'WE'
}

/** An enumeration. */
export enum AstGeneratorGeneratedAgreementStatusChoices {
  /** Fully signed */
  Fs = 'FS',
  /** Generated */
  Ge = 'GE',
  /** Pending */
  Pe = 'PE',
  /** Sent for signing */
  Ss = 'SS',
  /** Tenants signed */
  Ts = 'TS'
}

export type AverageConversationRatingType = {
  readonly __typename?: 'AverageConversationRatingType';
  readonly averageRating?: Maybe<Scalars['Float']['output']>;
  readonly date?: Maybe<Scalars['Date']['output']>;
};

export type BacsPaymentType = {
  readonly __typename?: 'BACSPaymentType';
  readonly last4: Scalars['String']['output'];
  readonly sortCode: Scalars['String']['output'];
};

export type BatchCreateTaskDocumentsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documents: ReadonlyArray<TaskDocumentItemInput>;
  readonly task: Scalars['UUID']['input'];
};

export type BatchCreateTaskDocumentsPayload = {
  readonly __typename?: 'BatchCreateTaskDocumentsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly taskDocuments?: Maybe<ReadonlyArray<Maybe<TaskDocumentNode>>>;
};

export type BlockComplianceRequirementItemAttachmentNode = {
  readonly __typename?: 'BlockComplianceRequirementItemAttachmentNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type BlockComplianceRequirementItemAttachmentNodeConnection = {
  readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockComplianceRequirementItemAttachmentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockComplianceRequirementItemAttachmentNode` and its cursor. */
export type BlockComplianceRequirementItemAttachmentNodeEdge = {
  readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockComplianceRequirementItemAttachmentNode>;
};

export type BlockComplianceRequirementItemNode = {
  readonly __typename?: 'BlockComplianceRequirementItemNode';
  readonly attachments: BlockComplianceRequirementItemAttachmentNodeConnection;
  readonly blockComplianceRequirements: BlockComplianceRequirementNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly expiryDate: Scalars['Date']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};


export type BlockComplianceRequirementItemNodeAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BlockComplianceRequirementItemNodeBlockComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockComplianceRequirementItemNodeConnection = {
  readonly __typename?: 'BlockComplianceRequirementItemNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockComplianceRequirementItemNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockComplianceRequirementItemNode` and its cursor. */
export type BlockComplianceRequirementItemNodeEdge = {
  readonly __typename?: 'BlockComplianceRequirementItemNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockComplianceRequirementItemNode>;
};

export type BlockComplianceRequirementNode = {
  readonly __typename?: 'BlockComplianceRequirementNode';
  readonly actionDate: Scalars['Date']['output'];
  readonly block: BlockNode;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly item?: Maybe<BlockComplianceRequirementItemNode>;
  readonly items: BlockComplianceRequirementItemNodeConnection;
  readonly requirement: BlocksComplianceRequirementNode;
  readonly status: BlockComplianceRequirementStatus;
};


export type BlockComplianceRequirementNodeItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockComplianceRequirementNodeConnection = {
  readonly __typename?: 'BlockComplianceRequirementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockComplianceRequirementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockComplianceRequirementNode` and its cursor. */
export type BlockComplianceRequirementNodeEdge = {
  readonly __typename?: 'BlockComplianceRequirementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockComplianceRequirementNode>;
};

export enum BlockComplianceRequirementStatus {
  Checked = 'CHECKED',
  Expired = 'EXPIRED',
  Expiring = 'EXPIRING',
  Missing = 'MISSING'
}

export type BlockGroupSuggestionMember = {
  readonly __typename?: 'BlockGroupSuggestionMember';
  readonly homeAddress: Scalars['String']['output'];
  readonly userName: Scalars['String']['output'];
};

export type BlockGroupSuggestionNode = {
  readonly __typename?: 'BlockGroupSuggestionNode';
  readonly block?: Maybe<BlockNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly group?: Maybe<CommunityGroupNode>;
  readonly homes: ReadonlyArray<HomeType>;
  readonly homesCount?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly members?: Maybe<ReadonlyArray<Maybe<BlockGroupSuggestionMember>>>;
  readonly status: ResidentialManagementBlockGroupSuggestionStatusChoices;
  readonly type: ResidentialManagementBlockGroupSuggestionTypeChoices;
  readonly users: ReadonlyArray<UserType>;
};

export type BlockGroupSuggestionNodeConnection = {
  readonly __typename?: 'BlockGroupSuggestionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockGroupSuggestionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockGroupSuggestionNode` and its cursor. */
export type BlockGroupSuggestionNodeEdge = {
  readonly __typename?: 'BlockGroupSuggestionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockGroupSuggestionNode>;
};

export type BlockNode = {
  readonly __typename?: 'BlockNode';
  readonly blockComplianceRequirements: BlockComplianceRequirementNodeConnection;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly dutyHolderLabel: Scalars['String']['output'];
  readonly hasBlockSuggestions?: Maybe<Scalars['Boolean']['output']>;
  readonly homes?: Maybe<HomeNodeConnection>;
  readonly homesCount?: Maybe<Scalars['Int']['output']>;
  readonly hrbReference?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly latestBlockGroupSuggestion?: Maybe<BlockGroupSuggestionNode>;
  readonly latestBlockSuggestionIsAccepted?: Maybe<Scalars['Boolean']['output']>;
  readonly latestEveryoneBlockGroupSuggestion?: Maybe<BlockGroupSuggestionNode>;
  readonly latestLeaseholderBlockGroupSuggestion?: Maybe<BlockGroupSuggestionNode>;
  readonly latestPendingOrAlteredSuggestion?: Maybe<BlockSuggestionNode>;
  readonly latestResidentBlockGroupSuggestion?: Maybe<BlockGroupSuggestionNode>;
  readonly latestSuggestionStatusIsPendingOrAltered?: Maybe<Scalars['Boolean']['output']>;
  readonly name: Scalars['String']['output'];
  readonly responsiblePersonName: Scalars['String']['output'];
  readonly responsiblePersonRole: Scalars['String']['output'];
  readonly safetyResponderPack?: Maybe<SafetyResponderPackNode>;
  readonly shortCode?: Maybe<Scalars['String']['output']>;
  readonly totalFloors?: Maybe<Scalars['Int']['output']>;
};


export type BlockNodeBlockComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type BlockNodeHomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBlock?: InputMaybe<Scalars['Boolean']['input']>;
  hasUncollected?: InputMaybe<Scalars['Boolean']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
  includeDemoHomes?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  missingFloor?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  packagesStatus?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  trigramSearch?: InputMaybe<Scalars['String']['input']>;
};

export type BlockNodeConnection = {
  readonly __typename?: 'BlockNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockNode` and its cursor. */
export type BlockNodeEdge = {
  readonly __typename?: 'BlockNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockNode>;
};

export type BlockSuggestionNode = {
  readonly __typename?: 'BlockSuggestionNode';
  readonly block?: Maybe<BlockNode>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly homeCount?: Maybe<Scalars['Int']['output']>;
  readonly homes?: Maybe<HomeNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly status: ResidentialManagementBlockSuggestionStatusChoices;
};


export type BlockSuggestionNodeHomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBlock?: InputMaybe<Scalars['Boolean']['input']>;
  hasUncollected?: InputMaybe<Scalars['Boolean']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
  includeDemoHomes?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  missingFloor?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  packagesStatus?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  trigramSearch?: InputMaybe<Scalars['String']['input']>;
};

export type BlockSuggestionNodeConnection = {
  readonly __typename?: 'BlockSuggestionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockSuggestionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockSuggestionNode` and its cursor. */
export type BlockSuggestionNodeEdge = {
  readonly __typename?: 'BlockSuggestionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockSuggestionNode>;
};

export type BlocksComplianceRequirementNode = {
  readonly __typename?: 'BlocksComplianceRequirementNode';
  readonly blockComplianceRequirements: BlockComplianceRequirementNodeConnection;
  readonly blocks: BlockNodeConnection;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly shared: Scalars['Boolean']['output'];
};


export type BlocksComplianceRequirementNodeBlockComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type BlocksComplianceRequirementNodeBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type BookCommunityEventMutationInput = {
  readonly additionalAttendance?: InputMaybe<Scalars['Int']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly eventId: Scalars['UUID']['input'];
};

export type BookCommunityEventMutationPayload = {
  readonly __typename?: 'BookCommunityEventMutationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly event?: Maybe<CommunityEventNode>;
};

export type BookPaidCommunityEventMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly eventId: Scalars['UUID']['input'];
};

export type BookPaidCommunityEventMutationPayload = {
  readonly __typename?: 'BookPaidCommunityEventMutationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly event?: Maybe<CommunityEventNode>;
  readonly payment: PaymentNode;
  readonly stripeClientSecret: Scalars['String']['output'];
};

export type BookingReportingBookedByNode = {
  readonly __typename?: 'BookingReportingBookedByNode';
  readonly bookedByStaff: Scalars['Boolean']['output'];
  readonly count: Scalars['Int']['output'];
};

export type BookingReportingBookersNode = {
  readonly __typename?: 'BookingReportingBookersNode';
  readonly bookingsPerBooker?: Maybe<Scalars['Float']['output']>;
  readonly frequency: ReadonlyArray<BookingReportingFrequencyNode>;
  readonly uniqueBookers: Scalars['Int']['output'];
};

export type BookingReportingCancellationNode = {
  readonly __typename?: 'BookingReportingCancellationNode';
  readonly byDay: ReadonlyArray<BookingReportingDayCountNode>;
  readonly rate?: Maybe<Scalars['Float']['output']>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type BookingReportingCapacityNode = {
  readonly __typename?: 'BookingReportingCapacityNode';
  readonly amenityId: Scalars['UUID']['output'];
  readonly capacityHours?: Maybe<Scalars['Float']['output']>;
  readonly label: Scalars['String']['output'];
  readonly share?: Maybe<Scalars['Float']['output']>;
  readonly usedHours: Scalars['Float']['output'];
};

export type BookingReportingCountNode = {
  readonly __typename?: 'BookingReportingCountNode';
  readonly byDay: ReadonlyArray<BookingReportingDayCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type BookingReportingDayCountNode = {
  readonly __typename?: 'BookingReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type BookingReportingFacilityNode = {
  readonly __typename?: 'BookingReportingFacilityNode';
  readonly amenityId?: Maybe<Scalars['UUID']['output']>;
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
};

export type BookingReportingFrequencyNode = {
  readonly __typename?: 'BookingReportingFrequencyNode';
  readonly bookers: Scalars['Int']['output'];
  readonly maxBookings?: Maybe<Scalars['Int']['output']>;
  readonly minBookings: Scalars['Int']['output'];
};

export type BookingReportingHourCountNode = {
  readonly __typename?: 'BookingReportingHourCountNode';
  readonly count: Scalars['Int']['output'];
  readonly hour: Scalars['Int']['output'];
  readonly weekday: Scalars['Int']['output'];
};

export type BookingReportingLeadTimeNode = {
  readonly __typename?: 'BookingReportingLeadTimeNode';
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type BookingReportingNode = {
  readonly __typename?: 'BookingReportingNode';
  readonly bookedBy: ReadonlyArray<BookingReportingBookedByNode>;
  readonly bookers: BookingReportingBookersNode;
  readonly bookings: BookingReportingCountNode;
  readonly byFacility: ReadonlyArray<BookingReportingFacilityNode>;
  readonly cancellations: BookingReportingCancellationNode;
  readonly capacityUse: ReadonlyArray<BookingReportingCapacityNode>;
  readonly leadTime: BookingReportingLeadTimeNode;
  readonly residentReach: BookingReportingResidentReachNode;
  readonly slotPattern: ReadonlyArray<BookingReportingHourCountNode>;
};

export type BookingReportingResidentReachNode = {
  readonly __typename?: 'BookingReportingResidentReachNode';
  readonly bookerCount: Scalars['Int']['output'];
  readonly residentCount: Scalars['Int']['output'];
  readonly share?: Maybe<Scalars['Float']['output']>;
};

export type BudgetNode = {
  readonly __typename?: 'BudgetNode';
  readonly activatedOn: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};

export type BudgetNodeConnection = {
  readonly __typename?: 'BudgetNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BudgetNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BudgetNode` and its cursor. */
export type BudgetNodeEdge = {
  readonly __typename?: 'BudgetNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BudgetNode>;
};

export type BudgetSummaryType = {
  readonly __typename?: 'BudgetSummaryType';
  readonly buildingSafetyActCompliance: Scalars['Decimal']['output'];
  readonly buildingsInsurance: Scalars['Decimal']['output'];
  readonly generalExpenses: Scalars['Decimal']['output'];
  readonly generalHealthAndSafety: Scalars['Decimal']['output'];
  readonly management: Scalars['Decimal']['output'];
  readonly onsiteStaff: Scalars['Decimal']['output'];
  readonly otherProfessionalFees: Scalars['Decimal']['output'];
  readonly repairsAndMaintenance: Scalars['Decimal']['output'];
  readonly reserveFunds: Scalars['Decimal']['output'];
  readonly utilities: Scalars['Decimal']['output'];
  readonly yearEnd: Scalars['DateTime']['output'];
  readonly yearStart: Scalars['DateTime']['output'];
};

export type BulkConversationActionJobNode = {
  readonly __typename?: 'BulkConversationActionJobNode';
  readonly action: ResidentialManagementBulkConversationActionJobActionChoices;
  readonly closedReason: ResidentialManagementBulkConversationActionJobClosedReasonChoices;
  readonly conversationIds: Scalars['JSONString']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly failed: Scalars['Int']['output'];
  readonly finishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly processed: Scalars['Int']['output'];
  readonly skipped: Scalars['Int']['output'];
  readonly snapshotAt: Scalars['DateTime']['output'];
  readonly startedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly status: ResidentialManagementBulkConversationActionJobStatusChoices;
  readonly succeeded: Scalars['Int']['output'];
  readonly total: Scalars['Int']['output'];
};

export type BulkConversationCloseFilterInput = {
  readonly assignedTo?: InputMaybe<Scalars['String']['input']>;
  readonly assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  readonly dateFrom?: InputMaybe<Scalars['Date']['input']>;
  readonly dateTo?: InputMaybe<Scalars['Date']['input']>;
  readonly direction?: InputMaybe<Scalars['String']['input']>;
  readonly inactive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly search?: InputMaybe<Scalars['String']['input']>;
  readonly source?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type BulkDeactivationJobNode = {
  readonly __typename?: 'BulkDeactivationJobNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  readonly failed: Scalars['Int']['output'];
  readonly finishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly processed: Scalars['Int']['output'];
  readonly startedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly succeeded: Scalars['Int']['output'];
  readonly total: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type CalendarLinkType = {
  readonly __typename?: 'CalendarLinkType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastChecked?: Maybe<Scalars['DateTime']['output']>;
  readonly manager: ManagerType;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type CancelAmenityReservationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CancelAmenityReservationPayload = {
  readonly __typename?: 'CancelAmenityReservationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type CancelPaymentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly payment: Scalars['UUID']['input'];
};

export type CancelPaymentPayload = {
  readonly __typename?: 'CancelPaymentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly payment: PaymentNode;
};

export type CancelScheduledMessage = {
  readonly __typename?: 'CancelScheduledMessage';
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type CancelScheduledMessageInput = {
  readonly id: Scalars['UUID']['input'];
};

export type CancelScheduledPublishCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CancelScheduledPublishCommunityUpdatePayload = {
  readonly __typename?: 'CancelScheduledPublishCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CardPaymentType = {
  readonly __typename?: 'CardPaymentType';
  readonly brand: Scalars['String']['output'];
  readonly last4: Scalars['String']['output'];
};

export type ChangeTaskStatusInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly status?: InputMaybe<Status>;
};

export type ChangeTaskStatusPayload = {
  readonly __typename?: 'ChangeTaskStatusPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type ChargeType = {
  readonly __typename?: 'ChargeType';
  readonly paymentMethodDetails: PaymentMethod;
};

export type CheckBlockSuggestionHomesInput = {
  readonly blockSuggestionId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homesToAdd: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
};

export type CheckBlockSuggestionHomesPayload = {
  readonly __typename?: 'CheckBlockSuggestionHomesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly homeDuplicates?: Maybe<ReadonlyArray<Maybe<HomeDuplicate>>>;
};

export type CheckInKeyV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CheckInKeyV2Payload = {
  readonly __typename?: 'CheckInKeyV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type CheckOutKeyV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly currentKeyholder?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CheckOutKeyV2Payload = {
  readonly __typename?: 'CheckOutKeyV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type ChecklistActionNode = {
  readonly __typename?: 'ChecklistActionNode';
  readonly confidence?: Maybe<Scalars['Float']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly dismissalNote: Scalars['String']['output'];
  readonly dismissalReason?: Maybe<Scalars['String']['output']>;
  readonly dueDate?: Maybe<Scalars['Date']['output']>;
  readonly finding: Scalars['String']['output'];
  readonly followUpTaskCount: Scalars['Int']['output'];
  readonly followUpTasks?: Maybe<ReadonlyArray<TaskNode>>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSuggested: Scalars['Boolean']['output'];
  readonly item: TaskChecklistItemNode;
  readonly legislationReference: Scalars['String']['output'];
  readonly location: Scalars['String']['output'];
  readonly locations: ReadonlyArray<Scalars['String']['output']>;
  readonly origin?: Maybe<Scalars['String']['output']>;
  readonly plannedDate?: Maybe<Scalars['Date']['output']>;
  readonly priority?: Maybe<Scalars['String']['output']>;
  readonly priorityRaw: Scalars['String']['output'];
  readonly recommendation: Scalars['String']['output'];
  readonly resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly resolvedBy?: Maybe<UserType>;
  readonly reviewStatus?: Maybe<Scalars['String']['output']>;
  readonly reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly reviewedBy?: Maybe<UserType>;
  readonly sourceExtraction?: Maybe<DocumentExtractionNode>;
  readonly sourceQuote: Scalars['String']['output'];
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly suggestedTaskDescription: Scalars['String']['output'];
  readonly suggestedTaskTitle: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ChecklistActionSourceNode = {
  readonly __typename?: 'ChecklistActionSourceNode';
  readonly actionId: Scalars['UUID']['output'];
  readonly isRegionLevel: Scalars['Boolean']['output'];
  readonly page?: Maybe<SourceDocumentPageNode>;
  readonly regions: ReadonlyArray<ActionSourceRegionNode>;
};

export type ChecklistComplianceRecordNode = {
  readonly __typename?: 'ChecklistComplianceRecordNode';
  readonly assessedBy?: Maybe<UserType>;
  readonly assessmentDate?: Maybe<Scalars['Date']['output']>;
  readonly assessorName?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly nextAssessmentDate?: Maybe<Scalars['Date']['output']>;
  readonly providerName?: Maybe<Scalars['String']['output']>;
  readonly riskConsequence?: Maybe<Scalars['String']['output']>;
  readonly riskLikelihood?: Maybe<Scalars['String']['output']>;
  readonly riskRating?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ChecklistItemResponseValueInput = {
  readonly responseBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  readonly responseChoice?: InputMaybe<Response_Choice>;
  readonly responseDate?: InputMaybe<Scalars['Date']['input']>;
  readonly responseId?: InputMaybe<Scalars['String']['input']>;
  readonly responseNumber?: InputMaybe<Scalars['Decimal']['input']>;
  readonly responseText?: InputMaybe<Scalars['String']['input']>;
  readonly responseTime?: InputMaybe<Scalars['Time']['input']>;
  readonly sourceInputId?: InputMaybe<Scalars['String']['input']>;
};

export type ChecklistSectionInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly steps?: InputMaybe<ReadonlyArray<ChecklistStepInput>>;
  readonly title: Scalars['String']['input'];
};

export type ChecklistStepFieldInput = {
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly inputType: Scalars['String']['input'];
  readonly isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  readonly label?: InputMaybe<Scalars['String']['input']>;
};

export type ChecklistStepInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly guidance?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly inputs?: InputMaybe<ReadonlyArray<ChecklistStepFieldInput>>;
  readonly isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  readonly referenceCode?: InputMaybe<Scalars['String']['input']>;
  readonly requiresPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  readonly stepType?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

export type ClientAdminNode = {
  readonly __typename?: 'ClientAdminNode';
  readonly client?: Maybe<ClientType>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly user: UserType;
};


export type ClientAdminNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClientContractorCompanyNode = {
  readonly __typename?: 'ClientContractorCompanyNode';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly communities: CommunityNodeConnection;
  readonly companyType?: Maybe<ResidentialManagementClientContractorCompanyCompanyTypeChoices>;
  readonly contractorCompany: ContractorCompanyNode;
  readonly contractorCount?: Maybe<Scalars['Int']['output']>;
  readonly contractors: ContractorNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly website?: Maybe<Scalars['String']['output']>;
};


export type ClientContractorCompanyNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ClientContractorCompanyNodeContractorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientContractorCompanyNodeConnection = {
  readonly __typename?: 'ClientContractorCompanyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ClientContractorCompanyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientContractorCompanyNode` and its cursor. */
export type ClientContractorCompanyNodeEdge = {
  readonly __typename?: 'ClientContractorCompanyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ClientContractorCompanyNode>;
};

export type ClientStaffDirectoryMemberType = {
  readonly __typename?: 'ClientStaffDirectoryMemberType';
  readonly clientId: Scalars['UUID']['output'];
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
  readonly roles: ReadonlyArray<ClientStaffDirectoryRoleType>;
};

export type ClientStaffDirectoryRoleType = {
  readonly __typename?: 'ClientStaffDirectoryRoleType';
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly roleSlug: Scalars['String']['output'];
};

export type ClientStaffMemberNode = {
  readonly __typename?: 'ClientStaffMemberNode';
  readonly communityIds: ReadonlyArray<Maybe<Scalars['UUID']['output']>>;
  readonly dateJoined: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isRoleActive?: Maybe<Scalars['Boolean']['output']>;
  readonly lastActive?: Maybe<Scalars['DateTime']['output']>;
  readonly lastName: Scalars['String']['output'];
  readonly mfaEnabled: Scalars['Boolean']['output'];
  readonly profile?: Maybe<UserProfileNode>;
  readonly role?: Maybe<Scalars['String']['output']>;
  readonly roleCommunitiesPreview?: Maybe<ReadonlyArray<Maybe<ClientUserCommunityType>>>;
  readonly roleCommunityCount: Scalars['Int']['output'];
  readonly teamIds: ReadonlyArray<Maybe<Scalars['UUID']['output']>>;
  readonly teams?: Maybe<ReadonlyArray<Maybe<ClientStaffMemberTeamType>>>;
};

export type ClientStaffMemberNodeConnection = {
  readonly __typename?: 'ClientStaffMemberNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ClientStaffMemberNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientStaffMemberNode` and its cursor. */
export type ClientStaffMemberNodeEdge = {
  readonly __typename?: 'ClientStaffMemberNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ClientStaffMemberNode>;
};

export type ClientStaffMemberTeamType = {
  readonly __typename?: 'ClientStaffMemberTeamType';
  readonly icon?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['UUID']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type ClientTagNode = {
  readonly __typename?: 'ClientTagNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly assignments: TagAssignmentNodeConnection;
  readonly client: ClientType;
  readonly color?: Maybe<Scalars['String']['output']>;
  readonly createdBy?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSystemManaged: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};


export type ClientTagNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientTagNodeConnection = {
  readonly __typename?: 'ClientTagNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ClientTagNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientTagNode` and its cursor. */
export type ClientTagNodeEdge = {
  readonly __typename?: 'ClientTagNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ClientTagNode>;
};

export type ClientType = {
  readonly __typename?: 'ClientType';
  readonly asanaWebFormUrl?: Maybe<Scalars['String']['output']>;
  readonly btlSubscriptionPerHomeCost?: Maybe<Scalars['Float']['output']>;
  readonly btlSubscriptionTotalCost?: Maybe<Scalars['Float']['output']>;
  readonly buttonColor?: Maybe<Scalars['String']['output']>;
  readonly clientType: PeopleClientClientTypeChoices;
  readonly emergencyNumber?: Maybe<Scalars['String']['output']>;
  readonly features: ReadonlyArray<FeatureType>;
  readonly hasAddedHome?: Maybe<Scalars['Boolean']['output']>;
  readonly hasCheckedCompliance?: Maybe<Scalars['Boolean']['output']>;
  readonly hasCreatedTenancy?: Maybe<Scalars['Boolean']['output']>;
  readonly hasPayments?: Maybe<Scalars['Boolean']['output']>;
  readonly hasSentReference?: Maybe<Scalars['Boolean']['output']>;
  readonly hasSetupRentCollection?: Maybe<Scalars['Boolean']['output']>;
  readonly hasSignedAgreement?: Maybe<Scalars['Boolean']['output']>;
  readonly homes: ReadonlyArray<HomeType>;
  readonly homesCount?: Maybe<Scalars['Int']['output']>;
  readonly iconColor?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly integrations?: Maybe<IntegrationType>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  readonly logo?: Maybe<Scalars['String']['output']>;
  readonly managers: ReadonlyArray<ManagerType>;
  readonly name: Scalars['String']['output'];
  readonly paymentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly referenceStartedOn?: Maybe<Scalars['Date']['output']>;
  readonly stripeAccountId?: Maybe<Scalars['String']['output']>;
  readonly stripeAccountLink?: Maybe<Scalars['String']['output']>;
  readonly stripeDashboardLink?: Maybe<Scalars['String']['output']>;
  readonly subscriptions?: Maybe<ReadonlyArray<Maybe<SubscriptionNode>>>;
  readonly tags?: Maybe<ConversationTagNodeConnection>;
  readonly textColor?: Maybe<Scalars['String']['output']>;
  readonly themeColor?: Maybe<Scalars['String']['output']>;
  readonly tierUpTo?: Maybe<Scalars['Int']['output']>;
  readonly tokens: Scalars['Int']['output'];
};


export type ClientTypeBtlSubscriptionTotalCostArgs = {
  includeSetupFee?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ClientTypeStripeAccountLinkArgs = {
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};


export type ClientTypeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientUserCommunityType = {
  readonly __typename?: 'ClientUserCommunityType';
  readonly id?: Maybe<Scalars['UUID']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type ClientUserNode = {
  readonly __typename?: 'ClientUserNode';
  readonly clientAdmin?: Maybe<ClientAdminNode>;
  readonly communityManager?: Maybe<CommunityManagerNode>;
  readonly concierge?: Maybe<ConciergeNode>;
  readonly dateJoined: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isRoleActive?: Maybe<Scalars['Boolean']['output']>;
  readonly lastActive?: Maybe<Scalars['DateTime']['output']>;
  readonly lastName: Scalars['String']['output'];
  readonly manager?: Maybe<ManagerType>;
  readonly mfaEnabled: Scalars['Boolean']['output'];
  readonly profile?: Maybe<UserProfileNode>;
  readonly role?: Maybe<Scalars['String']['output']>;
  readonly roleCommunities?: Maybe<ReadonlyArray<Maybe<ClientUserCommunityType>>>;
  readonly teams?: Maybe<TeamNodeConnection>;
};


export type ClientUserNodeTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientUserNodeConnection = {
  readonly __typename?: 'ClientUserNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ClientUserNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientUserNode` and its cursor. */
export type ClientUserNodeEdge = {
  readonly __typename?: 'ClientUserNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ClientUserNode>;
};

export type CloseConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly notify?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sendMessage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CloseConversationPayload = {
  readonly __typename?: 'CloseConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type CloseSurvey = {
  readonly __typename?: 'CloseSurvey';
  readonly survey?: Maybe<ResidentSurveyNode>;
};

export type CollectPackagesForHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly home: Scalars['UUID']['input'];
  readonly user?: InputMaybe<Scalars['UUID']['input']>;
};

export type CollectPackagesForHomePayload = {
  readonly __typename?: 'CollectPackagesForHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeNode>;
};

export type CollectPackagesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly packageIds: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
  readonly userId: Scalars['UUID']['input'];
};

export type CollectPackagesPayload = {
  readonly __typename?: 'CollectPackagesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly packages: ReadonlyArray<Maybe<PackageNode>>;
};

export type CommunityDashboardType = {
  readonly __typename?: 'CommunityDashboardType';
  readonly activeResidentsDifference?: Maybe<Scalars['Int']['output']>;
  readonly allTimeSatisfaction?: Maybe<Scalars['Decimal']['output']>;
  readonly averageResponseTime?: Maybe<Scalars['Int']['output']>;
  readonly downloadRate?: Maybe<Scalars['Int']['output']>;
  readonly downloadRateOverTime?: Maybe<ReadonlyArray<Maybe<DownloadRateType>>>;
  readonly listEngagementScores?: Maybe<ReadonlyArray<CommunityEngagementScoreType>>;
  readonly monthlyActiveResidents?: Maybe<Scalars['Int']['output']>;
  readonly openCount?: Maybe<Scalars['Int']['output']>;
  readonly ratingsOverTime?: Maybe<ReadonlyArray<Maybe<AverageConversationRatingType>>>;
  readonly responseTimeDifference?: Maybe<Scalars['Int']['output']>;
  readonly responseTimeOverTime?: Maybe<ReadonlyArray<Maybe<ResponseTimeType>>>;
  readonly snoozedCount?: Maybe<Scalars['Int']['output']>;
};

export type CommunityDocumentNode = {
  readonly __typename?: 'CommunityDocumentNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly availableClientTags?: Maybe<ClientTagNodeConnection>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<ManagerType>;
  readonly createdByUser?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<DocumentNode>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly groups: CommunityGroupNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly tagAssignments?: Maybe<TagAssignmentNodeConnection>;
  readonly tags?: Maybe<TagNodeConnection>;
  readonly title: Scalars['String']['output'];
  readonly totalPotentialViewers: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
  readonly viewers: ResidentialManagementCommunityDocumentViewersChoices;
  readonly views: CommunityDocumentViewNodeConnection;
};


export type CommunityDocumentNodeAvailableClientTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityDocumentNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityDocumentNodeTagAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityDocumentNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityDocumentNodeViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityDocumentNodeConnection = {
  readonly __typename?: 'CommunityDocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityDocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityDocumentNode` and its cursor. */
export type CommunityDocumentNodeEdge = {
  readonly __typename?: 'CommunityDocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityDocumentNode>;
};

export type CommunityDocumentReminderNode = {
  readonly __typename?: 'CommunityDocumentReminderNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly document?: Maybe<CommunityDocumentNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type CommunityDocumentReminderNodeConnection = {
  readonly __typename?: 'CommunityDocumentReminderNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityDocumentReminderNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityDocumentReminderNode` and its cursor. */
export type CommunityDocumentReminderNodeEdge = {
  readonly __typename?: 'CommunityDocumentReminderNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityDocumentReminderNode>;
};

export type CommunityDocumentViewNode = {
  readonly __typename?: 'CommunityDocumentViewNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly user: UserType;
};

export type CommunityDocumentViewNodeConnection = {
  readonly __typename?: 'CommunityDocumentViewNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityDocumentViewNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityDocumentViewNode` and its cursor. */
export type CommunityDocumentViewNodeEdge = {
  readonly __typename?: 'CommunityDocumentViewNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityDocumentViewNode>;
};

export type CommunityEngagementScoreType = {
  readonly __typename?: 'CommunityEngagementScoreType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly score: Scalars['Decimal']['output'];
};

export type CommunityEventNode = {
  readonly __typename?: 'CommunityEventNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly attendanceFee?: Maybe<Scalars['Decimal']['output']>;
  readonly availableSpaces?: Maybe<Scalars['Int']['output']>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description: Scalars['String']['output'];
  readonly end: Scalars['DateTime']['output'];
  readonly groups: CommunityGroupNodeConnection;
  readonly guests?: Maybe<ContactNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isAttending?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  /** Meeting or external links for this event (e.g. Google Meet, Teams, Zoom). */
  readonly links?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly maxAdditionalAttendees: Scalars['Int']['output'];
  readonly maxSpaces: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly parties: CommunityEventPartyNodeConnection;
  readonly partyAdditionalAttendance?: Maybe<Scalars['Int']['output']>;
  readonly start: Scalars['DateTime']['output'];
};


export type CommunityEventNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityEventNodeGuestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allowApplicants?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityEventNodePartiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventEndDateAfter?: InputMaybe<Scalars['Date']['input']>;
  event_Start?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityEventNodeConnection = {
  readonly __typename?: 'CommunityEventNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityEventNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityEventNode` and its cursor. */
export type CommunityEventNodeEdge = {
  readonly __typename?: 'CommunityEventNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityEventNode>;
};

export type CommunityEventPartyNode = {
  readonly __typename?: 'CommunityEventPartyNode';
  readonly additionalAttendance: Scalars['Int']['output'];
  readonly event?: Maybe<CommunityEventNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly users?: Maybe<ContactNodeConnection>;
};


export type CommunityEventPartyNodeUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allowApplicants?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type CommunityEventPartyNodeConnection = {
  readonly __typename?: 'CommunityEventPartyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityEventPartyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityEventPartyNode` and its cursor. */
export type CommunityEventPartyNodeEdge = {
  readonly __typename?: 'CommunityEventPartyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityEventPartyNode>;
};

export type CommunityFeatureNode = {
  readonly __typename?: 'CommunityFeatureNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type CommunityFeatureNodeConnection = {
  readonly __typename?: 'CommunityFeatureNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityFeatureNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityFeatureNode` and its cursor. */
export type CommunityFeatureNodeEdge = {
  readonly __typename?: 'CommunityFeatureNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityFeatureNode>;
};

export type CommunityFormNode = {
  readonly __typename?: 'CommunityFormNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly externalId: Scalars['String']['output'];
  readonly groups: CommunityGroupNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly isCompleted?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly link: Scalars['String']['output'];
  readonly numberOfResponses?: Maybe<Scalars['Int']['output']>;
  readonly provider: ResidentialManagementCommunityFormProviderChoices;
  readonly questions?: Maybe<TypeformQuestionConnection>;
  readonly responses?: Maybe<TypeformResponseConnection>;
  readonly title?: Maybe<Scalars['String']['output']>;
};


export type CommunityFormNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityFormNodeQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityFormNodeResponsesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityFormNodeConnection = {
  readonly __typename?: 'CommunityFormNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityFormNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityFormNode` and its cursor. */
export type CommunityFormNodeEdge = {
  readonly __typename?: 'CommunityFormNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityFormNode>;
};

export type CommunityGroupNode = {
  readonly __typename?: 'CommunityGroupNode';
  readonly block?: Maybe<BlockNode>;
  readonly community?: Maybe<CommunityNode>;
  readonly communityId?: Maybe<Scalars['ID']['output']>;
  readonly communityName?: Maybe<Scalars['String']['output']>;
  readonly deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly homes?: Maybe<HomeNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isAutomatic: Scalars['Boolean']['output'];
  readonly isBlockScoped?: Maybe<Scalars['Boolean']['output']>;
  readonly isCommunityManager?: Maybe<Scalars['Boolean']['output']>;
  readonly isCommunityScoped?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly numUsers?: Maybe<Scalars['Int']['output']>;
  readonly users?: Maybe<ContactNodeConnection>;
};


export type CommunityGroupNodeHomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityGroupNodeUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allowApplicants?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type CommunityGroupNodeConnection = {
  readonly __typename?: 'CommunityGroupNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityGroupNodeEdge>>;
  readonly locales?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityGroupNode` and its cursor. */
export type CommunityGroupNodeEdge = {
  readonly __typename?: 'CommunityGroupNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityGroupNode>;
};

export type CommunityManagerNode = {
  readonly __typename?: 'CommunityManagerNode';
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
};


export type CommunityManagerNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityNode = {
  readonly __typename?: 'CommunityNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly appCoverImage?: Maybe<Scalars['String']['output']>;
  readonly asanaWebFormUrl?: Maybe<Scalars['String']['output']>;
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly averageRentAmount?: Maybe<Scalars['Float']['output']>;
  readonly averageResidencyLength?: Maybe<Scalars['Float']['output']>;
  readonly blocks: BlockNodeConnection;
  readonly budgetSummaries: ReadonlyArray<Maybe<BudgetSummaryType>>;
  readonly buttonColor?: Maybe<Scalars['String']['output']>;
  readonly client?: Maybe<ClientType>;
  readonly commentsEnabled: Scalars['Boolean']['output'];
  readonly communityChatEnabled: Scalars['Boolean']['output'];
  readonly communityEvents: CommunityEventNodeConnection;
  readonly communityGroups: CommunityGroupNodeConnection;
  readonly deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly dwellantTaskCategories?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly engagementScore?: Maybe<Scalars['Decimal']['output']>;
  readonly engagementScoreDifference?: Maybe<Scalars['Float']['output']>;
  readonly externalId?: Maybe<Scalars['String']['output']>;
  readonly features: CommunityFeatureNodeConnection;
  readonly hasAsanaIntegration: Scalars['Boolean']['output'];
  readonly hasBlockSuggestions: Scalars['Boolean']['output'];
  readonly hasBlocks: Scalars['Boolean']['output'];
  readonly hasDwellantIntegration?: Maybe<Scalars['Boolean']['output']>;
  readonly homeCount: Scalars['Int']['output'];
  readonly iconColor?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isLeasehold: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastSibPackGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly lastSibPackPrintedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly logo?: Maybe<Scalars['String']['output']>;
  readonly managers: ReadonlyArray<ManagerType>;
  readonly marketplaceEnabled: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly officeHoursEnabled: Scalars['Boolean']['output'];
  readonly openConversationsCount?: Maybe<Scalars['Int']['output']>;
  readonly openPeriods?: Maybe<ReadonlyArray<CommunityOpenPeriodNode>>;
  readonly outOfOfficeMessage?: Maybe<Scalars['String']['output']>;
  readonly packageLocations?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly paymentsEnabled: Scalars['Boolean']['output'];
  readonly percentOccupied?: Maybe<Scalars['Float']['output']>;
  readonly postcode?: Maybe<Scalars['String']['output']>;
  readonly recentUnresolvedConversations?: Maybe<ReadonlyArray<ConversationNode>>;
  readonly referencingEnabled: Scalars['Boolean']['output'];
  readonly requisiteDate?: Maybe<Scalars['Date']['output']>;
  readonly residentCount: Scalars['Int']['output'];
  readonly responsiblePersonName: Scalars['String']['output'];
  readonly responsiblePersonRole: Scalars['String']['output'];
  readonly safetyComplianceReadiness: SafetyComplianceReadinessType;
  readonly safetyPackEligibility: SafetyPackEligibilityType;
  readonly satisfactionScore?: Maybe<Scalars['Float']['output']>;
  readonly settings: CommunitySettingsType;
  readonly sibPackStale: Scalars['Boolean']['output'];
  readonly sibPackUrl?: Maybe<Scalars['String']['output']>;
  readonly sibResidentNeedCount: Scalars['Int']['output'];
  readonly sibTaggedDocumentCount: Scalars['Int']['output'];
  readonly statisticDataPoint?: Maybe<CommunityStatisticDataPointNode>;
  readonly statisticDataPoints?: Maybe<ReadonlyArray<Maybe<CommunityStatisticDataPointNode>>>;
  readonly statisticDifference?: Maybe<Scalars['Float']['output']>;
  readonly status: Scalars['String']['output'];
  readonly team?: Maybe<CommunityTeamNodeConnection>;
  readonly textColor?: Maybe<Scalars['String']['output']>;
  readonly themeColor?: Maybe<Scalars['String']['output']>;
  readonly unreadConversations: Scalars['Int']['output'];
  readonly updates?: Maybe<ReadonlyArray<CommunityUpdateType>>;
};


export type CommunityNodeBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityNodeCommunityEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDateAfter?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  partyUsers?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type CommunityNodeCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityNodeFeaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityNodeStatisticDataPointArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  statisticType: HistoricalDataPointType;
};


export type CommunityNodeStatisticDataPointsArgs = {
  frequency: HistoricalDataFrequency;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  statisticType: HistoricalDataPointType;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CommunityNodeStatisticDifferenceArgs = {
  since?: InputMaybe<Scalars['Date']['input']>;
  statisticType: HistoricalDataPointType;
};


export type CommunityNodeTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentAppVisibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommunityNodeConnection = {
  readonly __typename?: 'CommunityNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityNode` and its cursor. */
export type CommunityNodeEdge = {
  readonly __typename?: 'CommunityNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityNode>;
};

export type CommunityOpenPeriodNode = {
  readonly __typename?: 'CommunityOpenPeriodNode';
  readonly end: Scalars['Time']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly start: Scalars['Time']['output'];
  readonly weekdayIndex: Scalars['Int']['output'];
};

export type CommunityOpenPeriodSerializerInput = {
  readonly end: Scalars['Time']['input'];
  readonly start: Scalars['Time']['input'];
  readonly weekdayIndex: Scalars['Int']['input'];
};

export type CommunityProductNode = {
  readonly __typename?: 'CommunityProductNode';
  readonly active: Scalars['Boolean']['output'];
  readonly client?: Maybe<ClientType>;
  readonly communities: CommunityNodeConnection;
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly price?: Maybe<Scalars['Decimal']['output']>;
  readonly purchases: CommunityProductPurchaseNodeConnection;
};


export type CommunityProductNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityProductNodePurchasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type CommunityProductNodeConnection = {
  readonly __typename?: 'CommunityProductNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityProductNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityProductNode` and its cursor. */
export type CommunityProductNodeEdge = {
  readonly __typename?: 'CommunityProductNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityProductNode>;
};

export type CommunityProductPurchaseNode = {
  readonly __typename?: 'CommunityProductPurchaseNode';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly payment?: Maybe<PaymentNode>;
  readonly product?: Maybe<CommunityProductNode>;
  readonly user?: Maybe<UserType>;
};

export type CommunityProductPurchaseNodeConnection = {
  readonly __typename?: 'CommunityProductPurchaseNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityProductPurchaseNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityProductPurchaseNode` and its cursor. */
export type CommunityProductPurchaseNodeEdge = {
  readonly __typename?: 'CommunityProductPurchaseNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityProductPurchaseNode>;
};

export type CommunitySettingsType = {
  readonly __typename?: 'CommunitySettingsType';
  readonly abMessageSuggestion: Scalars['Boolean']['output'];
  readonly accounts: Scalars['Boolean']['output'];
  readonly appointments: Scalars['Boolean']['output'];
  readonly bankAccountName?: Maybe<Scalars['String']['output']>;
  readonly bankAccountNumber?: Maybe<Scalars['String']['output']>;
  readonly bankSortCode?: Maybe<Scalars['String']['output']>;
  readonly closureGateEnforced: Scalars['Boolean']['output'];
  readonly compliance: Scalars['Boolean']['output'];
  readonly contractorSuggestionsEnforced: Scalars['Boolean']['output'];
  readonly conversationForwardingEmails: ReadonlyArray<ConversationForwardingEmailType>;
  readonly documents: Scalars['Boolean']['output'];
  readonly dwellantOrgId?: Maybe<Scalars['String']['output']>;
  readonly emailHeaderImageUrl?: Maybe<Scalars['String']['output']>;
  readonly events: Scalars['Boolean']['output'];
  readonly externalPortalUrls: ReadonlyArray<ExternalPortalUrlType>;
  readonly facilities: Scalars['Boolean']['output'];
  readonly fixfloRepairPrompts: Scalars['Boolean']['output'];
  readonly fixfloUrl?: Maybe<Scalars['String']['output']>;
  readonly forms: Scalars['Boolean']['output'];
  readonly fullMessageSuggestion: Scalars['Boolean']['output'];
  readonly keys: Scalars['Boolean']['output'];
  readonly marketplace: Scalars['Boolean']['output'];
  readonly marketplaceBatchNotifications: Scalars['Boolean']['output'];
  readonly messages: Scalars['Boolean']['output'];
  readonly mobileNumberRequired: Scalars['Boolean']['output'];
  readonly newsfeed: Scalars['Boolean']['output'];
  readonly occupancySurvey: Scalars['Boolean']['output'];
  readonly packageLabels: Scalars['Boolean']['output'];
  readonly packages: Scalars['Boolean']['output'];
  readonly payByBankEnabled: Scalars['Boolean']['output'];
  readonly payByBankUiVariant: Scalars['String']['output'];
  readonly portalUrl?: Maybe<Scalars['String']['output']>;
  readonly products: Scalars['Boolean']['output'];
  readonly residentVisibleTasks: Scalars['Boolean']['output'];
  readonly safetyCenter: Scalars['Boolean']['output'];
  readonly safetyComplianceV2ActivatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly sendExternalIdToFixflo: Scalars['Boolean']['output'];
  readonly serviceChargeWaiver: Scalars['Boolean']['output'];
  readonly sibPackReviewNudgeMonths: Scalars['Int']['output'];
  readonly sibPackReviewRemindersEnabled: Scalars['Boolean']['output'];
  readonly staffEmailPatterns: ReadonlyArray<Maybe<Scalars['String']['output']>>;
  readonly surveyReviewIntervalMonths: Scalars['Int']['output'];
  readonly surveys: Scalars['Boolean']['output'];
  readonly termsAndConditions: Scalars['Boolean']['output'];
};

export type CommunityStaffCandidateType = {
  readonly __typename?: 'CommunityStaffCandidateType';
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
};

export type CommunityStaffRoleType = {
  readonly __typename?: 'CommunityStaffRoleType';
  readonly clientId: Scalars['UUID']['output'];
  readonly communityId: Scalars['UUID']['output'];
  readonly grantedAt: Scalars['DateTime']['output'];
  readonly grantedById?: Maybe<Scalars['UUID']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly roleSlug: Scalars['String']['output'];
  readonly userId: Scalars['UUID']['output'];
  readonly userName: Scalars['String']['output'];
};

export type CommunityStatisticDataPointNode = {
  readonly __typename?: 'CommunityStatisticDataPointNode';
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly date: Scalars['Date']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly type: ResidentialManagementCommunityStatisticDataPointTypeChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly value: Scalars['Float']['output'];
};

export type CommunityTaskDefinitionNode = {
  readonly __typename?: 'CommunityTaskDefinitionNode';
  readonly block?: Maybe<BlockNode>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly taskDefinition: TaskDefinitionNode;
  readonly taskGroup?: Maybe<TaskGroupNode>;
};

export type CommunityTaskDefinitionNodeConnection = {
  readonly __typename?: 'CommunityTaskDefinitionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityTaskDefinitionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityTaskDefinitionNode` and its cursor. */
export type CommunityTaskDefinitionNodeEdge = {
  readonly __typename?: 'CommunityTaskDefinitionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityTaskDefinitionNode>;
};

export type CommunityTaskNode = {
  readonly __typename?: 'CommunityTaskNode';
  readonly communityName?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly residentStatus?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'id' instead. Retained for resident-app <= 4.20.x compatibility; remove once min-supported app version floor is raised above 4.20. */
  readonly taskId?: Maybe<Scalars['UUID']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly updates?: Maybe<ReadonlyArray<ResidentTaskUpdateType>>;
};

export type CommunityTaskNodeConnection = {
  readonly __typename?: 'CommunityTaskNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityTaskNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityTaskNode` and its cursor. */
export type CommunityTaskNodeEdge = {
  readonly __typename?: 'CommunityTaskNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityTaskNode>;
};

export type CommunityTeamMembersGroupType = {
  readonly __typename?: 'CommunityTeamMembersGroupType';
  readonly communityId: Scalars['UUID']['output'];
  readonly members: ReadonlyArray<CommunityTeamNode>;
};

export type CommunityTeamNode = {
  readonly __typename?: 'CommunityTeamNode';
  readonly biography?: Maybe<Scalars['String']['output']>;
  readonly displayPicture?: Maybe<Scalars['String']['output']>;
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isAdmin?: Maybe<Scalars['Boolean']['output']>;
  readonly isCommunityManager?: Maybe<Scalars['Boolean']['output']>;
  readonly isConcierge?: Maybe<Scalars['Boolean']['output']>;
  readonly isManager?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly lastName: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly publicUuid: Scalars['UUID']['output'];
};

export type CommunityTeamNodeConnection = {
  readonly __typename?: 'CommunityTeamNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityTeamNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityTeamNode` and its cursor. */
export type CommunityTeamNodeEdge = {
  readonly __typename?: 'CommunityTeamNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityTeamNode>;
};

export type CommunityUpdateAttachmentNode = {
  readonly __typename?: 'CommunityUpdateAttachmentNode';
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly fileName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type CommunityUpdateCommentNode = {
  readonly __typename?: 'CommunityUpdateCommentNode';
  readonly author: UserType;
  readonly comment: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly userType: ResidentialManagementCommunityUpdateCommentUserTypeChoices;
};

export type CommunityUpdateCommentNodeConnection = {
  readonly __typename?: 'CommunityUpdateCommentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityUpdateCommentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityUpdateCommentNode` and its cursor. */
export type CommunityUpdateCommentNodeEdge = {
  readonly __typename?: 'CommunityUpdateCommentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityUpdateCommentNode>;
};

export type CommunityUpdateLikeType = {
  readonly __typename?: 'CommunityUpdateLikeType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly update: CommunityUpdateType;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};

export type CommunityUpdateLocaleVariantNode = {
  readonly __typename?: 'CommunityUpdateLocaleVariantNode';
  readonly body?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly locale?: Maybe<Scalars['String']['output']>;
  readonly status: ResidentialManagementCommunityUpdateLocaleVariantStatusChoices;
  readonly summary?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type CommunityUpdateLocaleVariantNodeConnection = {
  readonly __typename?: 'CommunityUpdateLocaleVariantNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityUpdateLocaleVariantNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityUpdateLocaleVariantNode` and its cursor. */
export type CommunityUpdateLocaleVariantNodeEdge = {
  readonly __typename?: 'CommunityUpdateLocaleVariantNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityUpdateLocaleVariantNode>;
};

export type CommunityUpdateNode = {
  readonly __typename?: 'CommunityUpdateNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly attachment?: Maybe<Scalars['String']['output']>;
  readonly attachments?: Maybe<ReadonlyArray<Maybe<CommunityUpdateAttachmentNode>>>;
  readonly body: Scalars['String']['output'];
  readonly category: Scalars['String']['output'];
  readonly comments?: Maybe<CommunityUpdateCommentNodeConnection>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly groups?: Maybe<CommunityGroupNodeConnection>;
  readonly hasBookmarked?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly imageSearchTerm?: Maybe<Scalars['String']['output']>;
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  readonly isArk: Scalars['Boolean']['output'];
  readonly isLiked?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly linkedFeature?: Maybe<ResidentialManagementCommunityUpdateLinkedFeatureChoices>;
  readonly numLikes?: Maybe<Scalars['Int']['output']>;
  readonly numberOfBookmarks?: Maybe<Scalars['Int']['output']>;
  readonly publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly residentLike?: Maybe<Scalars['UUID']['output']>;
  readonly scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  readonly stats: CommunityUpdateStatsType;
  readonly status: CommunityUpdateStatusEnum;
  readonly summary: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly uniqueReads?: Maybe<Scalars['Int']['output']>;
  readonly variants?: Maybe<CommunityUpdateLocaleVariantNodeConnection>;
};


export type CommunityUpdateNodeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityUpdateNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityUpdateNodeVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityUpdateNodeConnection = {
  readonly __typename?: 'CommunityUpdateNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityUpdateNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityUpdateNode` and its cursor. */
export type CommunityUpdateNodeEdge = {
  readonly __typename?: 'CommunityUpdateNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityUpdateNode>;
};

export type CommunityUpdateStatsType = {
  readonly __typename?: 'CommunityUpdateStatsType';
  readonly totalComments: Scalars['Int']['output'];
  readonly totalLikes: Scalars['Int']['output'];
  readonly totalReads: Scalars['Int']['output'];
};

/** An enumeration. */
export enum CommunityUpdateStatusEnum {
  Archived = 'Archived',
  Dr = 'DR',
  Li = 'LI',
  Sc = 'SC'
}

export type CommunityUpdateType = {
  readonly __typename?: 'CommunityUpdateType';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly attachment?: Maybe<Scalars['String']['output']>;
  readonly attachments: ReadonlyArray<CommunityUpdateAttachmentNode>;
  readonly body: Scalars['String']['output'];
  readonly bookmarkedBy: ReadonlyArray<UserType>;
  readonly category: Scalars['String']['output'];
  readonly comments?: Maybe<CommunityUpdateCommentNodeConnection>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly creatorType: ResidentialManagementCommunityUpdateCreatorTypeChoices;
  readonly groups: CommunityGroupNodeConnection;
  readonly hasBookmarked?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly imageSearchTerm?: Maybe<Scalars['String']['output']>;
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  readonly isArk: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly likes: ReadonlyArray<CommunityUpdateLikeType>;
  readonly linkedFeature?: Maybe<ResidentialManagementCommunityUpdateLinkedFeatureChoices>;
  readonly numLikes?: Maybe<Scalars['Int']['output']>;
  readonly publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly residentLike?: Maybe<Scalars['UUID']['output']>;
  readonly scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  readonly stats: CommunityUpdateStatsType;
  readonly status: CommunityUpdateStatusEnum;
  readonly summary: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly uniqueReads?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly updatedBy?: Maybe<UserType>;
  readonly variants?: Maybe<CommunityUpdateLocaleVariantNodeConnection>;
};


export type CommunityUpdateTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityUpdateTypeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityUpdateTypeVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityVisitorNode = {
  readonly __typename?: 'CommunityVisitorNode';
  readonly community: CommunityNode;
  readonly company?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly reasonForVisit?: Maybe<Scalars['String']['output']>;
  readonly residentName?: Maybe<Scalars['String']['output']>;
  readonly signedOutAt?: Maybe<Scalars['DateTime']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly vehicleRegistration?: Maybe<Scalars['String']['output']>;
};

export type CommunityVisitorNodeConnection = {
  readonly __typename?: 'CommunityVisitorNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityVisitorNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityVisitorNode` and its cursor. */
export type CommunityVisitorNodeEdge = {
  readonly __typename?: 'CommunityVisitorNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityVisitorNode>;
};

export type CompleteChecklistItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
  readonly isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly responseBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  readonly responseChoice?: InputMaybe<Response_Choice>;
  readonly responseDate?: InputMaybe<Scalars['Date']['input']>;
  readonly responseNumber?: InputMaybe<Scalars['Decimal']['input']>;
  readonly responseText?: InputMaybe<Scalars['String']['input']>;
  readonly responseTime?: InputMaybe<Scalars['Time']['input']>;
  readonly responses?: InputMaybe<ReadonlyArray<InputMaybe<ChecklistItemResponseValueInput>>>;
};

export type CompleteChecklistItemPayload = {
  readonly __typename?: 'CompleteChecklistItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskChecklistItem?: Maybe<TaskChecklistItemNode>;
};

/** An enumeration. */
export enum ComplianceAttachmentTypeChoices {
  /** Home */
  Ho = 'HO',
  /** Requirement item */
  Ri = 'RI'
}

/** An enumeration. */
export enum ComplianceComplianceRequirementTypeChoices {
  /** Custom */
  Cu = 'CU',
  /** Deposit Certificate */
  Dc = 'DC',
  /** Electrical Installation Condition Report */
  Ei = 'EI',
  /** Energy Performance Assessment */
  Ep = 'EP',
  /** Gas Safety Inspection */
  Gs = 'GS',
  /** Local Authority Licensing */
  La = 'LA',
  /** Portable Appliance Test */
  Pa = 'PA',
  /** Smoke Alarm & Carbon Monoxide */
  Sa = 'SA',
  /** Tenancy Agreement */
  Ta = 'TA'
}

/** An enumeration. */
export enum ComplianceComplianceUpdateActionRequirementChoices {
  /** Action */
  Ac = 'AC',
  /** Advice */
  Ad = 'AD'
}

export type ComplianceRequirementNode = {
  readonly __typename?: 'ComplianceRequirementNode';
  readonly actionDate?: Maybe<Scalars['String']['output']>;
  readonly agreement?: Maybe<GeneratedAgreementNode>;
  readonly currentItem?: Maybe<RequirementItemNode>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly frequencyText?: Maybe<Scalars['String']['output']>;
  readonly home: HomeType;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly items: RequirementItemNodeConnection;
  readonly name: Scalars['String']['output'];
  readonly residency?: Maybe<ResidencyType>;
  readonly shared: Scalars['Boolean']['output'];
  readonly status: Scalars['String']['output'];
  readonly type: ComplianceComplianceRequirementTypeChoices;
};


export type ComplianceRequirementNodeItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplianceRequirementNodeConnection = {
  readonly __typename?: 'ComplianceRequirementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ComplianceRequirementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ComplianceRequirementNode` and its cursor. */
export type ComplianceRequirementNodeEdge = {
  readonly __typename?: 'ComplianceRequirementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ComplianceRequirementNode>;
};

export type ComplianceUpdateReadType = {
  readonly __typename?: 'ComplianceUpdateReadType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly manager: ManagerType;
  readonly update: ComplianceUpdateType;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ComplianceUpdateType = {
  readonly __typename?: 'ComplianceUpdateType';
  readonly actionRequirement: ComplianceComplianceUpdateActionRequirementChoices;
  readonly actionText?: Maybe<Scalars['String']['output']>;
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly dateText?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly infoSource?: Maybe<Scalars['String']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly reads: ReadonlyArray<ComplianceUpdateReadType>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly wasRead?: Maybe<Scalars['Boolean']['output']>;
};

export type ConciergeNode = {
  readonly __typename?: 'ConciergeNode';
  readonly client?: Maybe<ClientType>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
};


export type ConciergeNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmResidencyWillRollInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmResidencyWillRollPayload = {
  readonly __typename?: 'ConfirmResidencyWillRollPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export enum ConsentAttestationAuthority {
  PrescribedRepresentative = 'PRESCRIBED_REPRESENTATIVE',
  Resident = 'RESIDENT'
}

export enum ConsentAttestationChannel {
  SignedPaper = 'SIGNED_PAPER',
  Verbal = 'VERBAL'
}

export type ConsentAttestationInput = {
  readonly authority: ConsentAttestationAuthority;
  readonly channel: ConsentAttestationChannel;
  readonly representativeName?: InputMaybe<Scalars['String']['input']>;
  readonly representativeRelationship?: InputMaybe<Scalars['String']['input']>;
};

export type ContactApplicationSupportInput = {
  readonly applicationId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly rejectedCommunityIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type ContactApplicationSupportPayload = {
  readonly __typename?: 'ContactApplicationSupportPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly ok: Scalars['Boolean']['output'];
};

export type ContactNode = {
  readonly __typename?: 'ContactNode';
  readonly amenityReservations: AmenityReservationNodeConnection;
  readonly applicant?: Maybe<ApplicantNode>;
  readonly communities?: Maybe<ReadonlyArray<Maybe<CommunityNode>>>;
  readonly communityGroups?: Maybe<CommunityGroupNodeConnection>;
  readonly contactNotes: ContactNoteNodeConnection;
  readonly email: Scalars['String']['output'];
  readonly eventParties?: Maybe<CommunityEventPartyNodeConnection>;
  readonly firstName: Scalars['String']['output'];
  readonly forms?: Maybe<ReadonlyArray<Maybe<CommunityFormNode>>>;
  readonly id: Scalars['ID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastAppUse?: Maybe<Scalars['DateTime']['output']>;
  readonly lastName: Scalars['String']['output'];
  readonly leaseholder?: Maybe<LeaseholderNode>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly packages: PackageNodeConnection;
  readonly resident?: Maybe<ResidentNode>;
  readonly waivers: WaiverNodeConnection;
};


export type ContactNodeAmenityReservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amenity?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactNodeCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ContactNodeContactNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactNodeEventPartiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventEndDateAfter?: InputMaybe<Scalars['Date']['input']>;
  event_Start?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type ContactNodePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactNodeWaiversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};

export type ContactNodeConnection = {
  readonly __typename?: 'ContactNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ContactNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ContactNode` and its cursor. */
export type ContactNodeEdge = {
  readonly __typename?: 'ContactNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ContactNode>;
};

export type ContactNoteNode = {
  readonly __typename?: 'ContactNoteNode';
  readonly author: UserType;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly text: Scalars['String']['output'];
  readonly user: UserType;
};

export type ContactNoteNodeConnection = {
  readonly __typename?: 'ContactNoteNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ContactNoteNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ContactNoteNode` and its cursor. */
export type ContactNoteNodeEdge = {
  readonly __typename?: 'ContactNoteNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ContactNoteNode>;
};

export type ContactPackagesReminderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contact: Scalars['UUID']['input'];
  readonly packageIds: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type ContactPackagesReminderPayload = {
  readonly __typename?: 'ContactPackagesReminderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type ContractorCompanyNode = {
  readonly __typename?: 'ContractorCompanyNode';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<ResidentialManagementContractorCompanyTypeChoices>;
  readonly website?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum ContractorDecision {
  Accepted = 'ACCEPTED',
  DontKnow = 'DONT_KNOW',
  Rejected = 'REJECTED'
}

export type ContractorNode = {
  readonly __typename?: 'ContractorNode';
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly user: UserType;
};

export type ContractorNodeConnection = {
  readonly __typename?: 'ContractorNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ContractorNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ContractorNode` and its cursor. */
export type ContractorNodeEdge = {
  readonly __typename?: 'ContractorNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ContractorNode>;
};

export type ContractorSuggestionType = {
  readonly __typename?: 'ContractorSuggestionType';
  readonly contractorConfidence?: Maybe<Scalars['Float']['output']>;
  readonly contractorHasCompany: Scalars['Boolean']['output'];
  readonly homeConfidence?: Maybe<Scalars['Float']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isContractor: Scalars['Boolean']['output'];
  readonly isContractorDecision?: Maybe<ContractorDecision>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly suggestedHome?: Maybe<HomeType>;
};

export type ConversationActionModelType = {
  readonly __typename?: 'ConversationActionModelType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly extra?: Maybe<Scalars['JSONString']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ConversationAssignmentNode = {
  readonly __typename?: 'ConversationAssignmentNode';
  readonly assignedBy?: Maybe<UserType>;
  readonly assignedTo: UserType;
  readonly conversation: ConversationNode;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type ConversationAssignmentNodeConnection = {
  readonly __typename?: 'ConversationAssignmentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationAssignmentNode` and its cursor. */
export type ConversationAssignmentNodeEdge = {
  readonly __typename?: 'ConversationAssignmentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationAssignmentNode>;
};

export type ConversationCountsNode = {
  readonly __typename?: 'ConversationCountsNode';
  readonly all: Scalars['Int']['output'];
  readonly assigned: Scalars['Int']['output'];
  readonly assignedToMyTeam: Scalars['Int']['output'];
  readonly fromArk: Scalars['Int']['output'];
  readonly fromEmail: Scalars['Int']['output'];
  readonly inactive: Scalars['Int']['output'];
  readonly inactiveOwed: Scalars['Int']['output'];
  readonly needsResponse: Scalars['Int']['output'];
  readonly snoozed: Scalars['Int']['output'];
  readonly unassigned: Scalars['Int']['output'];
};

export type ConversationEventType = ConversationActionModelType | ConversationMediaType | ConversationMessageType;

export type ConversationForwardingEmailType = {
  readonly __typename?: 'ConversationForwardingEmailType';
  readonly emails?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum ConversationHomeDecision {
  Accepted = 'ACCEPTED',
  Edited = 'EDITED',
  Rejected = 'REJECTED'
}

export type ConversationMediaType = {
  readonly __typename?: 'ConversationMediaType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly sender: ResidentialManagementConversationMediaSenderChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};

export type ConversationMessageType = {
  readonly __typename?: 'ConversationMessageType';
  readonly body: Scalars['String']['output'];
  readonly contractorClassifications: ReadonlyArray<ContractorSuggestionType>;
  readonly conversation: ConversationNode;
  readonly conversationsummarySet: ConversationSummaryNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  /** Raw From header of the inbound email, including any display name */
  readonly fromEmailRaw?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  /** Quoted reply text from email */
  readonly quotedText?: Maybe<Scalars['String']['output']>;
  readonly scheduledSource: ReadonlyArray<ScheduledMessageType>;
  readonly seen?: Maybe<Scalars['Boolean']['output']>;
  readonly sender: ResidentialManagementConversationMessageSenderChoices;
  readonly suggestion?: Maybe<MessageSuggestionType>;
  readonly suggestions: ReadonlyArray<MessageSuggestionType>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};


export type ConversationMessageTypeConversationsummarySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationNode = {
  readonly __typename?: 'ConversationNode';
  readonly actions: ReadonlyArray<ConversationActionModelType>;
  readonly asanaTaskId?: Maybe<Scalars['String']['output']>;
  readonly assignment?: Maybe<ConversationAssignmentNode>;
  readonly assignments: ConversationAssignmentNodeConnection;
  readonly availableClientTags?: Maybe<ClientTagNodeConnection>;
  readonly availableTags?: Maybe<ConversationTagNodeConnection>;
  readonly availableTeams?: Maybe<TeamNodeConnection>;
  readonly category: ResidentialManagementConversationCategoryChoices;
  readonly closedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly closedBy?: Maybe<ResidentialManagementConversationClosedByChoices>;
  readonly closedByUser?: Maybe<UserType>;
  readonly closedReason?: Maybe<ResidentialManagementConversationClosedReasonChoices>;
  readonly community?: Maybe<CommunityNode>;
  readonly contractorSuggestion?: Maybe<ContractorSuggestionType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentStatus?: Maybe<Scalars['String']['output']>;
  readonly currentUrgency?: Maybe<Scalars['String']['output']>;
  /** Original email Message-ID for threading */
  readonly emailMessageId?: Maybe<Scalars['String']['output']>;
  readonly hasUnread: Scalars['Boolean']['output'];
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isResidentWaiting: Scalars['Boolean']['output'];
  readonly lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  readonly lastReopenedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly lastResidentMessageAt?: Maybe<Scalars['DateTime']['output']>;
  readonly lastStaffEventAt?: Maybe<Scalars['DateTime']['output']>;
  readonly latestEvent?: Maybe<ConversationEventType>;
  readonly latestMedia?: Maybe<ConversationMediaType>;
  readonly latestMessage?: Maybe<ConversationMessageType>;
  readonly latestOpen?: Maybe<ConversationOpenedType>;
  readonly latestStatus?: Maybe<ConversationStatusType>;
  readonly latestUpdatedDate?: Maybe<Scalars['DateTime']['output']>;
  readonly linkedTasks?: Maybe<ReadonlyArray<Maybe<TaskNode>>>;
  readonly media: ReadonlyArray<ConversationMediaType>;
  readonly messages: ReadonlyArray<ConversationMessageType>;
  readonly notes?: Maybe<ConversationNoteNodeConnection>;
  readonly notifications?: Maybe<ReadonlyArray<Maybe<ManagerNotificationType>>>;
  readonly openedCount?: Maybe<Scalars['Int']['output']>;
  readonly opens: ReadonlyArray<ConversationOpenedType>;
  readonly participantType: ResidentialManagementConversationParticipantTypeChoices;
  readonly rating?: Maybe<ConversationRatingType>;
  readonly ratingPresentation: RatingPresentationType;
  readonly ratingPromptDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly ratingPromptedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly ratingQuestions: ReadonlyArray<ConversationRatingQuestionType>;
  readonly reopenCount: Scalars['Int']['output'];
  readonly residency?: Maybe<ResidencyNode>;
  readonly resident?: Maybe<ResidentNode>;
  readonly responseTime?: Maybe<Scalars['Int']['output']>;
  /** Set while a re-tag run holds this conversation. Cleared when it finishes; a value older than the lease is treated as abandoned. */
  readonly retagClaimedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly scheduledMessages?: Maybe<ReadonlyArray<Maybe<ScheduledMessageType>>>;
  readonly snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  readonly source?: Maybe<Scalars['String']['output']>;
  readonly sourceApplicationThread?: Maybe<ApplicationThreadNode>;
  readonly statuses: ReadonlyArray<ConversationStatusType>;
  readonly subject: Scalars['String']['output'];
  readonly summaries: ConversationSummaryNodeConnection;
  readonly summary?: Maybe<ConversationSummaryNode>;
  readonly tagAssignments?: Maybe<TagAssignmentNodeConnection>;
  readonly tagSuggestions: ConversationTagSuggestionNodeConnection;
  readonly tags?: Maybe<ConversationTagNodeConnection>;
  readonly tasks: TaskNodeConnection;
  readonly teamAssignment?: Maybe<TeamAssignmentNode>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly urgencies: ReadonlyArray<ConversationUrgencyType>;
  readonly user?: Maybe<UserType>;
};


export type ConversationNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeAvailableClientTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ConversationNodeAvailableTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeAvailableTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ConversationNodeNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeSummariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeTagAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeTagSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedUser?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  dueDateAfter?: InputMaybe<Scalars['Date']['input']>;
  dueDateBefore?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  taskDefinition?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConversationNodeConnection = {
  readonly __typename?: 'ConversationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ConversationNode` and its cursor. */
export type ConversationNodeEdge = {
  readonly __typename?: 'ConversationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationNode>;
};

export type ConversationNoteMediaNode = {
  readonly __typename?: 'ConversationNoteMediaNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly user: UserType;
};

export type ConversationNoteNode = {
  readonly __typename?: 'ConversationNoteNode';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly media?: Maybe<ReadonlyArray<Maybe<ConversationNoteMediaNode>>>;
  readonly text: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};

export type ConversationNoteNodeConnection = {
  readonly __typename?: 'ConversationNoteNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationNoteNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationNoteNode` and its cursor. */
export type ConversationNoteNodeEdge = {
  readonly __typename?: 'ConversationNoteNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationNoteNode>;
};

export type ConversationOpenedType = {
  readonly __typename?: 'ConversationOpenedType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ConversationRatingAnswerSerializerInput = {
  readonly question: Scalars['String']['input'];
  readonly valueText: Scalars['String']['input'];
};

export type ConversationRatingAnswerType = {
  readonly __typename?: 'ConversationRatingAnswerType';
  readonly id: Scalars['UUID']['output'];
  readonly question: ConversationRatingQuestionType;
  readonly valueText: Scalars['String']['output'];
};

export type ConversationRatingQuestionType = {
  readonly __typename?: 'ConversationRatingQuestionType';
  readonly answerType: ResidentialManagementConversationRatingQuestionAnswerTypeChoices;
  readonly id: Scalars['UUID']['output'];
  readonly order: Scalars['Int']['output'];
  readonly questionText: Scalars['String']['output'];
};

export type ConversationRatingType = {
  readonly __typename?: 'ConversationRatingType';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly answers: ReadonlyArray<ConversationRatingAnswerType>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly displayStyle?: Maybe<ResidentialManagementConversationRatingDisplayStyleChoices>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly promptText: Scalars['String']['output'];
  readonly rating: Scalars['Int']['output'];
  readonly surface?: Maybe<ResidentialManagementConversationRatingSurfaceChoices>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ConversationReportingBlockTagNode = {
  readonly __typename?: 'ConversationReportingBlockTagNode';
  readonly blockId: Scalars['UUID']['output'];
  readonly blockLabel: Scalars['String']['output'];
  readonly count: Scalars['Int']['output'];
  readonly tagId: Scalars['UUID']['output'];
};

/** An enumeration. */
export enum ConversationReportingChannel {
  Ark = 'ARK',
  Email = 'EMAIL'
}

export type ConversationReportingChannelCountNode = {
  readonly __typename?: 'ConversationReportingChannelCountNode';
  readonly channel: ConversationReportingChannel;
  readonly count: Scalars['Int']['output'];
};

export type ConversationReportingCountNode = {
  readonly __typename?: 'ConversationReportingCountNode';
  readonly byDay: ReadonlyArray<ConversationReportingDayCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type ConversationReportingDayCountNode = {
  readonly __typename?: 'ConversationReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type ConversationReportingDayDurationNode = {
  readonly __typename?: 'ConversationReportingDayDurationNode';
  readonly day: Scalars['Date']['output'];
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type ConversationReportingDurationNode = {
  readonly __typename?: 'ConversationReportingDurationNode';
  readonly byDay: ReadonlyArray<ConversationReportingDayDurationNode>;
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type ConversationReportingHourCountNode = {
  readonly __typename?: 'ConversationReportingHourCountNode';
  readonly count: Scalars['Int']['output'];
  readonly hour: Scalars['Int']['output'];
  readonly weekday: Scalars['Int']['output'];
};

export type ConversationReportingMonthRatingNode = {
  readonly __typename?: 'ConversationReportingMonthRatingNode';
  readonly meanRating?: Maybe<Scalars['Float']['output']>;
  readonly month: Scalars['Date']['output'];
  readonly ratedCount: Scalars['Int']['output'];
};

export type ConversationReportingNode = {
  readonly __typename?: 'ConversationReportingNode';
  readonly blockTags: ReadonlyArray<ConversationReportingBlockTagNode>;
  readonly byChannel: ReadonlyArray<ConversationReportingChannelCountNode>;
  readonly bySenderCategory: ReadonlyArray<ConversationReportingSenderCategoryCountNode>;
  readonly closed: ConversationReportingCountNode;
  readonly firstResponse: ConversationReportingDurationNode;
  readonly openConversations: ConversationReportingOpenNode;
  readonly opened: ConversationReportingCountNode;
  readonly openedPattern: ReadonlyArray<ConversationReportingHourCountNode>;
  readonly ratedShare?: Maybe<Scalars['Float']['output']>;
  readonly reopened: ConversationReportingCountNode;
  readonly resolutionTime: ConversationReportingDurationNode;
  readonly responseTime: ConversationReportingDurationNode;
  readonly satisfaction: ConversationReportingSatisfactionNode;
  readonly satisfactionByMonth: ReadonlyArray<ConversationReportingMonthRatingNode>;
  readonly satisfactionByTopic: ReadonlyArray<ConversationReportingTopicSatisfactionNode>;
  readonly tagUseTotal: Scalars['Int']['output'];
  readonly topicComparison: ReadonlyArray<ConversationReportingTopicComparisonNode>;
  readonly topics: ReadonlyArray<ConversationReportingTopicNode>;
};

export type ConversationReportingOpenNode = {
  readonly __typename?: 'ConversationReportingOpenNode';
  readonly atEnd?: Maybe<ConversationReportingDayCountNode>;
  readonly byDay: ReadonlyArray<ConversationReportingDayCountNode>;
};

export type ConversationReportingSatisfactionNode = {
  readonly __typename?: 'ConversationReportingSatisfactionNode';
  readonly byStar: ReadonlyArray<ConversationReportingStarCountNode>;
  readonly meanRating?: Maybe<Scalars['Float']['output']>;
  readonly ratedCount: Scalars['Int']['output'];
};

/** An enumeration. */
export enum ConversationReportingSenderCategory {
  Contractor = 'CONTRACTOR',
  Internal = 'INTERNAL',
  Leaseholder = 'LEASEHOLDER',
  Resident = 'RESIDENT',
  Unknown = 'UNKNOWN'
}

export type ConversationReportingSenderCategoryCountNode = {
  readonly __typename?: 'ConversationReportingSenderCategoryCountNode';
  readonly count: Scalars['Int']['output'];
  readonly senderCategory: ConversationReportingSenderCategory;
};

export type ConversationReportingStarCountNode = {
  readonly __typename?: 'ConversationReportingStarCountNode';
  readonly count: Scalars['Int']['output'];
  readonly stars: Scalars['Int']['output'];
};

export type ConversationReportingTopicComparisonNode = {
  readonly __typename?: 'ConversationReportingTopicComparisonNode';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly tagId: Scalars['UUID']['output'];
  readonly yearAverage?: Maybe<Scalars['Float']['output']>;
};

export type ConversationReportingTopicNode = {
  readonly __typename?: 'ConversationReportingTopicNode';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly tagId: Scalars['UUID']['output'];
};

export type ConversationReportingTopicSatisfactionNode = {
  readonly __typename?: 'ConversationReportingTopicSatisfactionNode';
  readonly conversationCount: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly meanRating: Scalars['Float']['output'];
  readonly tagId: Scalars['UUID']['output'];
};

/** An enumeration. */
export enum ConversationRole {
  Concierge = 'Concierge',
  Leaseholder = 'Leaseholder',
  Manager = 'Manager',
  Resident = 'Resident'
}

export type ConversationStatusType = {
  readonly __typename?: 'ConversationStatusType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ConversationSummaryNode = {
  readonly __typename?: 'ConversationSummaryNode';
  readonly conversation: ConversationNode;
  readonly editedBy?: Maybe<UserType>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly message: ConversationMessageType;
  readonly summary: Scalars['String']['output'];
};

export type ConversationSummaryNodeConnection = {
  readonly __typename?: 'ConversationSummaryNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationSummaryNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationSummaryNode` and its cursor. */
export type ConversationSummaryNodeEdge = {
  readonly __typename?: 'ConversationSummaryNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationSummaryNode>;
};

export type ConversationTagNode = {
  readonly __typename?: 'ConversationTagNode';
  readonly client: ClientType;
  readonly color?: Maybe<Scalars['String']['output']>;
  readonly conversations: ConversationNodeConnection;
  readonly deletedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSelected?: Maybe<Scalars['Boolean']['output']>;
  readonly name: Scalars['String']['output'];
  readonly suggested?: Maybe<Scalars['Boolean']['output']>;
};


export type ConversationTagNodeConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  resident?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  subject_Icontains?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversationTagNodeConnection = {
  readonly __typename?: 'ConversationTagNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationTagNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ConversationTagNode` and its cursor. */
export type ConversationTagNodeEdge = {
  readonly __typename?: 'ConversationTagNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationTagNode>;
};

export type ConversationTagSuggestionNode = {
  readonly __typename?: 'ConversationTagSuggestionNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly tag: ConversationTagNode;
};

export type ConversationTagSuggestionNodeConnection = {
  readonly __typename?: 'ConversationTagSuggestionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationTagSuggestionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationTagSuggestionNode` and its cursor. */
export type ConversationTagSuggestionNodeEdge = {
  readonly __typename?: 'ConversationTagSuggestionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationTagSuggestionNode>;
};

export type ConversationUrgencyType = {
  readonly __typename?: 'ConversationUrgencyType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly urgency?: Maybe<Scalars['String']['output']>;
};

export type CorrectInspectionSeriesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly complianceType: Compliance_Type;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CorrectInspectionSeriesPayload = {
  readonly __typename?: 'CorrectInspectionSeriesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly documentExtraction?: Maybe<DocumentExtractionNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CountersignAgreementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CountersignAgreementPayload = {
  readonly __typename?: 'CountersignAgreementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type CreateAgreementForTenancyInput = {
  readonly additionalTerms?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly furnished?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly landlordAddress?: InputMaybe<Scalars['String']['input']>;
  readonly residency?: InputMaybe<Scalars['String']['input']>;
  readonly utilitiesIncluded?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAgreementForTenancyPayload = {
  readonly __typename?: 'CreateAgreementForTenancyPayload';
  readonly additionalTerms?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly furnished?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly residency?: Maybe<Scalars['String']['output']>;
  readonly utilitiesIncluded?: Maybe<Scalars['String']['output']>;
};

export type CreateAmenityReservationMutationInput = {
  readonly amenityId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly timeSlots: ReadonlyArray<InputMaybe<Scalars['DateTime']['input']>>;
};

export type CreateAmenityReservationMutationPayload = {
  readonly __typename?: 'CreateAmenityReservationMutationPayload';
  readonly amenity?: Maybe<AmenityNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateApplicantAndApplicationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['UUID']['input'];
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly home: Scalars['UUID']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly ownershipType: Scalars['String']['input'];
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicantAndApplicationPayload = {
  readonly __typename?: 'CreateApplicantAndApplicationPayload';
  readonly applicant?: Maybe<ApplicantNode>;
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateApplicationInput = {
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly isResident?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastName: Scalars['String']['input'];
  readonly moveInDate?: InputMaybe<Scalars['Date']['input']>;
  readonly ownershipType?: InputMaybe<Scalars['String']['input']>;
  readonly postcode: Scalars['String']['input'];
  readonly region?: InputMaybe<Scalars['String']['input']>;
  readonly townOrCity?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationPayload = {
  readonly __typename?: 'CreateApplicationPayload';
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly isResident?: Maybe<Scalars['Boolean']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly moveInDate?: Maybe<Scalars['Date']['output']>;
  readonly ownershipType?: Maybe<Scalars['String']['output']>;
  readonly postcode?: Maybe<Scalars['String']['output']>;
  readonly region?: Maybe<Scalars['String']['output']>;
  readonly townOrCity?: Maybe<Scalars['String']['output']>;
};

export type CreateApplicationThreadMutationInput = {
  readonly applicationId: Scalars['UUID']['input'];
  readonly body: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationThreadMutationPayload = {
  readonly __typename?: 'CreateApplicationThreadMutationPayload';
  readonly applicationThread?: Maybe<ApplicationThreadNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateAttachmentOnHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homeId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAttachmentOnHomePayload = {
  readonly __typename?: 'CreateAttachmentOnHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly homeId?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type CreateAttachmentOnRequirementItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly requirementItemId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAttachmentOnRequirementItemPayload = {
  readonly __typename?: 'CreateAttachmentOnRequirementItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly requirementItemId?: Maybe<Scalars['String']['output']>;
};

export type CreateBlockComplianceRequirementItemInput = {
  readonly blockComplianceRequirements: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly expiryDate: Scalars['Date']['input'];
};

export type CreateBlockComplianceRequirementItemPayload = {
  readonly __typename?: 'CreateBlockComplianceRequirementItemPayload';
  readonly blockComplianceRequirementItem?: Maybe<BlockComplianceRequirementItemNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateBlockGroupSuggestionsInput = {
  readonly block: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBlockGroupSuggestionsPayload = {
  readonly __typename?: 'CreateBlockGroupSuggestionsPayload';
  readonly blockGroupSuggestions?: Maybe<ReadonlyArray<Maybe<BlockGroupSuggestionNode>>>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateBlocks = {
  readonly __typename?: 'CreateBlocks';
  readonly blocks?: Maybe<ReadonlyArray<Maybe<BlockNode>>>;
};

export type CreateBlocksComplianceRequirementInput = {
  readonly blocks: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly shared: Scalars['Boolean']['input'];
};

export type CreateBlocksComplianceRequirementPayload = {
  readonly __typename?: 'CreateBlocksComplianceRequirementPayload';
  readonly blocksComplianceRequirement?: Maybe<BlocksComplianceRequirementNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateChecklistFromTemplateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly taskId: Scalars['String']['input'];
  readonly templateId: Scalars['String']['input'];
};

export type CreateChecklistFromTemplatePayload = {
  readonly __typename?: 'CreateChecklistFromTemplatePayload';
  readonly checklist?: Maybe<TaskChecklistNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateChecklistInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly requiresSignOff?: InputMaybe<Scalars['Boolean']['input']>;
  readonly task: Scalars['String']['input'];
};

export type CreateChecklistItemCommentInput = {
  readonly body: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly item: Scalars['String']['input'];
};

export type CreateChecklistItemCommentPayload = {
  readonly __typename?: 'CreateChecklistItemCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskChecklistItemComment?: Maybe<TaskChecklistItemCommentNode>;
};

export type CreateChecklistItemMediaInput = {
  readonly checklistItem: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly response?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChecklistItemMediaPayload = {
  readonly __typename?: 'CreateChecklistItemMediaPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskChecklistItemMedia?: Maybe<TaskChecklistItemMediaNode>;
};

export type CreateChecklistPayload = {
  readonly __typename?: 'CreateChecklistPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskChecklist?: Maybe<TaskChecklistNode>;
};

export type CreateChecklistWithStructureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly kind?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly requiresSignOff?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sections: ReadonlyArray<ChecklistSectionInput>;
  readonly taskId: Scalars['UUID']['input'];
};

export type CreateChecklistWithStructurePayload = {
  readonly __typename?: 'CreateChecklistWithStructurePayload';
  readonly checklist?: Maybe<TaskChecklistNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCheckoutLinkInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly subscription: Scalars['UUID']['input'];
};

export type CreateCheckoutLinkPayload = {
  readonly __typename?: 'CreateCheckoutLinkPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly url: Scalars['String']['output'];
};

export type CreateClientContractorCompanyInput = {
  readonly client?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClientContractorCompanyPayload = {
  readonly __typename?: 'CreateClientContractorCompanyPayload';
  readonly clientContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateClientTagInput = {
  readonly client?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly color?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

export type CreateClientTagPayload = {
  readonly __typename?: 'CreateClientTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientTag?: Maybe<ClientTagNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
  readonly viewers?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityDocumentPayload = {
  readonly __typename?: 'CreateCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityDocumentReminderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityDocumentReminderPayload = {
  readonly __typename?: 'CreateCommunityDocumentReminderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocumentReminder?: Maybe<CommunityDocumentReminderNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityDocumentTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly objectId: Scalars['String']['input'];
};

export type CreateCommunityDocumentTagPayload = {
  readonly __typename?: 'CreateCommunityDocumentTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly tag?: Maybe<TagNode>;
};

export type CreateCommunityDocumentViewInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityDocumentViewPayload = {
  readonly __typename?: 'CreateCommunityDocumentViewPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocumentView?: Maybe<CommunityDocumentViewNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityProductInput = {
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly description: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateCommunityProductPayload = {
  readonly __typename?: 'CreateCommunityProductPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityProduct?: Maybe<CommunityProductNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityProductPaymentInput = {
  readonly amount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityProductId: Scalars['UUID']['input'];
};

export type CreateCommunityProductPaymentPayload = {
  readonly __typename?: 'CreateCommunityProductPaymentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly payment: PaymentNode;
  readonly stripeClientSecret: Scalars['String']['output'];
};

export type CreateCommunityTaskDefinitionInput = {
  readonly block?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly taskDefinition: Scalars['String']['input'];
  readonly taskGroup?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityTaskDefinitionPayload = {
  readonly __typename?: 'CreateCommunityTaskDefinitionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityTaskDefinition?: Maybe<CommunityTaskDefinitionNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityUpdateReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityUpdate: Scalars['String']['input'];
};

export type CreateCommunityUpdateReadPayload = {
  readonly __typename?: 'CreateCommunityUpdateReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityVisitorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['UUID']['input'];
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly companyAddress?: InputMaybe<Scalars['String']['input']>;
  readonly companyType?: InputMaybe<Scalars['String']['input']>;
  readonly companyWebsite?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
  readonly reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  readonly residentName?: InputMaybe<Scalars['String']['input']>;
  readonly type?: InputMaybe<Scalars['String']['input']>;
  readonly vehicleRegistration?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityVisitorPayload = {
  readonly __typename?: 'CreateCommunityVisitorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityVisitor?: Maybe<CommunityVisitorNode>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateComplianceRequirementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly frequencyText?: InputMaybe<Scalars['String']['input']>;
  readonly homes: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly name: Scalars['String']['input'];
  readonly renewalFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type CreateComplianceRequirementPayload = {
  readonly __typename?: 'CreateComplianceRequirementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly complianceRequirements?: Maybe<ReadonlyArray<Maybe<ComplianceRequirementNode>>>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly frequencyText?: Maybe<Scalars['String']['output']>;
  readonly homes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly renewalFrequency?: Maybe<Scalars['String']['output']>;
};

export type CreateComplianceUpdateReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly update: Scalars['String']['input'];
};

export type CreateComplianceUpdateReadPayload = {
  readonly __typename?: 'CreateComplianceUpdateReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly update?: Maybe<Scalars['String']['output']>;
};

export type CreateContractorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContractorPayload = {
  readonly __typename?: 'CreateContractorPayload';
  readonly clientContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateConversation = {
  readonly __typename?: 'CreateConversation';
  readonly conversation?: Maybe<ConversationNode>;
};

export type CreateConversationActionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly extra?: InputMaybe<Scalars['JSONString']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly type: Scalars['String']['input'];
};

export type CreateConversationActionPayload = {
  readonly __typename?: 'CreateConversationActionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<Scalars['String']['output']>;
  readonly createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly extra?: Maybe<Scalars['JSONString']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
};

export type CreateConversationAndFirstMessage = {
  readonly __typename?: 'CreateConversationAndFirstMessage';
  readonly conversation?: Maybe<ConversationNode>;
};

export type CreateConversationAndFirstMessageInput = {
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly homeId: Scalars['UUID']['input'];
};

export type CreateConversationAssignmentInput = {
  readonly assignedTo: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['UUID']['input'];
};

export type CreateConversationAssignmentPayload = {
  readonly __typename?: 'CreateConversationAssignmentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationAssignment?: Maybe<ConversationAssignmentNode>;
};

export type CreateConversationInput = {
  readonly category: Scalars['String']['input'];
  readonly comments?: InputMaybe<Scalars['String']['input']>;
  readonly contactId?: InputMaybe<Scalars['UUID']['input']>;
  readonly homeId?: InputMaybe<Scalars['UUID']['input']>;
  readonly residencyId?: InputMaybe<Scalars['UUID']['input']>;
  readonly residentId?: InputMaybe<Scalars['UUID']['input']>;
  readonly subject?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConversationMessage = {
  readonly __typename?: 'CreateConversationMessage';
  readonly conversation?: Maybe<ConversationNode>;
  readonly message?: Maybe<ConversationMessageType>;
  readonly scheduled?: Maybe<Scalars['Boolean']['output']>;
  readonly scheduledMessageId?: Maybe<Scalars['UUID']['output']>;
};

export type CreateConversationMessageInput = {
  readonly body: Scalars['String']['input'];
  readonly conversationId: Scalars['UUID']['input'];
  readonly reopen?: InputMaybe<Scalars['Boolean']['input']>;
  readonly suggestionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateConversationNoteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly text: Scalars['String']['input'];
};

export type CreateConversationNotePayload = {
  readonly __typename?: 'CreateConversationNotePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationNote?: Maybe<ConversationNoteNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateConversationSummaryInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly summary: Scalars['String']['input'];
};

export type CreateConversationSummaryPayload = {
  readonly __typename?: 'CreateConversationSummaryPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationSummary?: Maybe<ConversationSummaryNode>;
};

export type CreateConversationTagInput = {
  readonly client?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConversationTagPayload = {
  readonly __typename?: 'CreateConversationTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type CreateFollowUpTaskFromChecklistItemInput = {
  readonly assignedUser?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly itemId: Scalars['UUID']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFollowUpTaskFromChecklistItemPayload = {
  readonly __typename?: 'CreateFollowUpTaskFromChecklistItemPayload';
  readonly checklistItem?: Maybe<TaskChecklistItemNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly created: Scalars['Boolean']['output'];
  readonly task?: Maybe<TaskNode>;
};

export type CreateFollowUpTasksFromChecklistItemsInput = {
  readonly assignedUser?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly itemIds: ReadonlyArray<Scalars['UUID']['input']>;
};

export type CreateFollowUpTasksFromChecklistItemsPayload = {
  readonly __typename?: 'CreateFollowUpTasksFromChecklistItemsPayload';
  readonly checklistItems?: Maybe<ReadonlyArray<TaskChecklistItemNode>>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly createdCount: Scalars['Int']['output'];
  readonly existingCount: Scalars['Int']['output'];
  readonly tasks?: Maybe<ReadonlyArray<TaskNode>>;
};

export type CreateGroupChatMessageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupChat: Scalars['String']['input'];
  readonly repliedTo?: InputMaybe<Scalars['String']['input']>;
  readonly text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGroupChatMessagePayload = {
  readonly __typename?: 'CreateGroupChatMessagePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groupChatMessage?: Maybe<GroupChatMessageNode>;
};

export type CreateGroupChatMessageReactionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupChatMessage?: InputMaybe<Scalars['String']['input']>;
  readonly reaction: Scalars['String']['input'];
};

export type CreateGroupChatMessageReactionPayload = {
  readonly __typename?: 'CreateGroupChatMessageReactionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groupChatMessageReaction?: Maybe<GroupChatMessageReactionNode>;
};

export type CreateGroupChatMessageReportInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly reason: Scalars['String']['input'];
};

export type CreateGroupChatMessageReportPayload = {
  readonly __typename?: 'CreateGroupChatMessageReportPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groupChatMessageReport?: Maybe<GroupChatMessageReportNode>;
};

export type CreateGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly users?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateGroupPayload = {
  readonly __typename?: 'CreateGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly homes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly users?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
};

export type CreateKeyV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly home?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly image?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly reference?: InputMaybe<Scalars['String']['input']>;
};

export type CreateKeyV2Payload = {
  readonly __typename?: 'CreateKeyV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type CreateKeyholderV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly key: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateKeyholderV2Payload = {
  readonly __typename?: 'CreateKeyholderV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type CreateManagerConversationReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly unread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateManagerConversationReadPayload = {
  readonly __typename?: 'CreateManagerConversationReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly unread?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateManagerSafetyDeclarationInput = {
  readonly braille: Scalars['Boolean']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communicationNeedDeclared: Scalars['Boolean']['input'];
  readonly communicationNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly consent?: InputMaybe<ConsentAttestationInput>;
  readonly contactEmail?: InputMaybe<Scalars['String']['input']>;
  readonly declaredAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly first?: InputMaybe<Scalars['String']['input']>;
  readonly isOccupant: Scalars['Boolean']['input'];
  readonly language?: InputMaybe<Scalars['String']['input']>;
  readonly largePrint: Scalars['Boolean']['input'];
  readonly last?: InputMaybe<Scalars['String']['input']>;
  readonly mobilityNeedDeclared: Scalars['Boolean']['input'];
  readonly mobilityNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly origin: ManagerDeclarationOrigin;
  readonly recordId?: InputMaybe<Scalars['UUID']['input']>;
  readonly residencyId: Scalars['UUID']['input'];
  readonly textToSpeech: Scalars['Boolean']['input'];
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateManagerSafetyDeclarationPayload = {
  readonly __typename?: 'CreateManagerSafetyDeclarationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly declaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly needsReconciliation: Scalars['Boolean']['output'];
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type CreateMarketplaceItemCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment: Scalars['String']['input'];
  readonly item: Scalars['String']['input'];
};

/**
 * Left ungated by Access V2 deliberately.
 *
 * ``MarketplaceItemComment`` has no entry in ``RESOURCE_REGISTRY`` and no row
 * in the role matrix, and none of the three registered marketplace resources
 * describes it. ``marketplace_item`` is the closest, but its ownership policy
 * scopes a resident to listings they own, so gating a public comment on it
 * would deny commenting on anyone else's listing once the rollout flag is on
 * — a regression, not a narrowing. Inventing a ``marketplace_item_comment``
 * resource is out of scope for this pathway, so the legacy
 * ``IsResidentOrLeaseholder`` check stands alone until one is added.
 */
export type CreateMarketplaceItemCommentPayload = {
  readonly __typename?: 'CreateMarketplaceItemCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly item?: Maybe<Scalars['String']['output']>;
};

export type CreateMarketplaceItemThreadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly item: Scalars['UUID']['input'];
  readonly message: Scalars['String']['input'];
};

export type CreateMarketplaceItemThreadPayload = {
  readonly __typename?: 'CreateMarketplaceItemThreadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly marketplaceItemThread?: Maybe<MarketplaceItemThreadNode>;
};

export type CreateNewDevice = {
  readonly __typename?: 'CreateNewDevice';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateNewDeviceInput = {
  readonly platform?: InputMaybe<Scalars['String']['input']>;
  readonly token: Scalars['String']['input'];
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOccupancySurvey = {
  readonly __typename?: 'CreateOccupancySurvey';
  readonly occupancySurvey?: Maybe<OccupancySurveyNode>;
};

export type CreateOpenedConversation = {
  readonly __typename?: 'CreateOpenedConversation';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOpenedConversationInput = {
  readonly conversationId: Scalars['UUID']['input'];
};

export type CreateOrUpdateUserSessionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly sessionTarget: Session_Target;
};

export type CreateOrUpdateUserSessionPayload = {
  readonly __typename?: 'CreateOrUpdateUserSessionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly userSession?: Maybe<UserSessionNode>;
};

export type CreatePaymentInput = {
  readonly amount: Scalars['Decimal']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly paymentAccount?: InputMaybe<Scalars['UUID']['input']>;
  readonly paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentPayload = {
  readonly __typename?: 'CreatePaymentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly payment: PaymentNode;
  readonly stripeClientSecret: Scalars['String']['output'];
};

export type CreateReportingConfigurationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly configuration: Scalars['JSONString']['input'];
  readonly favourite: Scalars['Boolean']['input'];
  readonly name: Scalars['String']['input'];
  readonly reportKey: Scalars['String']['input'];
  readonly schemaVersion: Scalars['Int']['input'];
  readonly sourceId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateReportingConfigurationPayload = {
  readonly __typename?: 'CreateReportingConfigurationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly configuration: ReportingConfigurationNode;
};

export type CreateResidencyAndResidents = {
  readonly __typename?: 'CreateResidencyAndResidents';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
  readonly residency?: Maybe<ResidencyNode>;
};

export type CreateResidencyDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly residency: Scalars['String']['input'];
};

export type CreateResidencyDocumentPayload = {
  readonly __typename?: 'CreateResidencyDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residencyDocument?: Maybe<ResidencyDocumentNode>;
};

export type CreateResidencyDocumentViewInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateResidencyDocumentViewPayload = {
  readonly __typename?: 'CreateResidencyDocumentViewPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residencyDocumentView?: Maybe<ResidencyDocumentViewNode>;
};

export type CreateResidencyDocuments = {
  readonly __typename?: 'CreateResidencyDocuments';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateResidencyDocumentsInput = {
  readonly complianceItems?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly customComplianceItems?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly residencyId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateResidencySubscriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly methods?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly paymentStartDate?: InputMaybe<Scalars['Date']['input']>;
  readonly residencyId: Scalars['String']['input'];
};

export type CreateResidencySubscriptionPayload = {
  readonly __typename?: 'CreateResidencySubscriptionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly methods?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly paymentStartDate?: Maybe<Scalars['Date']['output']>;
  readonly residencyId?: Maybe<Scalars['String']['output']>;
};

export type CreateResidentSafetyRecordInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly records: ReadonlyArray<InputMaybe<ResidentSafetyRecordInput>>;
  readonly residencyId: Scalars['UUID']['input'];
};

/**
 * Submit (or re-submit) the household's safety records.
 *
 * Decoupled from consent: this mutation only persists declared needs and
 * audits NEEDS_SUBMITTED / NEEDS_UPDATED / OCCUPANT_REMOVED. Consent is
 * captured via the dedicated GiveSafetyConsent / DeclineSafetyConsent
 * mutations called separately from the resident app.
 */
export type CreateResidentSafetyRecordPayload = {
  readonly __typename?: 'CreateResidentSafetyRecordPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly residentSafetyRecords?: Maybe<ReadonlyArray<Maybe<ResidentSafetyRecordNode>>>;
};

export type CreateRuleActionInput = {
  readonly action: Action;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly objectId: Scalars['String']['input'];
  readonly rule: Scalars['String']['input'];
};

export type CreateRuleActionPayload = {
  readonly __typename?: 'CreateRuleActionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly ruleAction?: Maybe<RuleActionNode>;
};

export type CreateRuleConditions = {
  readonly __typename?: 'CreateRuleConditions';
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly ruleConditions?: Maybe<ReadonlyArray<Maybe<RuleConditionNode>>>;
};

export type CreateRuleConditionsInput = {
  readonly event: Scalars['String']['input'];
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly operator: Scalars['String']['input'];
  readonly ruleId: Scalars['UUID']['input'];
};

export type CreateRuleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

export type CreateRulePayload = {
  readonly __typename?: 'CreateRulePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly rule?: Maybe<RuleNode>;
};

export type CreateSafetyCenterDocumentInput = {
  readonly block?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly includeInSibPack?: InputMaybe<Scalars['Boolean']['input']>;
  readonly showInSafetyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sibCategory?: InputMaybe<Sib_Category>;
  readonly sourceDocument?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

export type CreateSafetyCenterDocumentPayload = {
  readonly __typename?: 'CreateSafetyCenterDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
};

export type CreateScheduledMessageInput = {
  readonly body: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly sendAt: Scalars['DateTime']['input'];
  readonly sender: Sender;
};

export type CreateScheduledMessagePayload = {
  readonly __typename?: 'CreateScheduledMessagePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly scheduledMessage?: Maybe<ScheduledMessageType>;
  readonly scheduledMessageId?: Maybe<Scalars['UUID']['output']>;
};

export type CreateStripeAccount = {
  readonly __typename?: 'CreateStripeAccount';
  readonly client?: Maybe<ClientType>;
};

export type CreateSurveyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly options?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly question: Scalars['String']['input'];
};

export type CreateSurveyPayload = {
  readonly __typename?: 'CreateSurveyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly options?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly question?: Maybe<Scalars['String']['output']>;
};

export type CreateTaskDefinitionInput = {
  readonly assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  readonly categoryId?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityId: Scalars['UUID']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly name: Scalars['String']['input'];
  readonly priority?: InputMaybe<Scalars['String']['input']>;
  readonly taskTemplateId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateTaskDefinitionPayload = {
  readonly __typename?: 'CreateTaskDefinitionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type CreateTaskDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityDocument?: InputMaybe<Scalars['String']['input']>;
  readonly task?: InputMaybe<Scalars['String']['input']>;
  readonly taskGroup?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

export type CreateTaskDocumentPayload = {
  readonly __typename?: 'CreateTaskDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskDocument?: Maybe<TaskDocumentNode>;
};

export type CreateTaskFromConversationInput = {
  readonly addAsWatcher?: InputMaybe<Scalars['Boolean']['input']>;
  readonly assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  readonly categoryId?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly name: Scalars['String']['input'];
  readonly priority?: InputMaybe<Scalars['String']['input']>;
  readonly taskTemplateId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateTaskFromConversationPayload = {
  readonly __typename?: 'CreateTaskFromConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type CreateTaskGroupInput = {
  readonly assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  readonly categoryId?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityId: Scalars['UUID']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly generationHorizonDays?: InputMaybe<Scalars['Int']['input']>;
  readonly name: Scalars['String']['input'];
  readonly priority?: InputMaybe<Scalars['String']['input']>;
  readonly schedule: Scalars['JSONString']['input'];
  readonly startDate: Scalars['Date']['input'];
  readonly taskTemplateId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateTaskGroupPayload = {
  readonly __typename?: 'CreateTaskGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly taskGroup?: Maybe<TaskGroupNode>;
  readonly tasksCreatedCount?: Maybe<Scalars['Int']['output']>;
};

export type CreateTaskInput = {
  readonly assignedTeamId?: InputMaybe<Scalars['UUID']['input']>;
  readonly assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  readonly categoryId?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly scheduledFor?: InputMaybe<Scalars['Date']['input']>;
  readonly status?: InputMaybe<Scalars['String']['input']>;
  readonly taskDefinitionId: Scalars['UUID']['input'];
};

export type CreateTaskPayload = {
  readonly __typename?: 'CreateTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
};

export type CreateTaskTemplateInput = {
  readonly autoCompleteTask?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientId?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityIds?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly pdfExportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly requiresSignOff?: InputMaybe<Scalars['Boolean']['input']>;
  readonly scope?: InputMaybe<Scalars['String']['input']>;
  readonly sections?: InputMaybe<ReadonlyArray<TaskTemplateSectionInput>>;
};

export type CreateTaskTemplatePayload = {
  readonly __typename?: 'CreateTaskTemplatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
};

export type CreateTeamInput = {
  readonly client?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTeamPayload = {
  readonly __typename?: 'CreateTeamPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type CreateTemplateFromChecklistInput = {
  readonly checklistId: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTemplateFromChecklistPayload = {
  readonly __typename?: 'CreateTemplateFromChecklistPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
};

export type CreateTenancyApplicationInput = {
  readonly applicants?: InputMaybe<ReadonlyArray<InputMaybe<Applicants>>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homeId?: InputMaybe<Scalars['UUID']['input']>;
  readonly rentAmount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateTenancyApplicationPayload = {
  readonly __typename?: 'CreateTenancyApplicationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tenancyApplication?: Maybe<TenancyApplicationNode>;
};

export type CreateUpdateCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment: Scalars['String']['input'];
  readonly updateId: Scalars['UUID']['input'];
  readonly userType: Scalars['String']['input'];
};

export type CreateUpdateCommentPayload = {
  readonly __typename?: 'CreateUpdateCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdateComment?: Maybe<CommunityUpdateCommentNode>;
};

export type CreateUserDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
  readonly users: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type CreateUserDocumentPayload = {
  readonly __typename?: 'CreateUserDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly userDocument?: Maybe<UserDocumentNode>;
};

export type CreateUserDocumentTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly objectId: Scalars['String']['input'];
};

export type CreateUserDocumentTagPayload = {
  readonly __typename?: 'CreateUserDocumentTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly tag?: Maybe<TagNode>;
};

export type CreateUserDocumentViewInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserDocumentViewPayload = {
  readonly __typename?: 'CreateUserDocumentViewPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly userDocumentView?: Maybe<UserDocumentViewNode>;
};

export type CreditCheckNode = {
  readonly __typename?: 'CreditCheckNode';
  readonly activeBankruptcies: Scalars['Int']['output'];
  readonly activeCountyCourtJudgements: Scalars['Int']['output'];
  readonly aliases: ReadonlyArray<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly riskLevel?: Maybe<Scalars['String']['output']>;
  readonly score: Scalars['Int']['output'];
  readonly totalBankruptcies: Scalars['Int']['output'];
  readonly totalCountyCourtJudgements: Scalars['Int']['output'];
};

export type DeactivateClientUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

export type DeactivateClientUserPayload = {
  readonly __typename?: 'DeactivateClientUserPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientUser?: Maybe<ClientUserNode>;
};

export type DeactivateGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeactivateGroupPayload = {
  readonly __typename?: 'DeactivateGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityGroup?: Maybe<CommunityGroupNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DebugSchema = {
  readonly __typename?: 'DebugSchema';
  readonly _debug?: Maybe<DjangoDebug>;
  readonly accountTransactions?: Maybe<AccountTransactionNodeConnection>;
  readonly agreement?: Maybe<GeneratedAgreementNode>;
  readonly agreements?: Maybe<GeneratedAgreementNodeConnection>;
  readonly amenities?: Maybe<AmenityNodeConnection>;
  readonly amenity?: Maybe<AmenityNode>;
  readonly amenityOperatingTime?: Maybe<AmenityOperatingTimesNode>;
  readonly amenityOperatingTimes?: Maybe<AmenityOperatingTimesNodeConnection>;
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly amenityReservations?: Maybe<AmenityReservationNodeConnection>;
  readonly applicant?: Maybe<ApplicantNode>;
  readonly application?: Maybe<ApplicationNode>;
  readonly applicationDecisionStats?: Maybe<ApplicationDecisionStatsType>;
  readonly applicationSupportThreadByApplication?: Maybe<ApplicationSupportThreadNode>;
  readonly applicationThread?: Maybe<ApplicationThreadNode>;
  readonly applicationThreadByApplication?: Maybe<ApplicationThreadNode>;
  readonly applicationThreadMedia?: Maybe<ApplicationThreadMediaNodeConnection>;
  readonly applicationThreadMessages?: Maybe<ApplicationThreadMessageNodeConnection>;
  readonly applications?: Maybe<ApplicationNodeConnection>;
  readonly asanaPendingTasks?: Maybe<AsanaPendingTaskNodeConnection>;
  readonly asanaPendingTasksCount: Scalars['Int']['output'];
  readonly block?: Maybe<BlockNode>;
  readonly blockComplianceRequirement?: Maybe<BlockComplianceRequirementNode>;
  readonly blockComplianceRequirements?: Maybe<BlockComplianceRequirementNodeConnection>;
  readonly blockGroupSuggestion?: Maybe<BlockGroupSuggestionNode>;
  readonly blockGroupSuggestions?: Maybe<BlockGroupSuggestionNodeConnection>;
  readonly blockSuggestion?: Maybe<BlockSuggestionNode>;
  readonly blockSuggestions?: Maybe<BlockSuggestionNodeConnection>;
  readonly blocks?: Maybe<BlockNodeConnection>;
  readonly budget?: Maybe<BudgetNode>;
  readonly budgets?: Maybe<BudgetNodeConnection>;
  readonly bulkConversationActionJob?: Maybe<BulkConversationActionJobNode>;
  readonly bulkDeactivationJob?: Maybe<BulkDeactivationJobNode>;
  readonly checklistActionSource?: Maybe<ChecklistActionSourceNode>;
  readonly clientContractorCompanies?: Maybe<ClientContractorCompanyNodeConnection>;
  readonly clientContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly clientStaffDirectory: ReadonlyArray<ClientStaffDirectoryMemberType>;
  readonly clientStaffMembers?: Maybe<ClientStaffMemberNodeConnection>;
  readonly clientTag?: Maybe<ClientTagNode>;
  readonly clientTags?: Maybe<ClientTagNodeConnection>;
  readonly clientUser?: Maybe<ClientUserNode>;
  readonly clientUserById?: Maybe<ClientUserNode>;
  readonly clientUsers?: Maybe<ClientUserNodeConnection>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly community?: Maybe<CommunityNode>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  readonly communityDocumentReminders?: Maybe<CommunityDocumentReminderNodeConnection>;
  readonly communityDocuments?: Maybe<CommunityDocumentNodeConnection>;
  readonly communityEvent?: Maybe<CommunityEventNode>;
  readonly communityEventParties?: Maybe<CommunityEventPartyNodeConnection>;
  readonly communityEventParty?: Maybe<CommunityEventPartyNode>;
  readonly communityEvents?: Maybe<CommunityEventNodeConnection>;
  readonly communityForm?: Maybe<CommunityFormNode>;
  readonly communityForms?: Maybe<CommunityFormNodeConnection>;
  readonly communityGroup?: Maybe<CommunityGroupNode>;
  readonly communityGroups?: Maybe<CommunityGroupNodeConnection>;
  readonly communityGroupsAll?: Maybe<CommunityGroupNodeConnection>;
  readonly communityProduct?: Maybe<CommunityProductNode>;
  readonly communityProductPurchases?: Maybe<CommunityProductPurchaseNodeConnection>;
  readonly communityProducts?: Maybe<CommunityProductNodeConnection>;
  readonly communityStaffCandidates: ReadonlyArray<CommunityStaffCandidateType>;
  readonly communityStaffRoles: ReadonlyArray<CommunityStaffRoleType>;
  readonly communityTask?: Maybe<CommunityTaskNode>;
  readonly communityTaskDefinition?: Maybe<CommunityTaskDefinitionNode>;
  readonly communityTaskDefinitions?: Maybe<CommunityTaskDefinitionNodeConnection>;
  readonly communityTasks?: Maybe<CommunityTaskNodeConnection>;
  readonly communityTeamMembersBulk?: Maybe<ReadonlyArray<CommunityTeamMembersGroupType>>;
  readonly communityUpdate?: Maybe<CommunityUpdateNode>;
  readonly communityUpdates?: Maybe<CommunityUpdateNodeConnection>;
  readonly communityVisitor?: Maybe<CommunityVisitorNode>;
  readonly communityVisitors?: Maybe<CommunityVisitorNodeConnection>;
  readonly complianceRequirement?: Maybe<ComplianceRequirementNode>;
  readonly complianceRequirements?: Maybe<ComplianceRequirementNodeConnection>;
  readonly contact?: Maybe<ContactNode>;
  readonly contactNote?: Maybe<ContactNoteNode>;
  readonly contactNotes?: Maybe<ContactNoteNodeConnection>;
  readonly contacts?: Maybe<ContactNodeConnection>;
  readonly conversation?: Maybe<ConversationNode>;
  readonly conversationCounts?: Maybe<ConversationCountsNode>;
  readonly conversationTag?: Maybe<ConversationTagNode>;
  readonly conversationTags?: Maybe<ConversationTagNodeConnection>;
  readonly conversations?: Maybe<ConversationNodeConnection>;
  readonly dashboard?: Maybe<CommunityDashboardType>;
  readonly document?: Maybe<DocumentNode>;
  readonly documentExtraction?: Maybe<DocumentExtractionNode>;
  readonly documentExtractions?: Maybe<DocumentExtractionNodeConnection>;
  readonly documents?: Maybe<DocumentNodeConnection>;
  readonly employerReference?: Maybe<EmployerReferenceNode>;
  readonly featureAnnouncement?: Maybe<FeatureAnnouncementNode>;
  readonly featureAnnouncementBySlug?: Maybe<FeatureAnnouncementNode>;
  readonly featureAnnouncements?: Maybe<FeatureAnnouncementNodeConnection>;
  readonly findComplianceUpdate?: Maybe<ComplianceUpdateType>;
  readonly findHome?: Maybe<HomeType>;
  readonly findSection21?: Maybe<GeneratedSection21Type>;
  readonly findTenancyAgreement?: Maybe<GeneratedAgreementType>;
  readonly getClient?: Maybe<ClientType>;
  readonly getClientAdmin?: Maybe<ClientAdminNode>;
  readonly getFixfloIssue?: Maybe<FixfloIssueType>;
  readonly getLandlord?: Maybe<LandlordNode>;
  readonly getLeaseholder?: Maybe<LeaseholderNode>;
  readonly getManager?: Maybe<ManagerType>;
  readonly getMe?: Maybe<ResidentType>;
  readonly getUser?: Maybe<UserType>;
  readonly globalFeatures?: Maybe<ReadonlyArray<Maybe<GlobalFeatureType>>>;
  readonly groupChat?: Maybe<GroupChatNode>;
  readonly groupChatMessage?: Maybe<GroupChatMessageNode>;
  readonly groupChatMessageReaction?: Maybe<GroupChatMessageReactionNode>;
  readonly groupChatMessageReactions?: Maybe<GroupChatMessageReactionNodeConnection>;
  readonly groupChatMessageReport?: Maybe<GroupChatMessageReportNode>;
  readonly groupChatMessageReports?: Maybe<GroupChatMessageReportNodeConnection>;
  readonly groupChatMessages?: Maybe<GroupChatMessageNodeConnection>;
  readonly groupChats?: Maybe<GroupChatNodeConnection>;
  readonly home?: Maybe<HomeNode>;
  readonly homes?: Maybe<HomeNodeConnection>;
  readonly invoice?: Maybe<InvoiceNode>;
  readonly invoices?: Maybe<InvoiceNodeConnection>;
  readonly key?: Maybe<KeyNode>;
  readonly keyholder?: Maybe<KeyholderNode>;
  readonly keyholders?: Maybe<KeyholderNodeConnection>;
  readonly keys?: Maybe<KeyNodeConnection>;
  readonly landlordAttachment?: Maybe<LandlordAttachmentNode>;
  readonly landlordDocuments?: Maybe<ReadonlyArray<Maybe<LandlordDocumentNode>>>;
  readonly landlordReference?: Maybe<LandlordReferenceNode>;
  readonly leanNotifications?: Maybe<LeanNotificationNodeConnection>;
  readonly leasehold?: Maybe<LeaseholdNode>;
  readonly leaseholdSchedule?: Maybe<LeaseholdScheduleNode>;
  readonly leaseholdSchedules?: Maybe<LeaseholdScheduleNodeConnection>;
  readonly leaseholds?: Maybe<LeaseholdNodeConnection>;
  readonly legacySafetyCenterDocument?: Maybe<PublicSafetyCenterDocumentType>;
  readonly legacySafetyPack?: Maybe<PublicSafetyPackType>;
  readonly listComplianceUpdates?: Maybe<ReadonlyArray<ComplianceUpdateType>>;
  readonly listHomes?: Maybe<ReadonlyArray<HomeType>>;
  readonly listResidencies?: Maybe<ReadonlyArray<ResidencyType>>;
  readonly marketplaceItem?: Maybe<MarketplaceItemNode>;
  readonly marketplaceItemThread?: Maybe<MarketplaceItemThreadNode>;
  readonly marketplaceItemThreadMessage?: Maybe<MarketplaceItemThreadMessageNode>;
  readonly marketplaceItemThreadMessages?: Maybe<MarketplaceItemThreadMessageNodeConnection>;
  readonly marketplaceItemThreads?: Maybe<MarketplaceItemThreadNodeConnection>;
  readonly marketplaceItems?: Maybe<MarketplaceItemNodeConnection>;
  readonly myOpenSafetyReviewRequests: ReadonlyArray<SafetyReviewRequestNode>;
  readonly notification?: Maybe<NotificationNode>;
  readonly notifications?: Maybe<NotificationNodeConnection>;
  readonly occupancySurvey?: Maybe<OccupancySurveyNode>;
  readonly occupancySurveys?: Maybe<OccupancySurveyNodeConnection>;
  readonly package?: Maybe<PackageNode>;
  readonly packages?: Maybe<PackageNodeConnection>;
  readonly packagesExport?: Maybe<Scalars['String']['output']>;
  readonly payment?: Maybe<PaymentNode>;
  readonly paymentAccount?: Maybe<PaymentAccountNode>;
  readonly paymentAccounts?: Maybe<PaymentAccountNodeConnection>;
  readonly productCosts?: Maybe<ProductCosts>;
  readonly profile?: Maybe<ProfileType>;
  readonly publicSafetyCenterDocument?: Maybe<PublicSafetyCenterDocumentType>;
  readonly publicSafetyPack?: Maybe<PublicSafetyPackType>;
  readonly ratingPromptConversation?: Maybe<ConversationNode>;
  readonly reportingApplications: ApplicationReportingNode;
  readonly reportingBookings: BookingReportingNode;
  readonly reportingConfiguration?: Maybe<ReportingConfigurationNode>;
  readonly reportingConfigurations: ReadonlyArray<ReportingConfigurationNode>;
  readonly reportingConversations: ConversationReportingNode;
  readonly reportingDocuments: DocumentReportingNode;
  readonly reportingKeys: KeyReportingNode;
  readonly reportingPackages: PackageReportingNode;
  readonly reportingPortfolioEngagement: PortfolioEngagementReportingNode;
  readonly reportingPortfolioMaintenance: PortfolioMaintenanceReportingNode;
  readonly reportingPortfolioSatisfaction: PortfolioSatisfactionReportingNode;
  readonly reportingTeamActivity: TeamActivityReportingNode;
  readonly reportingTeamApplications: TeamApplicationReportingNode;
  readonly reportingTeamConversations: TeamConversationReportingNode;
  readonly reportingTeamDocuments: TeamDocumentReportingNode;
  readonly reportingTeamMembers: ReadonlyArray<TeamRosterMemberNode>;
  readonly reportingTeamUpdates: TeamUpdateReportingNode;
  readonly reportingUpdates: UpdateReportingNode;
  readonly reportingVisits: VisitReportingNode;
  readonly residencies?: Maybe<ResidencyNodeConnection>;
  readonly residency?: Maybe<ResidencyNode>;
  readonly resident?: Maybe<ResidentNode>;
  readonly residentAppNotificationPreferences?: Maybe<ResidentAppNotificationPreferencesNode>;
  readonly residentSafetyDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly residentSafetyDeclarations?: Maybe<ResidentSafetyDeclarationNodeConnection>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
  readonly residentSafetyRecords?: Maybe<ResidentSafetyRecordNodeConnection>;
  readonly residentTask?: Maybe<ResidentTaskNode>;
  readonly residentTasks?: Maybe<ResidentTaskNodeConnection>;
  readonly residents?: Maybe<ResidentNodeConnection>;
  readonly rule?: Maybe<RuleNode>;
  readonly rules?: Maybe<RuleNodeConnection>;
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
  readonly safetyCenterDocuments?: Maybe<SafetyCenterDocumentNodeConnection>;
  readonly safetyHousehold?: Maybe<SafetyHouseholdType>;
  readonly safetyPortfolio: ReadonlyArray<SafetyCommunityReadinessType>;
  readonly safetyReadiness: ReadonlyArray<SafetyBlockReadinessType>;
  readonly safetyRoster?: Maybe<SafetyRosterType>;
  readonly schedule?: Maybe<ScheduleNode>;
  readonly scheduleFinancialYear?: Maybe<ScheduleFinancialYearNode>;
  readonly scheduleFinancialYearCategoryTotal?: Maybe<ScheduleFinancialYearCategoryTotalNode>;
  readonly scheduleFinancialYearCategoryTotals?: Maybe<ScheduleFinancialYearCategoryTotalNodeConnection>;
  readonly scheduleFinancialYears?: Maybe<ScheduleFinancialYearNodeConnection>;
  readonly schedules?: Maybe<ScheduleNodeConnection>;
  readonly searchAsanaTasks?: Maybe<ReadonlyArray<Maybe<AsanaTaskSearchResultType>>>;
  readonly searchEpc?: Maybe<ReadonlyArray<EpcResponseType>>;
  readonly section21?: Maybe<GeneratedSection21Node>;
  readonly signature?: Maybe<AgreementSignatureNode>;
  readonly staffRoleCatalog: ReadonlyArray<StaffRoleCatalogType>;
  readonly survey?: Maybe<ResidentSurveyNode>;
  readonly surveys?: Maybe<ResidentSurveyNodeConnection>;
  readonly tag?: Maybe<TagNode>;
  readonly tags?: Maybe<TagNodeConnection>;
  readonly task?: Maybe<TaskNode>;
  readonly taskCategories?: Maybe<TaskCategoryNodeConnection>;
  readonly taskCategory?: Maybe<TaskCategoryNode>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
  readonly taskDefinitions?: Maybe<TaskDefinitionNodeConnection>;
  readonly taskGroup?: Maybe<TaskGroupNode>;
  readonly taskGroups?: Maybe<TaskGroupNodeConnection>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
  readonly taskTemplates?: Maybe<TaskTemplateNodeConnection>;
  readonly tasks?: Maybe<TaskNodeConnection>;
  readonly team?: Maybe<TeamNode>;
  readonly teams?: Maybe<TeamNodeConnection>;
  readonly tenancyApplicant?: Maybe<TenancyApplicantNode>;
  readonly tenancyApplication?: Maybe<TenancyApplicationNode>;
  readonly tenancyApplications?: Maybe<TenancyApplicationNodeConnection>;
  readonly tenantReference?: Maybe<TenantReferenceNode>;
  readonly tenantReferences?: Maybe<TenantReferenceNodeConnection>;
  readonly userFeatureAnnouncements?: Maybe<UserFeatureAnnouncementNodeConnection>;
  readonly userNotificationPreference?: Maybe<UserNotificationPreferenceNode>;
  readonly userNotificationPreferences?: Maybe<UserNotificationPreferenceNodeConnection>;
  readonly userSession?: Maybe<UserSessionNode>;
  readonly userSessions?: Maybe<UserSessionNodeConnection>;
  readonly waiver?: Maybe<WaiverNode>;
  readonly waivers?: Maybe<WaiverNodeConnection>;
};


export type DebugSchemaAccountTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaAgreementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaAmenitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaAmenityArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaAmenityOperatingTimeArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaAmenityOperatingTimesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaAmenityReservationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaAmenityReservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amenity?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaApplicantArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaApplicationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaApplicationDecisionStatsArgs = {
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
};


export type DebugSchemaApplicationSupportThreadByApplicationArgs = {
  applicationId: Scalars['UUID']['input'];
};


export type DebugSchemaApplicationThreadArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaApplicationThreadByApplicationArgs = {
  applicationId: Scalars['UUID']['input'];
};


export type DebugSchemaApplicationThreadMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaApplicationThreadMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaAsanaPendingTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaAsanaPendingTasksCountArgs = {
  communityIds: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};


export type DebugSchemaBlockArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaBlockComplianceRequirementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaBlockComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaBlockGroupSuggestionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaBlockGroupSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaBlockSuggestionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaBlockSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBlock?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  latestPerNameCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaBudgetArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaBudgetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaBulkConversationActionJobArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaBulkDeactivationJobArgs = {
  id: Scalars['UUID']['input'];
};


export type DebugSchemaChecklistActionSourceArgs = {
  actionId: Scalars['UUID']['input'];
};


export type DebugSchemaClientContractorCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaClientContractorCompanyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaClientStaffDirectoryArgs = {
  clientId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaClientStaffMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  excludeTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
};


export type DebugSchemaClientTagArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaClientTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaClientUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaClientUserByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type DebugSchemaClientUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  excludeCommunities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
};


export type DebugSchemaCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityDocumentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityDocumentRemindersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaCommunityDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityEventArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityEventPartiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventEndDateAfter?: InputMaybe<Scalars['Date']['input']>;
  event_Start?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityEventPartyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDateAfter?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  partyUsers?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityFormArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaCommunityGroupArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaCommunityGroupsAllArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaCommunityProductArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityProductPurchasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaCommunityProductsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityStaffCandidatesArgs = {
  communityId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityStaffRolesArgs = {
  communityId: Scalars['UUID']['input'];
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DebugSchemaCommunityTaskArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityTaskDefinitionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityTaskDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  taskDefinition?: InputMaybe<Scalars['UUID']['input']>;
  taskGroup?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaCommunityTeamMembersBulkArgs = {
  communityIds: ReadonlyArray<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityUpdateArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityUpdatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['UUID']['input']>;
  hasLinkedFeature?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userBookmarked?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityVisitorArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityVisitorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onSite?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  signedOut?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaComplianceRequirementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaContactArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaContactNoteArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaContactNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allowApplicants?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaConversationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaConversationCountsArgs = {
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaConversationTagArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaConversationTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  resident?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<ConversationRole>;
  source?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  subject_Icontains?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaDashboardArgs = {
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
};


export type DebugSchemaDocumentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaDocumentExtractionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaDocumentExtractionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  complianceTypes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  tags2?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaEmployerReferenceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFeatureAnnouncementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFeatureAnnouncementBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type DebugSchemaFeatureAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaFindComplianceUpdateArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFindHomeArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFindSection21Args = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFindTenancyAgreementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGetFixfloIssueArgs = {
  communityId: Scalars['UUID']['input'];
  issueRef: Scalars['String']['input'];
};


export type DebugSchemaGroupChatArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGroupChatMessageArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGroupChatMessageReactionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGroupChatMessageReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaGroupChatMessageReportArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGroupChatMessageReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaGroupChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupChat?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaGroupChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaHomeArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaHomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBlock?: InputMaybe<Scalars['Boolean']['input']>;
  hasUncollected?: InputMaybe<Scalars['Boolean']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
  includeDemoHomes?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  missingFloor?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  packagesStatus?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  trigramSearch?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaInvoiceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isCredit?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaKeyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaKeyholderArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaKeyholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasCurrentKeyholder?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  search2?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaLandlordAttachmentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLandlordDocumentsArgs = {
  homeId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLandlordReferenceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLeanNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaLeaseholdArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLeaseholdScheduleArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLeaseholdSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaLeaseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaLegacySafetyCenterDocumentArgs = {
  communityId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
};


export type DebugSchemaLegacySafetyPackArgs = {
  communityId: Scalars['UUID']['input'];
};


export type DebugSchemaListComplianceUpdatesArgs = {
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DebugSchemaListHomesArgs = {
  communityId?: InputMaybe<Scalars['UUID']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaListResidenciesArgs = {
  communityId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaMarketplaceItemArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaMarketplaceItemThreadArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaMarketplaceItemThreadMessageArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaMarketplaceItemThreadMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaMarketplaceItemThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasMessages?: InputMaybe<Scalars['Boolean']['input']>;
  item?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaMarketplaceItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaNotificationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaOccupancySurveyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaOccupancySurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPackageArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPackagesExportArgs = {
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaPaymentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPaymentAccountArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPaymentAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communityActive?: InputMaybe<Scalars['Boolean']['input']>;
  communityPaymentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaPublicSafetyCenterDocumentArgs = {
  id: Scalars['UUID']['input'];
  token: Scalars['UUID']['input'];
};


export type DebugSchemaPublicSafetyPackArgs = {
  token: Scalars['UUID']['input'];
};


export type DebugSchemaRatingPromptConversationArgs = {
  surface: RatingPromptSurface;
};


export type DebugSchemaReportingApplicationsArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingBookingsArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingConfigurationArgs = {
  id: Scalars['UUID']['input'];
};


export type DebugSchemaReportingConversationsArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  tags?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingDocumentsArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  tags?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingKeysArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingPackagesArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingPortfolioEngagementArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingPortfolioMaintenanceArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingPortfolioSatisfactionArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingTeamActivityArgs = {
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingTeamApplicationsArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingTeamConversationsArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingTeamDocumentsArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingTeamUpdatesArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingUpdatesArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingVisitsArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  visitorTypes?: InputMaybe<ReadonlyArray<VisitReportingVisitorType>>;
};


export type DebugSchemaResidenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  referenceSent?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type DebugSchemaResidencyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentSafetyDeclarationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentSafetyDeclarationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  record?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentSafetyRecordArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentSafetyRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  eesStatus?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasNeeds?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pcfraStatus?: InputMaybe<Scalars['String']['input']>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentTaskArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaResidentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  notDownloaded?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  scanData?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withRating?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DebugSchemaRuleArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaSafetyCenterDocumentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaSafetyCenterDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  communityWide?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forBlock?: InputMaybe<Scalars['UUID']['input']>;
  includeInSibPack?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  showInSafetyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  sibCategory?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaSafetyHouseholdArgs = {
  residencyId: Scalars['UUID']['input'];
};


export type DebugSchemaSafetyPortfolioArgs = {
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
};


export type DebugSchemaSafetyReadinessArgs = {
  community: Scalars['UUID']['input'];
};


export type DebugSchemaSafetyRosterArgs = {
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  cohort?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  eesStatus?: InputMaybe<Scalars['String']['input']>;
  eesStatuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  issue?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pcfraStatus?: InputMaybe<Scalars['String']['input']>;
  pcfraStatuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaScheduleArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaScheduleFinancialYearArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaScheduleFinancialYearCategoryTotalArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaScheduleFinancialYearCategoryTotalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaScheduleFinancialYearsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaSearchAsanaTasksArgs = {
  communityId: Scalars['UUID']['input'];
  query: Scalars['String']['input'];
};


export type DebugSchemaSearchEpcArgs = {
  homeId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaSection21Args = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaSignatureArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaStaffRoleCatalogArgs = {
  communityId: Scalars['UUID']['input'];
};


export type DebugSchemaSurveyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaSurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLink?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaTagArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaTaskArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTaskCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaTaskCategoryArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTaskDefinitionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTaskDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaTaskGroupArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTaskGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaTaskTemplateArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTaskTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedUser?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  dueDateAfter?: InputMaybe<Scalars['Date']['input']>;
  dueDateBefore?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  taskDefinition?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTeamArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaTenancyApplicantArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTenancyApplicationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTenancyApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenSent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaTenantReferenceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTenantReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenSent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaUserFeatureAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaUserNotificationPreferenceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaUserNotificationPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaUserSessionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaUserSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaWaiverArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaWaiversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeclinePcfra = {
  readonly __typename?: 'DeclinePcfra';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

/** Resident declines (for now) a PCFRA against a specific safety record. */
export type DeclineSafetyConsent = {
  readonly __typename?: 'DeclineSafetyConsent';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type DeleteAmenityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAmenityPayload = {
  readonly __typename?: 'DeleteAmenityPayload';
  readonly amenity?: Maybe<AmenityNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteApplicant = {
  readonly __typename?: 'DeleteApplicant';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAttachmentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAttachmentPayload = {
  readonly __typename?: 'DeleteAttachmentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteChecklistInput = {
  readonly checklistId: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteChecklistItemMediaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly mediaId: Scalars['String']['input'];
};

export type DeleteChecklistItemMediaPayload = {
  readonly __typename?: 'DeleteChecklistItemMediaPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedMediaId?: Maybe<Scalars['UUID']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteChecklistPayload = {
  readonly __typename?: 'DeleteChecklistPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedChecklistId?: Maybe<Scalars['UUID']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteCommunityDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCommunityDocumentPayload = {
  readonly __typename?: 'DeleteCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteCommunityProductInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCommunityProductPayload = {
  readonly __typename?: 'DeleteCommunityProductPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityProduct?: Maybe<CommunityProductNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteCommunityUpdateAttachmentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type DeleteCommunityUpdateAttachmentPayload = {
  readonly __typename?: 'DeleteCommunityUpdateAttachmentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdateAttachment?: Maybe<CommunityUpdateAttachmentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteCommunityUpdateCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCommunityUpdateCommentPayload = {
  readonly __typename?: 'DeleteCommunityUpdateCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type DeleteCommunityUpdatePayload = {
  readonly __typename?: 'DeleteCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteComplianceRequirementV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteComplianceRequirementV2Payload = {
  readonly __typename?: 'DeleteComplianceRequirementV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteConversationTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
};

export type DeleteConversationTagPayload = {
  readonly __typename?: 'DeleteConversationTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationTag?: Maybe<ConversationTagNode>;
};

export type DeleteGroupChatMessageReactionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteGroupChatMessageReactionPayload = {
  readonly __typename?: 'DeleteGroupChatMessageReactionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groupChatMessageReaction?: Maybe<GroupChatMessageReactionNode>;
};

export type DeleteHomeImageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type DeleteHomeImagePayload = {
  readonly __typename?: 'DeleteHomeImagePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type DeleteHomePayload = {
  readonly __typename?: 'DeleteHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteMarketplaceItemImageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Hard-delete one image from a listing.
 *
 * ``IsOwnerOfMarketplaceItemImage`` is the fix for a live hole: this
 * mutation shipped with ``permission_classes = []``, so any authenticated
 * user could delete any listing's image. That fix sits at the legacy layer
 * on purpose — the Access V2 requirement below is inert until
 * ``ACCESS_RBAC_BACKED`` is on and so closes nothing today.
 */
export type DeleteMarketplaceItemImagePayload = {
  readonly __typename?: 'DeleteMarketplaceItemImagePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly marketplaceItemImage?: Maybe<MarketplaceItemImageNode>;
};

export type DeleteReportingConfigurationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
};

export type DeleteReportingConfigurationPayload = {
  readonly __typename?: 'DeleteReportingConfigurationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedId: Scalars['UUID']['output'];
};

export type DeleteRuleActionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteRuleActionPayload = {
  readonly __typename?: 'DeleteRuleActionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly ruleAction?: Maybe<RuleActionNode>;
};

export type DeleteRuleConditionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteRuleConditionPayload = {
  readonly __typename?: 'DeleteRuleConditionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly ruleCondition?: Maybe<RuleConditionNode>;
};

export type DismissAsanaPendingTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly pendingId: Scalars['UUID']['input'];
};

export type DismissAsanaPendingTaskPayload = {
  readonly __typename?: 'DismissAsanaPendingTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly pending?: Maybe<AsanaPendingTaskNode>;
};

export type DismissFeatureAnnouncementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly featureAnnouncementId: Scalars['UUID']['input'];
};

export type DismissFeatureAnnouncementPayload = {
  readonly __typename?: 'DismissFeatureAnnouncementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly featureAnnouncementView?: Maybe<FeatureAnnouncementViewNode>;
};

/** Debugging information for the current query. */
export type DjangoDebug = {
  readonly __typename?: 'DjangoDebug';
  /** Raise exceptions for this API query. */
  readonly exceptions?: Maybe<ReadonlyArray<Maybe<DjangoDebugException>>>;
  /** Executed SQL queries for this API query. */
  readonly sql?: Maybe<ReadonlyArray<Maybe<DjangoDebugSql>>>;
};

/** Represents a single exception raised. */
export type DjangoDebugException = {
  readonly __typename?: 'DjangoDebugException';
  /** The class of the exception */
  readonly excType: Scalars['String']['output'];
  /** The message of the exception */
  readonly message: Scalars['String']['output'];
  /** The stack trace */
  readonly stack: Scalars['String']['output'];
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
  readonly __typename?: 'DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  readonly alias: Scalars['String']['output'];
  /** Duration of this database query in seconds. */
  readonly duration: Scalars['Float']['output'];
  /** Postgres connection encoding if available. */
  readonly encoding?: Maybe<Scalars['String']['output']>;
  /** Whether this database query was a SELECT. */
  readonly isSelect: Scalars['Boolean']['output'];
  /** Whether this database query took more than 10 seconds. */
  readonly isSlow: Scalars['Boolean']['output'];
  /** Postgres isolation level if available. */
  readonly isoLevel?: Maybe<Scalars['String']['output']>;
  /** JSON encoded database query parameters. */
  readonly params: Scalars['String']['output'];
  /** The raw SQL of this query, without params. */
  readonly rawSql: Scalars['String']['output'];
  /** The actual SQL sent to this database. */
  readonly sql?: Maybe<Scalars['String']['output']>;
  /** Start time of this database query. */
  readonly startTime: Scalars['Float']['output'];
  /** Stop time of this database query. */
  readonly stopTime: Scalars['Float']['output'];
  /** Postgres transaction ID if available. */
  readonly transId?: Maybe<Scalars['String']['output']>;
  /** Postgres transaction status if available. */
  readonly transStatus?: Maybe<Scalars['String']['output']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  readonly vendor: Scalars['String']['output'];
};

export type DocumentContent = CommunityDocumentNode | ResidencyDocumentNode | UserDocumentNode;

export type DocumentExtractionNode = {
  readonly __typename?: 'DocumentExtractionNode';
  readonly community: CommunityNode;
  readonly complianceType?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly extractedTaskId?: Maybe<Scalars['UUID']['output']>;
  readonly extractedTemplate?: Maybe<TaskTemplateNode>;
  readonly extractionConfidence?: Maybe<Scalars['Float']['output']>;
  readonly failedStage?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly fileName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly mode: ResidentialManagementDocumentExtractionModeChoices;
  readonly overviewNarrative: Scalars['String']['output'];
  readonly overviewStats: InspectionOverviewStatsNode;
  readonly parseStrategy?: Maybe<ResidentialManagementDocumentExtractionParseStrategyChoices>;
  readonly progress?: Maybe<ReadonlyArray<ExtractionStageEventType>>;
  readonly sourceDocument?: Maybe<SourceDocumentNode>;
  readonly status: ResidentialManagementDocumentExtractionStatusChoices;
  readonly statusMessage?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly validationVerdict?: Maybe<Scalars['String']['output']>;
};

export type DocumentExtractionNodeConnection = {
  readonly __typename?: 'DocumentExtractionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<DocumentExtractionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `DocumentExtractionNode` and its cursor. */
export type DocumentExtractionNodeEdge = {
  readonly __typename?: 'DocumentExtractionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<DocumentExtractionNode>;
};

export type DocumentNode = {
  readonly __typename?: 'DocumentNode';
  readonly contentObject?: Maybe<DocumentContent>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type DocumentNodeConnection = {
  readonly __typename?: 'DocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<DocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `DocumentNode` and its cursor. */
export type DocumentNodeEdge = {
  readonly __typename?: 'DocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<DocumentNode>;
};

export type DocumentReportingAgeCountNode = {
  readonly __typename?: 'DocumentReportingAgeCountNode';
  readonly count: Scalars['Int']['output'];
  readonly maxDays?: Maybe<Scalars['Int']['output']>;
  readonly minDays: Scalars['Int']['output'];
};

export type DocumentReportingAllViewedNode = {
  readonly __typename?: 'DocumentReportingAllViewedNode';
  readonly audienceCount: Scalars['Int']['output'];
  readonly residentCount: Scalars['Int']['output'];
  readonly share?: Maybe<Scalars['Float']['output']>;
  readonly viewedAllCount: Scalars['Int']['output'];
};

export type DocumentReportingCountNode = {
  readonly __typename?: 'DocumentReportingCountNode';
  readonly byDay: ReadonlyArray<DocumentReportingDayCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type DocumentReportingDayCountNode = {
  readonly __typename?: 'DocumentReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type DocumentReportingHourCountNode = {
  readonly __typename?: 'DocumentReportingHourCountNode';
  readonly count: Scalars['Int']['output'];
  readonly hour: Scalars['Int']['output'];
  readonly weekday: Scalars['Int']['output'];
};

export type DocumentReportingLiveNode = {
  readonly __typename?: 'DocumentReportingLiveNode';
  readonly count: Scalars['Int']['output'];
  readonly viewedCount: Scalars['Int']['output'];
  readonly viewedShare?: Maybe<Scalars['Float']['output']>;
};

export type DocumentReportingNeverViewedNode = {
  readonly __typename?: 'DocumentReportingNeverViewedNode';
  readonly byAge: ReadonlyArray<DocumentReportingAgeCountNode>;
  readonly total: Scalars['Int']['output'];
};

export type DocumentReportingNode = {
  readonly __typename?: 'DocumentReportingNode';
  readonly added: DocumentReportingCountNode;
  readonly allViewed: DocumentReportingAllViewedNode;
  readonly firstViews: ReadonlyArray<DocumentReportingHourCountNode>;
  readonly live: DocumentReportingLiveNode;
  readonly liveByDay: ReadonlyArray<DocumentReportingDayCountNode>;
  readonly mostViewed: ReadonlyArray<DocumentReportingTopDocumentNode>;
  readonly neverViewed: DocumentReportingNeverViewedNode;
  readonly reach: ReadonlyArray<DocumentReportingReachNode>;
  readonly reminders: DocumentReportingCountNode;
  readonly tags: ReadonlyArray<DocumentReportingTagNode>;
  readonly uniqueViewers: Scalars['Int']['output'];
};

export type DocumentReportingReachNode = {
  readonly __typename?: 'DocumentReportingReachNode';
  readonly audienceCount: Scalars['Int']['output'];
  readonly documentId: Scalars['UUID']['output'];
  readonly share: Scalars['Float']['output'];
  readonly title: Scalars['String']['output'];
  readonly viewerCount: Scalars['Int']['output'];
};

export type DocumentReportingTagNode = {
  readonly __typename?: 'DocumentReportingTagNode';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly tagId: Scalars['UUID']['output'];
};

export type DocumentReportingTopDocumentNode = {
  readonly __typename?: 'DocumentReportingTopDocumentNode';
  readonly documentId: Scalars['UUID']['output'];
  readonly title: Scalars['String']['output'];
  readonly viewerCount: Scalars['Int']['output'];
};

export type DocumentVerificationResultNode = {
  readonly __typename?: 'DocumentVerificationResultNode';
  readonly addressMatchDetail?: Maybe<Scalars['String']['output']>;
  readonly addressMatchStatus?: Maybe<ResidentialManagementDocumentVerificationResultAddressMatchStatusChoices>;
  readonly aiRecommendation?: Maybe<ResidentialManagementDocumentVerificationResultAiRecommendationChoices>;
  readonly appearsAuthentic?: Maybe<Scalars['Boolean']['output']>;
  readonly authenticityDetail?: Maybe<Scalars['String']['output']>;
  readonly confidence?: Maybe<Scalars['Float']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly documentType?: Maybe<Scalars['String']['output']>;
  readonly extractedAddress?: Maybe<Scalars['String']['output']>;
  readonly extractedName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isProofOfAddress: Scalars['Boolean']['output'];
  readonly nameMatchDetail?: Maybe<Scalars['String']['output']>;
  readonly nameMatchStatus?: Maybe<ResidentialManagementDocumentVerificationResultNameMatchStatusChoices>;
  readonly status: ResidentialManagementDocumentVerificationResultStatusChoices;
};

export type DownloadRateType = {
  readonly __typename?: 'DownloadRateType';
  readonly date?: Maybe<Scalars['Date']['output']>;
  readonly downloadRate?: Maybe<Scalars['Float']['output']>;
};

export type EpcResponseType = {
  readonly __typename?: 'EPCResponseType';
  readonly checkedDate: Scalars['String']['output'];
  readonly city: Scalars['String']['output'];
  readonly currentEnergyEfficiency: Scalars['String']['output'];
  readonly currentEnergyRating: Scalars['String']['output'];
  readonly expiryDate: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly postcode: Scalars['String']['output'];
  readonly potentialEnergyEfficiency: Scalars['String']['output'];
  readonly potentialEnergyRating: Scalars['String']['output'];
};

export type EditKeyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly home?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly image?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly reference?: InputMaybe<Scalars['String']['input']>;
};

export type EditKeyPayload = {
  readonly __typename?: 'EditKeyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type EditMemberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly email: Scalars['String']['input'];
  readonly role: Scalars['String']['input'];
};

export type EditMemberPayload = {
  readonly __typename?: 'EditMemberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communities?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly role?: Maybe<Scalars['String']['output']>;
};

export type EmployerReferenceNode = {
  readonly __typename?: 'EmployerReferenceNode';
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly employeeInputtedCompanyName?: Maybe<Scalars['String']['output']>;
  readonly employeeName?: Maybe<Scalars['String']['output']>;
  readonly employerEmploymentDetails?: Maybe<EmploymentDetailsNode>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<TenancyApplicationEmployerReferenceStepChoices>;
  readonly submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmployerUpdateEmploymentDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly employerReferenceId: Scalars['String']['input'];
  readonly employmentEnding?: InputMaybe<Scalars['Boolean']['input']>;
  readonly employmentType?: InputMaybe<Scalars['String']['input']>;
  readonly fullOrPartTime?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly income?: InputMaybe<Scalars['Decimal']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly paymentFrequency?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type EmployerUpdateEmploymentDetailsPayload = {
  readonly __typename?: 'EmployerUpdateEmploymentDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly employmentEnding?: Maybe<Scalars['Boolean']['output']>;
  readonly employmentType?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly fullOrPartTime?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly income?: Maybe<Scalars['Decimal']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly paymentFrequency?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['Date']['output']>;
};

export type EmployerUpdatePersonalDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type EmployerUpdatePersonalDetailsPayload = {
  readonly __typename?: 'EmployerUpdatePersonalDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly companyName?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
};

export type EmploymentDetailsNode = {
  readonly __typename?: 'EmploymentDetailsNode';
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly employmentEnding?: Maybe<Scalars['Boolean']['output']>;
  readonly employmentType: TenancyApplicationEmploymentDetailsEmploymentTypeChoices;
  readonly fullOrPartTime?: Maybe<TenancyApplicationEmploymentDetailsFullOrPartTimeChoices>;
  readonly id: Scalars['UUID']['output'];
  readonly income?: Maybe<Scalars['Decimal']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly paymentFrequency?: Maybe<TenancyApplicationEmploymentDetailsPaymentFrequencyChoices>;
  readonly startDate?: Maybe<Scalars['Date']['output']>;
};

export type ErrorType = {
  readonly __typename?: 'ErrorType';
  readonly field: Scalars['String']['output'];
  readonly messages: ReadonlyArray<Scalars['String']['output']>;
};

export type ExternalPortalUrlType = {
  readonly __typename?: 'ExternalPortalUrlType';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};

export type ExtractionStageEventType = {
  readonly __typename?: 'ExtractionStageEventType';
  readonly at?: Maybe<Scalars['String']['output']>;
  readonly detail?: Maybe<Scalars['String']['output']>;
  readonly stage: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
};

export type FakeCreditCheckMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly creditSafePayload: Scalars['String']['input'];
  readonly tenantReferenceId: Scalars['UUID']['input'];
};

export type FakeCreditCheckMutationPayload = {
  readonly __typename?: 'FakeCreditCheckMutationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tenantReference: TenantReferenceNode;
};

export type FakeSendTenantReferenceRequestInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly tenantReferenceId: Scalars['UUID']['input'];
};

export type FakeSendTenantReferenceRequestPayload = {
  readonly __typename?: 'FakeSendTenantReferenceRequestPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tenantReference: TenantReferenceNode;
};

export type FakeStripeInvoicePaidEventInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly invoiceId: Scalars['String']['input'];
};

export type FakeStripeInvoicePaidEventPayload = {
  readonly __typename?: 'FakeStripeInvoicePaidEventPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly invoice?: Maybe<InvoiceNode>;
};

export type FeatureAnnouncementNode = {
  readonly __typename?: 'FeatureAnnouncementNode';
  readonly body: Scalars['JSONString']['output'];
  readonly communities: CommunityNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentUserView?: Maybe<FeatureAnnouncementViewNode>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly slug: Scalars['String']['output'];
  readonly stats: FeatureAnnouncementStatsType;
  readonly subtitle: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly views?: Maybe<FeatureAnnouncementViewNodeConnection>;
};


export type FeatureAnnouncementNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type FeatureAnnouncementNodeViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type FeatureAnnouncementNodeConnection = {
  readonly __typename?: 'FeatureAnnouncementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<FeatureAnnouncementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FeatureAnnouncementNode` and its cursor. */
export type FeatureAnnouncementNodeEdge = {
  readonly __typename?: 'FeatureAnnouncementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<FeatureAnnouncementNode>;
};

export type FeatureAnnouncementStatsType = {
  readonly __typename?: 'FeatureAnnouncementStatsType';
  readonly acceptanceCount: Scalars['Int']['output'];
  readonly acceptanceRate: Scalars['Float']['output'];
  readonly dismissalCount: Scalars['Int']['output'];
  readonly viewCount: Scalars['Int']['output'];
};

export type FeatureAnnouncementViewNode = {
  readonly __typename?: 'FeatureAnnouncementViewNode';
  readonly acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly featureAnnouncement: FeatureAnnouncementNode;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly viewedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly viewedBy: UserType;
};

export type FeatureAnnouncementViewNodeConnection = {
  readonly __typename?: 'FeatureAnnouncementViewNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<FeatureAnnouncementViewNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FeatureAnnouncementViewNode` and its cursor. */
export type FeatureAnnouncementViewNodeEdge = {
  readonly __typename?: 'FeatureAnnouncementViewNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<FeatureAnnouncementViewNode>;
};

export type FeatureType = {
  readonly __typename?: 'FeatureType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isBeta: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum FinanceScheduleFinancialYearCategoryTotalCategoryChoices {
  /** Buildings Insurance */
  BuildingsInsurance = 'BUILDINGS_INSURANCE',
  /** Building Safety Act Compliance */
  BuildingSafetyActCompliance = 'BUILDING_SAFETY_ACT_COMPLIANCE',
  /** General Expenses */
  GeneralExpenses = 'GENERAL_EXPENSES',
  /** General Health & Safety */
  GeneralHealthSafety = 'GENERAL_HEALTH_SAFETY',
  /** Management */
  Management = 'MANAGEMENT',
  /** Onsite staff */
  OnsiteStaff = 'ONSITE_STAFF',
  /** Other Professional Fees */
  OtherProfessionalFees = 'OTHER_PROFESSIONAL_FEES',
  /** Repairs & Maintenance */
  RepairsMaintenance = 'REPAIRS_MAINTENANCE',
  /** Reserve Funds */
  ReserveFunds = 'RESERVE_FUNDS',
  /** Utilities */
  Utilities = 'UTILITIES'
}

export type FixFloType = {
  readonly __typename?: 'FixFloType';
  readonly baseUrl?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type FixfloIssueType = {
  readonly __typename?: 'FixfloIssueType';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly created?: Maybe<Scalars['String']['output']>;
  readonly faultCategory?: Maybe<Scalars['String']['output']>;
  readonly faultPriority?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type FlagChecklistItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['Date']['input']>;
  readonly finding?: InputMaybe<Scalars['String']['input']>;
  readonly itemId: Scalars['UUID']['input'];
  readonly legislationReference?: InputMaybe<Scalars['String']['input']>;
  readonly location?: InputMaybe<Scalars['String']['input']>;
  readonly plannedDate?: InputMaybe<Scalars['Date']['input']>;
  readonly priority?: InputMaybe<Scalars['String']['input']>;
  readonly priorityRaw?: InputMaybe<Scalars['String']['input']>;
  readonly recommendation?: InputMaybe<Scalars['String']['input']>;
};

export type FlagChecklistItemPayload = {
  readonly __typename?: 'FlagChecklistItemPayload';
  readonly action?: Maybe<ChecklistActionNode>;
  readonly checklistItem?: Maybe<TaskChecklistItemNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type GenerateEes = {
  readonly __typename?: 'GenerateEes';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type GenerateHomeSafetyForm = {
  readonly __typename?: 'GenerateHomeSafetyForm';
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly pdfBase64?: Maybe<Scalars['String']['output']>;
  readonly residencyId?: Maybe<Scalars['UUID']['output']>;
};

export type GeneratePeepsExport = {
  readonly __typename?: 'GeneratePeepsExport';
  readonly liveUrl?: Maybe<Scalars['String']['output']>;
  readonly occupantCount?: Maybe<Scalars['Int']['output']>;
  readonly qrDataUri?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type GenerateSafetyDocumentQrPdf = {
  readonly __typename?: 'GenerateSafetyDocumentQrPdf';
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly pdfBase64?: Maybe<Scalars['String']['output']>;
};

export type GenerateSafetyRecordActivityPdf = {
  readonly __typename?: 'GenerateSafetyRecordActivityPdf';
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly pdfBase64?: Maybe<Scalars['String']['output']>;
};

export type GenerateSibPack = {
  readonly __typename?: 'GenerateSibPack';
  readonly appendedPdfCount?: Maybe<Scalars['Int']['output']>;
  readonly blockCount?: Maybe<Scalars['Int']['output']>;
  readonly community?: Maybe<CommunityNode>;
  readonly documentCount?: Maybe<Scalars['Int']['output']>;
  readonly liveUrl?: Maybe<Scalars['String']['output']>;
  readonly occupantCount?: Maybe<Scalars['Int']['output']>;
  readonly pack?: Maybe<SafetyResponderPackNode>;
  readonly qrDataUri?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type GenerateSibPackQrPdf = {
  readonly __typename?: 'GenerateSibPackQrPdf';
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly pdfBase64?: Maybe<Scalars['String']['output']>;
};

export type GeneratedAgreementNode = {
  readonly __typename?: 'GeneratedAgreementNode';
  readonly additionalTerms?: Maybe<Scalars['String']['output']>;
  readonly client?: Maybe<ClientType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly furnished: AstGeneratorGeneratedAgreementFurnishedChoices;
  readonly home?: Maybe<HomeType>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordMobile?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly paidFor: Scalars['Boolean']['output'];
  readonly paidForByInvoice?: Maybe<Scalars['Boolean']['output']>;
  readonly paymentFrequency: AstGeneratorGeneratedAgreementPaymentFrequencyChoices;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly requirementItem?: Maybe<RequirementItemNode>;
  readonly residency?: Maybe<ResidencyType>;
  readonly residentNames?: Maybe<Scalars['String']['output']>;
  readonly signatures: AgreementSignatureNodeConnection;
  readonly status: AstGeneratorGeneratedAgreementStatusChoices;
  readonly tenancyEnd?: Maybe<Scalars['Date']['output']>;
  readonly tenancyStart?: Maybe<Scalars['Date']['output']>;
  readonly tenantEmail?: Maybe<Scalars['String']['output']>;
  readonly tenantMobile?: Maybe<Scalars['String']['output']>;
  readonly tenants: AgreementTenantNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly utilitiesIncluded?: Maybe<Scalars['String']['output']>;
};


export type GeneratedAgreementNodeSignaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type GeneratedAgreementNodeTenantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GeneratedAgreementNodeConnection = {
  readonly __typename?: 'GeneratedAgreementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GeneratedAgreementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GeneratedAgreementNode` and its cursor. */
export type GeneratedAgreementNodeEdge = {
  readonly __typename?: 'GeneratedAgreementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GeneratedAgreementNode>;
};

export type GeneratedAgreementType = {
  readonly __typename?: 'GeneratedAgreementType';
  readonly additionalTerms?: Maybe<Scalars['String']['output']>;
  readonly client?: Maybe<ClientType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly furnished: AstGeneratorGeneratedAgreementFurnishedChoices;
  readonly home?: Maybe<HomeType>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordMobile?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly paidFor: Scalars['Boolean']['output'];
  readonly paymentFrequency: AstGeneratorGeneratedAgreementPaymentFrequencyChoices;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly requirementItem?: Maybe<RequirementItemNode>;
  readonly residency?: Maybe<ResidencyType>;
  readonly residentNames?: Maybe<Scalars['String']['output']>;
  readonly signatures: AgreementSignatureNodeConnection;
  readonly status: AstGeneratorGeneratedAgreementStatusChoices;
  readonly tenancyEnd?: Maybe<Scalars['Date']['output']>;
  readonly tenancyStart?: Maybe<Scalars['Date']['output']>;
  readonly tenantEmail?: Maybe<Scalars['String']['output']>;
  readonly tenantMobile?: Maybe<Scalars['String']['output']>;
  readonly tenants: AgreementTenantNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly utilitiesIncluded?: Maybe<Scalars['String']['output']>;
};


export type GeneratedAgreementTypeSignaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type GeneratedAgreementTypeTenantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GeneratedSection21Node = {
  readonly __typename?: 'GeneratedSection21Node';
  readonly client?: Maybe<ClientType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deadlineDate?: Maybe<Scalars['Date']['output']>;
  readonly depositCertificateProvided: Scalars['Boolean']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly homeRegion?: Maybe<Scalars['String']['output']>;
  readonly htrgProvided: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly inspectionDate?: Maybe<Scalars['Date']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordEmail?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly landlordPhone?: Maybe<Scalars['String']['output']>;
  readonly leadTenantEmail?: Maybe<Scalars['String']['output']>;
  readonly paidFor: Scalars['Boolean']['output'];
  readonly possessionDate?: Maybe<Scalars['Date']['output']>;
  readonly remindLandlord: Scalars['Boolean']['output'];
  readonly serviceDate?: Maybe<Scalars['Date']['output']>;
  readonly tenantEmails?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly tenants?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly viewedOnArk: Scalars['Boolean']['output'];
};

export type GeneratedSection21NodeConnection = {
  readonly __typename?: 'GeneratedSection21NodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GeneratedSection21NodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GeneratedSection21Node` and its cursor. */
export type GeneratedSection21NodeEdge = {
  readonly __typename?: 'GeneratedSection21NodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GeneratedSection21Node>;
};

export type GeneratedSection21Type = {
  readonly __typename?: 'GeneratedSection21Type';
  readonly client?: Maybe<ClientType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deadlineDate?: Maybe<Scalars['Date']['output']>;
  readonly depositCertificateProvided: Scalars['Boolean']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly homeRegion?: Maybe<Scalars['String']['output']>;
  readonly htrgProvided: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly inspectionDate?: Maybe<Scalars['Date']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordEmail?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly landlordPhone?: Maybe<Scalars['String']['output']>;
  readonly leadTenantEmail?: Maybe<Scalars['String']['output']>;
  readonly possessionDate?: Maybe<Scalars['Date']['output']>;
  readonly serviceDate?: Maybe<Scalars['Date']['output']>;
  readonly tenants?: Maybe<Scalars['String']['output']>;
  readonly viewedOnArk: Scalars['Boolean']['output'];
};

export type GiveFireServiceConsent = {
  readonly __typename?: 'GiveFireServiceConsent';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

/** Resident gives consent for a PCFRA against a specific safety record. */
export type GiveSafetyConsent = {
  readonly __typename?: 'GiveSafetyConsent';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type GlobalFeatureType = {
  readonly __typename?: 'GlobalFeatureType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isEnabled: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type GroupChatMessageNode = {
  readonly __typename?: 'GroupChatMessageNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly media?: Maybe<Scalars['String']['output']>;
  readonly reactions?: Maybe<GroupChatMessageReactionNodeConnection>;
  readonly repliedTo?: Maybe<GroupChatMessageNode>;
  readonly text?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<UserType>;
};


export type GroupChatMessageNodeReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupChatMessageNodeConnection = {
  readonly __typename?: 'GroupChatMessageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GroupChatMessageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GroupChatMessageNode` and its cursor. */
export type GroupChatMessageNodeEdge = {
  readonly __typename?: 'GroupChatMessageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GroupChatMessageNode>;
};

export type GroupChatMessageReactionNode = {
  readonly __typename?: 'GroupChatMessageReactionNode';
  readonly deletedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly groupChatMessage?: Maybe<GroupChatMessageNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly reaction: Scalars['String']['output'];
  readonly user?: Maybe<UserType>;
};

export type GroupChatMessageReactionNodeConnection = {
  readonly __typename?: 'GroupChatMessageReactionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GroupChatMessageReactionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GroupChatMessageReactionNode` and its cursor. */
export type GroupChatMessageReactionNodeEdge = {
  readonly __typename?: 'GroupChatMessageReactionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GroupChatMessageReactionNode>;
};

export type GroupChatMessageReportNode = {
  readonly __typename?: 'GroupChatMessageReportNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly message?: Maybe<GroupChatMessageNode>;
  readonly reason: Scalars['String']['output'];
  readonly reporter?: Maybe<UserType>;
};

export type GroupChatMessageReportNodeConnection = {
  readonly __typename?: 'GroupChatMessageReportNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GroupChatMessageReportNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GroupChatMessageReportNode` and its cursor. */
export type GroupChatMessageReportNodeEdge = {
  readonly __typename?: 'GroupChatMessageReportNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GroupChatMessageReportNode>;
};

export type GroupChatNode = {
  readonly __typename?: 'GroupChatNode';
  readonly community: CommunityNode;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type GroupChatNodeConnection = {
  readonly __typename?: 'GroupChatNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GroupChatNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GroupChatNode` and its cursor. */
export type GroupChatNodeEdge = {
  readonly __typename?: 'GroupChatNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GroupChatNode>;
};

export enum HistoricalDataFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum HistoricalDataPointType {
  ActiveResidentCount = 'ACTIVE_RESIDENT_COUNT',
  AveragePackageCollectionTime = 'AVERAGE_PACKAGE_COLLECTION_TIME',
  DownloadRatePercentage = 'DOWNLOAD_RATE_PERCENTAGE',
  FacilityBookingsCount = 'FACILITY_BOOKINGS_COUNT',
  IncomingMessagesCount = 'INCOMING_MESSAGES_COUNT',
  KeyInCount = 'KEY_IN_COUNT',
  KeyOutCount = 'KEY_OUT_COUNT',
  PackageCollectedCount = 'PACKAGE_COLLECTED_COUNT',
  PackageDeliveredCount = 'PACKAGE_DELIVERED_COUNT'
}

export type HomeDetailsType = {
  readonly __typename?: 'HomeDetailsType';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly furnishing?: Maybe<ResidentialManagementHomeDetailsFurnishingChoices>;
  readonly garden?: Maybe<Scalars['Boolean']['output']>;
  readonly home: HomeType;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly kitchen?: Maybe<Scalars['Boolean']['output']>;
  readonly numBathrooms?: Maybe<Scalars['Int']['output']>;
  readonly numBedrooms?: Maybe<Scalars['Int']['output']>;
  readonly numEnsuites?: Maybe<Scalars['Int']['output']>;
  readonly numLivingRooms?: Maybe<Scalars['Int']['output']>;
  readonly office?: Maybe<Scalars['Boolean']['output']>;
  readonly parking?: Maybe<ResidentialManagementHomeDetailsParkingChoices>;
};

export type HomeDuplicate = {
  readonly __typename?: 'HomeDuplicate';
  readonly block?: Maybe<BlockNode>;
  readonly blockSuggestion?: Maybe<BlockSuggestionNode>;
  readonly homeId: Scalars['UUID']['output'];
  readonly homeName: Scalars['String']['output'];
};

export type HomeImageType = {
  readonly __typename?: 'HomeImageType';
  readonly home: HomeType;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
};

export type HomeImageTypeConnection = {
  readonly __typename?: 'HomeImageTypeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<HomeImageTypeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HomeImageType` and its cursor. */
export type HomeImageTypeEdge = {
  readonly __typename?: 'HomeImageTypeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<HomeImageType>;
};

export type HomeNode = {
  readonly __typename?: 'HomeNode';
  readonly HMO: Scalars['Boolean']['output'];
  readonly activeResidency?: Maybe<ResidencyNode>;
  readonly address: Scalars['String']['output'];
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly aicoSensorsLastSevenDaysAverage?: Maybe<ReadonlyArray<AicoDailyAverageReadingNode>>;
  readonly applications: ApplicationNodeConnection;
  readonly block?: Maybe<BlockNode>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly client: ClientType;
  readonly community?: Maybe<CommunityNode>;
  readonly communityGroups: CommunityGroupNodeConnection;
  readonly environmentAdvice?: Maybe<AicoEnvironmentAdviceNode>;
  readonly environmentThresholds?: Maybe<AicoEnvironmentThresholdsNode>;
  readonly externalId?: Maybe<Scalars['String']['output']>;
  readonly fixfloUrl?: Maybe<Scalars['String']['output']>;
  readonly floorNumber?: Maybe<Scalars['Int']['output']>;
  readonly hasFixfloExternalId?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly images: HomeImageTypeConnection;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly keys?: Maybe<KeyNodeConnection>;
  readonly latestAverageAicoSensors?: Maybe<AicoLatestAverageReadingNode>;
  readonly leasehold?: Maybe<LeaseholdNode>;
  readonly name: Scalars['String']['output'];
  readonly packages?: Maybe<PackageNodeConnection>;
  readonly postcode: Scalars['String']['output'];
  readonly residencies?: Maybe<ResidencyNodeConnection>;
  readonly similarity?: Maybe<Scalars['Float']['output']>;
  readonly uncollectedPackageCount: Scalars['Int']['output'];
};


export type HomeNodeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeNodeCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeNodeImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeNodeKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeNodePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type HomeNodeResidenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeNodeConnection = {
  readonly __typename?: 'HomeNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<HomeNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HomeNode` and its cursor. */
export type HomeNodeEdge = {
  readonly __typename?: 'HomeNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<HomeNode>;
};

export type HomeType = {
  readonly __typename?: 'HomeType';
  readonly HMO: Scalars['Boolean']['output'];
  readonly activeResidencies?: Maybe<ReadonlyArray<Maybe<ResidencyType>>>;
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly aicoPropertyId?: Maybe<Scalars['String']['output']>;
  readonly applications: ApplicationNodeConnection;
  readonly archivedLeaseholds: LeaseholdNodeConnection;
  readonly block?: Maybe<BlockNode>;
  readonly blockGroupSuggestions: BlockGroupSuggestionNodeConnection;
  readonly blockSuggestions: BlockSuggestionNodeConnection;
  readonly cachedAddressees?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly client: ClientType;
  readonly community?: Maybe<CommunityNode>;
  readonly communityGroups: CommunityGroupNodeConnection;
  readonly complianceRequirements: ComplianceRequirementNodeConnection;
  readonly contractorClassifications: ReadonlyArray<ContractorSuggestionType>;
  readonly conversations: ConversationNodeConnection;
  /** Home that the user manually corrected to. */
  readonly correctedContractorClassifications: ReadonlyArray<ContractorSuggestionType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentPackageCount?: Maybe<Scalars['Int']['output']>;
  readonly currentResidency?: Maybe<ResidencyType>;
  readonly details?: Maybe<HomeDetailsType>;
  readonly floorNumber?: Maybe<Scalars['Int']['output']>;
  readonly generatedAgreements: GeneratedAgreementNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly images: HomeImageTypeConnection;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly keys: KeyNodeConnection;
  readonly latitude?: Maybe<Scalars['Decimal']['output']>;
  readonly leasehold?: Maybe<LeaseholdNode>;
  readonly longitude?: Maybe<Scalars['Decimal']['output']>;
  readonly name: Scalars['String']['output'];
  readonly numRooms: Scalars['Int']['output'];
  readonly packages: PackageNodeConnection;
  /** Homes on this CommunityGroup that must not be auto-removed by the daily clean_block_group task. Users with active Residencies or Leaseholds on pinned homes are also protected from removal. Use for management offices, common areas, amenity spaces, or demo homes. Must be a subset of this group's homes. */
  readonly pinnedToCommunityGroups: CommunityGroupNodeConnection;
  readonly postcode: Scalars['String']['output'];
  readonly residencies: ReadonlyArray<ResidencyType>;
  readonly section21s: GeneratedSection21NodeConnection;
  readonly shortCode?: Maybe<Scalars['String']['output']>;
  readonly tenancyApplications: TenancyApplicationNodeConnection;
  readonly uncollectedPackageCount: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type HomeTypeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeArchivedLeaseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeTypeBlockGroupSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type HomeTypeBlockSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBlock?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  latestPerNameCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  resident?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  subject_Icontains?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeGeneratedAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeTypeImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeTypeKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasCurrentKeyholder?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  search2?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type HomeTypePinnedToCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeSection21sArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeTypeTenancyApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenSent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type IdentityVerificationNode = {
  readonly __typename?: 'IdentityVerificationNode';
  readonly documentExpiryDate?: Maybe<Scalars['Date']['output']>;
  readonly documentNumber?: Maybe<Scalars['String']['output']>;
  readonly documentType?: Maybe<Scalars['String']['output']>;
  readonly hasRightToRent?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly nationality?: Maybe<Scalars['String']['output']>;
  readonly passport?: Maybe<Scalars['String']['output']>;
  readonly passportSelfie?: Maybe<Scalars['String']['output']>;
  readonly personaInquiryId: Scalars['String']['output'];
  readonly selfie?: Maybe<Scalars['String']['output']>;
  readonly status: TenancyApplicationIdentityVerificationStatusChoices;
};

export type IgnoreMessageSuggestionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionId: Scalars['UUID']['input'];
};

export type IgnoreMessageSuggestionPayload = {
  readonly __typename?: 'IgnoreMessageSuggestionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type InitializeSignup = {
  readonly __typename?: 'InitializeSignup';
  readonly landlord?: Maybe<LandlordNode>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type InspectionOverviewCountNode = {
  readonly __typename?: 'InspectionOverviewCountNode';
  readonly count: Scalars['Int']['output'];
  readonly key: Scalars['String']['output'];
  readonly label: Scalars['String']['output'];
};

export type InspectionOverviewStatsNode = {
  readonly __typename?: 'InspectionOverviewStatsNode';
  readonly actionsComplete: Scalars['Int']['output'];
  readonly actionsDismissed: Scalars['Int']['output'];
  readonly actionsInProgress: Scalars['Int']['output'];
  readonly actionsOutstanding: Scalars['Int']['output'];
  readonly actionsOverdue: Scalars['Int']['output'];
  readonly actionsTotal: Scalars['Int']['output'];
  readonly actionsWithTasks: Scalars['Int']['output'];
  readonly byArea: ReadonlyArray<InspectionOverviewCountNode>;
  readonly byPriority: ReadonlyArray<InspectionOverviewCountNode>;
  readonly byResolver: ReadonlyArray<InspectionOverviewCountNode>;
  readonly byReviewer: ReadonlyArray<InspectionOverviewCountNode>;
  readonly reportItemsNeedingAction: Scalars['Int']['output'];
  readonly reportItemsPassed: Scalars['Int']['output'];
  readonly reportItemsTotal: Scalars['Int']['output'];
};

export type IntegrationType = {
  readonly __typename?: 'IntegrationType';
  readonly fixflo?: Maybe<FixFloType>;
};

export type InviteDemoUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityId: Scalars['UUID']['input'];
  readonly email: Scalars['String']['input'];
};

export type InviteDemoUserPayload = {
  readonly __typename?: 'InviteDemoUserPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly residency: ResidencyNode;
};

export type InvoiceNode = {
  readonly __typename?: 'InvoiceNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isPaid: Scalars['Boolean']['output'];
};

export type InvoiceNodeConnection = {
  readonly __typename?: 'InvoiceNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<InvoiceNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InvoiceNode` and its cursor. */
export type InvoiceNodeEdge = {
  readonly __typename?: 'InvoiceNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<InvoiceNode>;
};

export type Invoices = {
  readonly __typename?: 'Invoices';
  readonly amount: Scalars['Int']['output'];
  readonly charge?: Maybe<ChargeType>;
  readonly created: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly nextPaymentAttempt?: Maybe<Scalars['Date']['output']>;
  readonly number?: Maybe<Scalars['String']['output']>;
  readonly paidAt?: Maybe<Scalars['String']['output']>;
  readonly paymentIntent?: Maybe<PaymentIntentType>;
  readonly status: Scalars['String']['output'];
};

export type KeyEventNode = {
  readonly __typename?: 'KeyEventNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly key: KeyNode;
  readonly keyholder: KeyholderNode;
  readonly performedBy: UserType;
  readonly type: ResidentialManagementKeyEventTypeChoices;
};

export type KeyEventNodeConnection = {
  readonly __typename?: 'KeyEventNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KeyEventNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `KeyEventNode` and its cursor. */
export type KeyEventNodeEdge = {
  readonly __typename?: 'KeyEventNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<KeyEventNode>;
};

export type KeyNode = {
  readonly __typename?: 'KeyNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly checkoutDate?: Maybe<Scalars['DateTime']['output']>;
  readonly community?: Maybe<CommunityNode>;
  readonly communityName: Scalars['String']['output'];
  readonly currentKeyholder?: Maybe<KeyholderNode>;
  readonly events: KeyEventNodeConnection;
  readonly home?: Maybe<HomeNode>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly keyholders: KeyholderNodeConnection;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly reference?: Maybe<Scalars['String']['output']>;
  readonly status: Scalars['String']['output'];
};


export type KeyNodeEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyNodeKeyholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type KeyNodeConnection = {
  readonly __typename?: 'KeyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KeyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `KeyNode` and its cursor. */
export type KeyNodeEdge = {
  readonly __typename?: 'KeyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<KeyNode>;
};

export type KeyReportingDayCountNode = {
  readonly __typename?: 'KeyReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type KeyReportingDayDurationNode = {
  readonly __typename?: 'KeyReportingDayDurationNode';
  readonly day: Scalars['Date']['output'];
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type KeyReportingDayMovementNode = {
  readonly __typename?: 'KeyReportingDayMovementNode';
  readonly checkedIn?: Maybe<Scalars['Int']['output']>;
  readonly checkedOut?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type KeyReportingDaysHeldBucketNode = {
  readonly __typename?: 'KeyReportingDaysHeldBucketNode';
  readonly count: Scalars['Int']['output'];
  readonly maxDays?: Maybe<Scalars['Int']['output']>;
  readonly minDays: Scalars['Int']['output'];
  readonly overdue: Scalars['Boolean']['output'];
};

export type KeyReportingDaysHeldNode = {
  readonly __typename?: 'KeyReportingDaysHeldNode';
  readonly buckets: ReadonlyArray<KeyReportingDaysHeldBucketNode>;
  readonly overdueCount: Scalars['Int']['output'];
};

export type KeyReportingHeldKeyNode = {
  readonly __typename?: 'KeyReportingHeldKeyNode';
  readonly heldSeconds: Scalars['Int']['output'];
  readonly keyId: Scalars['UUID']['output'];
  readonly label: Scalars['String']['output'];
};

export type KeyReportingHolderCompanyNode = {
  readonly __typename?: 'KeyReportingHolderCompanyNode';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
};

export type KeyReportingKeysOutNode = {
  readonly __typename?: 'KeyReportingKeysOutNode';
  readonly atEnd?: Maybe<KeyReportingDayCountNode>;
  readonly byDay: ReadonlyArray<KeyReportingDayCountNode>;
};

export type KeyReportingMovementsNode = {
  readonly __typename?: 'KeyReportingMovementsNode';
  readonly byDay: ReadonlyArray<KeyReportingDayMovementNode>;
  readonly checkedIn?: Maybe<Scalars['Int']['output']>;
  readonly checkedOut?: Maybe<Scalars['Int']['output']>;
};

export type KeyReportingNode = {
  readonly __typename?: 'KeyReportingNode';
  readonly activeHolders: Scalars['Int']['output'];
  readonly daysHeld: KeyReportingDaysHeldNode;
  readonly holderCompanies: ReadonlyArray<KeyReportingHolderCompanyNode>;
  readonly keysOut: KeyReportingKeysOutNode;
  readonly longestHeld: ReadonlyArray<KeyReportingHeldKeyNode>;
  readonly movements: KeyReportingMovementsNode;
  readonly overdueAtEnd: Scalars['Int']['output'];
  readonly timeHeld: KeyReportingTimeHeldNode;
};

export type KeyReportingTimeHeldNode = {
  readonly __typename?: 'KeyReportingTimeHeldNode';
  readonly byDay: ReadonlyArray<KeyReportingDayDurationNode>;
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type KeyholderNode = {
  readonly __typename?: 'KeyholderNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly company?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly endDate?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly key: KeyNode;
  readonly name: Scalars['String']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly startDate: Scalars['DateTime']['output'];
  readonly type: Scalars['String']['output'];
};

export type KeyholderNodeConnection = {
  readonly __typename?: 'KeyholderNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KeyholderNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `KeyholderNode` and its cursor. */
export type KeyholderNodeEdge = {
  readonly __typename?: 'KeyholderNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<KeyholderNode>;
};

export type LabelConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly tags: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type LabelConversationPayload = {
  readonly __typename?: 'LabelConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type LandlordAttachmentNode = {
  readonly __typename?: 'LandlordAttachmentNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly requirementItem?: Maybe<RequirementItemNode>;
  readonly type: ComplianceAttachmentTypeChoices;
};

export type LandlordAttachmentType = {
  readonly __typename?: 'LandlordAttachmentType';
  readonly client: ClientType;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly objectId: Scalars['UUID']['output'];
  readonly requirementItem?: Maybe<RequirementItemNode>;
  readonly type: ComplianceAttachmentTypeChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type LandlordDocumentNode = GeneratedAgreementNode | GeneratedSection21Node | LandlordAttachmentNode;

export type LandlordNode = {
  readonly __typename?: 'LandlordNode';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly emailPreferences: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly smsPreferences: Scalars['Boolean']['output'];
};

export type LandlordReferenceNode = {
  readonly __typename?: 'LandlordReferenceNode';
  readonly comments?: Maybe<Scalars['String']['output']>;
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly hasOutstandingRent: TenancyApplicationLandlordReferenceHasOutstandingRentChoices;
  readonly id: Scalars['UUID']['output'];
  readonly landlordOrAgent: Scalars['String']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly mobile: Scalars['String']['output'];
  readonly monthlyRentAmount: Scalars['Decimal']['output'];
  readonly rentPaidOnTime: TenancyApplicationLandlordReferenceRentPaidOnTimeChoices;
  readonly step?: Maybe<TenancyApplicationLandlordReferenceStepChoices>;
  readonly submittedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly tenancyType: TenancyApplicationLandlordReferenceTenancyTypeChoices;
  readonly tenantMoveInDate?: Maybe<Scalars['Date']['output']>;
  readonly tenantReference?: Maybe<TenantReferenceNode>;
  readonly treatedPropertyWell: TenancyApplicationLandlordReferenceTreatedPropertyWellChoices;
};

export type LandlordUpdateLandlordReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly landlordOrAgent: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile: Scalars['String']['input'];
};

export type LandlordUpdateLandlordReferencePayload = {
  readonly __typename?: 'LandlordUpdateLandlordReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly landlordOrAgent?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
};

export type LandlordUpdateRentalDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly hasOutstandingRent?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly monthlyRentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly rentPaidOnTime?: InputMaybe<Scalars['String']['input']>;
  readonly tenancyType?: InputMaybe<Scalars['String']['input']>;
  readonly tenantMoveInDate?: InputMaybe<Scalars['Date']['input']>;
  readonly treatedPropertyWell?: InputMaybe<Scalars['String']['input']>;
};

export type LandlordUpdateRentalDetailsPayload = {
  readonly __typename?: 'LandlordUpdateRentalDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly hasOutstandingRent?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly monthlyRentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly rentPaidOnTime?: Maybe<Scalars['String']['output']>;
  readonly tenancyType?: Maybe<Scalars['String']['output']>;
  readonly tenantMoveInDate?: Maybe<Scalars['Date']['output']>;
  readonly treatedPropertyWell?: Maybe<Scalars['String']['output']>;
};

export type LeanNotificationNode = {
  readonly __typename?: 'LeanNotificationNode';
  readonly actionObjectObjectId?: Maybe<Scalars['String']['output']>;
  readonly actionObjectType?: Maybe<Scalars['String']['output']>;
  readonly actorName?: Maybe<Scalars['String']['output']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isFeatureAnnouncement: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly navigationMeta?: Maybe<NotificationNavigationMeta>;
  readonly platform?: Maybe<Scalars['String']['output']>;
  readonly read: Scalars['Boolean']['output'];
  readonly targetObjectId?: Maybe<Scalars['String']['output']>;
  readonly targetType?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
  readonly verb?: Maybe<Scalars['String']['output']>;
};

export type LeanNotificationNodeConnection = {
  readonly __typename?: 'LeanNotificationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<LeanNotificationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LeanNotificationNode` and its cursor. */
export type LeanNotificationNodeEdge = {
  readonly __typename?: 'LeanNotificationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<LeanNotificationNode>;
};

export type LeaseholdNode = {
  readonly __typename?: 'LeaseholdNode';
  readonly balance?: Maybe<Scalars['Decimal']['output']>;
  readonly balanceLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly externalId?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastPayment?: Maybe<PaymentNode>;
  readonly leaseholdSchedules?: Maybe<LeaseholdScheduleNodeConnection>;
  readonly leaseholder: LeaseholderNodeConnection;
  readonly pastLeaseholders?: Maybe<ArchivedContactNodeConnection>;
  readonly remainingSchedules?: Maybe<ScheduleNodeConnection>;
  readonly schedules: LeaseholdScheduleNodeConnection;
};


export type LeaseholdNodeLeaseholdSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LeaseholdNodeLeaseholderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LeaseholdNodePastLeaseholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LeaseholdNodeRemainingSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LeaseholdNodeSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LeaseholdNodeConnection = {
  readonly __typename?: 'LeaseholdNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<LeaseholdNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LeaseholdNode` and its cursor. */
export type LeaseholdNodeEdge = {
  readonly __typename?: 'LeaseholdNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<LeaseholdNode>;
};

export type LeaseholdScheduleNode = {
  readonly __typename?: 'LeaseholdScheduleNode';
  /** Apportionment percentage as decimal */
  readonly apportionment?: Maybe<Scalars['Decimal']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly leasehold: LeaseholdNode;
  readonly schedule: ScheduleNode;
  readonly totalContribution?: Maybe<Scalars['Decimal']['output']>;
};

export type LeaseholdScheduleNodeConnection = {
  readonly __typename?: 'LeaseholdScheduleNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<LeaseholdScheduleNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LeaseholdScheduleNode` and its cursor. */
export type LeaseholdScheduleNodeEdge = {
  readonly __typename?: 'LeaseholdScheduleNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<LeaseholdScheduleNode>;
};

export type LeaseholderNode = {
  readonly __typename?: 'LeaseholderNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly leaseholds: LeaseholdNodeConnection;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly serviceChargeWaiverAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly user: UserType;
};


export type LeaseholderNodeLeaseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LeaseholderNodeConnection = {
  readonly __typename?: 'LeaseholderNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<LeaseholderNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LeaseholderNode` and its cursor. */
export type LeaseholderNodeEdge = {
  readonly __typename?: 'LeaseholderNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<LeaseholderNode>;
};

export type LinkConversationToTaskInput = {
  readonly addAsWatcher?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly taskId: Scalars['UUID']['input'];
};

export type LinkConversationToTaskPayload = {
  readonly __typename?: 'LinkConversationToTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
};

export type LinkSafetySubjectInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
  readonly userId: Scalars['String']['input'];
};

export type LinkSafetySubjectPayload = {
  readonly __typename?: 'LinkSafetySubjectPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type LinkTaskToAsanaInput = {
  readonly asanaId?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type LinkTaskToAsanaPayload = {
  readonly __typename?: 'LinkTaskToAsanaPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type LinkTaskToFixfloInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly fixfloId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type LinkTaskToFixfloPayload = {
  readonly __typename?: 'LinkTaskToFixfloPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type LogDocumentReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type LogDocumentReadPayload = {
  readonly __typename?: 'LogDocumentReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type LogManagerDashUse = {
  readonly __typename?: 'LogManagerDashUse';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type LogPublicDocumentReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type LogPublicDocumentReadPayload = {
  readonly __typename?: 'LogPublicDocumentReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type LogUserAppUseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceBrand: Scalars['String']['input'];
  readonly deviceNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly deviceType: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly locale?: InputMaybe<Scalars['String']['input']>;
  readonly systemName: Scalars['String']['input'];
};

export type LogUserAppUsePayload = {
  readonly __typename?: 'LogUserAppUsePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceBrand?: Maybe<Scalars['String']['output']>;
  readonly deviceNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly deviceType?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly locale?: Maybe<Scalars['String']['output']>;
  readonly systemName?: Maybe<Scalars['String']['output']>;
};

export type ManagerAddApplicationHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly home?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ManagerAddApplicationHomePayload = {
  readonly __typename?: 'ManagerAddApplicationHomePayload';
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ManagerCancelAmenityReservationInput = {
  readonly cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ManagerCancelAmenityReservationPayload = {
  readonly __typename?: 'ManagerCancelAmenityReservationPayload';
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ManagerCreateAmenityReservationInput = {
  readonly amenityId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly reason: Scalars['String']['input'];
  readonly timeSlots: ReadonlyArray<InputMaybe<TimeSlot>>;
};

export type ManagerCreateAmenityReservationPayload = {
  readonly __typename?: 'ManagerCreateAmenityReservationPayload';
  readonly amenity?: Maybe<AmenityNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export enum ManagerDeclarationOrigin {
  ManagerDirect = 'MANAGER_DIRECT',
  ManagerPaper = 'MANAGER_PAPER',
  ManagerPhone = 'MANAGER_PHONE'
}

export type ManagerNotificationType = {
  readonly __typename?: 'ManagerNotificationType';
  readonly category?: Maybe<Scalars['String']['output']>;
  readonly client: ClientType;
  readonly contentObject?: Maybe<NotificationContentObjectType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description: Scalars['String']['output'];
  readonly dismissed: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly objectId: Scalars['UUID']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ManagerProfileType = {
  readonly __typename?: 'ManagerProfileType';
  readonly ASTPageViewed: Scalars['Boolean']['output'];
  readonly acceptedMarketing: Scalars['Boolean']['output'];
  readonly complianceEmailExplanation: Scalars['Boolean']['output'];
  readonly compliancePageViewed: Scalars['Boolean']['output'];
  readonly complianceUpdateEmails: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly manager: ManagerType;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly valueQuestionnaireAnswer?: Maybe<Scalars['Int']['output']>;
};

export type ManagerReserveAmenityInput = {
  readonly amenity?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly end: Scalars['DateTime']['input'];
  readonly reason?: InputMaybe<Scalars['String']['input']>;
  readonly start: Scalars['DateTime']['input'];
};

export type ManagerReserveAmenityPayload = {
  readonly __typename?: 'ManagerReserveAmenityPayload';
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ManagerType = {
  readonly __typename?: 'ManagerType';
  readonly applicationAttempts: ApplicationAttemptNodeConnection;
  readonly calendarLink?: Maybe<CalendarLinkType>;
  readonly client?: Maybe<ClientType>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly community?: Maybe<CommunityNodeConnection>;
  readonly complianceUpdateReads: ReadonlyArray<ComplianceUpdateReadType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdDocuments: CommunityDocumentNodeConnection;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly emailPreferences: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isActive?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly profile?: Maybe<ManagerProfileType>;
  readonly residencydocumentSet: ResidencyDocumentNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};


export type ManagerTypeApplicationAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTypeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTypeCommunityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTypeCreatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTypeResidencydocumentSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkApplicationThreadAsReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type MarkApplicationThreadAsReadPayload = {
  readonly __typename?: 'MarkApplicationThreadAsReadPayload';
  readonly applicationThread?: Maybe<ApplicationThreadNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type MarkSafetyReviewRequestOpened = {
  readonly __typename?: 'MarkSafetyReviewRequestOpened';
  readonly reviewRequest?: Maybe<SafetyReviewRequestNode>;
};

export type MarkSibPackPrinted = {
  readonly __typename?: 'MarkSibPackPrinted';
  readonly community?: Maybe<CommunityNode>;
  readonly pack?: Maybe<SafetyResponderPackNode>;
};

export type MarkSuggestionShownInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionId: Scalars['UUID']['input'];
};

export type MarkSuggestionShownPayload = {
  readonly __typename?: 'MarkSuggestionShownPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly suggestion?: Maybe<MessageSuggestionType>;
};

export type MarkThreadMessagesAsReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Mark the other participant's messages in a thread as read.
 *
 * Gated on ``marketplace_item_thread`` edit rather than
 * ``marketplace_item_thread_message`` edit: the write targets every unread
 * message in the thread and no message id is supplied, so the thread is the
 * only object the requirement can bind to. Binding the thread still routes
 * through the thread ownership policy, which limits the caller to threads
 * they inquire on or own the listing for.
 */
export type MarkThreadMessagesAsReadPayload = {
  readonly __typename?: 'MarkThreadMessagesAsReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly marketplaceItemThread?: Maybe<MarketplaceItemThreadNode>;
};

export type MarketplaceItemCommentNode = {
  readonly __typename?: 'MarketplaceItemCommentNode';
  readonly author?: Maybe<UserType>;
  readonly comment: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type MarketplaceItemCommentNodeConnection = {
  readonly __typename?: 'MarketplaceItemCommentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemCommentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemCommentNode` and its cursor. */
export type MarketplaceItemCommentNodeEdge = {
  readonly __typename?: 'MarketplaceItemCommentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemCommentNode>;
};

export type MarketplaceItemImageNode = {
  readonly __typename?: 'MarketplaceItemImageNode';
  readonly id: Scalars['UUID']['output'];
  readonly image: Scalars['String']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type MarketplaceItemImageNodeConnection = {
  readonly __typename?: 'MarketplaceItemImageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemImageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemImageNode` and its cursor. */
export type MarketplaceItemImageNodeEdge = {
  readonly __typename?: 'MarketplaceItemImageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemImageNode>;
};

export type MarketplaceItemNode = {
  readonly __typename?: 'MarketplaceItemNode';
  readonly archivedBy?: Maybe<UserType>;
  readonly archivedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly archivedReason?: Maybe<Scalars['String']['output']>;
  readonly closedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly comments: MarketplaceItemCommentNodeConnection;
  readonly community: CommunityNode;
  readonly condition?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly images: MarketplaceItemImageNodeConnection;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly notifications?: Maybe<NotificationNodeConnection>;
  readonly price: Scalars['Decimal']['output'];
  readonly threads: MarketplaceItemThreadNodeConnection;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};


export type MarketplaceItemNodeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MarketplaceItemNodeImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MarketplaceItemNodeNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MarketplaceItemNodeThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasMessages?: InputMaybe<Scalars['Boolean']['input']>;
  item?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketplaceItemNodeConnection = {
  readonly __typename?: 'MarketplaceItemNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemNode` and its cursor. */
export type MarketplaceItemNodeEdge = {
  readonly __typename?: 'MarketplaceItemNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemNode>;
};

export type MarketplaceItemThreadMessageNode = {
  readonly __typename?: 'MarketplaceItemThreadMessageNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isFromSeller?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly message: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly readAt?: Maybe<Scalars['DateTime']['output']>;
  readonly user: UserType;
};

export type MarketplaceItemThreadMessageNodeConnection = {
  readonly __typename?: 'MarketplaceItemThreadMessageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemThreadMessageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemThreadMessageNode` and its cursor. */
export type MarketplaceItemThreadMessageNodeEdge = {
  readonly __typename?: 'MarketplaceItemThreadMessageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemThreadMessageNode>;
};

export type MarketplaceItemThreadNode = {
  readonly __typename?: 'MarketplaceItemThreadNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly inquirer: UserType;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly item: MarketplaceItemNode;
  readonly lastMessage?: Maybe<MarketplaceItemThreadMessageNode>;
  readonly messages: MarketplaceItemThreadMessageNodeConnection;
  readonly otherUserName?: Maybe<Scalars['String']['output']>;
  readonly unreadCount?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type MarketplaceItemThreadNodeMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketplaceItemThreadNodeConnection = {
  readonly __typename?: 'MarketplaceItemThreadNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemThreadNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemThreadNode` and its cursor. */
export type MarketplaceItemThreadNodeEdge = {
  readonly __typename?: 'MarketplaceItemThreadNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemThreadNode>;
};

export type MessageSuggestionType = {
  readonly __typename?: 'MessageSuggestionType';
  readonly action?: Maybe<ResidentialManagementMessageSuggestionActionChoices>;
  readonly alteredMessage?: Maybe<Scalars['String']['output']>;
  readonly braintrustSpanId?: Maybe<Scalars['String']['output']>;
  readonly citations?: Maybe<Scalars['JSONString']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly model?: Maybe<Scalars['String']['output']>;
  readonly promptVersion?: Maybe<Scalars['String']['output']>;
  readonly suggestion?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly version: Scalars['Int']['output'];
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly acceptApplication?: Maybe<AcceptApplication>;
  readonly acceptAsanaPendingTask?: Maybe<AcceptAsanaPendingTaskPayload>;
  readonly acceptBlockGroupSuggestion?: Maybe<AcceptBlockGroupSuggestionPayload>;
  /**
   * Accept a suggestion, creating a block or folding homes into an existing one.
   *
   * Requires both ``create`` and ``edit``. The body only creates a block when
   * no block of the same name already exists in the community; otherwise it
   * calls ``block.homes.add(...)`` on the existing one, which is an edit.
   * Gating on ``create`` alone would let a community-scoped deny override on
   * ``edit`` be bypassed through this mutation.
   */
  readonly acceptBlockSuggestion?: Maybe<AcceptBlockSuggestionPayload>;
  readonly acceptFeatureAnnouncement?: Maybe<AcceptFeatureAnnouncementPayload>;
  readonly acceptMessageSuggestion?: Maybe<AcceptMessageSuggestionPayload>;
  readonly acceptServiceChargeWaiver?: Maybe<AcceptServiceChargeWaiverPayload>;
  readonly acceptTermsAndConditions?: Maybe<AcceptTermsAndConditionsPayload>;
  readonly acceptWaiver?: Maybe<AcceptWaiverPayload>;
  readonly activateGroup?: Maybe<ActivateGroupPayload>;
  readonly activateSafetyComplianceV2?: Maybe<ActivateSafetyComplianceV2>;
  readonly activateSafetyResponderToken?: Maybe<ActivateSafetyResponderToken>;
  readonly addApplicationCommunity?: Maybe<AddApplicationCommunity>;
  readonly addApplicationHome?: Maybe<AddApplicationHome>;
  readonly addApplicationOwnershipType?: Maybe<AddApplicationOwnershipType>;
  readonly addContractorToClientContractorCompany?: Maybe<AddContractorToClientContractorCompanyPayload>;
  readonly addDocumentSentStatus?: Maybe<AddDocumentSentStatus>;
  readonly addFeatureToClient?: Maybe<AddFeatureToClientPayload>;
  readonly addMember?: Maybe<AddMemberPayload>;
  readonly addMessageToThread?: Maybe<AddMessageToThreadPayload>;
  readonly addPackageToHome?: Maybe<AddPackageToHomePayload>;
  readonly addTaskComment?: Maybe<AddTaskCommentPayload>;
  readonly addTeamMembers?: Maybe<AddTeamMembersPayload>;
  readonly addUnknownCommunityStatus?: Maybe<AddUnknownCommunityStatus>;
  readonly agreeEes?: Maybe<AgreeEes>;
  readonly archiveAllNotificationsOnTarget?: Maybe<ArchiveAllNotificationsOnTargetPayload>;
  readonly archiveApplication?: Maybe<ArchiveApplicationPayload>;
  readonly archiveCommunityEvent?: Maybe<ArchiveCommunityEventPayload>;
  readonly archiveContactNote?: Maybe<ArchiveContactNotePayload>;
  readonly archiveKey?: Maybe<ArchiveKeyPayload>;
  readonly archiveKeyholder?: Maybe<ArchiveKeyholderPayload>;
  readonly archiveMarketplaceItem?: Maybe<ArchiveMarketplaceItemPayload>;
  readonly archiveNotification?: Maybe<ArchiveNotificationPayload>;
  readonly archiveSafetyCenterDocument?: Maybe<ArchiveSafetyCenterDocumentPayload>;
  readonly archiveSafetySubject?: Maybe<ArchiveSafetySubjectPayload>;
  readonly archiveTag?: Maybe<ArchiveTagPayload>;
  readonly archiveTask?: Maybe<ArchiveTaskPayload>;
  readonly archiveTaskGroup?: Maybe<ArchiveTaskGroupPayload>;
  readonly archiveTaskTemplate?: Maybe<ArchiveTaskTemplatePayload>;
  readonly assignChecklistItem?: Maybe<AssignChecklistItemPayload>;
  readonly assignChecklistSection?: Maybe<AssignChecklistSectionPayload>;
  readonly assignClientTag?: Maybe<AssignClientTagPayload>;
  readonly assignClientTagToCommunityDocument?: Maybe<AssignClientTagToCommunityDocumentPayload>;
  readonly assignClientTagToTaskDefinition?: Maybe<AssignClientTagToTaskDefinitionPayload>;
  readonly assignClientTagToUserDocument?: Maybe<AssignClientTagToUserDocumentPayload>;
  readonly assignCommunityStaffRole?: Maybe<AssignCommunityStaffRolePayload>;
  readonly assignContractorToTask?: Maybe<AssignContractorToTaskPayload>;
  readonly assignTask?: Maybe<AssignTaskPayload>;
  readonly assignTeam?: Maybe<AssignTeamPayload>;
  readonly associateAgreementWithClient?: Maybe<AssociateAgreementWithClient>;
  readonly associateSection21WithClient?: Maybe<AssociateSection21WithClient>;
  readonly batchCreateTaskDocuments?: Maybe<BatchCreateTaskDocumentsPayload>;
  readonly bookCommunityEvent?: Maybe<BookCommunityEventMutationPayload>;
  readonly bookPaidCommunityEvent?: Maybe<BookPaidCommunityEventMutationPayload>;
  readonly cancelAmenityReservation?: Maybe<CancelAmenityReservationPayload>;
  readonly cancelPayment?: Maybe<CancelPaymentPayload>;
  readonly cancelScheduledMessage?: Maybe<CancelScheduledMessage>;
  readonly cancelScheduledPublishCommunityUpdate?: Maybe<CancelScheduledPublishCommunityUpdatePayload>;
  readonly changeTaskStatus?: Maybe<ChangeTaskStatusPayload>;
  readonly checkBlockSuggestionHomes?: Maybe<CheckBlockSuggestionHomesPayload>;
  readonly checkInKeyV2?: Maybe<CheckInKeyV2Payload>;
  readonly checkOutKeyV2?: Maybe<CheckOutKeyV2Payload>;
  readonly closeConversation?: Maybe<CloseConversationPayload>;
  readonly closeSurvey?: Maybe<CloseSurvey>;
  readonly collectPackages?: Maybe<CollectPackagesPayload>;
  readonly collectPackagesForHome?: Maybe<CollectPackagesForHomePayload>;
  readonly completeChecklistItem?: Maybe<CompleteChecklistItemPayload>;
  readonly confirmResidencyWillRoll?: Maybe<ConfirmResidencyWillRollPayload>;
  readonly contactApplicationSupport?: Maybe<ContactApplicationSupportPayload>;
  readonly contactPackagesReminder?: Maybe<ContactPackagesReminderPayload>;
  readonly correctInspectionSeries?: Maybe<CorrectInspectionSeriesPayload>;
  readonly countersignAgreement?: Maybe<CountersignAgreementPayload>;
  readonly createAgreementForTenancy?: Maybe<CreateAgreementForTenancyPayload>;
  readonly createAmenityReservation?: Maybe<CreateAmenityReservationMutationPayload>;
  readonly createApplicantAndApplication?: Maybe<CreateApplicantAndApplicationPayload>;
  readonly createApplication?: Maybe<CreateApplicationPayload>;
  readonly createApplicationThread?: Maybe<CreateApplicationThreadMutationPayload>;
  readonly createAttachmentOnHome?: Maybe<CreateAttachmentOnHomePayload>;
  readonly createAttachmentOnRequirementItem?: Maybe<CreateAttachmentOnRequirementItemPayload>;
  readonly createBlockComplianceRequirementItem?: Maybe<CreateBlockComplianceRequirementItemPayload>;
  readonly createBlockGroupSuggestions?: Maybe<CreateBlockGroupSuggestionsPayload>;
  readonly createBlocks?: Maybe<CreateBlocks>;
  readonly createBlocksComplianceRequirement?: Maybe<CreateBlocksComplianceRequirementPayload>;
  readonly createChecklist?: Maybe<CreateChecklistPayload>;
  readonly createChecklistFromTemplate?: Maybe<CreateChecklistFromTemplatePayload>;
  readonly createChecklistItemComment?: Maybe<CreateChecklistItemCommentPayload>;
  readonly createChecklistItemMedia?: Maybe<CreateChecklistItemMediaPayload>;
  readonly createChecklistWithStructure?: Maybe<CreateChecklistWithStructurePayload>;
  readonly createCheckoutLink?: Maybe<CreateCheckoutLinkPayload>;
  readonly createClientContractorCompany?: Maybe<CreateClientContractorCompanyPayload>;
  readonly createClientTag?: Maybe<CreateClientTagPayload>;
  readonly createCommunityDocument?: Maybe<CreateCommunityDocumentPayload>;
  readonly createCommunityDocumentReminder?: Maybe<CreateCommunityDocumentReminderPayload>;
  readonly createCommunityDocumentTag?: Maybe<CreateCommunityDocumentTagPayload>;
  readonly createCommunityDocumentView?: Maybe<CreateCommunityDocumentViewPayload>;
  readonly createCommunityProduct?: Maybe<CreateCommunityProductPayload>;
  readonly createCommunityProductPayment?: Maybe<CreateCommunityProductPaymentPayload>;
  readonly createCommunityTaskDefinition?: Maybe<CreateCommunityTaskDefinitionPayload>;
  readonly createCommunityUpdateRead?: Maybe<CreateCommunityUpdateReadPayload>;
  readonly createCommunityVisitor?: Maybe<CreateCommunityVisitorPayload>;
  readonly createComplianceRequirement?: Maybe<CreateComplianceRequirementPayload>;
  readonly createComplianceUpdateRead?: Maybe<CreateComplianceUpdateReadPayload>;
  readonly createContractor?: Maybe<CreateContractorPayload>;
  readonly createConversation?: Maybe<CreateConversation>;
  readonly createConversationAction?: Maybe<CreateConversationActionPayload>;
  readonly createConversationAndFirstMessage?: Maybe<CreateConversationAndFirstMessage>;
  readonly createConversationAssignment?: Maybe<CreateConversationAssignmentPayload>;
  readonly createConversationMessage?: Maybe<CreateConversationMessage>;
  readonly createConversationNote?: Maybe<CreateConversationNotePayload>;
  readonly createConversationSummary?: Maybe<CreateConversationSummaryPayload>;
  readonly createConversationTag?: Maybe<CreateConversationTagPayload>;
  readonly createFollowUpTaskFromChecklistItem?: Maybe<CreateFollowUpTaskFromChecklistItemPayload>;
  readonly createFollowUpTasksFromChecklistItems?: Maybe<CreateFollowUpTasksFromChecklistItemsPayload>;
  readonly createGroup?: Maybe<CreateGroupPayload>;
  readonly createGroupChatMessage?: Maybe<CreateGroupChatMessagePayload>;
  readonly createGroupChatMessageReaction?: Maybe<CreateGroupChatMessageReactionPayload>;
  readonly createGroupChatMessageReport?: Maybe<CreateGroupChatMessageReportPayload>;
  readonly createKeyV2?: Maybe<CreateKeyV2Payload>;
  readonly createKeyholderV2?: Maybe<CreateKeyholderV2Payload>;
  readonly createManagerConversationRead?: Maybe<CreateManagerConversationReadPayload>;
  readonly createManagerSafetyDeclaration?: Maybe<CreateManagerSafetyDeclarationPayload>;
  /**
   * Left ungated by Access V2 deliberately.
   *
   * ``MarketplaceItemComment`` has no entry in ``RESOURCE_REGISTRY`` and no row
   * in the role matrix, and none of the three registered marketplace resources
   * describes it. ``marketplace_item`` is the closest, but its ownership policy
   * scopes a resident to listings they own, so gating a public comment on it
   * would deny commenting on anyone else's listing once the rollout flag is on
   * — a regression, not a narrowing. Inventing a ``marketplace_item_comment``
   * resource is out of scope for this pathway, so the legacy
   * ``IsResidentOrLeaseholder`` check stands alone until one is added.
   */
  readonly createMarketplaceItemComment?: Maybe<CreateMarketplaceItemCommentPayload>;
  readonly createMarketplaceItemThread?: Maybe<CreateMarketplaceItemThreadPayload>;
  readonly createNewDevice?: Maybe<CreateNewDevice>;
  readonly createOccupancySurvey?: Maybe<CreateOccupancySurvey>;
  readonly createOpenedConversation?: Maybe<CreateOpenedConversation>;
  readonly createOrUpdateUserSession?: Maybe<CreateOrUpdateUserSessionPayload>;
  readonly createPayment?: Maybe<CreatePaymentPayload>;
  readonly createReportingConfiguration?: Maybe<CreateReportingConfigurationPayload>;
  readonly createResidencyAndResidents?: Maybe<CreateResidencyAndResidents>;
  readonly createResidencyDocument?: Maybe<CreateResidencyDocumentPayload>;
  readonly createResidencyDocumentView?: Maybe<CreateResidencyDocumentViewPayload>;
  readonly createResidencyDocuments?: Maybe<CreateResidencyDocuments>;
  readonly createResidencySubscription?: Maybe<CreateResidencySubscriptionPayload>;
  /**
   * Submit (or re-submit) the household's safety records.
   *
   * Decoupled from consent: this mutation only persists declared needs and
   * audits NEEDS_SUBMITTED / NEEDS_UPDATED / OCCUPANT_REMOVED. Consent is
   * captured via the dedicated GiveSafetyConsent / DeclineSafetyConsent
   * mutations called separately from the resident app.
   */
  readonly createResidentSafetyRecord?: Maybe<CreateResidentSafetyRecordPayload>;
  readonly createRule?: Maybe<CreateRulePayload>;
  readonly createRuleAction?: Maybe<CreateRuleActionPayload>;
  readonly createRuleConditions?: Maybe<CreateRuleConditions>;
  readonly createSafetyCenterDocument?: Maybe<CreateSafetyCenterDocumentPayload>;
  readonly createScheduledMessage?: Maybe<CreateScheduledMessagePayload>;
  readonly createStripeAccount?: Maybe<CreateStripeAccount>;
  readonly createSurvey?: Maybe<CreateSurveyPayload>;
  readonly createTask?: Maybe<CreateTaskPayload>;
  readonly createTaskDefinition?: Maybe<CreateTaskDefinitionPayload>;
  readonly createTaskDocument?: Maybe<CreateTaskDocumentPayload>;
  readonly createTaskFromConversation?: Maybe<CreateTaskFromConversationPayload>;
  readonly createTaskGroup?: Maybe<CreateTaskGroupPayload>;
  readonly createTaskTemplate?: Maybe<CreateTaskTemplatePayload>;
  readonly createTeam?: Maybe<CreateTeamPayload>;
  readonly createTemplateFromChecklist?: Maybe<CreateTemplateFromChecklistPayload>;
  readonly createTenancyApplication?: Maybe<CreateTenancyApplicationPayload>;
  readonly createUpdateComment?: Maybe<CreateUpdateCommentPayload>;
  readonly createUserDocument?: Maybe<CreateUserDocumentPayload>;
  readonly createUserDocumentTag?: Maybe<CreateUserDocumentTagPayload>;
  readonly createUserDocumentView?: Maybe<CreateUserDocumentViewPayload>;
  readonly deactivateClientUser?: Maybe<DeactivateClientUserPayload>;
  readonly deactivateGroup?: Maybe<DeactivateGroupPayload>;
  readonly declinePcfra?: Maybe<DeclinePcfra>;
  /** Resident declines (for now) a PCFRA against a specific safety record. */
  readonly declineSafetyConsent?: Maybe<DeclineSafetyConsent>;
  readonly deleteAmenity?: Maybe<DeleteAmenityPayload>;
  readonly deleteApplicant?: Maybe<DeleteApplicant>;
  readonly deleteAttachment?: Maybe<DeleteAttachmentPayload>;
  readonly deleteChecklist?: Maybe<DeleteChecklistPayload>;
  readonly deleteChecklistItemMedia?: Maybe<DeleteChecklistItemMediaPayload>;
  readonly deleteCommunityDocument?: Maybe<DeleteCommunityDocumentPayload>;
  readonly deleteCommunityProduct?: Maybe<DeleteCommunityProductPayload>;
  readonly deleteCommunityUpdate?: Maybe<DeleteCommunityUpdatePayload>;
  readonly deleteCommunityUpdateAttachment?: Maybe<DeleteCommunityUpdateAttachmentPayload>;
  readonly deleteComplianceRequirementV2?: Maybe<DeleteComplianceRequirementV2Payload>;
  readonly deleteConversationTag?: Maybe<DeleteConversationTagPayload>;
  readonly deleteGroupChatMessageReaction?: Maybe<DeleteGroupChatMessageReactionPayload>;
  readonly deleteHome?: Maybe<DeleteHomePayload>;
  readonly deleteHomeImage?: Maybe<DeleteHomeImagePayload>;
  /**
   * Hard-delete one image from a listing.
   *
   * ``IsOwnerOfMarketplaceItemImage`` is the fix for a live hole: this
   * mutation shipped with ``permission_classes = []``, so any authenticated
   * user could delete any listing's image. That fix sits at the legacy layer
   * on purpose — the Access V2 requirement below is inert until
   * ``ACCESS_RBAC_BACKED`` is on and so closes nothing today.
   */
  readonly deleteMarketplaceItemImage?: Maybe<DeleteMarketplaceItemImagePayload>;
  readonly deleteReportingConfiguration?: Maybe<DeleteReportingConfigurationPayload>;
  readonly deleteRuleAction?: Maybe<DeleteRuleActionPayload>;
  readonly deleteRuleCondition?: Maybe<DeleteRuleConditionPayload>;
  readonly deleteUpdateComment?: Maybe<DeleteCommunityUpdateCommentPayload>;
  readonly dismissAsanaPendingTask?: Maybe<DismissAsanaPendingTaskPayload>;
  readonly dismissFeatureAnnouncement?: Maybe<DismissFeatureAnnouncementPayload>;
  readonly editKey?: Maybe<EditKeyPayload>;
  readonly editMember?: Maybe<EditMemberPayload>;
  readonly employerUpdateEmploymentDetails?: Maybe<EmployerUpdateEmploymentDetailsPayload>;
  readonly employerUpdatePersonalDetails?: Maybe<EmployerUpdatePersonalDetailsPayload>;
  readonly fakeCreditCheck?: Maybe<FakeCreditCheckMutationPayload>;
  readonly fakeSendTenantReferenceRequest?: Maybe<FakeSendTenantReferenceRequestPayload>;
  readonly fakeStripeInvoicePaidEvent?: Maybe<FakeStripeInvoicePaidEventPayload>;
  readonly flagChecklistItem?: Maybe<FlagChecklistItemPayload>;
  readonly generateEes?: Maybe<GenerateEes>;
  readonly generateHomeSafetyForm?: Maybe<GenerateHomeSafetyForm>;
  readonly generatePeepsExport?: Maybe<GeneratePeepsExport>;
  readonly generateSafetyDocumentQrPdf?: Maybe<GenerateSafetyDocumentQrPdf>;
  readonly generateSafetyRecordActivityPdf?: Maybe<GenerateSafetyRecordActivityPdf>;
  readonly generateSibPack?: Maybe<GenerateSibPack>;
  readonly generateSibPackQrPdf?: Maybe<GenerateSibPackQrPdf>;
  readonly giveFireServiceConsent?: Maybe<GiveFireServiceConsent>;
  /** Resident gives consent for a PCFRA against a specific safety record. */
  readonly giveSafetyConsent?: Maybe<GiveSafetyConsent>;
  readonly ignoreMessageSuggestion?: Maybe<IgnoreMessageSuggestionPayload>;
  readonly initializeCalendarLink?: Maybe<CalendarLinkType>;
  readonly initializeSignup?: Maybe<InitializeSignup>;
  readonly inviteDemoUser?: Maybe<InviteDemoUserPayload>;
  readonly labelConversation?: Maybe<LabelConversationPayload>;
  readonly landlordUpdateLandlordReference?: Maybe<LandlordUpdateLandlordReferencePayload>;
  readonly landlordUpdateRentalDetails?: Maybe<LandlordUpdateRentalDetailsPayload>;
  readonly linkConversationToTask?: Maybe<LinkConversationToTaskPayload>;
  readonly linkSafetySubject?: Maybe<LinkSafetySubjectPayload>;
  readonly linkTaskToAsana?: Maybe<LinkTaskToAsanaPayload>;
  readonly linkTaskToFixflo?: Maybe<LinkTaskToFixfloPayload>;
  readonly logDocumentRead?: Maybe<LogDocumentReadPayload>;
  readonly logManagerDashUse?: Maybe<LogManagerDashUse>;
  readonly logPublicDocumentRead?: Maybe<LogPublicDocumentReadPayload>;
  readonly logUserAppUse?: Maybe<LogUserAppUsePayload>;
  readonly managerAddApplicationHome?: Maybe<ManagerAddApplicationHomePayload>;
  readonly managerCancelAmenityReservation?: Maybe<ManagerCancelAmenityReservationPayload>;
  readonly managerCreateAmenityReservation?: Maybe<ManagerCreateAmenityReservationPayload>;
  readonly managerReserveAmenity?: Maybe<ManagerReserveAmenityPayload>;
  readonly markApplicationThreadAsRead?: Maybe<MarkApplicationThreadAsReadPayload>;
  readonly markSafetyReviewRequestOpened?: Maybe<MarkSafetyReviewRequestOpened>;
  readonly markSibPackPrinted?: Maybe<MarkSibPackPrinted>;
  readonly markSuggestionShown?: Maybe<MarkSuggestionShownPayload>;
  /**
   * Mark the other participant's messages in a thread as read.
   *
   * Gated on ``marketplace_item_thread`` edit rather than
   * ``marketplace_item_thread_message`` edit: the write targets every unread
   * message in the thread and no message id is supplied, so the thread is the
   * only object the requirement can bind to. Binding the thread still routes
   * through the thread ownership policy, which limits the caller to threads
   * they inquire on or own the listing for.
   */
  readonly markThreadMessagesAsRead?: Maybe<MarkThreadMessagesAsReadPayload>;
  readonly newCreateApplication?: Maybe<NewCreateApplication>;
  readonly offerPcfra?: Maybe<OfferPcfra>;
  readonly officiallyVerifyRightToRent?: Maybe<OfficiallyVerifyRightToRentPayload>;
  readonly orderConversationTags?: Maybe<OrderConversationTagsPayload>;
  readonly packageReminderToAll?: Maybe<PackageReminderToAll>;
  readonly packageReminderToHome?: Maybe<PackageReminderToHomePayload>;
  readonly payForDocument?: Maybe<PayForDocumentPayload>;
  readonly payForUnpaidApplicationReferences?: Maybe<PayForUnpaidApplicationReferencesPayload>;
  readonly publishCommunityUpdate?: Maybe<PublishCommunityUpdatePayload>;
  readonly pushTaskToAsana?: Maybe<PushTaskToAsanaPayload>;
  readonly rateConversation?: Maybe<RateConversationPayload>;
  readonly reOpenConversation?: Maybe<ReOpenConversationPayload>;
  readonly readAllNotifications?: Maybe<ReadAllNotificationsPayload>;
  readonly readAllNotificationsOnTarget?: Maybe<ReadAllNotificationsOnTargetPayload>;
  readonly readNotification?: Maybe<ReadNotificationPayload>;
  readonly reconcileSafetyDeclaration?: Maybe<ReconcileSafetyDeclaration>;
  readonly reconfirmSafetyRecord?: Maybe<ReconfirmSafetyRecord>;
  readonly recordConversationRatingPrompt?: Maybe<RecordConversationRatingPromptPayload>;
  readonly recordReportingConfigurationOpened?: Maybe<RecordReportingConfigurationOpenedPayload>;
  readonly referenceSignupError?: Maybe<ReferenceSignupErrorPayload>;
  readonly rejectApplication?: Maybe<RejectApplication>;
  readonly rejectBlockGroupSuggestion?: Maybe<RejectBlockGroupSuggestionPayload>;
  readonly rejectBlockSuggestion?: Maybe<RejectBlockSuggestionPayload>;
  readonly relateBlockGroupSuggestionToCommunityGroup?: Maybe<RelateBlockGroupSuggestionToCommunityGroupPayload>;
  readonly remindAllApplicants?: Maybe<RemindAllApplicants>;
  readonly remindApplicant?: Maybe<RemindApplicant>;
  readonly remindResident?: Maybe<RemindResidentPayload>;
  readonly removeConversationTag?: Maybe<RemoveConversationTagPayload>;
  readonly removeResidentFromUnpaidEvents?: Maybe<RemoveResidentFromUnpaidEventsPayload>;
  readonly removeResidentsFromResidency?: Maybe<RemoveResidentsFromResidencyPayload>;
  readonly removeTaskDocument?: Maybe<RemoveTaskDocumentPayload>;
  readonly removeTeamMember?: Maybe<RemoveTeamMemberPayload>;
  readonly renameTask?: Maybe<RenameTaskPayload>;
  readonly resendMemberInviteEmail?: Maybe<ResendMemberInviteEmailPayload>;
  readonly reserveAmenity?: Maybe<ReserveAmenityPayload>;
  readonly reserveAmenitySlot?: Maybe<ReserveAmenitySlotPayload>;
  readonly residentArchiveKeyholder?: Maybe<ResidentArchiveKeyholderPayload>;
  readonly residentCreateKeyholder?: Maybe<ResidentCreateKeyholder>;
  readonly residentUnarchiveKeyholder?: Maybe<ResidentUnarchiveKeyholderPayload>;
  readonly residentUpdateKeyholder?: Maybe<ResidentUpdateKeyholderPayload>;
  readonly resolveChecklistAction?: Maybe<ResolveChecklistActionPayload>;
  readonly respondToContractorSuggestion?: Maybe<RespondToContractorSuggestionPayload>;
  readonly respondToPcfra?: Maybe<RespondToPcfra>;
  readonly restartIdentityVerification?: Maybe<RestartIdentityVerificationPayload>;
  readonly retryDocumentExtraction?: Maybe<RetryDocumentExtractionPayload>;
  readonly reviewInspectionAction?: Maybe<ReviewInspectionActionPayload>;
  readonly revokeCommunityStaffRole?: Maybe<RevokeCommunityStaffRolePayload>;
  readonly revokeGeneratedAgreement?: Maybe<RevokeGeneratedAgreementPayload>;
  readonly rotateSafetyResponderToken?: Maybe<RotateSafetyResponderToken>;
  readonly saveAmenity?: Maybe<SaveAmenityPayload>;
  readonly saveAmenityOperatingTimes?: Maybe<SaveAmenityOperatingTimesPayload>;
  readonly saveCommunityEvent?: Maybe<SaveCommunityEventPayload>;
  readonly saveCommunityUpdate?: Maybe<SaveCommunityUpdatePayload>;
  readonly saveContactNote?: Maybe<SaveContactNotePayload>;
  readonly saveGeneratedAgreement?: Maybe<SaveGeneratedAgreementPayload>;
  readonly saveGeneratedSection21?: Maybe<SaveGeneratedSection21Payload>;
  readonly saveHome?: Maybe<SaveHomePayload>;
  readonly saveManagerProfile?: Maybe<SaveManagerProfilePayload>;
  readonly saveMarketplaceItem?: Maybe<SaveMarketplaceItemPayload>;
  readonly saveRequirementItem?: Maybe<SaveRequirementItemPayload>;
  readonly saveResidentSurveyAnswer?: Maybe<SaveResidentSurveyAnswerPayload>;
  readonly saveTenantEmploymentDetails?: Maybe<SaveTenantEmploymentDetailsPayload>;
  readonly schedulePublishCommunityUpdate?: Maybe<SchedulePublishCommunityUpdatePayload>;
  readonly sendAgreementForSigning?: Maybe<SendAgreementForSigning>;
  readonly sendApplicationSupportMessage?: Maybe<SendApplicationSupportMessagePayload>;
  readonly sendApplicationThreadMessage?: Maybe<SendApplicationThreadMessagePayload>;
  readonly sendConversationToAsana?: Maybe<SendConversationToAsanaPayload>;
  readonly sendDocument?: Maybe<SendDocument>;
  readonly sendManagerAmplitudeTest?: Maybe<SendManagerAmplitudeTestPayload>;
  readonly sendPaymentReceiptEmail?: Maybe<SendPaymentReceiptEmailPayload>;
  readonly sendSafetyReminder?: Maybe<SendSafetyReminder>;
  readonly sendSafetyReviewRequest?: Maybe<SendSafetyReviewRequest>;
  readonly sendTenantReferenceRequests?: Maybe<SendTenantReferenceRequestsPayload>;
  readonly setChecklistItemDueDate?: Maybe<SetChecklistItemDueDatePayload>;
  readonly setChecklistSectionDueDate?: Maybe<SetChecklistSectionDueDatePayload>;
  readonly setConversationHome?: Maybe<SetConversationHomePayload>;
  readonly setReportingFavourite?: Maybe<SetReportingFavouritePayload>;
  readonly setReportingSchedule?: Maybe<SetReportingSchedulePayload>;
  readonly setResidencyCompletionDate?: Maybe<SetResidencyCompletionDatePayload>;
  readonly setResidentAppLocale?: Maybe<SetResidentAppLocalePayload>;
  readonly setSafetyDocumentBlock?: Maybe<SetSafetyDocumentBlock>;
  readonly setSafetyDocumentInSibPack?: Maybe<SetSafetyDocumentInSibPack>;
  readonly setSafetyDocumentResidentVisible?: Maybe<SetSafetyDocumentResidentVisible>;
  readonly setSafetySubjectContactEmail?: Maybe<SetSafetySubjectContactEmailPayload>;
  readonly setUpManager?: Maybe<SetUpManagerPayload>;
  readonly shareComplianceRequirement?: Maybe<ShareComplianceRequirementPayload>;
  readonly signOffChecklist?: Maybe<SignOffChecklistPayload>;
  readonly signOutCommunityVisitor?: Maybe<SignOutCommunityVisitorPayload>;
  readonly snoozeConversation?: Maybe<SnoozeConversationPayload>;
  readonly startBulkConversationClose?: Maybe<StartBulkConversationClose>;
  readonly startBulkDeactivation?: Maybe<StartBulkDeactivationPayload>;
  readonly submitEmployerReference?: Maybe<SubmitEmployerReferencePayload>;
  readonly submitIdentityVerification?: Maybe<SubmitIdentityVerificationPayload>;
  readonly submitLandlordReference?: Maybe<SubmitLandlordReferencePayload>;
  readonly submitTenantReference?: Maybe<SubmitTenantReferencePayload>;
  readonly subscribeLandlord?: Maybe<SubscribeLandlordPayload>;
  readonly subscribeToNotificationGroup?: Maybe<SubscribeToNotificationGroup>;
  readonly suggestRemediationSteps?: Maybe<SuggestRemediationStepsPayload>;
  readonly tagConversation?: Maybe<TagConversationPayload>;
  readonly toggleAllResidentAppNotificationPreferences?: Maybe<ToggleAllResidentAppNotificationPreferencesPayload>;
  readonly toggleArchivedAtCommunityDocument?: Maybe<ToggleArchivedAtCommunityDocumentPayload>;
  readonly toggleArchivedAtCommunityUpdate?: Maybe<ToggleArchivedAtCommunityUpdatePayload>;
  readonly toggleClientTagArchivedAt?: Maybe<ToggleClientTagArchivedAtPayload>;
  readonly toggleCommunityUpdateBookmark?: Maybe<ToggleCommunityUpdateBookmarkPayload>;
  readonly toggleCommunityUpdateLike?: Maybe<ToggleCommunityUpdateLikePayload>;
  readonly toggleMarketplaceItemClose?: Maybe<ToggleMarketplaceItemClosePayload>;
  readonly toggleRuleActivated?: Maybe<ToggleRuleActivatedPayload>;
  readonly toggleTeamActivated?: Maybe<ToggleTeamActivatedPayload>;
  readonly unarchiveApplication?: Maybe<UnarchiveApplicationPayload>;
  readonly unarchiveKey?: Maybe<UnarchiveKeyPayload>;
  readonly unarchiveKeyholder?: Maybe<UnarchiveKeyholderPayload>;
  readonly unarchiveTask?: Maybe<UnarchiveTaskPayload>;
  readonly unarchiveTaskGroup?: Maybe<UnarchiveTaskGroupPayload>;
  readonly unarchiveTaskTemplate?: Maybe<UnarchiveTaskTemplatePayload>;
  readonly unassignClientTag?: Maybe<UnassignClientTagPayload>;
  readonly unassignClientTagFromCommunityDocument?: Maybe<UnassignClientTagFromCommunityDocumentPayload>;
  readonly unassignClientTagFromTaskDefinition?: Maybe<UnassignClientTagFromTaskDefinitionPayload>;
  readonly unassignClientTagFromUserDocument?: Maybe<UnassignClientTagFromUserDocumentPayload>;
  readonly unassignTeam?: Maybe<UnassignTeamPayload>;
  readonly unbookCommunityEvent?: Maybe<UnbookCommunityEventMutationPayload>;
  readonly unflagChecklistItem?: Maybe<UnflagChecklistItemPayload>;
  readonly unlabelConversation?: Maybe<UnlabelConversationPayload>;
  readonly unlinkTaskFromAsana?: Maybe<UnlinkTaskFromAsanaPayload>;
  readonly unlinkTaskFromFixflo?: Maybe<UnlinkTaskFromFixfloPayload>;
  readonly unreadAllNotificationsOnTarget?: Maybe<UnreadAllNotificationsOnTargetPayload>;
  readonly unreadNotification?: Maybe<UnreadNotificationPayload>;
  readonly unsnoozeConversation?: Maybe<UnsnoozeConversationPayload>;
  readonly unsubscribeFromNotificationGroup?: Maybe<UnsubscribeFromNotificationGroup>;
  readonly updateAmenityOperatingSchedule?: Maybe<UpdateAmenityOperatingSchedulePayload>;
  readonly updateAmenityType?: Maybe<UpdateAmenityTypePayload>;
  readonly updateApplicationCommunity?: Maybe<UpdateApplicationCommunity>;
  readonly updateApplicationHome?: Maybe<UpdateApplicationHome>;
  readonly updateAttachment?: Maybe<UpdateAttachmentPayload>;
  readonly updateBlockHomes?: Maybe<UpdateBlockHomesPayload>;
  readonly updateBlockSafetyIdentity?: Maybe<UpdateBlockSafetyIdentityPayload>;
  readonly updateBlockSuggestionHomes?: Maybe<UpdateBlockSuggestionHomesPayload>;
  readonly updateChecklist?: Maybe<UpdateChecklistPayload>;
  readonly updateChecklistStructure?: Maybe<UpdateChecklistStructurePayload>;
  readonly updateClientAdmin?: Maybe<UpdateClientAdminPayload>;
  readonly updateClientContractorCompany?: Maybe<UpdateClientContractorCompanyPayload>;
  readonly updateClientContractorCompanyCommunities?: Maybe<UpdateClientContractorCompanyCommunitiesPayload>;
  readonly updateClientContractorCompanyContractors?: Maybe<UpdateClientContractorCompanyContractorsPayload>;
  readonly updateClientTag?: Maybe<UpdateClientTagPayload>;
  readonly updateClientTagColor?: Maybe<UpdateClientTagColorPayload>;
  readonly updateCommunityDocument?: Maybe<UpdateCommunityDocumentPayload>;
  readonly updateCommunityProduct?: Maybe<UpdateCommunityProductPayload>;
  /** Set the Responsible Person details printed on EES PDFs. */
  readonly updateCommunityResponsiblePerson?: Maybe<UpdateCommunityResponsiblePerson>;
  readonly updateCommunitySettings?: Maybe<UpdateCommunitySettingsPayload>;
  /** Toggle the annual SIB-pack review nudge and tweak the lead-time months. */
  readonly updateCommunitySibPackReviewSettings?: Maybe<UpdateCommunitySibPackReviewSettings>;
  readonly updateCommunityTaskDefinition?: Maybe<UpdateCommunityTaskDefinitionPayload>;
  readonly updateContactGroups?: Maybe<UpdateContactGroupsPayload>;
  readonly updateContractor?: Maybe<UpdateContractorPayload>;
  readonly updateConversationNote?: Maybe<UpdateConversationNotePayload>;
  readonly updateConversationParticipantType?: Maybe<UpdateConversationParticipantTypePayload>;
  readonly updateConversationTag?: Maybe<UpdateConversationTagPayload>;
  readonly updateConversationTitle?: Maybe<UpdateConversationTitlePayload>;
  readonly updateConversationUrgency?: Maybe<UpdateConversationUrgency>;
  readonly updateEmployerReference?: Maybe<UpdateEmployerReferencePayload>;
  readonly updateEmployerReferenceStep?: Maybe<UpdateEmployerReferenceStepPayload>;
  readonly updateGroup?: Maybe<UpdateGroupPayload>;
  readonly updateGroupDescription?: Maybe<UpdateGroupDescriptionPayload>;
  readonly updateHomeAddress?: Maybe<UpdateHomeAddressPayload>;
  readonly updateHomeDetails?: Maybe<UpdateHomeDetailsPayload>;
  readonly updateHomeFloorNumber?: Maybe<UpdateHomeFloorNumberPayload>;
  readonly updateKeyholder?: Maybe<UpdateKeyholderPayload>;
  readonly updateLandlord?: Maybe<UpdateLandlordPayload>;
  readonly updateLandlordReference?: Maybe<UpdateLandlordReferencePayload>;
  readonly updateLandlordReferenceComments?: Maybe<UpdateLandlordReferenceCommentsPayload>;
  readonly updateLandlordReferenceStep?: Maybe<UpdateLandlordReferenceStepPayload>;
  readonly updateManager?: Maybe<UpdateManagerPayload>;
  readonly updateManagerNotificationSettings?: Maybe<UpdateManagerNotificationSettingsPayload>;
  readonly updateMobileNumber?: Maybe<UpdateUserMobileNumberPayload>;
  readonly updateNotificationPreference?: Maybe<UpdateNotificationPreferencePayload>;
  readonly updatePackageLocation?: Maybe<UpdatePackageLocationPayload>;
  readonly updatePackageStatus?: Maybe<UpdatePackageStatusPayload>;
  readonly updateReferenceAddressHistory?: Maybe<UpdateReferenceAddressHistoryPayload>;
  readonly updateReferenceStartedOn?: Maybe<UpdateReferenceStartedOnPayload>;
  readonly updateReportingConfiguration?: Maybe<UpdateReportingConfigurationPayload>;
  readonly updateResidencyAndResidents?: Maybe<UpdateResidencyAndResidents>;
  readonly updateResidencyDocument?: Maybe<UpdateResidencyDocumentPayload>;
  readonly updateResidentAppNotificationPreferences?: Maybe<UpdateResidentAppNotificationPreferencesPayload>;
  readonly updateResidentSafetyRecord?: Maybe<UpdateResidentSafetyRecord>;
  readonly updateRightToRent?: Maybe<UpdateRightToRentPayload>;
  readonly updateRule?: Maybe<UpdateRulePayload>;
  readonly updateRuleCategoryContentTypes?: Maybe<UpdateRuleCategoryContentTypes>;
  readonly updateRuleCommunities?: Maybe<UpdateRuleCommunitiesPayload>;
  readonly updateRuleCondition?: Maybe<UpdateRuleConditionPayload>;
  readonly updateSafetyCenterDocument?: Maybe<UpdateSafetyCenterDocumentPayload>;
  readonly updateSafetyReviewInterval?: Maybe<UpdateSafetyReviewInterval>;
  readonly updateScheduledMessage?: Maybe<UpdateScheduledMessage>;
  readonly updateTask?: Maybe<UpdateTaskPayload>;
  readonly updateTaskDefinitionDescription?: Maybe<UpdateTaskDefinitionDescriptionPayload>;
  readonly updateTaskDefinitionPriority?: Maybe<UpdateTaskDefinitionPriorityPayload>;
  readonly updateTaskDefinitionVisibility?: Maybe<UpdateTaskDefinitionVisibilityPayload>;
  readonly updateTaskGroup?: Maybe<UpdateTaskGroupPayload>;
  readonly updateTaskPriority?: Maybe<UpdateTaskPriorityPayload>;
  readonly updateTaskTemplate?: Maybe<UpdateTaskTemplatePayload>;
  readonly updateTaskTemplateStructure?: Maybe<UpdateTaskTemplateStructurePayload>;
  readonly updateTeamCommunities?: Maybe<UpdateTeamCommunitiesPayload>;
  readonly updateTeamDetails?: Maybe<UpdateTeamDetailsPayload>;
  readonly updateTeamIcon?: Maybe<UpdateTeamIconPayload>;
  readonly updateTeamMembers?: Maybe<UpdateTeamMembersPayload>;
  readonly updateTenantReference?: Maybe<UpdateTenantReferencePayload>;
  readonly updateTenantReferenceStep?: Maybe<UpdateTenantReferenceStepPayload>;
  readonly updateUser?: Maybe<UpdateUserPayload>;
  readonly updateUserDocument?: Maybe<UpdateUserDocumentPayload>;
  readonly updateUserProfile?: Maybe<UpdateUserProfilePayload>;
  readonly upgradeLandlordToSubscription?: Maybe<UpgradeLandlordToSubscriptionPayload>;
  readonly viewFeatureAnnouncement?: Maybe<ViewFeatureAnnouncementPayload>;
  readonly viewUserFeatureAnnouncement?: Maybe<ViewUserFeatureAnnouncementPayload>;
  readonly voidSafetyDeclaration?: Maybe<VoidSafetyDeclaration>;
  readonly withdrawFireServiceConsent?: Maybe<WithdrawFireServiceConsent>;
};


export type MutationAcceptApplicationArgs = {
  application: Scalars['UUID']['input'];
  home?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationAcceptAsanaPendingTaskArgs = {
  input: AcceptAsanaPendingTaskInput;
};


export type MutationAcceptBlockGroupSuggestionArgs = {
  input: AcceptBlockGroupSuggestionInput;
};


export type MutationAcceptBlockSuggestionArgs = {
  input: AcceptBlockSuggestionInput;
};


export type MutationAcceptFeatureAnnouncementArgs = {
  input: AcceptFeatureAnnouncementInput;
};


export type MutationAcceptMessageSuggestionArgs = {
  input: AcceptMessageSuggestionInput;
};


export type MutationAcceptServiceChargeWaiverArgs = {
  input: AcceptServiceChargeWaiverInput;
};


export type MutationAcceptTermsAndConditionsArgs = {
  input: AcceptTermsAndConditionsInput;
};


export type MutationAcceptWaiverArgs = {
  input: AcceptWaiverInput;
};


export type MutationActivateGroupArgs = {
  input: ActivateGroupInput;
};


export type MutationActivateSafetyComplianceV2Args = {
  communityId: Scalars['UUID']['input'];
  confirm: Scalars['Boolean']['input'];
};


export type MutationActivateSafetyResponderTokenArgs = {
  packId: Scalars['UUID']['input'];
  replacementQrsInstalled: Scalars['Boolean']['input'];
};


export type MutationAddApplicationCommunityArgs = {
  application: Scalars['UUID']['input'];
  community: Scalars['UUID']['input'];
};


export type MutationAddApplicationHomeArgs = {
  application: Scalars['ID']['input'];
  home: Scalars['UUID']['input'];
};


export type MutationAddApplicationOwnershipTypeArgs = {
  application: Scalars['ID']['input'];
  isResident: Scalars['Boolean']['input'];
  ownershipType: Scalars['String']['input'];
};


export type MutationAddContractorToClientContractorCompanyArgs = {
  input: AddContractorToClientContractorCompanyInput;
};


export type MutationAddDocumentSentStatusArgs = {
  application: Scalars['ID']['input'];
};


export type MutationAddFeatureToClientArgs = {
  input: AddFeatureToClientInput;
};


export type MutationAddMemberArgs = {
  input: AddMemberInput;
};


export type MutationAddMessageToThreadArgs = {
  input: AddMessageToThreadInput;
};


export type MutationAddPackageToHomeArgs = {
  input: AddPackageToHomeInput;
};


export type MutationAddTaskCommentArgs = {
  input: AddTaskCommentInput;
};


export type MutationAddTeamMembersArgs = {
  input: AddTeamMembersInput;
};


export type MutationAddUnknownCommunityStatusArgs = {
  application: Scalars['ID']['input'];
};


export type MutationAgreeEesArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationArchiveAllNotificationsOnTargetArgs = {
  input: ArchiveAllNotificationsOnTargetInput;
};


export type MutationArchiveApplicationArgs = {
  input: ArchiveApplicationInput;
};


export type MutationArchiveCommunityEventArgs = {
  input: ArchiveCommunityEventInput;
};


export type MutationArchiveContactNoteArgs = {
  input: ArchiveContactNoteInput;
};


export type MutationArchiveKeyArgs = {
  input: ArchiveKeyInput;
};


export type MutationArchiveKeyholderArgs = {
  input: ArchiveKeyholderInput;
};


export type MutationArchiveMarketplaceItemArgs = {
  input: ArchiveMarketplaceItemInput;
};


export type MutationArchiveNotificationArgs = {
  input: ArchiveNotificationInput;
};


export type MutationArchiveSafetyCenterDocumentArgs = {
  input: ArchiveSafetyCenterDocumentInput;
};


export type MutationArchiveSafetySubjectArgs = {
  input: ArchiveSafetySubjectInput;
};


export type MutationArchiveTagArgs = {
  input: ArchiveTagInput;
};


export type MutationArchiveTaskArgs = {
  input: ArchiveTaskInput;
};


export type MutationArchiveTaskGroupArgs = {
  input: ArchiveTaskGroupInput;
};


export type MutationArchiveTaskTemplateArgs = {
  input: ArchiveTaskTemplateInput;
};


export type MutationAssignChecklistItemArgs = {
  input: AssignChecklistItemInput;
};


export type MutationAssignChecklistSectionArgs = {
  input: AssignChecklistSectionInput;
};


export type MutationAssignClientTagArgs = {
  input: AssignClientTagInput;
};


export type MutationAssignClientTagToCommunityDocumentArgs = {
  input: AssignClientTagToCommunityDocumentInput;
};


export type MutationAssignClientTagToTaskDefinitionArgs = {
  input: AssignClientTagToTaskDefinitionInput;
};


export type MutationAssignClientTagToUserDocumentArgs = {
  input: AssignClientTagToUserDocumentInput;
};


export type MutationAssignCommunityStaffRoleArgs = {
  input: AssignCommunityStaffRoleInput;
};


export type MutationAssignContractorToTaskArgs = {
  input: AssignContractorToTaskInput;
};


export type MutationAssignTaskArgs = {
  input: AssignTaskInput;
};


export type MutationAssignTeamArgs = {
  input: AssignTeamInput;
};


export type MutationAssociateAgreementWithClientArgs = {
  input: AssociateAgreementWithClientInput;
};


export type MutationAssociateSection21WithClientArgs = {
  input: AssociateSection21WithClientInput;
};


export type MutationBatchCreateTaskDocumentsArgs = {
  input: BatchCreateTaskDocumentsInput;
};


export type MutationBookCommunityEventArgs = {
  input: BookCommunityEventMutationInput;
};


export type MutationBookPaidCommunityEventArgs = {
  input: BookPaidCommunityEventMutationInput;
};


export type MutationCancelAmenityReservationArgs = {
  input: CancelAmenityReservationInput;
};


export type MutationCancelPaymentArgs = {
  input: CancelPaymentInput;
};


export type MutationCancelScheduledMessageArgs = {
  input: CancelScheduledMessageInput;
};


export type MutationCancelScheduledPublishCommunityUpdateArgs = {
  input: CancelScheduledPublishCommunityUpdateInput;
};


export type MutationChangeTaskStatusArgs = {
  input: ChangeTaskStatusInput;
};


export type MutationCheckBlockSuggestionHomesArgs = {
  input: CheckBlockSuggestionHomesInput;
};


export type MutationCheckInKeyV2Args = {
  input: CheckInKeyV2Input;
};


export type MutationCheckOutKeyV2Args = {
  input: CheckOutKeyV2Input;
};


export type MutationCloseConversationArgs = {
  input: CloseConversationInput;
};


export type MutationCloseSurveyArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCollectPackagesArgs = {
  input: CollectPackagesInput;
};


export type MutationCollectPackagesForHomeArgs = {
  input: CollectPackagesForHomeInput;
};


export type MutationCompleteChecklistItemArgs = {
  input: CompleteChecklistItemInput;
};


export type MutationConfirmResidencyWillRollArgs = {
  input: ConfirmResidencyWillRollInput;
};


export type MutationContactApplicationSupportArgs = {
  input: ContactApplicationSupportInput;
};


export type MutationContactPackagesReminderArgs = {
  input: ContactPackagesReminderInput;
};


export type MutationCorrectInspectionSeriesArgs = {
  input: CorrectInspectionSeriesInput;
};


export type MutationCountersignAgreementArgs = {
  input: CountersignAgreementInput;
};


export type MutationCreateAgreementForTenancyArgs = {
  input: CreateAgreementForTenancyInput;
};


export type MutationCreateAmenityReservationArgs = {
  input: CreateAmenityReservationMutationInput;
};


export type MutationCreateApplicantAndApplicationArgs = {
  input: CreateApplicantAndApplicationInput;
};


export type MutationCreateApplicationArgs = {
  input: CreateApplicationInput;
};


export type MutationCreateApplicationThreadArgs = {
  input: CreateApplicationThreadMutationInput;
};


export type MutationCreateAttachmentOnHomeArgs = {
  input: CreateAttachmentOnHomeInput;
};


export type MutationCreateAttachmentOnRequirementItemArgs = {
  input: CreateAttachmentOnRequirementItemInput;
};


export type MutationCreateBlockComplianceRequirementItemArgs = {
  input: CreateBlockComplianceRequirementItemInput;
};


export type MutationCreateBlockGroupSuggestionsArgs = {
  input: CreateBlockGroupSuggestionsInput;
};


export type MutationCreateBlocksArgs = {
  blockNames?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communityId: Scalars['UUID']['input'];
};


export type MutationCreateBlocksComplianceRequirementArgs = {
  input: CreateBlocksComplianceRequirementInput;
};


export type MutationCreateChecklistArgs = {
  input: CreateChecklistInput;
};


export type MutationCreateChecklistFromTemplateArgs = {
  input: CreateChecklistFromTemplateInput;
};


export type MutationCreateChecklistItemCommentArgs = {
  input: CreateChecklistItemCommentInput;
};


export type MutationCreateChecklistItemMediaArgs = {
  input: CreateChecklistItemMediaInput;
};


export type MutationCreateChecklistWithStructureArgs = {
  input: CreateChecklistWithStructureInput;
};


export type MutationCreateCheckoutLinkArgs = {
  input: CreateCheckoutLinkInput;
};


export type MutationCreateClientContractorCompanyArgs = {
  input: CreateClientContractorCompanyInput;
};


export type MutationCreateClientTagArgs = {
  input: CreateClientTagInput;
};


export type MutationCreateCommunityDocumentArgs = {
  input: CreateCommunityDocumentInput;
};


export type MutationCreateCommunityDocumentReminderArgs = {
  input: CreateCommunityDocumentReminderInput;
};


export type MutationCreateCommunityDocumentTagArgs = {
  input: CreateCommunityDocumentTagInput;
};


export type MutationCreateCommunityDocumentViewArgs = {
  input: CreateCommunityDocumentViewInput;
};


export type MutationCreateCommunityProductArgs = {
  input: CreateCommunityProductInput;
};


export type MutationCreateCommunityProductPaymentArgs = {
  input: CreateCommunityProductPaymentInput;
};


export type MutationCreateCommunityTaskDefinitionArgs = {
  input: CreateCommunityTaskDefinitionInput;
};


export type MutationCreateCommunityUpdateReadArgs = {
  input: CreateCommunityUpdateReadInput;
};


export type MutationCreateCommunityVisitorArgs = {
  input: CreateCommunityVisitorInput;
};


export type MutationCreateComplianceRequirementArgs = {
  input: CreateComplianceRequirementInput;
};


export type MutationCreateComplianceUpdateReadArgs = {
  input: CreateComplianceUpdateReadInput;
};


export type MutationCreateContractorArgs = {
  input: CreateContractorInput;
};


export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
  sender: ConversationRole;
};


export type MutationCreateConversationActionArgs = {
  input: CreateConversationActionInput;
};


export type MutationCreateConversationAndFirstMessageArgs = {
  input: CreateConversationAndFirstMessageInput;
};


export type MutationCreateConversationAssignmentArgs = {
  input: CreateConversationAssignmentInput;
};


export type MutationCreateConversationMessageArgs = {
  input: CreateConversationMessageInput;
  sender: ConversationRole;
};


export type MutationCreateConversationNoteArgs = {
  input: CreateConversationNoteInput;
};


export type MutationCreateConversationSummaryArgs = {
  input: CreateConversationSummaryInput;
};


export type MutationCreateConversationTagArgs = {
  input: CreateConversationTagInput;
};


export type MutationCreateFollowUpTaskFromChecklistItemArgs = {
  input: CreateFollowUpTaskFromChecklistItemInput;
};


export type MutationCreateFollowUpTasksFromChecklistItemsArgs = {
  input: CreateFollowUpTasksFromChecklistItemsInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateGroupChatMessageArgs = {
  input: CreateGroupChatMessageInput;
};


export type MutationCreateGroupChatMessageReactionArgs = {
  input: CreateGroupChatMessageReactionInput;
};


export type MutationCreateGroupChatMessageReportArgs = {
  input: CreateGroupChatMessageReportInput;
};


export type MutationCreateKeyV2Args = {
  input: CreateKeyV2Input;
};


export type MutationCreateKeyholderV2Args = {
  input: CreateKeyholderV2Input;
};


export type MutationCreateManagerConversationReadArgs = {
  input: CreateManagerConversationReadInput;
};


export type MutationCreateManagerSafetyDeclarationArgs = {
  input: CreateManagerSafetyDeclarationInput;
};


export type MutationCreateMarketplaceItemCommentArgs = {
  input: CreateMarketplaceItemCommentInput;
};


export type MutationCreateMarketplaceItemThreadArgs = {
  input: CreateMarketplaceItemThreadInput;
};


export type MutationCreateNewDeviceArgs = {
  input: CreateNewDeviceInput;
};


export type MutationCreateOccupancySurveyArgs = {
  isOccupant: Scalars['Boolean']['input'];
  occupants?: InputMaybe<ReadonlyArray<InputMaybe<OccupantInput>>>;
  residencyId: Scalars['UUID']['input'];
};


export type MutationCreateOpenedConversationArgs = {
  input: CreateOpenedConversationInput;
};


export type MutationCreateOrUpdateUserSessionArgs = {
  input: CreateOrUpdateUserSessionInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreateReportingConfigurationArgs = {
  input: CreateReportingConfigurationInput;
};


export type MutationCreateResidencyAndResidentsArgs = {
  input: ResidencyAndResidentsInput;
};


export type MutationCreateResidencyDocumentArgs = {
  input: CreateResidencyDocumentInput;
};


export type MutationCreateResidencyDocumentViewArgs = {
  input: CreateResidencyDocumentViewInput;
};


export type MutationCreateResidencyDocumentsArgs = {
  input: CreateResidencyDocumentsInput;
};


export type MutationCreateResidencySubscriptionArgs = {
  input: CreateResidencySubscriptionInput;
};


export type MutationCreateResidentSafetyRecordArgs = {
  input: CreateResidentSafetyRecordInput;
};


export type MutationCreateRuleArgs = {
  input: CreateRuleInput;
};


export type MutationCreateRuleActionArgs = {
  input: CreateRuleActionInput;
};


export type MutationCreateRuleConditionsArgs = {
  input: CreateRuleConditionsInput;
};


export type MutationCreateSafetyCenterDocumentArgs = {
  input: CreateSafetyCenterDocumentInput;
};


export type MutationCreateScheduledMessageArgs = {
  input: CreateScheduledMessageInput;
};


export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTaskDefinitionArgs = {
  input: CreateTaskDefinitionInput;
};


export type MutationCreateTaskDocumentArgs = {
  input: CreateTaskDocumentInput;
};


export type MutationCreateTaskFromConversationArgs = {
  input: CreateTaskFromConversationInput;
};


export type MutationCreateTaskGroupArgs = {
  input: CreateTaskGroupInput;
};


export type MutationCreateTaskTemplateArgs = {
  input: CreateTaskTemplateInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTemplateFromChecklistArgs = {
  input: CreateTemplateFromChecklistInput;
};


export type MutationCreateTenancyApplicationArgs = {
  input: CreateTenancyApplicationInput;
};


export type MutationCreateUpdateCommentArgs = {
  input: CreateUpdateCommentInput;
};


export type MutationCreateUserDocumentArgs = {
  input: CreateUserDocumentInput;
};


export type MutationCreateUserDocumentTagArgs = {
  input: CreateUserDocumentTagInput;
};


export type MutationCreateUserDocumentViewArgs = {
  input: CreateUserDocumentViewInput;
};


export type MutationDeactivateClientUserArgs = {
  input: DeactivateClientUserInput;
};


export type MutationDeactivateGroupArgs = {
  input: DeactivateGroupInput;
};


export type MutationDeclinePcfraArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeclineSafetyConsentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteAmenityArgs = {
  input: DeleteAmenityInput;
};


export type MutationDeleteAttachmentArgs = {
  input: DeleteAttachmentInput;
};


export type MutationDeleteChecklistArgs = {
  input: DeleteChecklistInput;
};


export type MutationDeleteChecklistItemMediaArgs = {
  input: DeleteChecklistItemMediaInput;
};


export type MutationDeleteCommunityDocumentArgs = {
  input: DeleteCommunityDocumentInput;
};


export type MutationDeleteCommunityProductArgs = {
  input: DeleteCommunityProductInput;
};


export type MutationDeleteCommunityUpdateArgs = {
  input: DeleteCommunityUpdateInput;
};


export type MutationDeleteCommunityUpdateAttachmentArgs = {
  input: DeleteCommunityUpdateAttachmentInput;
};


export type MutationDeleteComplianceRequirementV2Args = {
  input: DeleteComplianceRequirementV2Input;
};


export type MutationDeleteConversationTagArgs = {
  input: DeleteConversationTagInput;
};


export type MutationDeleteGroupChatMessageReactionArgs = {
  input: DeleteGroupChatMessageReactionInput;
};


export type MutationDeleteHomeArgs = {
  input: DeleteHomeInput;
};


export type MutationDeleteHomeImageArgs = {
  input: DeleteHomeImageInput;
};


export type MutationDeleteMarketplaceItemImageArgs = {
  input: DeleteMarketplaceItemImageInput;
};


export type MutationDeleteReportingConfigurationArgs = {
  input: DeleteReportingConfigurationInput;
};


export type MutationDeleteRuleActionArgs = {
  input: DeleteRuleActionInput;
};


export type MutationDeleteRuleConditionArgs = {
  input: DeleteRuleConditionInput;
};


export type MutationDeleteUpdateCommentArgs = {
  input: DeleteCommunityUpdateCommentInput;
};


export type MutationDismissAsanaPendingTaskArgs = {
  input: DismissAsanaPendingTaskInput;
};


export type MutationDismissFeatureAnnouncementArgs = {
  input: DismissFeatureAnnouncementInput;
};


export type MutationEditKeyArgs = {
  input: EditKeyInput;
};


export type MutationEditMemberArgs = {
  input: EditMemberInput;
};


export type MutationEmployerUpdateEmploymentDetailsArgs = {
  input: EmployerUpdateEmploymentDetailsInput;
};


export type MutationEmployerUpdatePersonalDetailsArgs = {
  input: EmployerUpdatePersonalDetailsInput;
};


export type MutationFakeCreditCheckArgs = {
  input: FakeCreditCheckMutationInput;
};


export type MutationFakeSendTenantReferenceRequestArgs = {
  input: FakeSendTenantReferenceRequestInput;
};


export type MutationFakeStripeInvoicePaidEventArgs = {
  input: FakeStripeInvoicePaidEventInput;
};


export type MutationFlagChecklistItemArgs = {
  input: FlagChecklistItemInput;
};


export type MutationGenerateEesArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationGenerateHomeSafetyFormArgs = {
  homeId: Scalars['UUID']['input'];
  recordId?: InputMaybe<Scalars['UUID']['input']>;
  scope?: InputMaybe<SafetyPaperFormScope>;
};


export type MutationGeneratePeepsExportArgs = {
  blockId: Scalars['UUID']['input'];
};


export type MutationGenerateSafetyDocumentQrPdfArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationGenerateSafetyRecordActivityPdfArgs = {
  recordId: Scalars['UUID']['input'];
};


export type MutationGenerateSibPackArgs = {
  blockId: Scalars['UUID']['input'];
};


export type MutationGenerateSibPackQrPdfArgs = {
  communityId: Scalars['UUID']['input'];
};


export type MutationGiveFireServiceConsentArgs = {
  authority?: InputMaybe<SafetyComplianceAuthority>;
  channel?: InputMaybe<SafetyComplianceChannel>;
  id: Scalars['UUID']['input'];
  representativeName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGiveSafetyConsentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationIgnoreMessageSuggestionArgs = {
  input: IgnoreMessageSuggestionInput;
};


export type MutationInitializeSignupArgs = {
  acceptedMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  suppressWelcomeEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInviteDemoUserArgs = {
  input: InviteDemoUserInput;
};


export type MutationLabelConversationArgs = {
  input: LabelConversationInput;
};


export type MutationLandlordUpdateLandlordReferenceArgs = {
  input: LandlordUpdateLandlordReferenceInput;
};


export type MutationLandlordUpdateRentalDetailsArgs = {
  input: LandlordUpdateRentalDetailsInput;
};


export type MutationLinkConversationToTaskArgs = {
  input: LinkConversationToTaskInput;
};


export type MutationLinkSafetySubjectArgs = {
  input: LinkSafetySubjectInput;
};


export type MutationLinkTaskToAsanaArgs = {
  input: LinkTaskToAsanaInput;
};


export type MutationLinkTaskToFixfloArgs = {
  input: LinkTaskToFixfloInput;
};


export type MutationLogDocumentReadArgs = {
  input: LogDocumentReadInput;
};


export type MutationLogPublicDocumentReadArgs = {
  input: LogPublicDocumentReadInput;
};


export type MutationLogUserAppUseArgs = {
  input: LogUserAppUseInput;
};


export type MutationManagerAddApplicationHomeArgs = {
  input: ManagerAddApplicationHomeInput;
};


export type MutationManagerCancelAmenityReservationArgs = {
  input: ManagerCancelAmenityReservationInput;
};


export type MutationManagerCreateAmenityReservationArgs = {
  input: ManagerCreateAmenityReservationInput;
};


export type MutationManagerReserveAmenityArgs = {
  input: ManagerReserveAmenityInput;
};


export type MutationMarkApplicationThreadAsReadArgs = {
  input: MarkApplicationThreadAsReadInput;
};


export type MutationMarkSafetyReviewRequestOpenedArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationMarkSibPackPrintedArgs = {
  blockId: Scalars['UUID']['input'];
};


export type MutationMarkSuggestionShownArgs = {
  input: MarkSuggestionShownInput;
};


export type MutationMarkThreadMessagesAsReadArgs = {
  input: MarkThreadMessagesAsReadInput;
};


export type MutationNewCreateApplicationArgs = {
  input: NewCreateApplicationInput;
};


export type MutationOfferPcfraArgs = {
  channel?: InputMaybe<SafetyComplianceChannel>;
  id: Scalars['UUID']['input'];
  offeredAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationOfficiallyVerifyRightToRentArgs = {
  input: OfficiallyVerifyRightToRentInput;
};


export type MutationOrderConversationTagsArgs = {
  input: OrderConversationTagsInput;
};


export type MutationPackageReminderToAllArgs = {
  communities: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
};


export type MutationPackageReminderToHomeArgs = {
  input: PackageReminderToHomeInput;
};


export type MutationPayForDocumentArgs = {
  input: PayForDocumentInput;
};


export type MutationPayForUnpaidApplicationReferencesArgs = {
  input: PayForUnpaidApplicationReferencesInput;
};


export type MutationPublishCommunityUpdateArgs = {
  input: PublishCommunityUpdateInput;
};


export type MutationPushTaskToAsanaArgs = {
  input: PushTaskToAsanaInput;
};


export type MutationRateConversationArgs = {
  input: RateConversationInput;
};


export type MutationReOpenConversationArgs = {
  input: ReOpenConversationInput;
};


export type MutationReadAllNotificationsArgs = {
  input: ReadAllNotificationsInput;
};


export type MutationReadAllNotificationsOnTargetArgs = {
  input: ReadAllNotificationsOnTargetInput;
};


export type MutationReadNotificationArgs = {
  input: ReadNotificationInput;
};


export type MutationReconcileSafetyDeclarationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationReconfirmSafetyRecordArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRecordConversationRatingPromptArgs = {
  input: RecordConversationRatingPromptInput;
};


export type MutationRecordReportingConfigurationOpenedArgs = {
  input: RecordReportingConfigurationOpenedInput;
};


export type MutationReferenceSignupErrorArgs = {
  input: ReferenceSignupErrorInput;
};


export type MutationRejectApplicationArgs = {
  application: Scalars['UUID']['input'];
  rejectionReason: Scalars['String']['input'];
};


export type MutationRejectBlockGroupSuggestionArgs = {
  input: RejectBlockGroupSuggestionInput;
};


export type MutationRejectBlockSuggestionArgs = {
  input: RejectBlockSuggestionInput;
};


export type MutationRelateBlockGroupSuggestionToCommunityGroupArgs = {
  input: RelateBlockGroupSuggestionToCommunityGroupInput;
};


export type MutationRemindAllApplicantsArgs = {
  communities: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
};


export type MutationRemindApplicantArgs = {
  application: Scalars['UUID']['input'];
};


export type MutationRemindResidentArgs = {
  input: RemindResidentInput;
};


export type MutationRemoveConversationTagArgs = {
  input: RemoveConversationTagInput;
};


export type MutationRemoveResidentFromUnpaidEventsArgs = {
  input: RemoveResidentFromUnpaidEventsInput;
};


export type MutationRemoveResidentsFromResidencyArgs = {
  input: RemoveResidentsFromResidencyInput;
};


export type MutationRemoveTaskDocumentArgs = {
  input: RemoveTaskDocumentInput;
};


export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};


export type MutationRenameTaskArgs = {
  input: RenameTaskInput;
};


export type MutationResendMemberInviteEmailArgs = {
  input: ResendMemberInviteEmailInput;
};


export type MutationReserveAmenityArgs = {
  input: ReserveAmenityInput;
};


export type MutationReserveAmenitySlotArgs = {
  input: ReserveAmenitySlotInput;
};


export type MutationResidentArchiveKeyholderArgs = {
  input: ResidentArchiveKeyholderInput;
};


export type MutationResidentCreateKeyholderArgs = {
  input: ResidentCreateKeyholderInput;
};


export type MutationResidentUnarchiveKeyholderArgs = {
  input: ResidentUnarchiveKeyholderInput;
};


export type MutationResidentUpdateKeyholderArgs = {
  input: ResidentUpdateKeyholderInput;
};


export type MutationResolveChecklistActionArgs = {
  input: ResolveChecklistActionInput;
};


export type MutationRespondToContractorSuggestionArgs = {
  input: RespondToContractorSuggestionInput;
};


export type MutationRespondToPcfraArgs = {
  accepted: Scalars['Boolean']['input'];
  authority?: InputMaybe<SafetyComplianceAuthority>;
  channel?: InputMaybe<SafetyComplianceChannel>;
  id: Scalars['UUID']['input'];
};


export type MutationRestartIdentityVerificationArgs = {
  input: RestartIdentityVerificationInput;
};


export type MutationRetryDocumentExtractionArgs = {
  input: RetryDocumentExtractionInput;
};


export type MutationReviewInspectionActionArgs = {
  input: ReviewInspectionActionInput;
};


export type MutationRevokeCommunityStaffRoleArgs = {
  input: RevokeCommunityStaffRoleInput;
};


export type MutationRevokeGeneratedAgreementArgs = {
  input: RevokeGeneratedAgreementInput;
};


export type MutationRotateSafetyResponderTokenArgs = {
  packId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSaveAmenityArgs = {
  input: SaveAmenityInput;
};


export type MutationSaveAmenityOperatingTimesArgs = {
  input: SaveAmenityOperatingTimesInput;
};


export type MutationSaveCommunityEventArgs = {
  input: SaveCommunityEventInput;
};


export type MutationSaveCommunityUpdateArgs = {
  input: SaveCommunityUpdateInput;
};


export type MutationSaveContactNoteArgs = {
  input: SaveContactNoteInput;
};


export type MutationSaveGeneratedAgreementArgs = {
  input: SaveGeneratedAgreementInput;
};


export type MutationSaveGeneratedSection21Args = {
  input: SaveGeneratedSection21Input;
};


export type MutationSaveHomeArgs = {
  input: SaveHomeInput;
};


export type MutationSaveManagerProfileArgs = {
  input: SaveManagerProfileInput;
};


export type MutationSaveMarketplaceItemArgs = {
  input: SaveMarketplaceItemInput;
};


export type MutationSaveRequirementItemArgs = {
  input: SaveRequirementItemInput;
};


export type MutationSaveResidentSurveyAnswerArgs = {
  input: SaveResidentSurveyAnswerInput;
};


export type MutationSaveTenantEmploymentDetailsArgs = {
  input: SaveTenantEmploymentDetailsInput;
};


export type MutationSchedulePublishCommunityUpdateArgs = {
  input: SchedulePublishCommunityUpdateInput;
};


export type MutationSendAgreementForSigningArgs = {
  input: SendAgreementForSigningInput;
};


export type MutationSendApplicationSupportMessageArgs = {
  input: SendApplicationSupportMessageInput;
};


export type MutationSendApplicationThreadMessageArgs = {
  input: SendApplicationThreadMessageInput;
};


export type MutationSendConversationToAsanaArgs = {
  input: SendConversationToAsanaInput;
};


export type MutationSendDocumentArgs = {
  input: SendDocumentInput;
};


export type MutationSendManagerAmplitudeTestArgs = {
  input: SendManagerAmplitudeTestInput;
};


export type MutationSendPaymentReceiptEmailArgs = {
  input: SendPaymentReceiptEmailInput;
};


export type MutationSendSafetyReminderArgs = {
  recordId: Scalars['UUID']['input'];
};


export type MutationSendSafetyReviewRequestArgs = {
  channel?: InputMaybe<SafetyReviewAttemptChannel>;
  note?: InputMaybe<Scalars['String']['input']>;
  recordId: Scalars['UUID']['input'];
};


export type MutationSendTenantReferenceRequestsArgs = {
  input: SendTenantReferenceRequestsInput;
};


export type MutationSetChecklistItemDueDateArgs = {
  input: SetChecklistItemDueDateInput;
};


export type MutationSetChecklistSectionDueDateArgs = {
  input: SetChecklistSectionDueDateInput;
};


export type MutationSetConversationHomeArgs = {
  input: SetConversationHomeInput;
};


export type MutationSetReportingFavouriteArgs = {
  input: SetReportingFavouriteInput;
};


export type MutationSetReportingScheduleArgs = {
  input: SetReportingScheduleInput;
};


export type MutationSetResidencyCompletionDateArgs = {
  input: SetResidencyCompletionDateInput;
};


export type MutationSetResidentAppLocaleArgs = {
  input: SetResidentAppLocaleInput;
};


export type MutationSetSafetyDocumentBlockArgs = {
  blockId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
};


export type MutationSetSafetyDocumentInSibPackArgs = {
  id: Scalars['UUID']['input'];
  include: Scalars['Boolean']['input'];
};


export type MutationSetSafetyDocumentResidentVisibleArgs = {
  id: Scalars['UUID']['input'];
  visible: Scalars['Boolean']['input'];
};


export type MutationSetSafetySubjectContactEmailArgs = {
  input: SetSafetySubjectContactEmailInput;
};


export type MutationSetUpManagerArgs = {
  input: SetUpManagerInput;
};


export type MutationShareComplianceRequirementArgs = {
  input: ShareComplianceRequirementInput;
};


export type MutationSignOffChecklistArgs = {
  input: SignOffChecklistInput;
};


export type MutationSignOutCommunityVisitorArgs = {
  input: SignOutCommunityVisitorInput;
};


export type MutationSnoozeConversationArgs = {
  input: SnoozeConversationInput;
};


export type MutationStartBulkConversationCloseArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  closedReason?: InputMaybe<Scalars['String']['input']>;
  consent?: InputMaybe<Scalars['Boolean']['input']>;
  conversationIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  filters?: InputMaybe<BulkConversationCloseFilterInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationStartBulkDeactivationArgs = {
  input: StartBulkDeactivationInput;
};


export type MutationSubmitEmployerReferenceArgs = {
  input: SubmitEmployerReferenceInput;
};


export type MutationSubmitIdentityVerificationArgs = {
  input: SubmitIdentityVerificationInput;
};


export type MutationSubmitLandlordReferenceArgs = {
  input: SubmitLandlordReferenceInput;
};


export type MutationSubmitTenantReferenceArgs = {
  input: SubmitTenantReferenceInput;
};


export type MutationSubscribeLandlordArgs = {
  input: SubscribeLandlordInput;
};


export type MutationSubscribeToNotificationGroupArgs = {
  input: NotificationPreferencesInput;
};


export type MutationSuggestRemediationStepsArgs = {
  input: SuggestRemediationStepsInput;
};


export type MutationTagConversationArgs = {
  input: TagConversationInput;
};


export type MutationToggleAllResidentAppNotificationPreferencesArgs = {
  input: ToggleAllResidentAppNotificationPreferencesInput;
};


export type MutationToggleArchivedAtCommunityDocumentArgs = {
  input: ToggleArchivedAtCommunityDocumentInput;
};


export type MutationToggleArchivedAtCommunityUpdateArgs = {
  input: ToggleArchivedAtCommunityUpdateInput;
};


export type MutationToggleClientTagArchivedAtArgs = {
  input: ToggleClientTagArchivedAtInput;
};


export type MutationToggleCommunityUpdateBookmarkArgs = {
  input: ToggleCommunityUpdateBookmarkInput;
};


export type MutationToggleCommunityUpdateLikeArgs = {
  input: ToggleCommunityUpdateLikeInput;
};


export type MutationToggleMarketplaceItemCloseArgs = {
  input: ToggleMarketplaceItemCloseInput;
};


export type MutationToggleRuleActivatedArgs = {
  input: ToggleRuleActivatedInput;
};


export type MutationToggleTeamActivatedArgs = {
  input: ToggleTeamActivatedInput;
};


export type MutationUnarchiveApplicationArgs = {
  input: UnarchiveApplicationInput;
};


export type MutationUnarchiveKeyArgs = {
  input: UnarchiveKeyInput;
};


export type MutationUnarchiveKeyholderArgs = {
  input: UnarchiveKeyholderInput;
};


export type MutationUnarchiveTaskArgs = {
  input: UnarchiveTaskInput;
};


export type MutationUnarchiveTaskGroupArgs = {
  input: UnarchiveTaskGroupInput;
};


export type MutationUnarchiveTaskTemplateArgs = {
  input: UnarchiveTaskTemplateInput;
};


export type MutationUnassignClientTagArgs = {
  input: UnassignClientTagInput;
};


export type MutationUnassignClientTagFromCommunityDocumentArgs = {
  input: UnassignClientTagFromCommunityDocumentInput;
};


export type MutationUnassignClientTagFromTaskDefinitionArgs = {
  input: UnassignClientTagFromTaskDefinitionInput;
};


export type MutationUnassignClientTagFromUserDocumentArgs = {
  input: UnassignClientTagFromUserDocumentInput;
};


export type MutationUnassignTeamArgs = {
  input: UnassignTeamInput;
};


export type MutationUnbookCommunityEventArgs = {
  input: UnbookCommunityEventMutationInput;
};


export type MutationUnflagChecklistItemArgs = {
  input: UnflagChecklistItemInput;
};


export type MutationUnlabelConversationArgs = {
  input: UnlabelConversationInput;
};


export type MutationUnlinkTaskFromAsanaArgs = {
  input: UnlinkTaskFromAsanaInput;
};


export type MutationUnlinkTaskFromFixfloArgs = {
  input: UnlinkTaskFromFixfloInput;
};


export type MutationUnreadAllNotificationsOnTargetArgs = {
  input: UnreadAllNotificationsOnTargetInput;
};


export type MutationUnreadNotificationArgs = {
  input: UnreadNotificationInput;
};


export type MutationUnsnoozeConversationArgs = {
  input: UnsnoozeConversationInput;
};


export type MutationUnsubscribeFromNotificationGroupArgs = {
  input: NotificationPreferencesInput;
};


export type MutationUpdateAmenityOperatingScheduleArgs = {
  input: UpdateAmenityOperatingScheduleInput;
};


export type MutationUpdateAmenityTypeArgs = {
  input: UpdateAmenityTypeInput;
};


export type MutationUpdateApplicationCommunityArgs = {
  input: UpdateApplicationCommunityInput;
};


export type MutationUpdateApplicationHomeArgs = {
  input: UpdateApplicationHomeInput;
};


export type MutationUpdateAttachmentArgs = {
  input: UpdateAttachmentInput;
};


export type MutationUpdateBlockHomesArgs = {
  input: UpdateBlockHomesInput;
};


export type MutationUpdateBlockSafetyIdentityArgs = {
  input: UpdateBlockSafetyIdentityInput;
};


export type MutationUpdateBlockSuggestionHomesArgs = {
  input: UpdateBlockSuggestionHomesInput;
};


export type MutationUpdateChecklistArgs = {
  input: UpdateChecklistInput;
};


export type MutationUpdateChecklistStructureArgs = {
  input: UpdateChecklistStructureInput;
};


export type MutationUpdateClientAdminArgs = {
  input: UpdateClientAdminInput;
};


export type MutationUpdateClientContractorCompanyArgs = {
  input: UpdateClientContractorCompanyInput;
};


export type MutationUpdateClientContractorCompanyCommunitiesArgs = {
  input: UpdateClientContractorCompanyCommunitiesInput;
};


export type MutationUpdateClientContractorCompanyContractorsArgs = {
  input: UpdateClientContractorCompanyContractorsInput;
};


export type MutationUpdateClientTagArgs = {
  input: UpdateClientTagInput;
};


export type MutationUpdateClientTagColorArgs = {
  input: UpdateClientTagColorInput;
};


export type MutationUpdateCommunityDocumentArgs = {
  input: UpdateCommunityDocumentInput;
};


export type MutationUpdateCommunityProductArgs = {
  input: UpdateCommunityProductInput;
};


export type MutationUpdateCommunityResponsiblePersonArgs = {
  communityId: Scalars['UUID']['input'];
  responsiblePersonName?: InputMaybe<Scalars['String']['input']>;
  responsiblePersonRole?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCommunitySettingsArgs = {
  input: UpdateCommunitySettingsInput;
};


export type MutationUpdateCommunitySibPackReviewSettingsArgs = {
  communityId: Scalars['UUID']['input'];
  sibPackReviewNudgeMonths?: InputMaybe<Scalars['Int']['input']>;
  sibPackReviewRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateCommunityTaskDefinitionArgs = {
  input: UpdateCommunityTaskDefinitionInput;
};


export type MutationUpdateContactGroupsArgs = {
  input: UpdateContactGroupsInput;
};


export type MutationUpdateContractorArgs = {
  input: UpdateContractorInput;
};


export type MutationUpdateConversationNoteArgs = {
  input: UpdateConversationNoteInput;
};


export type MutationUpdateConversationParticipantTypeArgs = {
  input: UpdateConversationParticipantTypeInput;
};


export type MutationUpdateConversationTagArgs = {
  input: UpdateConversationTagInput;
};


export type MutationUpdateConversationTitleArgs = {
  input: UpdateConversationTitleInput;
};


export type MutationUpdateConversationUrgencyArgs = {
  input: UpdateConversationUrgencyInput;
};


export type MutationUpdateEmployerReferenceArgs = {
  input: UpdateEmployerReferenceInput;
};


export type MutationUpdateEmployerReferenceStepArgs = {
  input: UpdateEmployerReferenceStepInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateGroupDescriptionArgs = {
  input: UpdateGroupDescriptionInput;
};


export type MutationUpdateHomeAddressArgs = {
  input: UpdateHomeAddressInput;
};


export type MutationUpdateHomeDetailsArgs = {
  input: UpdateHomeDetailsInput;
};


export type MutationUpdateHomeFloorNumberArgs = {
  input: UpdateHomeFloorNumberInput;
};


export type MutationUpdateKeyholderArgs = {
  input: UpdateKeyholderInput;
};


export type MutationUpdateLandlordArgs = {
  input: UpdateLandlordInput;
};


export type MutationUpdateLandlordReferenceArgs = {
  input: UpdateLandlordReferenceInput;
};


export type MutationUpdateLandlordReferenceCommentsArgs = {
  input: UpdateLandlordReferenceCommentsInput;
};


export type MutationUpdateLandlordReferenceStepArgs = {
  input: UpdateLandlordReferenceStepInput;
};


export type MutationUpdateManagerArgs = {
  input: UpdateManagerInput;
};


export type MutationUpdateManagerNotificationSettingsArgs = {
  input: UpdateManagerNotificationSettingsInput;
};


export type MutationUpdateMobileNumberArgs = {
  input: UpdateUserMobileNumberInput;
};


export type MutationUpdateNotificationPreferenceArgs = {
  input: UpdateNotificationPreferenceInput;
};


export type MutationUpdatePackageLocationArgs = {
  input: UpdatePackageLocationInput;
};


export type MutationUpdatePackageStatusArgs = {
  input: UpdatePackageStatusInput;
};


export type MutationUpdateReferenceAddressHistoryArgs = {
  input: UpdateReferenceAddressHistoryInput;
};


export type MutationUpdateReferenceStartedOnArgs = {
  input: UpdateReferenceStartedOnInput;
};


export type MutationUpdateReportingConfigurationArgs = {
  input: UpdateReportingConfigurationInput;
};


export type MutationUpdateResidencyAndResidentsArgs = {
  input: ResidencyAndResidentsInput;
};


export type MutationUpdateResidencyDocumentArgs = {
  input: UpdateResidencyDocumentInput;
};


export type MutationUpdateResidentAppNotificationPreferencesArgs = {
  input: UpdateResidentAppNotificationPreferencesInput;
};


export type MutationUpdateResidentSafetyRecordArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateResidentSafetyRecordInput;
};


export type MutationUpdateRightToRentArgs = {
  input: UpdateRightToRentInput;
};


export type MutationUpdateRuleArgs = {
  input: UpdateRuleInput;
};


export type MutationUpdateRuleCategoryContentTypesArgs = {
  input: UpdateRuleCategoryContentTypesInput;
};


export type MutationUpdateRuleCommunitiesArgs = {
  input: UpdateRuleCommunitiesInput;
};


export type MutationUpdateRuleConditionArgs = {
  input: UpdateRuleConditionInput;
};


export type MutationUpdateSafetyCenterDocumentArgs = {
  input: UpdateSafetyCenterDocumentInput;
};


export type MutationUpdateSafetyReviewIntervalArgs = {
  communityId: Scalars['UUID']['input'];
  surveyReviewIntervalMonths: Scalars['Int']['input'];
};


export type MutationUpdateScheduledMessageArgs = {
  input: UpdateScheduledMessageInput;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTaskDefinitionDescriptionArgs = {
  input: UpdateTaskDefinitionDescriptionInput;
};


export type MutationUpdateTaskDefinitionPriorityArgs = {
  input: UpdateTaskDefinitionPriorityInput;
};


export type MutationUpdateTaskDefinitionVisibilityArgs = {
  input: UpdateTaskDefinitionVisibilityInput;
};


export type MutationUpdateTaskGroupArgs = {
  input: UpdateTaskGroupInput;
};


export type MutationUpdateTaskPriorityArgs = {
  input: UpdateTaskPriorityInput;
};


export type MutationUpdateTaskTemplateArgs = {
  input: UpdateTaskTemplateInput;
};


export type MutationUpdateTaskTemplateStructureArgs = {
  input: UpdateTaskTemplateStructureInput;
};


export type MutationUpdateTeamCommunitiesArgs = {
  input: UpdateTeamCommunitiesInput;
};


export type MutationUpdateTeamDetailsArgs = {
  input: UpdateTeamDetailsInput;
};


export type MutationUpdateTeamIconArgs = {
  input: UpdateTeamIconInput;
};


export type MutationUpdateTeamMembersArgs = {
  input: UpdateTeamMembersInput;
};


export type MutationUpdateTenantReferenceArgs = {
  input: UpdateTenantReferenceInput;
};


export type MutationUpdateTenantReferenceStepArgs = {
  input: UpdateTenantReferenceStepInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserDocumentArgs = {
  input: UpdateUserDocumentInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpgradeLandlordToSubscriptionArgs = {
  input: UpgradeLandlordToSubscriptionInput;
};


export type MutationViewFeatureAnnouncementArgs = {
  input: ViewFeatureAnnouncementInput;
};


export type MutationViewUserFeatureAnnouncementArgs = {
  input: ViewUserFeatureAnnouncementInput;
};


export type MutationVoidSafetyDeclarationArgs = {
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationWithdrawFireServiceConsentArgs = {
  channel?: InputMaybe<SafetyComplianceChannel>;
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type NewCommunityOption = {
  readonly __typename?: 'NewCommunityOption';
  readonly distance?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly postcode?: Maybe<Scalars['String']['output']>;
};

export type NewCreateApplication = {
  readonly __typename?: 'NewCreateApplication';
  readonly application?: Maybe<ApplicationNode>;
  readonly communities?: Maybe<ReadonlyArray<NewCommunityOption>>;
  readonly homes?: Maybe<ReadonlyArray<NewHomeOption>>;
  readonly status: Scalars['String']['output'];
};

export type NewCreateApplicationInput = {
  readonly communityId?: InputMaybe<Scalars['ID']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly flatNumber: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly postcode?: InputMaybe<Scalars['String']['input']>;
};

export type NewHomeOption = {
  readonly __typename?: 'NewHomeOption';
  readonly address: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type NotificationContentObjectType = ConversationNode | ResidencyType;

export type NotificationNavigationMeta = {
  readonly __typename?: 'NotificationNavigationMeta';
  readonly actionObjectType?: Maybe<Scalars['String']['output']>;
  readonly routeId?: Maybe<Scalars['String']['output']>;
  readonly secondaryId?: Maybe<Scalars['String']['output']>;
  readonly targetType?: Maybe<Scalars['String']['output']>;
};

export type NotificationNode = {
  readonly __typename?: 'NotificationNode';
  readonly actionObject?: Maybe<ActionObject>;
  readonly actor?: Maybe<Actor>;
  readonly actorName?: Maybe<Scalars['String']['output']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly community?: Maybe<CommunityNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly pulseTitle?: Maybe<Scalars['String']['output']>;
  readonly read: Scalars['Boolean']['output'];
  readonly recipient: UserType;
  readonly target?: Maybe<Target>;
  readonly title: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
  readonly verb?: Maybe<Scalars['String']['output']>;
};

export type NotificationNodeConnection = {
  readonly __typename?: 'NotificationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<NotificationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `NotificationNode` and its cursor. */
export type NotificationNodeEdge = {
  readonly __typename?: 'NotificationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<NotificationNode>;
};

export type NotificationPreferencesInput = {
  readonly type: Scalars['String']['input'];
};

export type OccupancySurveyNode = {
  readonly __typename?: 'OccupancySurveyNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOccupant: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly occupants: OccupantNodeConnection;
  readonly residency: ResidencyType;
  readonly user: UserType;
};


export type OccupancySurveyNodeOccupantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OccupancySurveyNodeConnection = {
  readonly __typename?: 'OccupancySurveyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<OccupancySurveyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OccupancySurveyNode` and its cursor. */
export type OccupancySurveyNodeEdge = {
  readonly __typename?: 'OccupancySurveyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<OccupancySurveyNode>;
};

export type OccupantInput = {
  readonly communicationNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly first: Scalars['String']['input'];
  readonly last: Scalars['String']['input'];
  readonly mobilityNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OccupantNode = {
  readonly __typename?: 'OccupantNode';
  readonly communicationNeeds?: Maybe<Scalars['String']['output']>;
  readonly first: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly last: Scalars['String']['output'];
  readonly mobilityNeeds?: Maybe<Scalars['String']['output']>;
  readonly occupancySurvey: OccupancySurveyNode;
  readonly user?: Maybe<UserType>;
};

export type OccupantNodeConnection = {
  readonly __typename?: 'OccupantNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<OccupantNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OccupantNode` and its cursor. */
export type OccupantNodeEdge = {
  readonly __typename?: 'OccupantNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<OccupantNode>;
};

export type OfferPcfra = {
  readonly __typename?: 'OfferPcfra';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type OfficiallyVerifyRightToRentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly officialExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  readonly officialVerificationStatus?: InputMaybe<Scalars['String']['input']>;
};

export type OfficiallyVerifyRightToRentPayload = {
  readonly __typename?: 'OfficiallyVerifyRightToRentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly officialExpiryDate?: Maybe<Scalars['Date']['output']>;
  readonly officialVerificationStatus?: Maybe<Scalars['String']['output']>;
};

export type OperatingTimeInput = {
  readonly endTime?: InputMaybe<Scalars['DateTime']['input']>;
  readonly isActivated: Scalars['Boolean']['input'];
  readonly startTime?: InputMaybe<Scalars['DateTime']['input']>;
  readonly weekDay: Scalars['Int']['input'];
};

export type OrderConversationTagsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type OrderConversationTagsPayload = {
  readonly __typename?: 'OrderConversationTagsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type PackageEventNode = {
  readonly __typename?: 'PackageEventNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly package: PackageNode;
  readonly performedBy?: Maybe<UserType>;
  readonly reason?: Maybe<Scalars['String']['output']>;
  readonly type: ResidentialManagementPackageEventTypeChoices;
};

export type PackageNode = {
  readonly __typename?: 'PackageNode';
  readonly addressee?: Maybe<Scalars['String']['output']>;
  readonly collectedBy?: Maybe<UserType>;
  readonly collectedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly collectionCode?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly events: ReadonlyArray<PackageEventNode>;
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly label?: Maybe<Scalars['String']['output']>;
  readonly lastAction: Scalars['DateTime']['output'];
  readonly location?: Maybe<Scalars['String']['output']>;
  readonly pickupLocation?: Maybe<Scalars['String']['output']>;
  readonly reminders?: Maybe<ReadonlyArray<PackageReminderNode>>;
  readonly residency?: Maybe<ResidencyNode>;
  readonly resident?: Maybe<ResidentType>;
  readonly scannedInBy?: Maybe<UserType>;
  readonly status: ResidentialManagementPackageStatusChoices;
  readonly user?: Maybe<UserType>;
};

export type PackageNodeConnection = {
  readonly __typename?: 'PackageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<PackageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PackageNode` and its cursor. */
export type PackageNodeEdge = {
  readonly __typename?: 'PackageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<PackageNode>;
};

export type PackageReminderNode = {
  readonly __typename?: 'PackageReminderNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly user: UserType;
};

export type PackageReminderToAll = {
  readonly __typename?: 'PackageReminderToAll';
  readonly packages?: Maybe<ReadonlyArray<Maybe<PackageNode>>>;
};

export type PackageReminderToHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type PackageReminderToHomePayload = {
  readonly __typename?: 'PackageReminderToHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly home?: Maybe<HomeType>;
};

export type PackageReportingAgeBucketNode = {
  readonly __typename?: 'PackageReportingAgeBucketNode';
  readonly count: Scalars['Int']['output'];
  readonly maxDays?: Maybe<Scalars['Int']['output']>;
  readonly minDays: Scalars['Int']['output'];
};

export type PackageReportingAgeingNode = {
  readonly __typename?: 'PackageReportingAgeingNode';
  readonly buckets: ReadonlyArray<PackageReportingAgeBucketNode>;
  readonly overTwoWeeks?: Maybe<Scalars['Int']['output']>;
};

export type PackageReportingCollectionPointNode = {
  readonly __typename?: 'PackageReportingCollectionPointNode';
  readonly count: Scalars['Int']['output'];
  readonly inLocker: Scalars['Boolean']['output'];
};

export type PackageReportingCountNode = {
  readonly __typename?: 'PackageReportingCountNode';
  readonly byDay: ReadonlyArray<PackageReportingDayCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type PackageReportingDataQualityNode = {
  readonly __typename?: 'PackageReportingDataQualityNode';
  readonly markedAsDuplicate?: Maybe<Scalars['Int']['output']>;
  readonly markedAsIncorrectlyAssigned?: Maybe<Scalars['Int']['output']>;
};

export type PackageReportingDayCountNode = {
  readonly __typename?: 'PackageReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type PackageReportingDayDurationNode = {
  readonly __typename?: 'PackageReportingDayDurationNode';
  readonly day: Scalars['Date']['output'];
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type PackageReportingDurationNode = {
  readonly __typename?: 'PackageReportingDurationNode';
  readonly byDay: ReadonlyArray<PackageReportingDayDurationNode>;
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type PackageReportingHomeCountNode = {
  readonly __typename?: 'PackageReportingHomeCountNode';
  readonly count: Scalars['Int']['output'];
  readonly homeId: Scalars['UUID']['output'];
  readonly label: Scalars['String']['output'];
};

export type PackageReportingHourCountNode = {
  readonly __typename?: 'PackageReportingHourCountNode';
  readonly count: Scalars['Int']['output'];
  readonly hour: Scalars['Int']['output'];
  readonly weekday: Scalars['Int']['output'];
};

export type PackageReportingLastReminderNode = {
  readonly __typename?: 'PackageReportingLastReminderNode';
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly medianShare?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type PackageReportingLocationCountNode = {
  readonly __typename?: 'PackageReportingLocationCountNode';
  readonly count: Scalars['Int']['output'];
  readonly location?: Maybe<Scalars['String']['output']>;
};

export type PackageReportingNode = {
  readonly __typename?: 'PackageReportingNode';
  readonly ageing: PackageReportingAgeingNode;
  readonly collected: PackageReportingCountNode;
  readonly collectionPattern: ReadonlyArray<PackageReportingHourCountNode>;
  readonly collectionPoints: ReadonlyArray<PackageReportingCollectionPointNode>;
  readonly dataQuality: PackageReportingDataQualityNode;
  readonly delivered: PackageReportingCountNode;
  readonly deliveryPattern: ReadonlyArray<PackageReportingHourCountNode>;
  readonly lastReminder: PackageReportingLastReminderNode;
  readonly locations: ReadonlyArray<PackageReportingLocationCountNode>;
  readonly overTwoWeeksAtEnd: Scalars['Int']['output'];
  readonly reminders: PackageReportingRemindersNode;
  readonly remindersPerPackage?: Maybe<Scalars['Float']['output']>;
  readonly timeToCollection: PackageReportingDurationNode;
  readonly uncollected: PackageReportingUncollectedNode;
  readonly waitingHomes: ReadonlyArray<PackageReportingHomeCountNode>;
};

export type PackageReportingRemindersNode = {
  readonly __typename?: 'PackageReportingRemindersNode';
  readonly collectedWithin48Hours?: Maybe<Scalars['Float']['output']>;
  readonly collectedWithin48HoursCount: Scalars['Int']['output'];
  readonly sampleCount: Scalars['Int']['output'];
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type PackageReportingUncollectedNode = {
  readonly __typename?: 'PackageReportingUncollectedNode';
  readonly atEnd?: Maybe<PackageReportingDayCountNode>;
  readonly byDay: ReadonlyArray<PackageReportingDayCountNode>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

export type PayForDocumentInput = {
  readonly agreementId?: InputMaybe<Scalars['ID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly section21Id?: InputMaybe<Scalars['ID']['input']>;
  readonly type: Scalars['String']['input'];
};

export type PayForDocumentPayload = {
  readonly __typename?: 'PayForDocumentPayload';
  readonly amount?: Maybe<Scalars['Float']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly invoice?: Maybe<InvoiceNode>;
  readonly stripeClientSecret?: Maybe<Scalars['String']['output']>;
};

export type PayForUnpaidApplicationReferencesInput = {
  readonly applicationUuid: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type PayForUnpaidApplicationReferencesPayload = {
  readonly __typename?: 'PayForUnpaidApplicationReferencesPayload';
  readonly amount?: Maybe<Scalars['Float']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly stripeClientSecret?: Maybe<Scalars['String']['output']>;
};

export type PaymentAccountNode = {
  readonly __typename?: 'PaymentAccountNode';
  readonly balance: Scalars['Decimal']['output'];
  readonly balanceLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  readonly home?: Maybe<HomeNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastPayment?: Maybe<PaymentNode>;
  readonly leasehold?: Maybe<LeaseholdNode>;
  readonly paymentReference?: Maybe<Scalars['String']['output']>;
  readonly payments?: Maybe<PaymentNodeConnection>;
  readonly residency?: Maybe<ResidencyNode>;
  readonly unreconciledPaymentsTotal?: Maybe<Scalars['Float']['output']>;
};


export type PaymentAccountNodePaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type PaymentAccountNodeConnection = {
  readonly __typename?: 'PaymentAccountNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<PaymentAccountNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PaymentAccountNode` and its cursor. */
export type PaymentAccountNodeEdge = {
  readonly __typename?: 'PaymentAccountNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<PaymentAccountNode>;
};

export type PaymentIntentType = {
  readonly __typename?: 'PaymentIntentType';
  readonly clientSecret?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
};

export type PaymentMethod = {
  readonly __typename?: 'PaymentMethod';
  readonly bacsDebit?: Maybe<BacsPaymentType>;
  readonly card?: Maybe<CardPaymentType>;
  readonly type: Scalars['String']['output'];
};

export type PaymentNode = {
  readonly __typename?: 'PaymentNode';
  readonly amount: Scalars['BigInt']['output'];
  readonly clientSecret: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly paymentIntentId: Scalars['String']['output'];
  readonly receipt?: Maybe<PaymentReceiptType>;
  readonly requestedPaymentMethod?: Maybe<Scalars['String']['output']>;
  readonly status: PaymentsPaymentStatusChoices;
  readonly type: PaymentsPaymentTypeChoices;
};

export type PaymentNodeConnection = {
  readonly __typename?: 'PaymentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<PaymentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PaymentNode` and its cursor. */
export type PaymentNodeEdge = {
  readonly __typename?: 'PaymentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<PaymentNode>;
};

export type PaymentReceiptType = {
  readonly __typename?: 'PaymentReceiptType';
  readonly amountReceived?: Maybe<Scalars['Int']['output']>;
  readonly bankName?: Maybe<Scalars['String']['output']>;
  readonly cardBrand?: Maybe<Scalars['String']['output']>;
  readonly chargeId?: Maybe<Scalars['String']['output']>;
  readonly communityName?: Maybe<Scalars['String']['output']>;
  readonly created?: Maybe<Scalars['Int']['output']>;
  readonly currency?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly last4?: Maybe<Scalars['String']['output']>;
  readonly paidTo?: Maybe<Scalars['String']['output']>;
  readonly paymentIntentId?: Maybe<Scalars['String']['output']>;
  readonly paymentIntentStatus?: Maybe<Scalars['String']['output']>;
  readonly paymentMethodDisplay?: Maybe<Scalars['String']['output']>;
  readonly paymentMethodType?: Maybe<Scalars['String']['output']>;
  readonly paymentReference?: Maybe<Scalars['String']['output']>;
  readonly receiptUrl?: Maybe<Scalars['String']['output']>;
  readonly statementDescriptor?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum PaymentsPaymentStatusChoices {
  /** Canceled */
  Ca = 'CA',
  /** Created */
  Cr = 'CR',
  /** Payment failed */
  Fa = 'FA',
  /** Partially funded */
  Pf = 'PF',
  /** Processing */
  Pr = 'PR',
  /** Requires action */
  Ra = 'RA',
  /** Succeeded */
  Su = 'SU'
}

/** An enumeration. */
export enum PaymentsPaymentTypeChoices {
  /** AST trial */
  At = 'AT',
  /** Community event */
  Ce = 'CE',
  /** Community product */
  Cp = 'CP',
  /** Deposit */
  De = 'DE',
  /** Payment account */
  Pa = 'PA'
}

/** An enumeration. */
export enum PeopleClientClientTypeChoices {
  /** Buy to let */
  Btl = 'BTL',
  /** Enterprise */
  Ent = 'ENT'
}

/** An enumeration. */
export enum PeopleUnsubscribeNotificationGroupTypeChoices {
  /** RESIDENT_APP_AMENITY */
  ResidentAppAmenity = 'RESIDENT_APP_AMENITY',
  /** RESIDENT_APP_COMMUNITY_PRODUCT */
  ResidentAppCommunityProduct = 'RESIDENT_APP_COMMUNITY_PRODUCT',
  /** RESIDENT_APP_CONVERSATION */
  ResidentAppConversation = 'RESIDENT_APP_CONVERSATION',
  /** RESIDENT_APP_DOCUMENT */
  ResidentAppDocument = 'RESIDENT_APP_DOCUMENT',
  /** RESIDENT_APP_EVENT */
  ResidentAppEvent = 'RESIDENT_APP_EVENT',
  /** RESIDENT_APP_GROUP_CHAT */
  ResidentAppGroupChat = 'RESIDENT_APP_GROUP_CHAT',
  /** RESIDENT_APP_KEY */
  ResidentAppKey = 'RESIDENT_APP_KEY',
  /** RESIDENT_APP_MARKETPLACE */
  ResidentAppMarketplace = 'RESIDENT_APP_MARKETPLACE',
  /** RESIDENT_APP_NEWSFEED */
  ResidentAppNewsfeed = 'RESIDENT_APP_NEWSFEED',
  /** RESIDENT_APP_PACKAGE */
  ResidentAppPackage = 'RESIDENT_APP_PACKAGE'
}

/** An enumeration. */
export enum PeopleUserCommunityRestrictionFeatureTypeChoices {
  /** AMENITIES */
  Amenities = 'AMENITIES',
  /** COMMUNITY_CHAT */
  CommunityChat = 'COMMUNITY_CHAT',
  /** MARKETPLACE */
  Marketplace = 'MARKETPLACE'
}

/** An enumeration. */
export enum PeopleUserSessionSessionTargetChoices {
  /** MANAGER_APP */
  ManagerApp = 'MANAGER_APP',
  /** MANAGER_DASHBOARD */
  ManagerDashboard = 'MANAGER_DASHBOARD',
  /** RESIDENT_APP */
  ResidentApp = 'RESIDENT_APP'
}

export enum PermissionAuthority {
  Deny = 'DENY',
  Legacy = 'LEGACY',
  V2 = 'V2'
}

export type PermissionSnapshotType = {
  readonly __typename?: 'PermissionSnapshotType';
  readonly authority: PermissionAuthority;
  readonly clientId: Scalars['UUID']['output'];
  readonly permissions: ReadonlyArray<UserPermissionType>;
  readonly refreshAfter: Scalars['DateTime']['output'];
  readonly revision: Scalars['String']['output'];
};

export type PortfolioApplicationSourceNode = {
  readonly __typename?: 'PortfolioApplicationSourceNode';
  readonly inApp: Scalars['Int']['output'];
  readonly inAppShare?: Maybe<Scalars['Float']['output']>;
  readonly received: Scalars['Int']['output'];
};

export type PortfolioBookingNode = {
  readonly __typename?: 'PortfolioBookingNode';
  readonly communitiesWithBookings: Scalars['Int']['output'];
  readonly communityCount: Scalars['Int']['output'];
  readonly count: Scalars['Int']['output'];
};

export type PortfolioCoverageNode = {
  readonly __typename?: 'PortfolioCoverageNode';
  readonly active7: Scalars['Int']['output'];
  readonly active30: Scalars['Int']['output'];
  readonly active90: Scalars['Int']['output'];
  readonly appUsers: Scalars['Int']['output'];
  readonly people: Scalars['Int']['output'];
  readonly segment: PortfolioCoverageSegment;
};

/** An enumeration. */
export enum PortfolioCoverageSegment {
  Everyone = 'EVERYONE',
  Leaseholder = 'LEASEHOLDER',
  Resident = 'RESIDENT'
}

export type PortfolioEngagementReportingNode = {
  readonly __typename?: 'PortfolioEngagementReportingNode';
  readonly applications: PortfolioApplicationSourceNode;
  readonly bookings: PortfolioBookingNode;
  readonly coverage: ReadonlyArray<PortfolioCoverageNode>;
  readonly reach: ReadonlyArray<PortfolioReachRowNode>;
  readonly reachTrend: ReadonlyArray<PortfolioReachTrendNode>;
  readonly rows: ReadonlyArray<PortfolioEngagementRowNode>;
  readonly trend: ReadonlyArray<PortfolioEngagementTrendNode>;
};

export type PortfolioEngagementRowNode = {
  readonly __typename?: 'PortfolioEngagementRowNode';
  readonly activeHomes: Scalars['Int']['output'];
  readonly activeRate?: Maybe<Scalars['Float']['output']>;
  readonly activeUsers: Scalars['Int']['output'];
  readonly appHomes: Scalars['Int']['output'];
  readonly appUsers: Scalars['Int']['output'];
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly downloadRate?: Maybe<Scalars['Float']['output']>;
  readonly health?: Maybe<Scalars['Float']['output']>;
  readonly homes: Scalars['Int']['output'];
  readonly occupiedHomes: Scalars['Int']['output'];
  readonly people: Scalars['Int']['output'];
};

export type PortfolioEngagementTrendNode = {
  readonly __typename?: 'PortfolioEngagementTrendNode';
  readonly rows: ReadonlyArray<PortfolioEngagementRowNode>;
  readonly window: PortfolioWindowNode;
};

export type PortfolioIssueTypeNode = {
  readonly __typename?: 'PortfolioIssueTypeNode';
  readonly closed: Scalars['Int']['output'];
  readonly medianCloseSeconds?: Maybe<Scalars['Float']['output']>;
  readonly name: Scalars['String']['output'];
  readonly openAtEnd: Scalars['Int']['output'];
  readonly tagId: Scalars['UUID']['output'];
};

export type PortfolioMaintenanceReportingNode = {
  readonly __typename?: 'PortfolioMaintenanceReportingNode';
  readonly closeTargetDays: Scalars['Int']['output'];
  readonly rows: ReadonlyArray<PortfolioMaintenanceRowNode>;
  readonly trend: ReadonlyArray<PortfolioMaintenanceTrendNode>;
  readonly types: ReadonlyArray<PortfolioIssueTypeNode>;
};

export type PortfolioMaintenanceRowNode = {
  readonly __typename?: 'PortfolioMaintenanceRowNode';
  readonly closed: Scalars['Int']['output'];
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly health?: Maybe<Scalars['Float']['output']>;
  readonly homes: Scalars['Int']['output'];
  readonly judged: Scalars['Int']['output'];
  readonly medianCloseSeconds?: Maybe<Scalars['Float']['output']>;
  readonly onTime: Scalars['Int']['output'];
  readonly openAtEnd: Scalars['Int']['output'];
  readonly openByAge: ReadonlyArray<Scalars['Int']['output']>;
  readonly openPerHundredHomes?: Maybe<Scalars['Float']['output']>;
  readonly opened: Scalars['Int']['output'];
};

export type PortfolioMaintenanceTrendNode = {
  readonly __typename?: 'PortfolioMaintenanceTrendNode';
  readonly rows: ReadonlyArray<PortfolioMaintenanceRowNode>;
  readonly window: PortfolioWindowNode;
};

/** An enumeration. */
export enum PortfolioRatingKind {
  Maintenance = 'MAINTENANCE',
  Other = 'OTHER'
}

export type PortfolioRatingKindNode = {
  readonly __typename?: 'PortfolioRatingKindNode';
  readonly health?: Maybe<Scalars['Float']['output']>;
  readonly kind: PortfolioRatingKind;
  readonly meanRating?: Maybe<Scalars['Float']['output']>;
  readonly positive: Scalars['Int']['output'];
  readonly rated: Scalars['Int']['output'];
};

export type PortfolioReachRowNode = {
  readonly __typename?: 'PortfolioReachRowNode';
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly documentViewShare?: Maybe<Scalars['Float']['output']>;
  readonly documentViewerHomes: Scalars['Int']['output'];
  readonly occupiedHomes: Scalars['Int']['output'];
  readonly updateReadShare?: Maybe<Scalars['Float']['output']>;
  readonly updateReaderHomes: Scalars['Int']['output'];
};

export type PortfolioReachTrendNode = {
  readonly __typename?: 'PortfolioReachTrendNode';
  readonly rows: ReadonlyArray<PortfolioReachRowNode>;
  readonly window: PortfolioWindowNode;
};

export type PortfolioSatisfactionReportingNode = {
  readonly __typename?: 'PortfolioSatisfactionReportingNode';
  readonly kinds: ReadonlyArray<PortfolioRatingKindNode>;
  readonly rows: ReadonlyArray<PortfolioSatisfactionRowNode>;
  readonly timings: ReadonlyArray<PortfolioSatisfactionTimingNode>;
  readonly trend: ReadonlyArray<PortfolioSatisfactionTrendNode>;
};

export type PortfolioSatisfactionRowNode = {
  readonly __typename?: 'PortfolioSatisfactionRowNode';
  readonly closed: Scalars['Int']['output'];
  readonly closedRated: Scalars['Int']['output'];
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly health?: Maybe<Scalars['Float']['output']>;
  readonly meanRating?: Maybe<Scalars['Float']['output']>;
  readonly positive: Scalars['Int']['output'];
  readonly rated: Scalars['Int']['output'];
  readonly responseRate?: Maybe<Scalars['Float']['output']>;
  readonly stars: ReadonlyArray<Scalars['Int']['output']>;
};

export type PortfolioSatisfactionTimingNode = {
  readonly __typename?: 'PortfolioSatisfactionTimingNode';
  readonly closeSeconds?: Maybe<Scalars['Float']['output']>;
  readonly closes: Scalars['Int']['output'];
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly firstResponseSeconds?: Maybe<Scalars['Float']['output']>;
  readonly firstResponses: Scalars['Int']['output'];
  readonly replies: Scalars['Int']['output'];
  readonly replySeconds?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioSatisfactionTrendNode = {
  readonly __typename?: 'PortfolioSatisfactionTrendNode';
  readonly rows: ReadonlyArray<PortfolioSatisfactionRowNode>;
  readonly window: PortfolioWindowNode;
};

export type PortfolioWindowNode = {
  readonly __typename?: 'PortfolioWindowNode';
  readonly endDate: Scalars['Date']['output'];
  readonly startDate: Scalars['Date']['output'];
};

export type ProductCosts = {
  readonly __typename?: 'ProductCosts';
  readonly astCost?: Maybe<Scalars['Float']['output']>;
  readonly s21Cost?: Maybe<Scalars['Float']['output']>;
};

export enum ProfileHomesEnum {
  Application = 'application',
  Leasehold = 'leasehold',
  Residency = 'residency'
}

export type ProfileType = {
  readonly __typename?: 'ProfileType';
  readonly homes: ReadonlyArray<HomeNode>;
  readonly inProgressApplication?: Maybe<ApplicationNode>;
};


export type ProfileTypeHomesArgs = {
  userLinkType: ProfileHomesEnum;
};

export type PublicBlockType = {
  readonly __typename?: 'PublicBlockType';
  readonly dutyHolderLabel: Scalars['String']['output'];
  readonly homeCount?: Maybe<Scalars['Int']['output']>;
  readonly hrbReference?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly packGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly packUrl?: Maybe<Scalars['String']['output']>;
  readonly responsiblePerson?: Maybe<PublicResponsiblePersonType>;
  readonly rows?: Maybe<ReadonlyArray<PublicPeepRowType>>;
  readonly shortCode?: Maybe<Scalars['String']['output']>;
  readonly totalFloors?: Maybe<Scalars['Int']['output']>;
};

export type PublicContactType = {
  readonly __typename?: 'PublicContactType';
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly role?: Maybe<Scalars['String']['output']>;
};

export type PublicPeepRowType = {
  readonly __typename?: 'PublicPeepRowType';
  readonly assistance?: Maybe<Scalars['String']['output']>;
  readonly communication?: Maybe<Scalars['String']['output']>;
  readonly eesInPlace?: Maybe<Scalars['Boolean']['output']>;
  readonly flat?: Maybe<Scalars['String']['output']>;
  readonly floor?: Maybe<Scalars['Int']['output']>;
  readonly pcfraInPlace?: Maybe<Scalars['Boolean']['output']>;
};

export type PublicResidencyDocumentType = {
  readonly __typename?: 'PublicResidencyDocumentType';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type PublicResponsiblePersonType = {
  readonly __typename?: 'PublicResponsiblePersonType';
  readonly name: Scalars['String']['output'];
  readonly role?: Maybe<Scalars['String']['output']>;
};

export type PublicSafetyCenterDocumentType = {
  readonly __typename?: 'PublicSafetyCenterDocumentType';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly fileUrl?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly sibCategory?: Maybe<Scalars['String']['output']>;
  readonly sibCategoryLabel?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
};

export type PublicSafetyPackType = {
  readonly __typename?: 'PublicSafetyPackType';
  readonly blocks?: Maybe<ReadonlyArray<PublicBlockType>>;
  readonly communityId: Scalars['UUID']['output'];
  readonly communityName: Scalars['String']['output'];
  readonly contacts?: Maybe<ReadonlyArray<PublicContactType>>;
  readonly documents?: Maybe<ReadonlyArray<PublicSafetyCenterDocumentType>>;
  readonly lastGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly responsiblePerson?: Maybe<PublicResponsiblePersonType>;
  readonly sibPackUrl?: Maybe<Scalars['String']['output']>;
  readonly totalHomes?: Maybe<Scalars['Int']['output']>;
  readonly totalOccupants?: Maybe<Scalars['Int']['output']>;
};

export type PublishCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type PublishCommunityUpdatePayload = {
  readonly __typename?: 'PublishCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type PushTaskToAsanaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type PushTaskToAsanaPayload = {
  readonly __typename?: 'PushTaskToAsanaPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type RmcDirectorNode = {
  readonly __typename?: 'RMCDirectorNode';
  readonly communities: CommunityNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};


export type RmcDirectorNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RateConversationInput = {
  readonly answers?: InputMaybe<ReadonlyArray<InputMaybe<ConversationRatingAnswerSerializerInput>>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly rating: Scalars['Int']['input'];
  readonly surface?: InputMaybe<Surface>;
};

export type RateConversationPayload = {
  readonly __typename?: 'RateConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly rating?: Maybe<Scalars['Int']['output']>;
  readonly surface?: Maybe<Surface>;
};

export enum RatingDisplayStyle {
  Numbers = 'NUMBERS',
  Stars = 'STARS'
}

export type RatingPresentationType = {
  readonly __typename?: 'RatingPresentationType';
  readonly prompt: Scalars['String']['output'];
  readonly style: RatingDisplayStyle;
};

export enum RatingPromptSurface {
  AppOpen = 'APP_OPEN',
  Banner = 'BANNER'
}

export type ReOpenConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type ReOpenConversationPayload = {
  readonly __typename?: 'ReOpenConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type ReadAllNotificationsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

export type ReadAllNotificationsOnTargetInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

export type ReadAllNotificationsOnTargetPayload = {
  readonly __typename?: 'ReadAllNotificationsOnTargetPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly notifications: NotificationNodeConnection;
};


export type ReadAllNotificationsOnTargetPayloadNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ReadAllNotificationsPayload = {
  readonly __typename?: 'ReadAllNotificationsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type ReadNotificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ReadNotificationPayload = {
  readonly __typename?: 'ReadNotificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly notification?: Maybe<NotificationNode>;
};

export type ReconcileSafetyDeclaration = {
  readonly __typename?: 'ReconcileSafetyDeclaration';
  readonly residentSafetyDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type ReconfirmSafetyRecord = {
  readonly __typename?: 'ReconfirmSafetyRecord';
  readonly declaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
  readonly reviewRequest?: Maybe<SafetyReviewRequestNode>;
};

export type RecordConversationRatingPromptInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly closedAt: Scalars['DateTime']['input'];
  readonly dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RecordConversationRatingPromptPayload = {
  readonly __typename?: 'RecordConversationRatingPromptPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type RecordReportingConfigurationOpenedInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
};

export type RecordReportingConfigurationOpenedPayload = {
  readonly __typename?: 'RecordReportingConfigurationOpenedPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly configuration: ReportingConfigurationNode;
};

export type ReferenceHistoricalAddressNode = {
  readonly __typename?: 'ReferenceHistoricalAddressNode';
  readonly buildingName?: Maybe<Scalars['String']['output']>;
  readonly buildingNumber?: Maybe<Scalars['String']['output']>;
  readonly city: Scalars['String']['output'];
  readonly country: Scalars['String']['output'];
  readonly fullAddress?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly postcode: Scalars['String']['output'];
  readonly startDate: Scalars['Date']['output'];
  readonly street?: Maybe<Scalars['String']['output']>;
};

export type ReferenceHistoricalAddressNodeConnection = {
  readonly __typename?: 'ReferenceHistoricalAddressNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ReferenceHistoricalAddressNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ReferenceHistoricalAddressNode` and its cursor. */
export type ReferenceHistoricalAddressNodeEdge = {
  readonly __typename?: 'ReferenceHistoricalAddressNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ReferenceHistoricalAddressNode>;
};

export type ReferenceHistoricalAddressSerializerInput = {
  readonly buildingName?: InputMaybe<Scalars['String']['input']>;
  readonly buildingNumber?: InputMaybe<Scalars['String']['input']>;
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly postcode: Scalars['String']['input'];
  readonly startDate: Scalars['Date']['input'];
  readonly street?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceSignupErrorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
};

export type ReferenceSignupErrorPayload = {
  readonly __typename?: 'ReferenceSignupErrorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RejectApplication = {
  readonly __typename?: 'RejectApplication';
  readonly application?: Maybe<ApplicationNode>;
};

export type RejectBlockGroupSuggestionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RejectBlockGroupSuggestionPayload = {
  readonly __typename?: 'RejectBlockGroupSuggestionPayload';
  readonly blockGroupSuggestion?: Maybe<BlockGroupSuggestionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type RejectBlockSuggestionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RejectBlockSuggestionPayload = {
  readonly __typename?: 'RejectBlockSuggestionPayload';
  readonly blockSuggestion?: Maybe<BlockSuggestionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type RelateBlockGroupSuggestionToCommunityGroupInput = {
  readonly blockGroupSuggestionId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityGroupId: Scalars['UUID']['input'];
};

export type RelateBlockGroupSuggestionToCommunityGroupPayload = {
  readonly __typename?: 'RelateBlockGroupSuggestionToCommunityGroupPayload';
  readonly blockGroupSuggestion?: Maybe<BlockGroupSuggestionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type RemindAllApplicants = {
  readonly __typename?: 'RemindAllApplicants';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RemindApplicant = {
  readonly __typename?: 'RemindApplicant';
  readonly application?: Maybe<ApplicationNode>;
};

export type RemindResidentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RemindResidentPayload = {
  readonly __typename?: 'RemindResidentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type RemoveConversationTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type RemoveConversationTagPayload = {
  readonly __typename?: 'RemoveConversationTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationTag?: Maybe<ConversationTagNode>;
};

export type RemoveResidentFromUnpaidEventsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveResidentFromUnpaidEventsPayload = {
  readonly __typename?: 'RemoveResidentFromUnpaidEventsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveResidentsFromResidencyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly residents?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type RemoveResidentsFromResidencyPayload = {
  readonly __typename?: 'RemoveResidentsFromResidencyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residency?: Maybe<ResidencyType>;
};

export type RemoveTaskDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveTaskDocumentPayload = {
  readonly __typename?: 'RemoveTaskDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskDocument?: Maybe<TaskDocumentNode>;
};

export type RemoveTeamMemberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
  readonly user: Scalars['UUID']['input'];
};

export type RemoveTeamMemberPayload = {
  readonly __typename?: 'RemoveTeamMemberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type RenameTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly taskId: Scalars['UUID']['input'];
};

export type RenameTaskPayload = {
  readonly __typename?: 'RenameTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
};

export type ReportingConfigurationNode = {
  readonly __typename?: 'ReportingConfigurationNode';
  readonly configuration: Scalars['JSONString']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isFavourite: Scalars['Boolean']['output'];
  readonly lastOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly name: Scalars['String']['output'];
  readonly reportKey: Scalars['String']['output'];
  readonly revision: Scalars['Int']['output'];
  readonly schedules: ReadonlyArray<ReportingScheduleNode>;
  readonly schemaVersion: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ReportingPeriodInput = {
  readonly endDate: Scalars['Date']['input'];
  readonly startDate: Scalars['Date']['input'];
};

/** An enumeration. */
export enum ReportingScheduleCadence {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type ReportingScheduleNode = {
  readonly __typename?: 'ReportingScheduleNode';
  readonly cadence?: Maybe<ReportingScheduleCadence>;
  readonly id: Scalars['UUID']['output'];
  readonly nextRunAt: Scalars['DateTime']['output'];
};

export type RequirementItemNode = {
  readonly __typename?: 'RequirementItemNode';
  readonly attachment?: Maybe<LandlordAttachmentType>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly expiryDate?: Maybe<Scalars['Date']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly requirement: ComplianceRequirementNode;
  readonly status?: Maybe<Scalars['String']['output']>;
};

export type RequirementItemNodeConnection = {
  readonly __typename?: 'RequirementItemNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RequirementItemNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RequirementItemNode` and its cursor. */
export type RequirementItemNodeEdge = {
  readonly __typename?: 'RequirementItemNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<RequirementItemNode>;
};

export type ResendMemberInviteEmailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type ResendMemberInviteEmailPayload = {
  readonly __typename?: 'ResendMemberInviteEmailPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientUser?: Maybe<ClientUserNode>;
};

export type ReserveAmenityInput = {
  readonly amenity?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly end: Scalars['DateTime']['input'];
  readonly start: Scalars['DateTime']['input'];
};

export type ReserveAmenityPayload = {
  readonly __typename?: 'ReserveAmenityPayload';
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ReserveAmenitySlotInput = {
  readonly additionalAttendance?: InputMaybe<Scalars['Int']['input']>;
  readonly amenity?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly end: Scalars['DateTime']['input'];
  readonly start: Scalars['DateTime']['input'];
};

export type ReserveAmenitySlotPayload = {
  readonly __typename?: 'ReserveAmenitySlotPayload';
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ResidencyAndResidentsInput = {
  readonly depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly endDate?: InputMaybe<Scalars['Date']['input']>;
  readonly homeId?: InputMaybe<Scalars['UUID']['input']>;
  readonly paymentFrequency: Scalars['String']['input'];
  readonly paymentStartDate?: InputMaybe<Scalars['Date']['input']>;
  readonly rentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly residencyId?: InputMaybe<Scalars['UUID']['input']>;
  readonly sendTenantWelcomeEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startDate?: InputMaybe<Scalars['Date']['input']>;
  readonly tenants?: InputMaybe<ReadonlyArray<InputMaybe<Tenants>>>;
};

export type ResidencyDocumentNode = {
  readonly __typename?: 'ResidencyDocumentNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly author?: Maybe<UserType>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly residency: ResidencyType;
  readonly title: Scalars['String']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
  readonly views: ResidencyDocumentViewNodeConnection;
};


export type ResidencyDocumentNodeViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ResidencyDocumentNodeConnection = {
  readonly __typename?: 'ResidencyDocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidencyDocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidencyDocumentNode` and its cursor. */
export type ResidencyDocumentNodeEdge = {
  readonly __typename?: 'ResidencyDocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidencyDocumentNode>;
};

export type ResidencyDocumentViewNode = {
  readonly __typename?: 'ResidencyDocumentViewNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly user: UserType;
};

export type ResidencyDocumentViewNodeConnection = {
  readonly __typename?: 'ResidencyDocumentViewNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidencyDocumentViewNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidencyDocumentViewNode` and its cursor. */
export type ResidencyDocumentViewNodeEdge = {
  readonly __typename?: 'ResidencyDocumentViewNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidencyDocumentViewNode>;
};

export type ResidencyNode = {
  readonly __typename?: 'ResidencyNode';
  readonly completionDate?: Maybe<Scalars['Date']['output']>;
  readonly complianceRequirements: ComplianceRequirementNodeConnection;
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly depositPayment?: Maybe<PaymentNode>;
  readonly documents: ResidencyDocumentNodeConnection;
  readonly endDate: Scalars['Date']['output'];
  readonly externalId?: Maybe<Scalars['String']['output']>;
  readonly generatedAgreements: GeneratedAgreementNodeConnection;
  readonly home: HomeType;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly occupancySurveys: OccupancySurveyNodeConnection;
  readonly packages: PackageNodeConnection;
  readonly pastResidents?: Maybe<ArchivedContactNodeConnection>;
  readonly paymentFrequency: Scalars['String']['output'];
  readonly paymentStartDate?: Maybe<Scalars['Date']['output']>;
  readonly publicDocuments: ReadonlyArray<PublicResidencyDocumentType>;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly residentSafetyRecords: ResidentSafetyRecordNodeConnection;
  readonly residents: ReadonlyArray<ResidentType>;
  readonly rollingConfirmed: Scalars['Boolean']['output'];
  readonly stage?: Maybe<Scalars['String']['output']>;
  readonly startDate: Scalars['Date']['output'];
  readonly subscription?: Maybe<SubscriptionNode>;
  readonly type?: Maybe<Scalars['String']['output']>;
};


export type ResidencyNodeComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ResidencyNodeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyNodeGeneratedAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyNodeOccupancySurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyNodePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyNodePastResidentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyNodeResidentSafetyRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  eesStatus?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasNeeds?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pcfraStatus?: InputMaybe<Scalars['String']['input']>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};

export type ResidencyNodeConnection = {
  readonly __typename?: 'ResidencyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidencyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidencyNode` and its cursor. */
export type ResidencyNodeEdge = {
  readonly __typename?: 'ResidencyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidencyNode>;
};

export type ResidencyType = {
  readonly __typename?: 'ResidencyType';
  readonly completionDate?: Maybe<Scalars['Date']['output']>;
  readonly complianceRequirements: ComplianceRequirementNodeConnection;
  readonly conversations?: Maybe<ReadonlyArray<ConversationNode>>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly documents: ResidencyDocumentNodeConnection;
  readonly emergencyNumber?: Maybe<Scalars['String']['output']>;
  readonly endDate: Scalars['Date']['output'];
  readonly generatedAgreements: GeneratedAgreementNodeConnection;
  readonly home: HomeNode;
  readonly howToRentShared: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly notifications?: Maybe<ReadonlyArray<Maybe<ManagerNotificationType>>>;
  readonly occupancySurveys: OccupancySurveyNodeConnection;
  readonly packages?: Maybe<PackageNodeConnection>;
  readonly paymentAccount?: Maybe<PaymentAccountNode>;
  readonly paymentFrequency: Scalars['String']['output'];
  readonly paymentStartDate?: Maybe<Scalars['Date']['output']>;
  readonly publicDocuments: ReadonlyArray<PublicResidencyDocumentType>;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly residentSafetyRecords: ResidentSafetyRecordNodeConnection;
  readonly residents: ReadonlyArray<ResidentType>;
  readonly rollingConfirmed: Scalars['Boolean']['output'];
  readonly stage?: Maybe<Scalars['String']['output']>;
  readonly startDate: Scalars['Date']['output'];
  readonly subscription?: Maybe<SubscriptionNode>;
  readonly tenancyapplicationSet: TenancyApplicationNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type ResidencyTypeComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ResidencyTypeConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyTypeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyTypeGeneratedAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyTypeOccupancySurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyTypePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyTypeResidentSafetyRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  eesStatus?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasNeeds?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pcfraStatus?: InputMaybe<Scalars['String']['input']>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyTypeTenancyapplicationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenSent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type ResidentAppNotificationPreferencesNode = {
  readonly __typename?: 'ResidentAppNotificationPreferencesNode';
  readonly amenityEmailEnabled: Scalars['Boolean']['output'];
  readonly amenityPushEnabled: Scalars['Boolean']['output'];
  readonly communityProductEmailEnabled: Scalars['Boolean']['output'];
  readonly communityProductPushEnabled: Scalars['Boolean']['output'];
  readonly conversationEmailEnabled: Scalars['Boolean']['output'];
  readonly conversationPushEnabled: Scalars['Boolean']['output'];
  readonly documentEmailEnabled: Scalars['Boolean']['output'];
  readonly documentPushEnabled: Scalars['Boolean']['output'];
  readonly environmentPushEnabled: Scalars['Boolean']['output'];
  readonly eventEmailEnabled: Scalars['Boolean']['output'];
  readonly eventPushEnabled: Scalars['Boolean']['output'];
  readonly groupChatEmailEnabled: Scalars['Boolean']['output'];
  readonly groupChatPushEnabled: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isMuted: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly keyEmailEnabled: Scalars['Boolean']['output'];
  readonly keyPushEnabled: Scalars['Boolean']['output'];
  readonly marketplaceEmailEnabled: Scalars['Boolean']['output'];
  readonly marketplacePushEnabled: Scalars['Boolean']['output'];
  readonly newsfeedEmailEnabled: Scalars['Boolean']['output'];
  readonly newsfeedPushEnabled: Scalars['Boolean']['output'];
  readonly packageEmailEnabled: Scalars['Boolean']['output'];
  readonly packagePushEnabled: Scalars['Boolean']['output'];
};

export type ResidentArchiveKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ResidentArchiveKeyholderPayload = {
  readonly __typename?: 'ResidentArchiveKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type ResidentCreateKeyholder = {
  readonly __typename?: 'ResidentCreateKeyholder';
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type ResidentCreateKeyholderInput = {
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['String']['input']>;
  readonly homeId?: InputMaybe<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly startDate: Scalars['String']['input'];
};

export type ResidentNode = {
  readonly __typename?: 'ResidentNode';
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly averageScore?: Maybe<Scalars['Float']['output']>;
  readonly conversation?: Maybe<ConversationNodeConnection>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentResidencies?: Maybe<ReadonlyArray<ResidencyType>>;
  readonly dateOfBirth?: Maybe<Scalars['String']['output']>;
  readonly documents: ResidencyDocumentNodeConnection;
  readonly email: Scalars['String']['output'];
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly hasAcceptedArkTerms: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isLeaseholder?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly packages: PackageNodeConnection;
  readonly residencies: ReadonlyArray<ResidencyType>;
  readonly surveyAnswers: ReadonlyArray<ResidentSurveyAnswerType>;
  readonly tenancyapplicantSet: TenancyApplicantNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};


export type ResidentNodeConversationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  resident?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  subject_Icontains?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ResidentNodeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidentNodePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidentNodeTenancyapplicantSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ResidentNodeConnection = {
  readonly __typename?: 'ResidentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentNode` and its cursor. */
export type ResidentNodeEdge = {
  readonly __typename?: 'ResidentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentNode>;
};

export type ResidentSafetyDeclarationNode = {
  readonly __typename?: 'ResidentSafetyDeclarationNode';
  readonly braille?: Maybe<Scalars['Boolean']['output']>;
  readonly communicationDetails?: Maybe<Scalars['String']['output']>;
  readonly communicationNeedDeclared?: Maybe<Scalars['Boolean']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly declarantName?: Maybe<Scalars['String']['output']>;
  readonly declaredAt: Scalars['DateTime']['output'];
  readonly evidenceFileUrl?: Maybe<Scalars['String']['output']>;
  readonly hasEvidence: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isAuthoritative: Scalars['Boolean']['output'];
  readonly isOccupant?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isVoided: Scalars['Boolean']['output'];
  readonly language: Scalars['String']['output'];
  readonly largePrint?: Maybe<Scalars['Boolean']['output']>;
  readonly mobilityDetails?: Maybe<Scalars['String']['output']>;
  readonly mobilityNeedDeclared?: Maybe<Scalars['Boolean']['output']>;
  readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices;
  readonly record: ResidentSafetyRecordNode;
  readonly submittedBy?: Maybe<UserType>;
  readonly textToSpeech?: Maybe<Scalars['Boolean']['output']>;
  readonly voidReason: Scalars['String']['output'];
  readonly voidedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly voidedBy?: Maybe<UserType>;
  readonly voidedByName?: Maybe<Scalars['String']['output']>;
};

export type ResidentSafetyDeclarationNodeConnection = {
  readonly __typename?: 'ResidentSafetyDeclarationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentSafetyDeclarationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentSafetyDeclarationNode` and its cursor. */
export type ResidentSafetyDeclarationNodeEdge = {
  readonly __typename?: 'ResidentSafetyDeclarationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentSafetyDeclarationNode>;
};

export type ResidentSafetyRecordAuditLogNode = {
  readonly __typename?: 'ResidentSafetyRecordAuditLogNode';
  readonly actor?: Maybe<UserType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly eventType: ResidentialManagementResidentSafetyRecordAuditLogEventTypeChoices;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly metadata: Scalars['JSONString']['output'];
};

export type ResidentSafetyRecordAuditLogNodeConnection = {
  readonly __typename?: 'ResidentSafetyRecordAuditLogNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentSafetyRecordAuditLogNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentSafetyRecordAuditLogNode` and its cursor. */
export type ResidentSafetyRecordAuditLogNodeEdge = {
  readonly __typename?: 'ResidentSafetyRecordAuditLogNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentSafetyRecordAuditLogNode>;
};

export type ResidentSafetyRecordInput = {
  readonly braille?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communicationNeedDeclared?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communicationNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly first: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly isOccupant: Scalars['Boolean']['input'];
  readonly language?: InputMaybe<Scalars['String']['input']>;
  readonly largePrint?: InputMaybe<Scalars['Boolean']['input']>;
  readonly last: Scalars['String']['input'];
  readonly mobilityNeedDeclared?: InputMaybe<Scalars['Boolean']['input']>;
  readonly mobilityNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly textToSpeech?: InputMaybe<Scalars['Boolean']['input']>;
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ResidentSafetyRecordNode = {
  readonly __typename?: 'ResidentSafetyRecordNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly auditLogs?: Maybe<ResidentSafetyRecordAuditLogNodeConnection>;
  readonly authoritativeDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly braille?: Maybe<Scalars['Boolean']['output']>;
  readonly communicationNeedDeclared?: Maybe<Scalars['Boolean']['output']>;
  readonly communicationNeeds?: Maybe<Scalars['String']['output']>;
  readonly consentDeclinedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly consentGivenAt?: Maybe<Scalars['DateTime']['output']>;
  readonly contactEmail?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly declarations?: Maybe<ResidentSafetyDeclarationNodeConnection>;
  readonly eesAgreedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly eesFileUrl?: Maybe<Scalars['String']['output']>;
  readonly eesGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly fireServiceConsentGivenAt?: Maybe<Scalars['DateTime']['output']>;
  readonly fireServiceConsentWithdrawnAt?: Maybe<Scalars['DateTime']['output']>;
  readonly first: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isAppLinked: Scalars['Boolean']['output'];
  readonly isOccupant?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly language: Scalars['String']['output'];
  readonly largePrint?: Maybe<Scalars['Boolean']['output']>;
  readonly last: Scalars['String']['output'];
  readonly lastReviewedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly latestDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly lifecycleStatus: Scalars['String']['output'];
  readonly linkSuggestions: ReadonlyArray<SafetySubjectLinkSuggestionType>;
  readonly mobilityNeedDeclared?: Maybe<Scalars['Boolean']['output']>;
  readonly mobilityNeeds?: Maybe<Scalars['String']['output']>;
  readonly needsReconciliation: Scalars['Boolean']['output'];
  readonly openReviewRequest?: Maybe<SafetyReviewRequestNode>;
  readonly outstandingActions?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly pcfraAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly pcfraAssessmentDate?: Maybe<Scalars['Date']['output']>;
  readonly pcfraCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly pcfraDeclinedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly pcfraFileUrl?: Maybe<Scalars['String']['output']>;
  readonly pcfraOfferedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly pcfraParticipation?: Maybe<Scalars['String']['output']>;
  readonly reconciledAt?: Maybe<Scalars['DateTime']['output']>;
  readonly residency: ResidencyType;
  readonly reviewRequests: ReadonlyArray<SafetyReviewRequestNode>;
  readonly sharesWithFireService: Scalars['Boolean']['output'];
  readonly submittedBy?: Maybe<UserType>;
  readonly textToSpeech?: Maybe<Scalars['Boolean']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};


export type ResidentSafetyRecordNodeAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  record?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidentSafetyRecordNodeDeclarationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  record?: InputMaybe<Scalars['UUID']['input']>;
};

export type ResidentSafetyRecordNodeConnection = {
  readonly __typename?: 'ResidentSafetyRecordNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentSafetyRecordNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentSafetyRecordNode` and its cursor. */
export type ResidentSafetyRecordNodeEdge = {
  readonly __typename?: 'ResidentSafetyRecordNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentSafetyRecordNode>;
};

export type ResidentSurveyAnswerType = {
  readonly __typename?: 'ResidentSurveyAnswerType';
  readonly answer?: Maybe<ResidentSurveyOptionType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly resident?: Maybe<ResidentType>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};

export type ResidentSurveyNode = {
  readonly __typename?: 'ResidentSurveyNode';
  readonly answers: ReadonlyArray<ResidentSurveyAnswerType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly groups: CommunityGroupNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly options: ReadonlyArray<ResidentSurveyOptionType>;
  readonly publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly question: Scalars['String']['output'];
  readonly rawCsv: Scalars['String']['output'];
  readonly residentHasAnswered?: Maybe<Scalars['Boolean']['output']>;
  readonly status: Scalars['String']['output'];
  readonly totalResidents: Scalars['Int']['output'];
};


export type ResidentSurveyNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type ResidentSurveyNodeConnection = {
  readonly __typename?: 'ResidentSurveyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentSurveyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentSurveyNode` and its cursor. */
export type ResidentSurveyNodeEdge = {
  readonly __typename?: 'ResidentSurveyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentSurveyNode>;
};

export type ResidentSurveyOptionType = {
  readonly __typename?: 'ResidentSurveyOptionType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly option?: Maybe<Scalars['String']['output']>;
  readonly residents: ReadonlyArray<ResidentSurveyAnswerType>;
  readonly totalResidents: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ResidentTaskNode = {
  readonly __typename?: 'ResidentTaskNode';
  readonly communityName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly residentStatus?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'id' instead. Retained for resident-app <= 4.20.x compatibility; remove once min-supported app version floor is raised above 4.20. */
  readonly taskId?: Maybe<Scalars['UUID']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly updates?: Maybe<ReadonlyArray<ResidentTaskUpdateType>>;
};

export type ResidentTaskNodeConnection = {
  readonly __typename?: 'ResidentTaskNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentTaskNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentTaskNode` and its cursor. */
export type ResidentTaskNodeEdge = {
  readonly __typename?: 'ResidentTaskNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentTaskNode>;
};

export type ResidentTaskUpdateType = {
  readonly __typename?: 'ResidentTaskUpdateType';
  readonly createdAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly newStatus?: Maybe<Scalars['String']['output']>;
  readonly updateType?: Maybe<Scalars['String']['output']>;
};

export type ResidentType = {
  readonly __typename?: 'ResidentType';
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly averageScore?: Maybe<Scalars['Float']['output']>;
  readonly conversations?: Maybe<ReadonlyArray<ConversationNode>>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentResidencies?: Maybe<ReadonlyArray<ResidencyType>>;
  readonly dateOfBirth?: Maybe<Scalars['String']['output']>;
  readonly documents: ResidencyDocumentNodeConnection;
  readonly email: Scalars['String']['output'];
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly hasAcceptedArkTerms: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isLeaseholder?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly packages: PackageNodeConnection;
  readonly residencies: ReadonlyArray<ResidencyType>;
  readonly surveyAnswers: ReadonlyArray<ResidentSurveyAnswerType>;
  readonly tenancyapplicantSet: TenancyApplicantNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};


export type ResidentTypeConversationsArgs = {
  conversationLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidentTypeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidentTypePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidentTypeTenancyapplicantSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ResidentUnarchiveKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ResidentUnarchiveKeyholderPayload = {
  readonly __typename?: 'ResidentUnarchiveKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type ResidentUpdateKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ResidentUpdateKeyholderPayload = {
  readonly __typename?: 'ResidentUpdateKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly company?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly endDate?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['DateTime']['output']>;
};

/** An enumeration. */
export enum ResidentialManagementAmenityTypeChoices {
  /** APPOINTMENT */
  Appointment = 'APPOINTMENT',
  /** FACILITY */
  Facility = 'FACILITY'
}

/** An enumeration. */
export enum ResidentialManagementApplicationAuditLogEventTypeChoices {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Archived */
  Archived = 'ARCHIVED',
  /** Bulk Reminder Sent */
  BulkReminderSent = 'BULK_REMINDER_SENT',
  /** Community Found */
  CommunityFound = 'COMMUNITY_FOUND',
  /** Created */
  Created = 'CREATED',
  /** Document Uploaded */
  DocumentUploaded = 'DOCUMENT_UPLOADED',
  /** Home Assigned */
  HomeAssigned = 'HOME_ASSIGNED',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Reminder Sent */
  ReminderSent = 'REMINDER_SENT',
  /** Unarchived */
  Unarchived = 'UNARCHIVED'
}

/** An enumeration. */
export enum ResidentialManagementApplicationOwnershipTypeChoices {
  /** Owned */
  Ow = 'OW',
  /** Renting */
  Re = 'RE',
  /** Shared Ownership */
  So = 'SO'
}

/** An enumeration. */
export enum ResidentialManagementApplicationSourceChoices {
  /** Applicant */
  Ap = 'AP',
  /** Concierge */
  Co = 'CO'
}

/** An enumeration. */
export enum ResidentialManagementApplicationStatusChoices {
  /** Approved */
  Ap = 'AP',
  /** Community Known */
  Ck = 'CK',
  /** Document Sent */
  Ds = 'DS',
  /** Multiple Communities */
  Mc = 'MC',
  /** Pending */
  Pe = 'PE',
  /** Rejected */
  Re = 'RE',
  /** Unknown Community */
  Uc = 'UC'
}

/** An enumeration. */
export enum ResidentialManagementApplicationSupportMessageSenderChoices {
  /** Applicant */
  Applicant = 'APPLICANT',
  /** Support */
  Support = 'SUPPORT'
}

/** An enumeration. */
export enum ResidentialManagementApplicationThreadMediaSenderChoices {
  /** Applicant */
  Ap = 'AP',
  /** Manager */
  Ma = 'MA'
}

/** An enumeration. */
export enum ResidentialManagementApplicationThreadMessageSenderChoices {
  /** Applicant */
  Ap = 'AP',
  /** Manager */
  Ma = 'MA'
}

/** An enumeration. */
export enum ResidentialManagementBlockGroupSuggestionStatusChoices {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Altered */
  Altered = 'ALTERED',
  /** Pending */
  Pending = 'PENDING',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Stale */
  Stale = 'STALE'
}

/** An enumeration. */
export enum ResidentialManagementBlockGroupSuggestionTypeChoices {
  /** Everyone */
  Everyone = 'EVERYONE',
  /** Leaseholders */
  Leaseholders = 'LEASEHOLDERS',
  /** Residents */
  Residents = 'RESIDENTS'
}

/** An enumeration. */
export enum ResidentialManagementBlockSuggestionStatusChoices {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Altered */
  Altered = 'ALTERED',
  /** Pending */
  Pending = 'PENDING',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Stale */
  Stale = 'STALE'
}

/** An enumeration. */
export enum ResidentialManagementBulkConversationActionJobActionChoices {
  /** Close with message */
  CloseMessage = 'CLOSE_MESSAGE',
  /** Close silent */
  CloseSilent = 'CLOSE_SILENT'
}

/** An enumeration. */
export enum ResidentialManagementBulkConversationActionJobClosedReasonChoices {
  /** Manual */
  Manual = 'MANUAL',
  /** Stale - inactivity */
  StaleInactivity = 'STALE_INACTIVITY',
  /** Stale - unanswered */
  StaleUnanswered = 'STALE_UNANSWERED'
}

/** An enumeration. */
export enum ResidentialManagementBulkConversationActionJobStatusChoices {
  /** Completed */
  Completed = 'COMPLETED',
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Processing */
  Processing = 'PROCESSING'
}

/** An enumeration. */
export enum ResidentialManagementClientContractorCompanyCompanyTypeChoices {
  /** CARPENTRY */
  Carpentry = 'CARPENTRY',
  /** CLEANING */
  Cleaning = 'CLEANING',
  /** ELECTRICIAN */
  Electrician = 'ELECTRICIAN',
  /** FIRE_SAFETY */
  FireSafety = 'FIRE_SAFETY',
  /** GENERAL_MAINTENANCE */
  GeneralMaintenance = 'GENERAL_MAINTENANCE',
  /** HVAC */
  Hvac = 'HVAC',
  /** LANDSCAPING */
  Landscaping = 'LANDSCAPING',
  /** LOCKSMITH */
  Locksmith = 'LOCKSMITH',
  /** OTHER */
  Other = 'OTHER',
  /** PAINTING */
  Painting = 'PAINTING',
  /** PEST_CONTROL */
  PestControl = 'PEST_CONTROL',
  /** PLUMBER */
  Plumber = 'PLUMBER',
  /** ROOFING */
  Roofing = 'ROOFING',
  /** SECURITY */
  Security = 'SECURITY'
}

/** An enumeration. */
export enum ResidentialManagementCommunityDocumentViewersChoices {
  /** All */
  Al = 'AL',
  /** Leaseholders */
  Le = 'LE',
  /** Residents */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementCommunityFormProviderChoices {
  /** TYPEFORM */
  Typeform = 'TYPEFORM'
}

/** An enumeration. */
export enum ResidentialManagementCommunityStatisticDataPointTypeChoices {
  /** ACTIVE_RESIDENT_COUNT */
  ActiveResidentCount = 'ACTIVE_RESIDENT_COUNT',
  /** AVERAGE_PACKAGE_COLLECTION_TIME */
  AveragePackageCollectionTime = 'AVERAGE_PACKAGE_COLLECTION_TIME',
  /** DOWNLOAD_RATE_PERCENTAGE */
  DownloadRatePercentage = 'DOWNLOAD_RATE_PERCENTAGE',
  /** FACILITY_BOOKINGS_COUNT */
  FacilityBookingsCount = 'FACILITY_BOOKINGS_COUNT',
  /** INCOMING_MESSAGES_COUNT */
  IncomingMessagesCount = 'INCOMING_MESSAGES_COUNT',
  /** KEY_IN_COUNT */
  KeyInCount = 'KEY_IN_COUNT',
  /** KEY_OUT_COUNT */
  KeyOutCount = 'KEY_OUT_COUNT',
  /** PACKAGE_COLLECTED_COUNT */
  PackageCollectedCount = 'PACKAGE_COLLECTED_COUNT',
  /** PACKAGE_DELIVERED_COUNT */
  PackageDeliveredCount = 'PACKAGE_DELIVERED_COUNT'
}

/** An enumeration. */
export enum ResidentialManagementCommunityUpdateCommentUserTypeChoices {
  /** Concierge */
  Co = 'CO',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementCommunityUpdateCreatorTypeChoices {
  /** Concierge */
  Co = 'CO',
  /** Manager */
  Ma = 'MA'
}

/** An enumeration. */
export enum ResidentialManagementCommunityUpdateLinkedFeatureChoices {
  /** MARKETPLACE_THREADS */
  MarketplaceThreads = 'MARKETPLACE_THREADS',
  /** SERVICE_CHARGE_TRANSPARENCY */
  ServiceChargeTransparency = 'SERVICE_CHARGE_TRANSPARENCY'
}

/** An enumeration. */
export enum ResidentialManagementCommunityUpdateLocaleVariantStatusChoices {
  /** Completed */
  Completed = 'COMPLETED',
  /** Error */
  Error = 'ERROR',
  /** Loading */
  Loading = 'LOADING'
}

/** An enumeration. */
export enum ResidentialManagementContractorCompanyTypeChoices {
  /** CARPENTRY */
  Carpentry = 'CARPENTRY',
  /** CLEANING */
  Cleaning = 'CLEANING',
  /** ELECTRICIAN */
  Electrician = 'ELECTRICIAN',
  /** FIRE_SAFETY */
  FireSafety = 'FIRE_SAFETY',
  /** GENERAL_MAINTENANCE */
  GeneralMaintenance = 'GENERAL_MAINTENANCE',
  /** HVAC */
  Hvac = 'HVAC',
  /** LANDSCAPING */
  Landscaping = 'LANDSCAPING',
  /** LOCKSMITH */
  Locksmith = 'LOCKSMITH',
  /** OTHER */
  Other = 'OTHER',
  /** PAINTING */
  Painting = 'PAINTING',
  /** PEST_CONTROL */
  PestControl = 'PEST_CONTROL',
  /** PLUMBER */
  Plumber = 'PLUMBER',
  /** ROOFING */
  Roofing = 'ROOFING',
  /** SECURITY */
  Security = 'SECURITY'
}

/** An enumeration. */
export enum ResidentialManagementConversationCategoryChoices {
  /** Concierge */
  Co = 'CO',
  /** Documents */
  Do = 'DO',
  /** Electric */
  El = 'EL',
  /** Heating */
  He = 'HE',
  /** Other */
  Ot = 'OT',
  /** Payment Queries */
  Pa = 'PA'
}

/** An enumeration. */
export enum ResidentialManagementConversationClosedByChoices {
  /** System */
  System = 'SYSTEM',
  /** User */
  User = 'USER'
}

/** An enumeration. */
export enum ResidentialManagementConversationClosedReasonChoices {
  /** Manual */
  Manual = 'MANUAL',
  /** Stale - inactivity */
  StaleInactivity = 'STALE_INACTIVITY',
  /** Stale - unanswered */
  StaleUnanswered = 'STALE_UNANSWERED'
}

/** An enumeration. */
export enum ResidentialManagementConversationMediaSenderChoices {
  /** Concierge */
  Co = 'CO',
  /** CONTRACTOR */
  Contractor = 'CONTRACTOR',
  /** Leaseholder */
  Le = 'LE',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementConversationMessageSenderChoices {
  /** Concierge */
  Co = 'CO',
  /** CONTRACTOR */
  Contractor = 'CONTRACTOR',
  /** Leaseholder */
  Le = 'LE',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementConversationParticipantTypeChoices {
  /** CONTRACTOR */
  Contractor = 'CONTRACTOR',
  /** INTERNAL */
  Internal = 'INTERNAL',
  /** LEASEHOLDER */
  Leaseholder = 'LEASEHOLDER',
  /** RESIDENT */
  Resident = 'RESIDENT',
  /** UNKNOWN */
  Unknown = 'UNKNOWN'
}

/** An enumeration. */
export enum ResidentialManagementConversationRatingDisplayStyleChoices {
  /** Numbers 1 to 5 */
  Numbers = 'NUMBERS',
  /** Stars */
  Stars = 'STARS'
}

/** An enumeration. */
export enum ResidentialManagementConversationRatingQuestionAnswerTypeChoices {
  /** 1 to 5 */
  Scale = 'SCALE',
  /** Text */
  Text = 'TEXT'
}

/** An enumeration. */
export enum ResidentialManagementConversationRatingSurfaceChoices {
  /** App open */
  AppOpen = 'APP_OPEN',
  /** Banner */
  Banner = 'BANNER',
  /** Chat footer */
  ChatFooter = 'CHAT_FOOTER',
  /** Push */
  Push = 'PUSH'
}

/** An enumeration. */
export enum ResidentialManagementDocumentExtractionModeChoices {
  /** Inspection */
  Inspection = 'INSPECTION',
  /** Template */
  Template = 'TEMPLATE'
}

/** An enumeration. */
export enum ResidentialManagementDocumentExtractionParseStrategyChoices {
  /** Docling */
  Docling = 'DOCLING',
  /** Gemini direct */
  GeminiDirect = 'GEMINI_DIRECT',
  /** OCTX DocAI */
  OctxDocai = 'OCTX_DOCAI',
  /** pdfplumber */
  Pdfplumber = 'PDFPLUMBER'
}

/** An enumeration. */
export enum ResidentialManagementDocumentExtractionStatusChoices {
  /** Extracting */
  Extracting = 'EXTRACTING',
  /** Failed */
  Failed = 'FAILED',
  /** Materializing */
  Materializing = 'MATERIALIZING',
  /** Parsing */
  Parsing = 'PARSING',
  /** Ready */
  Ready = 'READY',
  /** Uploaded */
  Uploaded = 'UPLOADED',
  /** Validating */
  Validating = 'VALIDATING'
}

/** An enumeration. */
export enum ResidentialManagementDocumentVerificationResultAddressMatchStatusChoices {
  /** Amber */
  Amber = 'AMBER',
  /** Green */
  Green = 'GREEN',
  /** Red */
  Red = 'RED'
}

/** An enumeration. */
export enum ResidentialManagementDocumentVerificationResultAiRecommendationChoices {
  /** Approved */
  Approved = 'APPROVED',
  /** Needs Review */
  NeedsReview = 'NEEDS_REVIEW',
  /** Rejected */
  Rejected = 'REJECTED'
}

/** An enumeration. */
export enum ResidentialManagementDocumentVerificationResultNameMatchStatusChoices {
  /** Amber */
  Amber = 'AMBER',
  /** Green */
  Green = 'GREEN',
  /** Red */
  Red = 'RED'
}

/** An enumeration. */
export enum ResidentialManagementDocumentVerificationResultStatusChoices {
  /** Completed */
  Completed = 'COMPLETED',
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Processing */
  Processing = 'PROCESSING'
}

/** An enumeration. */
export enum ResidentialManagementHomeDetailsFurnishingChoices {
  /** Fully Furnished */
  Fu = 'FU',
  /** None */
  No = 'NO',
  /** Partially Furnished */
  Pa = 'PA',
  /** Unfurnished */
  Un = 'UN'
}

/** An enumeration. */
export enum ResidentialManagementHomeDetailsParkingChoices {
  /** Not Available */
  Na = 'NA',
  /** None */
  No = 'NO',
  /** Off-Street */
  Of = 'OF',
  /** On-Street */
  On = 'ON'
}

/** An enumeration. */
export enum ResidentialManagementKeyEventTypeChoices {
  /** Check in */
  In = 'IN',
  /** Check out */
  Ou = 'OU'
}

/** An enumeration. */
export enum ResidentialManagementMessageSuggestionActionChoices {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Edited */
  Edited = 'EDITED',
  /** Ignored */
  Ignored = 'IGNORED'
}

/** An enumeration. */
export enum ResidentialManagementPackageEventTypeChoices {
  /** ARCHIVED */
  Archived = 'ARCHIVED',
  /** COLLECTION */
  Collection = 'COLLECTION',
  /** COLLECTION_CONFIRMATION_CONFIRMATION */
  CollectionConfirmationConfirmation = 'COLLECTION_CONFIRMATION_CONFIRMATION',
  /** COLLECTION_CONFIRMATION_REJECTION */
  CollectionConfirmationRejection = 'COLLECTION_CONFIRMATION_REJECTION',
  /** COLLECTION_CONFIRMATION_REQUEST */
  CollectionConfirmationRequest = 'COLLECTION_CONFIRMATION_REQUEST',
  /** DELIVERY */
  Delivery = 'DELIVERY',
  /** MARKED_AS_DUPLICATE */
  MarkedAsDuplicate = 'MARKED_AS_DUPLICATE',
  /** MARKED_AS_INCORRECTLY_ASSIGNED */
  MarkedAsIncorrectlyAssigned = 'MARKED_AS_INCORRECTLY_ASSIGNED',
  /** REMINDER */
  Reminder = 'REMINDER'
}

/** An enumeration. */
export enum ResidentialManagementPackageStatusChoices {
  /** ARCHIVED */
  Archived = 'ARCHIVED',
  /** Collected */
  Co = 'CO',
  /** Delivered */
  De = 'DE',
  /** DUPLICATE */
  Duplicate = 'DUPLICATE',
  /** INCORRECTLY_ASSIGNED */
  IncorrectlyAssigned = 'INCORRECTLY_ASSIGNED',
  /** PENDING_COLLECTION_CONFIRMATION */
  PendingCollectionConfirmation = 'PENDING_COLLECTION_CONFIRMATION'
}

/** An enumeration. */
export enum ResidentialManagementResidentSafetyDeclarationOriginChoices {
  /** Legacy V1 */
  LegacyV1 = 'LEGACY_V1',
  /** Manager Direct */
  ManagerDirect = 'MANAGER_DIRECT',
  /** Manager Paper */
  ManagerPaper = 'MANAGER_PAPER',
  /** Manager Phone */
  ManagerPhone = 'MANAGER_PHONE',
  /** Reconfirmation */
  Reconfirmation = 'RECONFIRMATION',
  /** Resident App */
  ResidentApp = 'RESIDENT_APP',
  /** Rolling Deploy Repair */
  RollingDeployRepair = 'ROLLING_DEPLOY_REPAIR'
}

/** An enumeration. */
export enum ResidentialManagementResidentSafetyRecordAuditLogEventTypeChoices {
  /** Compliance V2 Activated */
  ComplianceV2Activated = 'COMPLIANCE_V2_ACTIVATED',
  /** Consent Declined */
  ConsentDeclined = 'CONSENT_DECLINED',
  /** Consent Given */
  ConsentGiven = 'CONSENT_GIVEN',
  /** Ees Agreed */
  EesAgreed = 'EES_AGREED',
  /** Ees Generated */
  EesGenerated = 'EES_GENERATED',
  /** Needs Submitted */
  NeedsSubmitted = 'NEEDS_SUBMITTED',
  /** Needs Updated */
  NeedsUpdated = 'NEEDS_UPDATED',
  /** Occupant Removed */
  OccupantRemoved = 'OCCUPANT_REMOVED',
  /** Pcfra Accepted */
  PcfraAccepted = 'PCFRA_ACCEPTED',
  /** Pcfra Completed */
  PcfraCompleted = 'PCFRA_COMPLETED',
  /** Pcfra Declined */
  PcfraDeclined = 'PCFRA_DECLINED',
  /** Pcfra Offered */
  PcfraOffered = 'PCFRA_OFFERED',
  /** Reminder Sent */
  ReminderSent = 'REMINDER_SENT',
  /** Review Reset */
  ReviewReset = 'REVIEW_RESET',
  /** Sharing Consent Given */
  SharingConsentGiven = 'SHARING_CONSENT_GIVEN',
  /** Sharing Consent Withdrawn */
  SharingConsentWithdrawn = 'SHARING_CONSENT_WITHDRAWN',
  /** Subject Archived */
  SubjectArchived = 'SUBJECT_ARCHIVED',
  /** Subject Linked */
  SubjectLinked = 'SUBJECT_LINKED',
  /** Subject Merged */
  SubjectMerged = 'SUBJECT_MERGED',
  /** Subject Restored */
  SubjectRestored = 'SUBJECT_RESTORED'
}

/** An enumeration. */
export enum ResidentialManagementSafetyCenterDocumentSibCategoryChoices {
  /** Access plan */
  AccessPlan = 'ACCESS_PLAN',
  /** Block plan */
  BlockPlan = 'BLOCK_PLAN',
  /** Contractor contacts */
  ContractorContacts = 'CONTRACTOR_CONTACTS',
  /** Fire strategy */
  FireStrategy = 'FIRE_STRATEGY',
  /** Floor plan */
  FloorPlan = 'FLOOR_PLAN',
  /** Hydrant map */
  HydrantMap = 'HYDRANT_MAP',
  /** Key holders */
  KeyHolders = 'KEY_HOLDERS',
  /** Other */
  Other = 'OTHER',
  /** Risk assessment */
  RiskAssessment = 'RISK_ASSESSMENT'
}

/** An enumeration. */
export enum ResidentialManagementSafetyReviewAttemptChannelChoices {
  /** Resident app */
  App = 'APP',
  /** Paper form */
  Paper = 'PAPER',
  /** Phone call */
  Phone = 'PHONE'
}

/** An enumeration. */
export enum ResidentialManagementSafetyReviewRequestRequestTypeChoices {
  /** Initial request */
  Initial = 'INITIAL',
  /** Review request */
  Review = 'REVIEW'
}

/** An enumeration. */
export enum ResidentialManagementScheduledMessageSenderChoices {
  /** Concierge */
  Co = 'CO',
  /** Leaseholder */
  Le = 'LE',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementScheduledMessageStatusChoices {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Sent */
  Sent = 'SENT'
}

/** An enumeration. */
export enum ResidentialManagementUserFeatureAnnouncementViewPlatformChoices {
  /** Manager App */
  ManagerApp = 'MANAGER_APP',
  /** Manager Dashboard */
  ManagerDashboard = 'MANAGER_DASHBOARD',
  /** Resident App */
  ResidentApp = 'RESIDENT_APP'
}

/** An enumeration. */
export enum ResidentialManagementWaiverTypeChoices {
  /** KEY */
  Key = 'KEY',
  /** PACKAGE */
  Package = 'PACKAGE'
}

export type ResolveChecklistActionInput = {
  readonly actionId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ResolveChecklistActionPayload = {
  readonly __typename?: 'ResolveChecklistActionPayload';
  readonly action?: Maybe<ChecklistActionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type RespondToContractorSuggestionInput = {
  readonly classificationId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly decision: ContractorDecision;
};

export type RespondToContractorSuggestionPayload = {
  readonly __typename?: 'RespondToContractorSuggestionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type RespondToPcfra = {
  readonly __typename?: 'RespondToPcfra';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type ResponseTimeType = {
  readonly __typename?: 'ResponseTimeType';
  readonly averageResponseTime?: Maybe<Scalars['Int']['output']>;
  readonly date?: Maybe<Scalars['Date']['output']>;
};

export type RestartIdentityVerificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RestartIdentityVerificationPayload = {
  readonly __typename?: 'RestartIdentityVerificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type RetryDocumentExtractionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RetryDocumentExtractionPayload = {
  readonly __typename?: 'RetryDocumentExtractionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly documentExtraction?: Maybe<DocumentExtractionNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ReviewInspectionActionInput = {
  readonly actionId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dismissalNote?: InputMaybe<Scalars['String']['input']>;
  readonly dismissalReason?: InputMaybe<Scalars['String']['input']>;
  readonly reviewStatus: Scalars['String']['input'];
};

export type ReviewInspectionActionPayload = {
  readonly __typename?: 'ReviewInspectionActionPayload';
  readonly action?: Maybe<ChecklistActionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type RevokeCommunityStaffRoleInput = {
  readonly assignmentId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type RevokeCommunityStaffRolePayload = {
  readonly __typename?: 'RevokeCommunityStaffRolePayload';
  readonly assignment: CommunityStaffRoleType;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type RevokeGeneratedAgreementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RevokeGeneratedAgreementPayload = {
  readonly __typename?: 'RevokeGeneratedAgreementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
};

export type RightToRentNode = {
  readonly __typename?: 'RightToRentNode';
  readonly document?: Maybe<Scalars['String']['output']>;
  readonly hasShareCode: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly officialDocument?: Maybe<Scalars['String']['output']>;
  readonly officialExpiryDate?: Maybe<Scalars['Date']['output']>;
  readonly officialVerificationStatus?: Maybe<TenancyApplicationRightToRentOfficialVerificationStatusChoices>;
  readonly shareCode?: Maybe<Scalars['String']['output']>;
};

export type RotateSafetyResponderToken = {
  readonly __typename?: 'RotateSafetyResponderToken';
  readonly pack?: Maybe<SafetyResponderPackNode>;
  readonly residualWindow: Scalars['String']['output'];
};

export type RuleActionNode = {
  readonly __typename?: 'RuleActionNode';
  readonly action: RulesRuleActionActionChoices;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly objectId: Scalars['String']['output'];
  readonly target?: Maybe<RuleActionTargetUnion>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type RuleActionNodeConnection = {
  readonly __typename?: 'RuleActionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RuleActionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RuleActionNode` and its cursor. */
export type RuleActionNodeEdge = {
  readonly __typename?: 'RuleActionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<RuleActionNode>;
};

export type RuleActionTargetUnion = TeamNode | UserType;

export type RuleConditionNode = {
  readonly __typename?: 'RuleConditionNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly event: RulesRuleConditionEventChoices;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly objectId?: Maybe<Scalars['String']['output']>;
  readonly operator: RulesRuleConditionOperatorChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type RuleConditionNodeConnection = {
  readonly __typename?: 'RuleConditionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RuleConditionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RuleConditionNode` and its cursor. */
export type RuleConditionNodeEdge = {
  readonly __typename?: 'RuleConditionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<RuleConditionNode>;
};

export type RuleNode = {
  readonly __typename?: 'RuleNode';
  readonly actions?: Maybe<RuleActionNodeConnection>;
  readonly activatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly categoryContentTypes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly communities: CommunityNodeConnection;
  readonly conditions?: Maybe<RuleConditionNodeConnection>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly executionCount: Scalars['Int']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type RuleNodeActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RuleNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RuleNodeConditionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RuleNodeConnection = {
  readonly __typename?: 'RuleNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RuleNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RuleNode` and its cursor. */
export type RuleNodeEdge = {
  readonly __typename?: 'RuleNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<RuleNode>;
};

/** An enumeration. */
export enum RulesRuleActionActionChoices {
  /** ASSIGN_TEAM */
  AssignTeam = 'ASSIGN_TEAM',
  /** ASSIGN_USER */
  AssignUser = 'ASSIGN_USER',
  /** NOTIFY_TEAM */
  NotifyTeam = 'NOTIFY_TEAM',
  /** NOTIFY_USER */
  NotifyUser = 'NOTIFY_USER'
}

/** An enumeration. */
export enum RulesRuleConditionEventChoices {
  /** STATUS_CLOSED */
  StatusClosed = 'STATUS_CLOSED',
  /** STATUS_REOPENED */
  StatusReopened = 'STATUS_REOPENED',
  /** STATUS_SNOOZED */
  StatusSnoozed = 'STATUS_SNOOZED',
  /** TAG_ASSIGNMENT */
  TagAssignment = 'TAG_ASSIGNMENT'
}

/** An enumeration. */
export enum RulesRuleConditionOperatorChoices {
  /** EQUALS */
  Equals = 'EQUALS',
  /** NOT_EQUALS */
  NotEquals = 'NOT_EQUALS'
}

export type SafetyBlockReadinessType = {
  readonly __typename?: 'SafetyBlockReadinessType';
  readonly assessment: SafetyReadinessRatioType;
  readonly blockId: Scalars['UUID']['output'];
  readonly blockName: Scalars['String']['output'];
  readonly cohorts: SafetyReadinessCohortsType;
  readonly consent: SafetyReadinessRatioType;
  readonly currency: SafetyReadinessRatioType;
  readonly exclusions: ReadonlyArray<SafetyReadinessExclusionType>;
  readonly floorsKnown: Scalars['Boolean']['output'];
  readonly homes: Scalars['Int']['output'];
  readonly homesWithoutFloor: Scalars['Int']['output'];
  readonly packCurrent: Scalars['Boolean']['output'];
  readonly packGenerated: Scalars['Boolean']['output'];
  readonly response: SafetyReadinessRatioType;
  readonly responsiblePersonNamed: Scalars['Boolean']['output'];
  readonly unassignedResidents: Scalars['Int']['output'];
};

export type SafetyCenterDocumentNode = {
  readonly __typename?: 'SafetyCenterDocumentNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly block?: Maybe<BlockNode>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly description: Scalars['String']['output'];
  readonly effectiveFileUrl?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly fileName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly includeInSibPack: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly showInSafetyCenter: Scalars['Boolean']['output'];
  readonly sibCategory?: Maybe<ResidentialManagementSafetyCenterDocumentSibCategoryChoices>;
  readonly sourceDocument?: Maybe<CommunityDocumentNode>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type SafetyCenterDocumentNodeConnection = {
  readonly __typename?: 'SafetyCenterDocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<SafetyCenterDocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `SafetyCenterDocumentNode` and its cursor. */
export type SafetyCenterDocumentNodeEdge = {
  readonly __typename?: 'SafetyCenterDocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<SafetyCenterDocumentNode>;
};

export type SafetyCommunityReadinessType = {
  readonly __typename?: 'SafetyCommunityReadinessType';
  readonly blocks: ReadonlyArray<SafetyBlockReadinessType>;
  readonly communityId: Scalars['UUID']['output'];
  readonly communityName: Scalars['String']['output'];
  readonly postcode?: Maybe<Scalars['String']['output']>;
};

export enum SafetyComplianceAuthority {
  PrescribedRepresentative = 'PRESCRIBED_REPRESENTATIVE',
  Resident = 'RESIDENT'
}

export enum SafetyComplianceChannel {
  App = 'APP',
  InPerson = 'IN_PERSON',
  Paper = 'PAPER',
  Phone = 'PHONE'
}

export type SafetyComplianceReadinessType = {
  readonly __typename?: 'SafetyComplianceReadinessType';
  readonly activatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly awaitingExplicitConsentCount: Scalars['Int']['output'];
  readonly eligibleAfterActivation: Scalars['Int']['output'];
  readonly eligibleNow: Scalars['Int']['output'];
  readonly leavingPackCount: Scalars['Int']['output'];
  readonly pcfraOfferedNotCompletedCount: Scalars['Int']['output'];
  readonly pcfraStatusChangedCount: Scalars['Int']['output'];
};

export type SafetyHouseholdSubjectType = {
  readonly __typename?: 'SafetyHouseholdSubjectType';
  readonly answeredBySubject?: Maybe<Scalars['Boolean']['output']>;
  readonly braille?: Maybe<Scalars['Boolean']['output']>;
  readonly communicationNeedDeclared?: Maybe<Scalars['Boolean']['output']>;
  readonly communicationNeeds?: Maybe<Scalars['String']['output']>;
  readonly consentDeclinedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly consentGivenAt?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt?: Maybe<Scalars['DateTime']['output']>;
  readonly declarations?: Maybe<ReadonlyArray<Maybe<ResidentSafetyDeclarationNode>>>;
  readonly fireServiceConsentGivenAt?: Maybe<Scalars['DateTime']['output']>;
  readonly fireServiceConsentWithdrawnAt?: Maybe<Scalars['DateTime']['output']>;
  readonly first?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['UUID']['output']>;
  readonly informationHeld?: Maybe<Scalars['Boolean']['output']>;
  readonly isOccupant?: Maybe<Scalars['Boolean']['output']>;
  readonly isSelf?: Maybe<Scalars['Boolean']['output']>;
  readonly language?: Maybe<Scalars['String']['output']>;
  readonly largePrint?: Maybe<Scalars['Boolean']['output']>;
  readonly last?: Maybe<Scalars['String']['output']>;
  readonly lastDeclaredAt?: Maybe<Scalars['DateTime']['output']>;
  readonly lastDeclaredBy?: Maybe<Scalars['String']['output']>;
  readonly lastReviewedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly mobilityNeedDeclared?: Maybe<Scalars['Boolean']['output']>;
  readonly mobilityNeeds?: Maybe<Scalars['String']['output']>;
  readonly outstandingActions?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly pcfraOfferedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly pcfraParticipation?: Maybe<Scalars['String']['output']>;
  readonly sharesWithFireService?: Maybe<Scalars['Boolean']['output']>;
  readonly textToSpeech?: Maybe<Scalars['Boolean']['output']>;
  readonly userId?: Maybe<Scalars['UUID']['output']>;
};

export type SafetyHouseholdType = {
  readonly __typename?: 'SafetyHouseholdType';
  readonly openReviewRequest?: Maybe<SafetyReviewRequestNode>;
  readonly residencyId?: Maybe<Scalars['UUID']['output']>;
  readonly subjects?: Maybe<ReadonlyArray<Maybe<SafetyHouseholdSubjectType>>>;
};

export type SafetyPackEligibilityType = {
  readonly __typename?: 'SafetyPackEligibilityType';
  readonly eligibleCount: Scalars['Int']['output'];
  readonly excludedCount: Scalars['Int']['output'];
  readonly excludedRecords: ReadonlyArray<SafetyPackExcludedRecordType>;
  readonly exclusions: ReadonlyArray<SafetyPackExclusionType>;
  readonly totalCount: Scalars['Int']['output'];
};

export type SafetyPackExcludedRecordType = {
  readonly __typename?: 'SafetyPackExcludedRecordType';
  readonly blockName: Scalars['String']['output'];
  readonly floorNumber?: Maybe<Scalars['Int']['output']>;
  readonly homeName: Scalars['String']['output'];
  readonly label: Scalars['String']['output'];
  readonly reason: Scalars['String']['output'];
  readonly recordId: Scalars['UUID']['output'];
};

export type SafetyPackExclusionType = {
  readonly __typename?: 'SafetyPackExclusionType';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly reason: Scalars['String']['output'];
};

export enum SafetyPaperFormScope {
  Blank = 'BLANK',
  Household = 'HOUSEHOLD',
  Individual = 'INDIVIDUAL'
}

export type SafetyReadinessCohortsType = {
  readonly __typename?: 'SafetyReadinessCohortsType';
  readonly declaredNeeds: Scalars['Int']['output'];
  readonly noNeeds: Scalars['Int']['output'];
  readonly notAnswered: Scalars['Int']['output'];
  readonly notOccupant: Scalars['Int']['output'];
};

export type SafetyReadinessExclusionType = {
  readonly __typename?: 'SafetyReadinessExclusionType';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly reason: Scalars['String']['output'];
};

export type SafetyReadinessRatioType = {
  readonly __typename?: 'SafetyReadinessRatioType';
  readonly denominator: Scalars['Int']['output'];
  readonly numerator: Scalars['Int']['output'];
};

export type SafetyResponderPackNode = {
  readonly __typename?: 'SafetyResponderPackNode';
  readonly block: BlockNode;
  readonly eligibility: SafetyPackEligibilityType;
  readonly fileUrl?: Maybe<Scalars['String']['output']>;
  readonly generatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isComplete: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isStale: Scalars['Boolean']['output'];
  readonly isTokenActive: Scalars['Boolean']['output'];
  readonly printedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly responderUrl?: Maybe<Scalars['String']['output']>;
  readonly reviewNudgeSentAt?: Maybe<Scalars['DateTime']['output']>;
  readonly rotationResidualWindow: Scalars['String']['output'];
  readonly token?: Maybe<Scalars['UUID']['output']>;
  readonly tokenActivatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly tokenRotatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly tokenRotationReason: Scalars['String']['output'];
};

export enum SafetyReviewAttemptChannel {
  App = 'APP',
  Paper = 'PAPER',
  Phone = 'PHONE'
}

export type SafetyReviewAttemptNode = {
  readonly __typename?: 'SafetyReviewAttemptNode';
  readonly channel: ResidentialManagementSafetyReviewAttemptChannelChoices;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly initiatedByName?: Maybe<Scalars['String']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly queuedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly request: SafetyReviewRequestNode;
};

/** Attempt fields read one prefetched list so a roster page stays flat. */
export type SafetyReviewRequestNode = {
  readonly __typename?: 'SafetyReviewRequestNode';
  readonly attemptCount: Scalars['Int']['output'];
  readonly attempts: ReadonlyArray<SafetyReviewAttemptNode>;
  readonly cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  readonly completedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly completedByDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly escalationDueAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isEscalationDue: Scalars['Boolean']['output'];
  readonly isOpen: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly latestAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  readonly openedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly recipient?: Maybe<UserType>;
  readonly record: ResidentSafetyRecordNode;
  readonly requestType: ResidentialManagementSafetyReviewRequestRequestTypeChoices;
  readonly residencyId?: Maybe<Scalars['UUID']['output']>;
};

export type SafetyRosterCountsType = {
  readonly __typename?: 'SafetyRosterCountsType';
  readonly all: Scalars['Int']['output'];
  readonly declaredNeeds: Scalars['Int']['output'];
  readonly needsAction: Scalars['Int']['output'];
  readonly noNeeds: Scalars['Int']['output'];
  readonly notAnswered: Scalars['Int']['output'];
};

export type SafetyRosterEesCountsType = {
  readonly __typename?: 'SafetyRosterEesCountsType';
  readonly agreed: Scalars['Int']['output'];
  readonly generated: Scalars['Int']['output'];
  readonly notGenerated: Scalars['Int']['output'];
};

export type SafetyRosterPcfraCountsType = {
  readonly __typename?: 'SafetyRosterPcfraCountsType';
  readonly declined: Scalars['Int']['output'];
  readonly notOffered: Scalars['Int']['output'];
  readonly offered: Scalars['Int']['output'];
};

export type SafetyRosterRowType = {
  readonly __typename?: 'SafetyRosterRowType';
  readonly blockName?: Maybe<Scalars['String']['output']>;
  readonly communityName?: Maybe<Scalars['String']['output']>;
  readonly complianceActions: ReadonlyArray<Scalars['String']['output']>;
  readonly first: Scalars['String']['output'];
  readonly floorNumber?: Maybe<Scalars['Int']['output']>;
  readonly homeId?: Maybe<Scalars['UUID']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isAppLinked: Scalars['Boolean']['output'];
  readonly isOverdue: Scalars['Boolean']['output'];
  readonly last: Scalars['String']['output'];
  readonly lastDeclaredAt?: Maybe<Scalars['DateTime']['output']>;
  readonly latestDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly lifecycleStatus: Scalars['String']['output'];
  readonly needsAction: Scalars['Boolean']['output'];
  readonly needsReconciliation: Scalars['Boolean']['output'];
  readonly occupantKnown: Scalars['Boolean']['output'];
  readonly openReviewRequest?: Maybe<SafetyReviewRequestNode>;
  readonly record?: Maybe<ResidentSafetyRecordNode>;
  readonly residencyId: Scalars['UUID']['output'];
  readonly state: Scalars['String']['output'];
  readonly userId?: Maybe<Scalars['UUID']['output']>;
};

export type SafetyRosterType = {
  readonly __typename?: 'SafetyRosterType';
  readonly cohort: Scalars['String']['output'];
  readonly counts: SafetyRosterCountsType;
  readonly eesCounts: SafetyRosterEesCountsType;
  readonly hasMore: Scalars['Boolean']['output'];
  readonly pcfraCounts: SafetyRosterPcfraCountsType;
  readonly rows: ReadonlyArray<SafetyRosterRowType>;
  readonly totalCount: Scalars['Int']['output'];
};

export type SafetySubjectLinkSuggestionType = {
  readonly __typename?: 'SafetySubjectLinkSuggestionType';
  readonly email: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly userId: Scalars['UUID']['output'];
};

export type SaveAmenityInput = {
  readonly archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly daysAvailable: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly description: Scalars['String']['input'];
  readonly endTime: Scalars['DateTime']['input'];
  readonly exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly groups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly links?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly live?: InputMaybe<Scalars['Boolean']['input']>;
  readonly maxAdvanceReservationDays?: InputMaybe<Scalars['Int']['input']>;
  readonly maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  readonly maxHours?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum reservation duration in seconds */
  readonly maxReservationDuration?: InputMaybe<Scalars['Int']['input']>;
  readonly maxReservations?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum time in seconds */
  readonly maxTime?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum time in seconds before the start time that a user must book this amenity. */
  readonly minBookingNotice?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum reservation duration in seconds */
  readonly minReservationDuration?: InputMaybe<Scalars['Int']['input']>;
  readonly name: Scalars['String']['input'];
  readonly reservable?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly startTime: Scalars['DateTime']['input'];
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

export type SaveAmenityOperatingTimesInput = {
  readonly amenity: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly endTime?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startTime?: InputMaybe<Scalars['DateTime']['input']>;
  readonly weekDay: Scalars['Int']['input'];
};

export type SaveAmenityOperatingTimesPayload = {
  readonly __typename?: 'SaveAmenityOperatingTimesPayload';
  readonly amenityOperatingTimes?: Maybe<AmenityOperatingTimesNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type SaveAmenityPayload = {
  readonly __typename?: 'SaveAmenityPayload';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly daysAvailable?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly endTime?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly exclusive?: Maybe<Scalars['Boolean']['output']>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly links?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly live?: Maybe<Scalars['Boolean']['output']>;
  readonly maxAdvanceReservationDays?: Maybe<Scalars['Int']['output']>;
  readonly maxCapacity?: Maybe<Scalars['Int']['output']>;
  readonly maxHours?: Maybe<Scalars['Int']['output']>;
  /** The maximum reservation duration in seconds */
  readonly maxReservationDuration?: Maybe<Scalars['Int']['output']>;
  readonly maxReservations?: Maybe<Scalars['Int']['output']>;
  /** The maximum time in seconds */
  readonly maxTime?: Maybe<Scalars['Int']['output']>;
  /** Minimum time in seconds before the start time that a user must book this amenity. */
  readonly minBookingNotice?: Maybe<Scalars['Int']['output']>;
  /** The minimum reservation duration in seconds */
  readonly minReservationDuration?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly reservable?: Maybe<Scalars['Boolean']['output']>;
  readonly startDate?: Maybe<Scalars['DateTime']['output']>;
  readonly startTime?: Maybe<Scalars['DateTime']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
};

export type SaveCommunityEventInput = {
  readonly attendanceFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly description: Scalars['String']['input'];
  readonly end: Scalars['DateTime']['input'];
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly links?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly maxAdditionalAttendees?: InputMaybe<Scalars['Int']['input']>;
  readonly maxSpaces: Scalars['Int']['input'];
  readonly name: Scalars['String']['input'];
  readonly start: Scalars['DateTime']['input'];
};

export type SaveCommunityEventPayload = {
  readonly __typename?: 'SaveCommunityEventPayload';
  readonly attendanceFee?: Maybe<Scalars['Decimal']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly end?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly links?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly maxAdditionalAttendees?: Maybe<Scalars['Int']['output']>;
  readonly maxSpaces?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly start?: Maybe<Scalars['DateTime']['output']>;
};

export type SaveCommunityUpdateInput = {
  readonly body: Scalars['String']['input'];
  readonly category?: InputMaybe<Scalars['String']['input']>;
  readonly clearAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly creatorType: Scalars['String']['input'];
  readonly document?: InputMaybe<Scalars['String']['input']>;
  readonly groups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly imageUrl?: InputMaybe<Scalars['String']['input']>;
  readonly status?: InputMaybe<Scalars['String']['input']>;
  readonly summary?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCommunityUpdatePayload = {
  readonly __typename?: 'SaveCommunityUpdatePayload';
  readonly body?: Maybe<Scalars['String']['output']>;
  readonly category?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly creatorType?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly summary?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type SaveContactNoteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['UUID']['input'];
  readonly text: Scalars['String']['input'];
  readonly user: Scalars['UUID']['input'];
};

export type SaveContactNotePayload = {
  readonly __typename?: 'SaveContactNotePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contactNote?: Maybe<ContactNoteNode>;
};

export type SaveGeneratedAgreementInput = {
  readonly additionalTerms?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly furnished?: InputMaybe<Scalars['String']['input']>;
  readonly homeCity?: InputMaybe<Scalars['String']['input']>;
  readonly homeName?: InputMaybe<Scalars['String']['input']>;
  readonly homePostcode?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly landlordAddress?: InputMaybe<Scalars['String']['input']>;
  readonly landlordMobile?: InputMaybe<Scalars['String']['input']>;
  readonly landlordName?: InputMaybe<Scalars['String']['input']>;
  readonly paymentFrequency?: InputMaybe<Scalars['String']['input']>;
  readonly rentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly tenancyEnd?: InputMaybe<Scalars['Date']['input']>;
  readonly tenancyStart?: InputMaybe<Scalars['Date']['input']>;
  readonly tenants: ReadonlyArray<InputMaybe<TenantSerializerInput>>;
  readonly utilitiesIncluded?: InputMaybe<Scalars['String']['input']>;
};

export type SaveGeneratedAgreementPayload = {
  readonly __typename?: 'SaveGeneratedAgreementPayload';
  readonly additionalTerms?: Maybe<Scalars['String']['output']>;
  readonly agreement?: Maybe<GeneratedAgreementNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly furnished?: Maybe<Scalars['String']['output']>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordMobile?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly paymentFrequency?: Maybe<Scalars['String']['output']>;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly tenancyEnd?: Maybe<Scalars['Date']['output']>;
  readonly tenancyStart?: Maybe<Scalars['Date']['output']>;
  readonly tenants?: Maybe<ReadonlyArray<Maybe<AgreementTenantNode>>>;
  readonly utilitiesIncluded?: Maybe<Scalars['String']['output']>;
};

export type SaveGeneratedSection21Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deadlineDate?: InputMaybe<Scalars['Date']['input']>;
  readonly depositCertificateProvided?: InputMaybe<Scalars['Boolean']['input']>;
  readonly home?: InputMaybe<Scalars['String']['input']>;
  readonly homeCity?: InputMaybe<Scalars['String']['input']>;
  readonly homeName?: InputMaybe<Scalars['String']['input']>;
  readonly homePostcode?: InputMaybe<Scalars['String']['input']>;
  readonly homeRegion?: InputMaybe<Scalars['String']['input']>;
  readonly htrgProvided?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly inspectionDate?: InputMaybe<Scalars['Date']['input']>;
  readonly landlordAddress?: InputMaybe<Scalars['String']['input']>;
  readonly landlordEmail?: InputMaybe<Scalars['String']['input']>;
  readonly landlordName?: InputMaybe<Scalars['String']['input']>;
  readonly landlordPhone?: InputMaybe<Scalars['String']['input']>;
  readonly leadTenantEmail?: InputMaybe<Scalars['String']['input']>;
  readonly possessionDate?: InputMaybe<Scalars['Date']['input']>;
  readonly tenants?: InputMaybe<Scalars['String']['input']>;
  readonly viewedOnArk?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveGeneratedSection21Payload = {
  readonly __typename?: 'SaveGeneratedSection21Payload';
  readonly client?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deadlineDate?: Maybe<Scalars['Date']['output']>;
  readonly depositCertificateProvided?: Maybe<Scalars['Boolean']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<Scalars['String']['output']>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly homeRegion?: Maybe<Scalars['String']['output']>;
  readonly htrgProvided?: Maybe<Scalars['Boolean']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly inspectionDate?: Maybe<Scalars['Date']['output']>;
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordEmail?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly landlordPhone?: Maybe<Scalars['String']['output']>;
  readonly leadTenantEmail?: Maybe<Scalars['String']['output']>;
  readonly possessionDate?: Maybe<Scalars['Date']['output']>;
  readonly tenants?: Maybe<Scalars['String']['output']>;
  readonly viewedOnArk?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveHomeInput = {
  readonly HMO?: InputMaybe<Scalars['Boolean']['input']>;
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  readonly city?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly numRooms?: InputMaybe<Scalars['Int']['input']>;
  readonly postcode: Scalars['String']['input'];
};

export type SaveHomePayload = {
  readonly __typename?: 'SaveHomePayload';
  readonly HMO?: Maybe<Scalars['Boolean']['output']>;
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly numRooms?: Maybe<Scalars['Int']['output']>;
  readonly postcode?: Maybe<Scalars['String']['output']>;
};

export type SaveManagerProfileInput = {
  readonly ASTPageViewed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly complianceEmailExplanation?: InputMaybe<Scalars['Boolean']['input']>;
  readonly compliancePageViewed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly complianceUpdateEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly valueQuestionnaireAnswer?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveManagerProfilePayload = {
  readonly __typename?: 'SaveManagerProfilePayload';
  readonly ASTPageViewed?: Maybe<Scalars['Boolean']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly complianceEmailExplanation?: Maybe<Scalars['Boolean']['output']>;
  readonly compliancePageViewed?: Maybe<Scalars['Boolean']['output']>;
  readonly complianceUpdateEmails?: Maybe<Scalars['Boolean']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly valueQuestionnaireAnswer?: Maybe<Scalars['Int']['output']>;
};

export type SaveMarketplaceItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly condition?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly price: Scalars['Decimal']['input'];
  readonly title: Scalars['String']['input'];
};

export type SaveMarketplaceItemPayload = {
  readonly __typename?: 'SaveMarketplaceItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly condition?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly price?: Maybe<Scalars['Decimal']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type SaveRequirementItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly expiryDate?: InputMaybe<Scalars['Date']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly requirement: Scalars['String']['input'];
};

export type SaveRequirementItemPayload = {
  readonly __typename?: 'SaveRequirementItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly expiryDate?: Maybe<Scalars['Date']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly requirement?: Maybe<Scalars['String']['output']>;
};

export type SaveResidentSurveyAnswerInput = {
  readonly answer?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly resident?: InputMaybe<Scalars['String']['input']>;
  readonly survey?: InputMaybe<Scalars['String']['input']>;
};

export type SaveResidentSurveyAnswerPayload = {
  readonly __typename?: 'SaveResidentSurveyAnswerPayload';
  readonly answer?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly resident?: Maybe<Scalars['String']['output']>;
  readonly survey?: Maybe<Scalars['String']['output']>;
};

export type SaveTenantEmploymentDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly employmentEnding?: InputMaybe<Scalars['Boolean']['input']>;
  readonly employmentType?: InputMaybe<Scalars['String']['input']>;
  readonly fullOrPartTime?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly income?: InputMaybe<Scalars['Decimal']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly paymentFrequency?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['Date']['input']>;
  readonly tenantReferenceId: Scalars['String']['input'];
};

export type SaveTenantEmploymentDetailsPayload = {
  readonly __typename?: 'SaveTenantEmploymentDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly employmentEnding?: Maybe<Scalars['Boolean']['output']>;
  readonly employmentType?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly fullOrPartTime?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly income?: Maybe<Scalars['Decimal']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly paymentFrequency?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['Date']['output']>;
};

export type ScheduleFinancialYearCategoryTotalNode = {
  readonly __typename?: 'ScheduleFinancialYearCategoryTotalNode';
  readonly category: FinanceScheduleFinancialYearCategoryTotalCategoryChoices;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly scheduleFinancialYear: ScheduleFinancialYearNode;
  readonly totalActual: Scalars['Decimal']['output'];
  readonly totalBudget: Scalars['Decimal']['output'];
  readonly variance?: Maybe<Scalars['Decimal']['output']>;
  readonly variancePercentage?: Maybe<Scalars['Float']['output']>;
};

export type ScheduleFinancialYearCategoryTotalNodeConnection = {
  readonly __typename?: 'ScheduleFinancialYearCategoryTotalNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ScheduleFinancialYearCategoryTotalNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ScheduleFinancialYearCategoryTotalNode` and its cursor. */
export type ScheduleFinancialYearCategoryTotalNodeEdge = {
  readonly __typename?: 'ScheduleFinancialYearCategoryTotalNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ScheduleFinancialYearCategoryTotalNode>;
};

export type ScheduleFinancialYearNode = {
  readonly __typename?: 'ScheduleFinancialYearNode';
  readonly actual: Scalars['JSONString']['output'];
  readonly budget: Scalars['JSONString']['output'];
  readonly budgetDocument?: Maybe<Scalars['String']['output']>;
  readonly budgetDocumentUrl?: Maybe<Scalars['String']['output']>;
  readonly categoryTotals: ScheduleFinancialYearCategoryTotalNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly demandMatchesCalculated?: Maybe<Scalars['Boolean']['output']>;
  readonly endDate: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly schedule: ScheduleNode;
  readonly startDate: Scalars['DateTime']['output'];
  readonly totalActual?: Maybe<Scalars['Decimal']['output']>;
  readonly totalBudget?: Maybe<Scalars['Decimal']['output']>;
  readonly yearEndDocument?: Maybe<Scalars['String']['output']>;
  readonly yearEndDocumentUrl?: Maybe<Scalars['String']['output']>;
};


export type ScheduleFinancialYearNodeCategoryTotalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduleFinancialYearNodeDemandMatchesCalculatedArgs = {
  leaseholdId: Scalars['UUID']['input'];
};

export type ScheduleFinancialYearNodeConnection = {
  readonly __typename?: 'ScheduleFinancialYearNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ScheduleFinancialYearNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ScheduleFinancialYearNode` and its cursor. */
export type ScheduleFinancialYearNodeEdge = {
  readonly __typename?: 'ScheduleFinancialYearNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ScheduleFinancialYearNode>;
};

export type ScheduleNode = {
  readonly __typename?: 'ScheduleNode';
  readonly community?: Maybe<CommunityNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly financialYears: ScheduleFinancialYearNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly latestFinancialYear?: Maybe<ScheduleFinancialYearNode>;
  readonly leaseholdSchedules: LeaseholdScheduleNodeConnection;
  readonly name: Scalars['String']['output'];
  readonly totalBudget?: Maybe<Scalars['Decimal']['output']>;
};


export type ScheduleNodeFinancialYearsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduleNodeLeaseholdSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ScheduleNodeConnection = {
  readonly __typename?: 'ScheduleNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ScheduleNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ScheduleNode` and its cursor. */
export type ScheduleNodeEdge = {
  readonly __typename?: 'ScheduleNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ScheduleNode>;
};

export type SchedulePublishCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchedulePublishCommunityUpdatePayload = {
  readonly __typename?: 'SchedulePublishCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ScheduledMessageMediaType = {
  readonly __typename?: 'ScheduledMessageMediaType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly user: UserType;
};

export type ScheduledMessageType = {
  readonly __typename?: 'ScheduledMessageType';
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly media?: Maybe<ReadonlyArray<Maybe<ScheduledMessageMediaType>>>;
  readonly sendAt: Scalars['DateTime']['output'];
  readonly sender: ResidentialManagementScheduledMessageSenderChoices;
  readonly status: ResidentialManagementScheduledMessageStatusChoices;
  readonly user: UserType;
};

export type SendAgreementForSigning = {
  readonly __typename?: 'SendAgreementForSigning';
  readonly tenants?: Maybe<ReadonlyArray<Maybe<AgreementSignatureOutput>>>;
};

export type SendAgreementForSigningInput = {
  readonly agreementId?: InputMaybe<Scalars['UUID']['input']>;
  readonly tenants?: InputMaybe<ReadonlyArray<InputMaybe<AgreementSignaturesTenant>>>;
};

export type SendApplicationSupportMessageInput = {
  readonly body: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly thread: Scalars['String']['input'];
};

export type SendApplicationSupportMessagePayload = {
  readonly __typename?: 'SendApplicationSupportMessagePayload';
  readonly applicationSupportMessage?: Maybe<ApplicationSupportMessageNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type SendApplicationThreadMessageInput = {
  readonly body: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly thread: Scalars['String']['input'];
};

export type SendApplicationThreadMessagePayload = {
  readonly __typename?: 'SendApplicationThreadMessagePayload';
  readonly applicationThreadMessage?: Maybe<ApplicationThreadMessageNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type SendConversationToAsanaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly summary: Scalars['String']['input'];
};

export type SendConversationToAsanaPayload = {
  readonly __typename?: 'SendConversationToAsanaPayload';
  readonly asanaSendPending: Scalars['Boolean']['output'];
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type SendDocument = {
  readonly __typename?: 'SendDocument';
  readonly section21?: Maybe<GeneratedSection21Type>;
};

export type SendDocumentInput = {
  readonly emails?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id: Scalars['String']['input'];
};

export type SendManagerAmplitudeTestInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type SendManagerAmplitudeTestPayload = {
  readonly __typename?: 'SendManagerAmplitudeTestPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly manager?: Maybe<ManagerType>;
};

export type SendPaymentReceiptEmailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly payment: Scalars['UUID']['input'];
};

export type SendPaymentReceiptEmailPayload = {
  readonly __typename?: 'SendPaymentReceiptEmailPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly ok: Scalars['Boolean']['output'];
};

export type SendSafetyReminder = {
  readonly __typename?: 'SendSafetyReminder';
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendSafetyReviewRequest = {
  readonly __typename?: 'SendSafetyReviewRequest';
  readonly attempt?: Maybe<SafetyReviewAttemptNode>;
  readonly reviewRequest?: Maybe<SafetyReviewRequestNode>;
};

export type SendTenantReferenceRequestsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SendTenantReferenceRequestsPayload = {
  readonly __typename?: 'SendTenantReferenceRequestsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly tenancyApplication?: Maybe<TenancyApplicationNode>;
};

export type SetChecklistItemDueDateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['Date']['input']>;
  readonly itemId: Scalars['UUID']['input'];
};

export type SetChecklistItemDueDatePayload = {
  readonly __typename?: 'SetChecklistItemDueDatePayload';
  readonly checklistItem?: Maybe<TaskChecklistItemNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type SetChecklistSectionDueDateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['Date']['input']>;
  readonly sectionId: Scalars['UUID']['input'];
};

export type SetChecklistSectionDueDatePayload = {
  readonly __typename?: 'SetChecklistSectionDueDatePayload';
  readonly checklistSection?: Maybe<TaskChecklistSectionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type SetConversationHomeInput = {
  readonly classificationId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly decision: ConversationHomeDecision;
  readonly homeId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SetConversationHomePayload = {
  readonly __typename?: 'SetConversationHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type SetReportingFavouriteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly favourite: Scalars['Boolean']['input'];
  readonly id: Scalars['UUID']['input'];
};

export type SetReportingFavouritePayload = {
  readonly __typename?: 'SetReportingFavouritePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly configuration: ReportingConfigurationNode;
};

export type SetReportingScheduleInput = {
  readonly cadence: ReportingScheduleCadence;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly enabled: Scalars['Boolean']['input'];
  readonly id: Scalars['UUID']['input'];
};

export type SetReportingSchedulePayload = {
  readonly __typename?: 'SetReportingSchedulePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly configuration: ReportingConfigurationNode;
};

export type SetResidencyCompletionDateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly completionDate?: InputMaybe<Scalars['Date']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SetResidencyCompletionDatePayload = {
  readonly __typename?: 'SetResidencyCompletionDatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly completionDate?: Maybe<Scalars['Date']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SetResidentAppLocaleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly locale: Scalars['String']['input'];
};

export type SetResidentAppLocalePayload = {
  readonly __typename?: 'SetResidentAppLocalePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type SetSafetyDocumentBlock = {
  readonly __typename?: 'SetSafetyDocumentBlock';
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
};

export type SetSafetyDocumentInSibPack = {
  readonly __typename?: 'SetSafetyDocumentInSibPack';
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
};

export type SetSafetyDocumentResidentVisible = {
  readonly __typename?: 'SetSafetyDocumentResidentVisible';
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
};

export type SetSafetySubjectContactEmailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contactEmail?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SetSafetySubjectContactEmailPayload = {
  readonly __typename?: 'SetSafetySubjectContactEmailPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type SetUpManagerInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly managerEmail: Scalars['String']['input'];
};

export type SetUpManagerPayload = {
  readonly __typename?: 'SetUpManagerPayload';
  readonly client?: Maybe<ClientType>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type ShareComplianceRequirementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ShareComplianceRequirementPayload = {
  readonly __typename?: 'ShareComplianceRequirementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SignOffChecklistInput = {
  readonly approvedBy?: InputMaybe<Scalars['UUID']['input']>;
  readonly checklistId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly nextAssessmentDate?: InputMaybe<Scalars['Date']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly riskConsequence?: InputMaybe<Scalars['String']['input']>;
  readonly riskLikelihood?: InputMaybe<Scalars['String']['input']>;
  readonly riskRating?: InputMaybe<Scalars['String']['input']>;
};

export type SignOffChecklistPayload = {
  readonly __typename?: 'SignOffChecklistPayload';
  readonly checklist?: Maybe<TaskChecklistNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type SignOutCommunityVisitorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SignOutCommunityVisitorPayload = {
  readonly __typename?: 'SignOutCommunityVisitorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityVisitor?: Maybe<CommunityVisitorNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type SnoozeConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly snoozeForSeconds: Scalars['Int']['input'];
};

export type SnoozeConversationPayload = {
  readonly __typename?: 'SnoozeConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type SourceDocumentNode = {
  readonly __typename?: 'SourceDocumentNode';
  readonly firstPage?: Maybe<SourceDocumentPageNode>;
  readonly id: Scalars['UUID']['output'];
  readonly pageCount?: Maybe<Scalars['Int']['output']>;
  readonly parserVersion: Scalars['String']['output'];
};

export type SourceDocumentPageNode = {
  readonly __typename?: 'SourceDocumentPageNode';
  readonly height?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly pageNo: Scalars['Int']['output'];
  readonly width?: Maybe<Scalars['Int']['output']>;
};

export type SourceRegionNode = {
  readonly __typename?: 'SourceRegionNode';
  readonly bboxNormB: Scalars['Float']['output'];
  readonly bboxNormL: Scalars['Float']['output'];
  readonly bboxNormR: Scalars['Float']['output'];
  readonly bboxNormT: Scalars['Float']['output'];
  readonly crop?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly kind?: Maybe<Scalars['String']['output']>;
  readonly selfRef: Scalars['String']['output'];
};

export type StaffRoleCatalogType = {
  readonly __typename?: 'StaffRoleCatalogType';
  readonly name: Scalars['String']['output'];
  readonly slug: Scalars['String']['output'];
};

export type StartBulkConversationClose = {
  readonly __typename?: 'StartBulkConversationClose';
  readonly job?: Maybe<BulkConversationActionJobNode>;
};

export type StartBulkDeactivationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly ids: ReadonlyArray<InputMaybe<Scalars['ID']['input']>>;
};

export type StartBulkDeactivationPayload = {
  readonly __typename?: 'StartBulkDeactivationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly job?: Maybe<BulkDeactivationJobNode>;
};

export type SubmitEmployerReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitEmployerReferencePayload = {
  readonly __typename?: 'SubmitEmployerReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SubmitIdentityVerificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitIdentityVerificationPayload = {
  readonly __typename?: 'SubmitIdentityVerificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SubmitLandlordReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitLandlordReferencePayload = {
  readonly __typename?: 'SubmitLandlordReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SubmitTenantReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitTenantReferencePayload = {
  readonly __typename?: 'SubmitTenantReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SubscribeLandlordInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly discountCode?: InputMaybe<Scalars['String']['input']>;
  readonly includeSetupFee?: InputMaybe<Scalars['Boolean']['input']>;
  readonly source?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribeLandlordPayload = {
  readonly __typename?: 'SubscribeLandlordPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly discountCodeValid?: Maybe<Scalars['Boolean']['output']>;
  readonly firstMonthCost?: Maybe<Scalars['Float']['output']>;
  readonly monthlyCost?: Maybe<Scalars['Float']['output']>;
  readonly stripeClientSecret?: Maybe<Scalars['String']['output']>;
  readonly tierUpTo?: Maybe<Scalars['Int']['output']>;
};

export type SubscribeToNotificationGroup = {
  readonly __typename?: 'SubscribeToNotificationGroup';
  readonly unsubscribeNotificationGroup?: Maybe<UnsubscribeNotificationGroupNode>;
};

export type SubscriptionDetails = {
  readonly __typename?: 'SubscriptionDetails';
  readonly endDate: Scalars['String']['output'];
  readonly paymentMethod?: Maybe<PaymentMethod>;
  readonly price: Scalars['Float']['output'];
  readonly startDate: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
};

export type SubscriptionNode = {
  readonly __typename?: 'SubscriptionNode';
  readonly details?: Maybe<SubscriptionDetails>;
  readonly id: Scalars['UUID']['output'];
  readonly invoices?: Maybe<ReadonlyArray<Invoices>>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly residency?: Maybe<ResidencyNode>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly upcomingInvoice?: Maybe<Invoices>;
};

export type SuggestRemediationStepsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly taskId: Scalars['UUID']['input'];
};

export type SuggestRemediationStepsPayload = {
  readonly __typename?: 'SuggestRemediationStepsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly steps?: Maybe<ReadonlyArray<SuggestedRemediationStepNode>>;
};

export type SuggestedRemediationStepNode = {
  readonly __typename?: 'SuggestedRemediationStepNode';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly guidance?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
};

export type TagAssignmentContent = CommunityDocumentNode | ConversationNode | TaskDefinitionNode | UserDocumentNode;

export type TagAssignmentNode = {
  readonly __typename?: 'TagAssignmentNode';
  readonly assignedBy?: Maybe<UserType>;
  readonly confidenceScore?: Maybe<Scalars['Decimal']['output']>;
  readonly contentObject?: Maybe<TagAssignmentContent>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly objectId: Scalars['UUID']['output'];
  readonly tag: ClientTagNode;
};

export type TagAssignmentNodeConnection = {
  readonly __typename?: 'TagAssignmentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TagAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TagAssignmentNode` and its cursor. */
export type TagAssignmentNodeEdge = {
  readonly __typename?: 'TagAssignmentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TagAssignmentNode>;
};

export type TagConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type TagConversationPayload = {
  readonly __typename?: 'TagConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationTag?: Maybe<ConversationTagNode>;
};

export type TagNode = {
  readonly __typename?: 'TagNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly color?: Maybe<Scalars['String']['output']>;
  /** Confidence score (0-1) that this tag is appropriate for the document */
  readonly confidenceScore?: Maybe<Scalars['Decimal']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type TagNodeConnection = {
  readonly __typename?: 'TagNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TagNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TagNode` and its cursor. */
export type TagNodeEdge = {
  readonly __typename?: 'TagNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TagNode>;
};

export type Target = AmenityNode | ApplicationNode | ApplicationThreadNode | CommunityDocumentNode | CommunityEventNode | CommunityNode | CommunityProductNode | CommunityUpdateNode | ConversationAssignmentNode | ConversationNode | DocumentExtractionNode | FeatureAnnouncementNode | GroupChatNode | HomeNode | KeyNode | MarketplaceItemNode | MarketplaceItemThreadNode | PackageNode | ResidencyDocumentNode | ResidentSurveyNode | TaskNode | TeamAssignmentNode | TenantReferenceNode | UserDocumentNode | UserType;

export type TaskCategoryNode = {
  readonly __typename?: 'TaskCategoryNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type TaskCategoryNodeConnection = {
  readonly __typename?: 'TaskCategoryNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskCategoryNode` and its cursor. */
export type TaskCategoryNodeEdge = {
  readonly __typename?: 'TaskCategoryNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskCategoryNode>;
};

export type TaskChecklistItemCommentNode = {
  readonly __typename?: 'TaskChecklistItemCommentNode';
  readonly author?: Maybe<UserType>;
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly item: TaskChecklistItemNode;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskChecklistItemMediaNode = {
  readonly __typename?: 'TaskChecklistItemMediaNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly response?: Maybe<TaskChecklistItemResponseNode>;
  readonly uploadedBy?: Maybe<UserType>;
};

export type TaskChecklistItemNode = {
  readonly __typename?: 'TaskChecklistItemNode';
  readonly action?: Maybe<ChecklistActionNode>;
  readonly actions?: Maybe<ReadonlyArray<ChecklistActionNode>>;
  readonly assignedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly assignedUser?: Maybe<UserType>;
  readonly checklist: TaskChecklistNode;
  readonly comments?: Maybe<ReadonlyArray<TaskChecklistItemCommentNode>>;
  readonly completedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly completedBy?: Maybe<UserType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly dueDate?: Maybe<Scalars['Date']['output']>;
  readonly guidance: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isCompleted: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isRequired: Scalars['Boolean']['output'];
  readonly media?: Maybe<ReadonlyArray<TaskChecklistItemMediaNode>>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly order: Scalars['Int']['output'];
  readonly referenceCode?: Maybe<Scalars['String']['output']>;
  readonly requiresPhoto: Scalars['Boolean']['output'];
  readonly responseBoolean?: Maybe<Scalars['Boolean']['output']>;
  readonly responseChoice?: Maybe<Scalars['String']['output']>;
  readonly responseDate?: Maybe<Scalars['Date']['output']>;
  readonly responseNumber?: Maybe<Scalars['Decimal']['output']>;
  readonly responseText: Scalars['String']['output'];
  readonly responseTime?: Maybe<Scalars['Time']['output']>;
  readonly responses?: Maybe<ReadonlyArray<TaskChecklistItemResponseNode>>;
  readonly section?: Maybe<TaskChecklistSectionNode>;
  readonly stepType?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskChecklistItemResponseNode = {
  readonly __typename?: 'TaskChecklistItemResponseNode';
  readonly answeredAt?: Maybe<Scalars['DateTime']['output']>;
  readonly answeredBy?: Maybe<UserType>;
  readonly config?: Maybe<Scalars['JSONString']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly inputType?: Maybe<Scalars['String']['output']>;
  readonly isRequired: Scalars['Boolean']['output'];
  readonly item: TaskChecklistItemNode;
  readonly label: Scalars['String']['output'];
  readonly order: Scalars['Int']['output'];
  readonly sourceInput?: Maybe<TaskTemplateStepInputNode>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  readonly valueChoice?: Maybe<Scalars['String']['output']>;
  readonly valueDate?: Maybe<Scalars['Date']['output']>;
  readonly valueNumber?: Maybe<Scalars['Decimal']['output']>;
  readonly valueText: Scalars['String']['output'];
  readonly valueTime?: Maybe<Scalars['Time']['output']>;
};

export type TaskChecklistNode = {
  readonly __typename?: 'TaskChecklistNode';
  readonly actions?: Maybe<ReadonlyArray<ChecklistActionNode>>;
  readonly approvedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly approvedBy?: Maybe<UserType>;
  readonly assessedBy?: Maybe<UserType>;
  readonly assessmentDate?: Maybe<Scalars['Date']['output']>;
  readonly assessorName?: Maybe<Scalars['String']['output']>;
  readonly autoCompleteTask: Scalars['Boolean']['output'];
  readonly complianceRecord?: Maybe<ChecklistComplianceRecordNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isManuallyCompletable: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSignedOff: Scalars['Boolean']['output'];
  readonly items?: Maybe<ReadonlyArray<TaskChecklistItemNode>>;
  readonly kind?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly nextAssessmentDate?: Maybe<Scalars['Date']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly providerName?: Maybe<Scalars['String']['output']>;
  readonly requiresSignOff: Scalars['Boolean']['output'];
  readonly riskConsequence?: Maybe<Scalars['String']['output']>;
  readonly riskLikelihood?: Maybe<Scalars['String']['output']>;
  readonly riskRating?: Maybe<Scalars['String']['output']>;
  readonly sections?: Maybe<ReadonlyArray<TaskChecklistSectionNode>>;
  readonly showsComplianceCeremony: Scalars['Boolean']['output'];
  readonly signedOffAt?: Maybe<Scalars['DateTime']['output']>;
  readonly signedOffBy?: Maybe<UserType>;
  readonly sourceExtraction?: Maybe<DocumentExtractionNode>;
  readonly structureRevision: Scalars['Int']['output'];
  readonly task: TaskNode;
  readonly template?: Maybe<TaskTemplateNode>;
  readonly templateStructureRevision?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskChecklistSectionNode = {
  readonly __typename?: 'TaskChecklistSectionNode';
  readonly assignedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly assignedUser?: Maybe<UserType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly dueDate?: Maybe<Scalars['Date']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly items?: Maybe<ReadonlyArray<TaskChecklistItemNode>>;
  readonly order: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskDefinitionNode = {
  readonly __typename?: 'TaskDefinitionNode';
  readonly availableClientTags?: Maybe<ClientTagNodeConnection>;
  readonly communityTaskDefinitions?: Maybe<CommunityTaskDefinitionNodeConnection>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isVisibleToResidents: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly priority?: Maybe<TasksTaskDefinitionPriorityChoices>;
  readonly tagAssignments?: Maybe<TagAssignmentNodeConnection>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly visibleToGroups?: Maybe<CommunityGroupNodeConnection>;
  readonly watchers: ReadonlyArray<UserType>;
};


export type TaskDefinitionNodeAvailableClientTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type TaskDefinitionNodeCommunityTaskDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  taskDefinition?: InputMaybe<Scalars['UUID']['input']>;
  taskGroup?: InputMaybe<Scalars['UUID']['input']>;
};


export type TaskDefinitionNodeTagAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TaskDefinitionNodeVisibleToGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type TaskDefinitionNodeConnection = {
  readonly __typename?: 'TaskDefinitionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskDefinitionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskDefinitionNode` and its cursor. */
export type TaskDefinitionNodeEdge = {
  readonly __typename?: 'TaskDefinitionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskDefinitionNode>;
};

export type TaskDocumentItemInput = {
  readonly communityDocument?: InputMaybe<Scalars['UUID']['input']>;
  readonly title: Scalars['String']['input'];
};

export type TaskDocumentNode = {
  readonly __typename?: 'TaskDocumentNode';
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly taskGroup?: Maybe<TaskGroupNode>;
  readonly title: Scalars['String']['output'];
  readonly uploadedBy?: Maybe<UserType>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type TaskDocumentNodeConnection = {
  readonly __typename?: 'TaskDocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskDocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskDocumentNode` and its cursor. */
export type TaskDocumentNodeEdge = {
  readonly __typename?: 'TaskDocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskDocumentNode>;
};

export type TaskGroupNode = {
  readonly __typename?: 'TaskGroupNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly documents?: Maybe<TaskDocumentNodeConnection>;
  readonly generationHorizon?: Maybe<Scalars['Float']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastGeneratedUntil?: Maybe<Scalars['Date']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly priority?: Maybe<Scalars['String']['output']>;
  readonly schedule?: Maybe<Scalars['JSONString']['output']>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
  readonly tasks?: Maybe<TaskNodeConnection>;
};


export type TaskGroupNodeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TaskGroupNodeTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedUser?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  dueDateAfter?: InputMaybe<Scalars['Date']['input']>;
  dueDateBefore?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  taskDefinition?: InputMaybe<Scalars['UUID']['input']>;
};

export type TaskGroupNodeConnection = {
  readonly __typename?: 'TaskGroupNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskGroupNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskGroupNode` and its cursor. */
export type TaskGroupNodeEdge = {
  readonly __typename?: 'TaskGroupNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskGroupNode>;
};

export type TaskNode = {
  readonly __typename?: 'TaskNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly asanaId?: Maybe<Scalars['String']['output']>;
  readonly asanaUrl?: Maybe<Scalars['String']['output']>;
  readonly assignedTeam?: Maybe<TeamNode>;
  readonly assignedUser?: Maybe<UserType>;
  readonly category?: Maybe<TaskCategoryNode>;
  readonly checklist?: Maybe<TaskChecklistNode>;
  readonly completedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly contractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly contractorUsers: ContractorNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly documents?: Maybe<TaskDocumentNodeConnection>;
  readonly dueDate?: Maybe<Scalars['DateTime']['output']>;
  readonly fixfloId?: Maybe<Scalars['String']['output']>;
  readonly fixfloUrl?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly linkedConversations?: Maybe<ReadonlyArray<Maybe<ConversationNode>>>;
  readonly priority?: Maybe<Scalars['String']['output']>;
  readonly scheduledFor?: Maybe<Scalars['Date']['output']>;
  readonly sharesDefinition: Scalars['Boolean']['output'];
  readonly sourceAction?: Maybe<ChecklistActionNode>;
  readonly status: TasksTaskStatusChoices;
  readonly taskDefinition: TaskDefinitionNode;
  readonly taskGroups: TaskGroupNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly updates?: Maybe<TaskUpdateNodeConnection>;
};


export type TaskNodeContractorUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TaskNodeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TaskNodeTaskGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type TaskNodeUpdatesArgs = {
  actor?: InputMaybe<Scalars['UUID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  task?: InputMaybe<Scalars['UUID']['input']>;
  updateType?: InputMaybe<Scalars['String']['input']>;
};

export type TaskNodeConnection = {
  readonly __typename?: 'TaskNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskNode` and its cursor. */
export type TaskNodeEdge = {
  readonly __typename?: 'TaskNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskNode>;
};

export type TaskTemplateNode = {
  readonly __typename?: 'TaskTemplateNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly autoCompleteTask: Scalars['Boolean']['output'];
  readonly communityIds?: Maybe<ReadonlyArray<Scalars['UUID']['output']>>;
  readonly complianceType?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly draftSourceTitle?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly isDraft: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSystem: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly pdfExportEnabled: Scalars['Boolean']['output'];
  readonly requiresSignOff: Scalars['Boolean']['output'];
  readonly scope?: Maybe<Scalars['String']['output']>;
  readonly sections?: Maybe<ReadonlyArray<TaskTemplateSectionNode>>;
  readonly stepCount: Scalars['Int']['output'];
  readonly steps?: Maybe<ReadonlyArray<TaskTemplateStepNode>>;
  readonly structureRevision: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskTemplateNodeConnection = {
  readonly __typename?: 'TaskTemplateNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskTemplateNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskTemplateNode` and its cursor. */
export type TaskTemplateNodeEdge = {
  readonly __typename?: 'TaskTemplateNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskTemplateNode>;
};

export type TaskTemplateSectionInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly steps?: InputMaybe<ReadonlyArray<TaskTemplateStepInput>>;
  readonly title: Scalars['String']['input'];
};

export type TaskTemplateSectionNode = {
  readonly __typename?: 'TaskTemplateSectionNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly order: Scalars['Int']['output'];
  readonly steps?: Maybe<ReadonlyArray<TaskTemplateStepNode>>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskTemplateStepFieldInput = {
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly inputType: Scalars['String']['input'];
  readonly isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  readonly label?: InputMaybe<Scalars['String']['input']>;
};

export type TaskTemplateStepInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly inputs?: InputMaybe<ReadonlyArray<TaskTemplateStepFieldInput>>;
  readonly isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly referenceCode?: InputMaybe<Scalars['String']['input']>;
  readonly requiresPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  readonly stepType?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

export type TaskTemplateStepInputNode = {
  readonly __typename?: 'TaskTemplateStepInputNode';
  readonly config?: Maybe<Scalars['JSONString']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly inputType?: Maybe<Scalars['String']['output']>;
  readonly isRequired: Scalars['Boolean']['output'];
  readonly label: Scalars['String']['output'];
  readonly order: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskTemplateStepNode = {
  readonly __typename?: 'TaskTemplateStepNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly inputs?: Maybe<ReadonlyArray<TaskTemplateStepInputNode>>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isRequired: Scalars['Boolean']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly order: Scalars['Int']['output'];
  readonly referenceCode?: Maybe<Scalars['String']['output']>;
  readonly requiresPhoto: Scalars['Boolean']['output'];
  readonly sectionId?: Maybe<Scalars['UUID']['output']>;
  readonly stepType?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskUpdateNode = {
  readonly __typename?: 'TaskUpdateNode';
  readonly actor?: Maybe<UserType>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly newStatus?: Maybe<TasksTaskUpdateNewStatusChoices>;
  readonly objectId?: Maybe<Scalars['UUID']['output']>;
  readonly source?: Maybe<TasksTaskUpdateSourceChoices>;
  readonly target?: Maybe<UserType>;
  readonly targetAction?: Maybe<ChecklistActionNode>;
  readonly targetContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly targetConversation?: Maybe<ConversationNode>;
  readonly targetDocument?: Maybe<TaskDocumentNode>;
  readonly task: TaskNode;
  readonly updateType: TasksTaskUpdateUpdateTypeChoices;
};

export type TaskUpdateNodeConnection = {
  readonly __typename?: 'TaskUpdateNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskUpdateNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskUpdateNode` and its cursor. */
export type TaskUpdateNodeEdge = {
  readonly __typename?: 'TaskUpdateNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskUpdateNode>;
};

/** An enumeration. */
export enum TasksAsanaPendingTaskStatusChoices {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Dismissed */
  Dismissed = 'DISMISSED',
  /** Pending */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum TasksTaskDefinitionPriorityChoices {
  /** High */
  High = 'HIGH',
  /** Low */
  Low = 'LOW',
  /** Medium */
  Medium = 'MEDIUM',
  /** Urgent */
  Urgent = 'URGENT'
}

/** An enumeration. */
export enum TasksTaskStatusChoices {
  /** Archived */
  Archived = 'ARCHIVED',
  /** Blocked */
  Blocked = 'BLOCKED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Completed */
  Completed = 'COMPLETED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Pending */
  Pending = 'PENDING',
  /** Scheduled */
  Scheduled = 'SCHEDULED'
}

/** An enumeration. */
export enum TasksTaskUpdateNewStatusChoices {
  /** Archived */
  Archived = 'ARCHIVED',
  /** Blocked */
  Blocked = 'BLOCKED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Completed */
  Completed = 'COMPLETED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Pending */
  Pending = 'PENDING',
  /** Scheduled */
  Scheduled = 'SCHEDULED'
}

/** An enumeration. */
export enum TasksTaskUpdateSourceChoices {
  /** Asana */
  Asana = 'ASANA',
  /** Fixflo */
  Fixflo = 'FIXFLO'
}

/** An enumeration. */
export enum TasksTaskUpdateUpdateTypeChoices {
  /** Archived */
  Archived = 'ARCHIVED',
  /** Asana Assignment Synced */
  AsanaAssignmentSynced = 'ASANA_ASSIGNMENT_SYNCED',
  /** Asana Comment Synced */
  AsanaCommentSynced = 'ASANA_COMMENT_SYNCED',
  /** Asana Linked */
  AsanaLinked = 'ASANA_LINKED',
  /** Asana Status Synced */
  AsanaStatusSynced = 'ASANA_STATUS_SYNCED',
  /** Asana Unlinked */
  AsanaUnlinked = 'ASANA_UNLINKED',
  /** Assigned */
  Assigned = 'ASSIGNED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Checklist Action Flagged */
  ChecklistActionFlagged = 'CHECKLIST_ACTION_FLAGGED',
  /** Checklist Action Resolved */
  ChecklistActionResolved = 'CHECKLIST_ACTION_RESOLVED',
  /** Checklist Action Task Created */
  ChecklistActionTaskCreated = 'CHECKLIST_ACTION_TASK_CREATED',
  /** Checklist Action Unflagged */
  ChecklistActionUnflagged = 'CHECKLIST_ACTION_UNFLAGGED',
  /** Checklist Attached */
  ChecklistAttached = 'CHECKLIST_ATTACHED',
  /** Checklist Comment Added */
  ChecklistCommentAdded = 'CHECKLIST_COMMENT_ADDED',
  /** Checklist Completed */
  ChecklistCompleted = 'CHECKLIST_COMPLETED',
  /** Checklist Item Assigned */
  ChecklistItemAssigned = 'CHECKLIST_ITEM_ASSIGNED',
  /** Checklist Item Completed */
  ChecklistItemCompleted = 'CHECKLIST_ITEM_COMPLETED',
  /** Checklist Item Uncompleted */
  ChecklistItemUncompleted = 'CHECKLIST_ITEM_UNCOMPLETED',
  /** Checklist Section Assigned */
  ChecklistSectionAssigned = 'CHECKLIST_SECTION_ASSIGNED',
  /** Checklist Signed Off */
  ChecklistSignedOff = 'CHECKLIST_SIGNED_OFF',
  /** Comment Added */
  CommentAdded = 'COMMENT_ADDED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Contractor Assigned */
  ContractorAssigned = 'CONTRACTOR_ASSIGNED',
  /** Contractor Unassigned */
  ContractorUnassigned = 'CONTRACTOR_UNASSIGNED',
  /** Conversation Linked */
  ConversationLinked = 'CONVERSATION_LINKED',
  /** Created */
  Created = 'CREATED',
  /** Created From Conversation */
  CreatedFromConversation = 'CREATED_FROM_CONVERSATION',
  /** Description Updated */
  DescriptionUpdated = 'DESCRIPTION_UPDATED',
  /** Document Added */
  DocumentAdded = 'DOCUMENT_ADDED',
  /** Document Removed */
  DocumentRemoved = 'DOCUMENT_REMOVED',
  /** Due Date Changed */
  DueDateChanged = 'DUE_DATE_CHANGED',
  /** Fixflo Comment Synced */
  FixfloCommentSynced = 'FIXFLO_COMMENT_SYNCED',
  /** Fixflo Linked */
  FixfloLinked = 'FIXFLO_LINKED',
  /** Fixflo Status Synced */
  FixfloStatusSynced = 'FIXFLO_STATUS_SYNCED',
  /** Fixflo Unlinked */
  FixfloUnlinked = 'FIXFLO_UNLINKED',
  /** Priority Changed */
  PriorityChanged = 'PRIORITY_CHANGED',
  /** Reopened */
  Reopened = 'REOPENED',
  /** Scheduled Activated */
  ScheduledActivated = 'SCHEDULED_ACTIVATED',
  /** Status Updated */
  StatusUpdated = 'STATUS_UPDATED',
  /** Tag Assigned */
  TagAssigned = 'TAG_ASSIGNED',
  /** Tag Unassigned */
  TagUnassigned = 'TAG_UNASSIGNED',
  /** Unarchived */
  Unarchived = 'UNARCHIVED',
  /** Unassigned */
  Unassigned = 'UNASSIGNED'
}

export type TeamActivityReportingNode = {
  readonly __typename?: 'TeamActivityReportingNode';
  readonly presence: TeamPresenceNode;
  readonly sessionLength: TeamDurationNode;
};

export type TeamApplicationReportingNode = {
  readonly __typename?: 'TeamApplicationReportingNode';
  readonly decisions: TeamDecisionsNode;
};

export type TeamAssignmentContent = CommunityDocumentNode | ConversationNode | UserDocumentNode;

export type TeamAssignmentNode = {
  readonly __typename?: 'TeamAssignmentNode';
  readonly assignedBy?: Maybe<UserType>;
  readonly contentObject?: Maybe<TeamAssignmentContent>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly objectId: Scalars['UUID']['output'];
  readonly team: TeamNode;
};

export type TeamAssignmentNodeConnection = {
  readonly __typename?: 'TeamAssignmentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TeamAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TeamAssignmentNode` and its cursor. */
export type TeamAssignmentNodeEdge = {
  readonly __typename?: 'TeamAssignmentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TeamAssignmentNode>;
};

export type TeamConversationReportingNode = {
  readonly __typename?: 'TeamConversationReportingNode';
  readonly assigned: TeamCountNode;
  readonly firstResponse: TeamDurationNode;
  readonly memberRatings: ReadonlyArray<TeamRatedConversationNode>;
  readonly openConversations: TeamOpenNode;
  readonly resolved: TeamCountNode;
  readonly responseTime: TeamDurationNode;
  readonly satisfaction: TeamSatisfactionNode;
  readonly topics: ReadonlyArray<TeamMemberTopicNode>;
};


export type TeamConversationReportingNodeMemberRatingsArgs = {
  userId: Scalars['UUID']['input'];
};

export type TeamCountNode = {
  readonly __typename?: 'TeamCountNode';
  readonly byDay: ReadonlyArray<TeamDayValueNode>;
  readonly byMember: ReadonlyArray<TeamMemberCountNode>;
  readonly total: Scalars['Int']['output'];
};

export type TeamDayValueNode = {
  readonly __typename?: 'TeamDayValueNode';
  readonly day: Scalars['Date']['output'];
  readonly value?: Maybe<Scalars['Float']['output']>;
};

export type TeamDecisionsNode = {
  readonly __typename?: 'TeamDecisionsNode';
  readonly approved: Scalars['Int']['output'];
  readonly byDay: ReadonlyArray<TeamDayValueNode>;
  readonly byMember: ReadonlyArray<TeamMemberDecisionsNode>;
  readonly medianActionSeconds?: Maybe<Scalars['Float']['output']>;
  readonly rejected: Scalars['Int']['output'];
};

export type TeamDocumentReachNode = {
  readonly __typename?: 'TeamDocumentReachNode';
  readonly byMember: ReadonlyArray<TeamMemberDocumentReachNode>;
  readonly documentCount: Scalars['Int']['output'];
  readonly neverViewedCount: Scalars['Int']['output'];
  readonly viewCount: Scalars['Int']['output'];
  readonly viewsPerDocument?: Maybe<Scalars['Float']['output']>;
};

export type TeamDocumentReportingNode = {
  readonly __typename?: 'TeamDocumentReportingNode';
  readonly reach: TeamDocumentReachNode;
  readonly uploaded: TeamCountNode;
};

export type TeamDurationNode = {
  readonly __typename?: 'TeamDurationNode';
  readonly byDay: ReadonlyArray<TeamDayValueNode>;
  readonly byMember: ReadonlyArray<TeamMemberDurationNode>;
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type TeamMemberCountNode = {
  readonly __typename?: 'TeamMemberCountNode';
  readonly count: Scalars['Int']['output'];
  readonly member: TeamMemberNode;
};

export type TeamMemberDecisionsNode = {
  readonly __typename?: 'TeamMemberDecisionsNode';
  readonly approved: Scalars['Int']['output'];
  readonly medianActionSeconds?: Maybe<Scalars['Float']['output']>;
  readonly member: TeamMemberNode;
  readonly rejected: Scalars['Int']['output'];
};

export type TeamMemberDocumentReachNode = {
  readonly __typename?: 'TeamMemberDocumentReachNode';
  readonly documentCount: Scalars['Int']['output'];
  readonly member: TeamMemberNode;
  readonly neverViewedCount: Scalars['Int']['output'];
  readonly viewCount: Scalars['Int']['output'];
};

export type TeamMemberDurationNode = {
  readonly __typename?: 'TeamMemberDurationNode';
  readonly medianSeconds: Scalars['Float']['output'];
  readonly member: TeamMemberNode;
  readonly sampleCount: Scalars['Int']['output'];
};

export type TeamMemberNode = {
  readonly __typename?: 'TeamMemberNode';
  readonly name: Scalars['String']['output'];
  readonly userId: Scalars['UUID']['output'];
};

export type TeamMemberRatingNode = {
  readonly __typename?: 'TeamMemberRatingNode';
  readonly meanRating: Scalars['Float']['output'];
  readonly member: TeamMemberNode;
  readonly ratedCount: Scalars['Int']['output'];
};

export type TeamMemberReachNode = {
  readonly __typename?: 'TeamMemberReachNode';
  readonly audienceSize: Scalars['Int']['output'];
  readonly likeCount: Scalars['Int']['output'];
  readonly likesPerUpdate: Scalars['Float']['output'];
  readonly member: TeamMemberNode;
  readonly readRate?: Maybe<Scalars['Float']['output']>;
  readonly readerCount: Scalars['Int']['output'];
  readonly readersPerUpdate: Scalars['Float']['output'];
  readonly updateCount: Scalars['Int']['output'];
};

export type TeamMemberTopicNode = {
  readonly __typename?: 'TeamMemberTopicNode';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly member: TeamMemberNode;
  readonly tagId: Scalars['UUID']['output'];
};

export type TeamNode = {
  readonly __typename?: 'TeamNode';
  readonly activatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly assignments?: Maybe<TeamAssignmentNodeConnection>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly icon?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly userCount: Scalars['Int']['output'];
  readonly users: ReadonlyArray<UserType>;
};


export type TeamNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TeamNodeConnection = {
  readonly __typename?: 'TeamNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TeamNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TeamNode` and its cursor. */
export type TeamNodeEdge = {
  readonly __typename?: 'TeamNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TeamNode>;
};

export type TeamOpenNode = {
  readonly __typename?: 'TeamOpenNode';
  readonly atEnd?: Maybe<TeamDayValueNode>;
  readonly byDay: ReadonlyArray<TeamDayValueNode>;
  readonly byMember: ReadonlyArray<TeamMemberCountNode>;
};

export type TeamPresenceNode = {
  readonly __typename?: 'TeamPresenceNode';
  readonly activeMemberCount: Scalars['Int']['output'];
  readonly medianSessionsPerMember?: Maybe<Scalars['Float']['output']>;
  readonly memberCount: Scalars['Int']['output'];
};

export type TeamRatedConversationNode = {
  readonly __typename?: 'TeamRatedConversationNode';
  readonly conversationId: Scalars['UUID']['output'];
  readonly ratedAt: Scalars['DateTime']['output'];
  readonly stars: Scalars['Int']['output'];
  readonly subject: Scalars['String']['output'];
};

export type TeamReachNode = {
  readonly __typename?: 'TeamReachNode';
  readonly audienceSize: Scalars['Int']['output'];
  readonly byMember: ReadonlyArray<TeamMemberReachNode>;
  readonly likeCount: Scalars['Int']['output'];
  readonly likesPerUpdate?: Maybe<Scalars['Float']['output']>;
  readonly readRate?: Maybe<Scalars['Float']['output']>;
  readonly readerCount: Scalars['Int']['output'];
  readonly readersPerUpdate?: Maybe<Scalars['Float']['output']>;
  readonly updateCount: Scalars['Int']['output'];
};

export type TeamRosterMemberNode = {
  readonly __typename?: 'TeamRosterMemberNode';
  readonly communityIds: ReadonlyArray<Scalars['UUID']['output']>;
  readonly name: Scalars['String']['output'];
  readonly userId: Scalars['UUID']['output'];
};

export type TeamSatisfactionNode = {
  readonly __typename?: 'TeamSatisfactionNode';
  readonly byMember: ReadonlyArray<TeamMemberRatingNode>;
  readonly meanRating?: Maybe<Scalars['Float']['output']>;
  readonly ratedCount: Scalars['Int']['output'];
};

export type TeamUpdateReportingNode = {
  readonly __typename?: 'TeamUpdateReportingNode';
  readonly published: TeamCountNode;
  readonly reach: TeamReachNode;
};

export type TenancyApplicantNode = {
  readonly __typename?: 'TenancyApplicantNode';
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly reference?: Maybe<TenantReferenceNode>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly tenancyApplication: TenancyApplicationNode;
};

export type TenancyApplicantNodeConnection = {
  readonly __typename?: 'TenancyApplicantNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TenancyApplicantNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TenancyApplicantNode` and its cursor. */
export type TenancyApplicantNodeEdge = {
  readonly __typename?: 'TenancyApplicantNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TenancyApplicantNode>;
};

/** An enumeration. */
export enum TenancyApplicationEmployerReferenceStepChoices {
  /** ALMOST_DONE */
  AlmostDone = 'ALMOST_DONE',
  /** EMPLOYMENT */
  Employment = 'EMPLOYMENT',
  /** PERSONAL */
  Personal = 'PERSONAL'
}

/** An enumeration. */
export enum TenancyApplicationEmploymentDetailsEmploymentTypeChoices {
  /** CONTRACTOR */
  Contractor = 'CONTRACTOR',
  /** EMPLOYED */
  Employed = 'EMPLOYED',
  /** SELF_EMPLOYED */
  SelfEmployed = 'SELF_EMPLOYED',
  /** UNEMPLOYED */
  Unemployed = 'UNEMPLOYED'
}

/** An enumeration. */
export enum TenancyApplicationEmploymentDetailsFullOrPartTimeChoices {
  /** FULL_TIME */
  FullTime = 'FULL_TIME',
  /** PART_TIME */
  PartTime = 'PART_TIME'
}

/** An enumeration. */
export enum TenancyApplicationEmploymentDetailsPaymentFrequencyChoices {
  /** MONTHLY */
  Monthly = 'MONTHLY',
  /** WEEKLY */
  Weekly = 'WEEKLY'
}

/** An enumeration. */
export enum TenancyApplicationIdentityVerificationStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** EXPIRED */
  Expired = 'EXPIRED',
  /** FAILED */
  Failed = 'FAILED',
  /** STARTED */
  Started = 'STARTED',
  /** SUBMITTED */
  Submitted = 'SUBMITTED'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceHasOutstandingRentChoices {
  /** NO */
  No = 'NO',
  /** YES */
  Yes = 'YES'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceRentPaidOnTimeChoices {
  /** NO */
  No = 'NO',
  /** YES */
  Yes = 'YES'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceStepChoices {
  /** ALMOST_DONE */
  AlmostDone = 'ALMOST_DONE',
  /** COMMENTS */
  Comments = 'COMMENTS',
  /** PERSONAL */
  Personal = 'PERSONAL',
  /** RENTAL_DETAILS */
  RentalDetails = 'RENTAL_DETAILS'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceTenancyTypeChoices {
  /** HMO */
  Hmo = 'HMO',
  /** PRIVATE_RESIDENTIAL */
  PrivateResidential = 'PRIVATE_RESIDENTIAL',
  /** SHARED */
  Shared = 'SHARED',
  /** SOCIAL_HOUSING */
  SocialHousing = 'SOCIAL_HOUSING'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceTreatedPropertyWellChoices {
  /** NO */
  No = 'NO',
  /** YES */
  Yes = 'YES'
}

export type TenancyApplicationNode = {
  readonly __typename?: 'TenancyApplicationNode';
  readonly affordabilityStatus: TenancyApplicationTenancyApplicationAffordabilityStatusChoices;
  readonly applicantNames?: Maybe<Scalars['String']['output']>;
  readonly applicants: TenancyApplicantNodeConnection;
  readonly combinedAffordability?: Maybe<Scalars['Int']['output']>;
  readonly completedOn?: Maybe<Scalars['Date']['output']>;
  readonly home: HomeType;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly references?: Maybe<ReadonlyArray<Maybe<TenantReferenceNode>>>;
  readonly rentAmount: Scalars['Decimal']['output'];
  readonly status: TenancyApplicationTenancyApplicationStatusChoices;
  readonly unpaidTenantReferenceCount?: Maybe<Scalars['Int']['output']>;
  readonly unpaidTenantReferencesTotalCost?: Maybe<Scalars['Float']['output']>;
};


export type TenancyApplicationNodeApplicantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TenancyApplicationNodeConnection = {
  readonly __typename?: 'TenancyApplicationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TenancyApplicationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TenancyApplicationNode` and its cursor. */
export type TenancyApplicationNodeEdge = {
  readonly __typename?: 'TenancyApplicationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TenancyApplicationNode>;
};

/** An enumeration. */
export enum TenancyApplicationRightToRentOfficialVerificationStatusChoices {
  /** LIMITED */
  Limited = 'LIMITED',
  /** PENDING */
  Pending = 'PENDING',
  /** REJECTED */
  Rejected = 'REJECTED',
  /** UNLIMITED */
  Unlimited = 'UNLIMITED'
}

/** An enumeration. */
export enum TenancyApplicationTenancyApplicationAffordabilityStatusChoices {
  /** CAUTION */
  Caution = 'CAUTION',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** WAITING */
  Waiting = 'WAITING'
}

/** An enumeration. */
export enum TenancyApplicationTenancyApplicationStatusChoices {
  /** CAUTION */
  Caution = 'CAUTION',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** WAITING */
  Waiting = 'WAITING'
}

/** An enumeration. */
export enum TenancyApplicationTenantReferenceStepChoices {
  /** ADDRESS_HISTORY */
  AddressHistory = 'ADDRESS_HISTORY',
  /** ALMOST_DONE */
  AlmostDone = 'ALMOST_DONE',
  /** EMPLOYER */
  Employer = 'EMPLOYER',
  /** EMPLOYMENT */
  Employment = 'EMPLOYMENT',
  /** IDENTITY */
  Identity = 'IDENTITY',
  /** LANDLORD */
  Landlord = 'LANDLORD',
  /** PERSONAL */
  Personal = 'PERSONAL',
  /** RIGHT_TO_RENT */
  RightToRent = 'RIGHT_TO_RENT'
}

/** An enumeration. */
export enum TenancyApplicationTenantReferenceTitleChoices {
  /** DR */
  Dr = 'DR',
  /** MISS */
  Miss = 'MISS',
  /** MR */
  Mr = 'MR',
  /** MRS */
  Mrs = 'MRS',
  /** MS */
  Ms = 'MS',
  /** MX */
  Mx = 'MX'
}

export type TenantReferenceNode = {
  readonly __typename?: 'TenantReferenceNode';
  readonly applicant: TenancyApplicantNode;
  readonly application: TenancyApplicationNode;
  readonly clientType?: Maybe<Scalars['String']['output']>;
  readonly creditCheck?: Maybe<CreditCheckNode>;
  readonly creditCheckPermission: Scalars['Boolean']['output'];
  readonly creditCheckStatus?: Maybe<Scalars['String']['output']>;
  readonly currentAddress?: Maybe<ReferenceHistoricalAddressNode>;
  readonly dateOfBirth?: Maybe<Scalars['Date']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly employerReference?: Maybe<EmployerReferenceNode>;
  readonly employmentStatus?: Maybe<Scalars['String']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly historicalAddresses: ReferenceHistoricalAddressNodeConnection;
  readonly home: HomeNode;
  readonly id: Scalars['UUID']['output'];
  readonly identityVerification?: Maybe<IdentityVerificationNode>;
  readonly identityVerificationStatus?: Maybe<Scalars['String']['output']>;
  readonly isPaid?: Maybe<Scalars['Boolean']['output']>;
  readonly landlordReference?: Maybe<LandlordReferenceNode>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly lettingHistoryStatus?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly rentAffordability?: Maybe<Scalars['Decimal']['output']>;
  readonly rightToRent?: Maybe<RightToRentNode>;
  readonly rightToRentStatus?: Maybe<Scalars['String']['output']>;
  readonly sentAt?: Maybe<Scalars['DateTime']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<TenancyApplicationTenantReferenceStepChoices>;
  readonly submittedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly tenantEmploymentDetails?: Maybe<EmploymentDetailsNode>;
  readonly title?: Maybe<TenancyApplicationTenantReferenceTitleChoices>;
};


export type TenantReferenceNodeHistoricalAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TenantReferenceNodeConnection = {
  readonly __typename?: 'TenantReferenceNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TenantReferenceNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TenantReferenceNode` and its cursor. */
export type TenantReferenceNodeEdge = {
  readonly __typename?: 'TenantReferenceNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TenantReferenceNode>;
};

export type TenantSerializerInput = {
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type Tenants = {
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type TimeSlot = {
  readonly end?: InputMaybe<Scalars['DateTime']['input']>;
  readonly start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ToggleAllResidentAppNotificationPreferencesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly enabled: Scalars['Boolean']['input'];
};

export type ToggleAllResidentAppNotificationPreferencesPayload = {
  readonly __typename?: 'ToggleAllResidentAppNotificationPreferencesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly residentAppNotificationPreferences?: Maybe<ResidentAppNotificationPreferencesNode>;
};

export type ToggleArchivedAtCommunityDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleArchivedAtCommunityDocumentPayload = {
  readonly __typename?: 'ToggleArchivedAtCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ToggleArchivedAtCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleArchivedAtCommunityUpdatePayload = {
  readonly __typename?: 'ToggleArchivedAtCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ToggleClientTagArchivedAtInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleClientTagArchivedAtPayload = {
  readonly __typename?: 'ToggleClientTagArchivedAtPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientTag?: Maybe<ClientTagNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ToggleCommunityUpdateBookmarkInput = {
  readonly bookmarkedBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleCommunityUpdateBookmarkPayload = {
  readonly __typename?: 'ToggleCommunityUpdateBookmarkPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ToggleCommunityUpdateLikeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
};

export type ToggleCommunityUpdateLikePayload = {
  readonly __typename?: 'ToggleCommunityUpdateLikePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly update?: Maybe<CommunityUpdateNode>;
};

export type ToggleMarketplaceItemCloseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleMarketplaceItemClosePayload = {
  readonly __typename?: 'ToggleMarketplaceItemClosePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly marketplaceItem?: Maybe<MarketplaceItemNode>;
};

export type ToggleRuleActivatedInput = {
  readonly activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleRuleActivatedPayload = {
  readonly __typename?: 'ToggleRuleActivatedPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly rule?: Maybe<RuleNode>;
};

export type ToggleTeamActivatedInput = {
  readonly activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleTeamActivatedPayload = {
  readonly __typename?: 'ToggleTeamActivatedPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type TypeformQuestionConnection = {
  readonly __typename?: 'TypeformQuestionConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TypeformQuestionEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `TypeformQuestion` and its cursor. */
export type TypeformQuestionEdge = {
  readonly __typename?: 'TypeformQuestionEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TypeformQuestionType>;
};

export type TypeformQuestionType = {
  readonly __typename?: 'TypeformQuestionType';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly properties?: Maybe<Scalars['JSONString']['output']>;
  readonly ref?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
};

export type TypeformResponseConnection = {
  readonly __typename?: 'TypeformResponseConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TypeformResponseEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `TypeformResponse` and its cursor. */
export type TypeformResponseEdge = {
  readonly __typename?: 'TypeformResponseEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TypeformResponseType>;
};

export type TypeformResponseType = {
  readonly __typename?: 'TypeformResponseType';
  readonly answers?: Maybe<Scalars['JSONString']['output']>;
  readonly hidden?: Maybe<Scalars['JSONString']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly submittedAt?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<UserType>;
};

export type UnarchiveApplicationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveApplicationPayload = {
  readonly __typename?: 'UnarchiveApplicationPayload';
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UnarchiveKeyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveKeyPayload = {
  readonly __typename?: 'UnarchiveKeyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type UnarchiveKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveKeyholderPayload = {
  readonly __typename?: 'UnarchiveKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type UnarchiveTaskGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveTaskGroupPayload = {
  readonly __typename?: 'UnarchiveTaskGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskGroup?: Maybe<TaskGroupNode>;
};

export type UnarchiveTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveTaskPayload = {
  readonly __typename?: 'UnarchiveTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type UnarchiveTaskTemplateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type UnarchiveTaskTemplatePayload = {
  readonly __typename?: 'UnarchiveTaskTemplatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
};

export type UnassignClientTagFromCommunityDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documentId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type UnassignClientTagFromCommunityDocumentPayload = {
  readonly __typename?: 'UnassignClientTagFromCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
};

export type UnassignClientTagFromTaskDefinitionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly tagId: Scalars['UUID']['input'];
  readonly taskDefinitionId: Scalars['UUID']['input'];
};

export type UnassignClientTagFromTaskDefinitionPayload = {
  readonly __typename?: 'UnassignClientTagFromTaskDefinitionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type UnassignClientTagFromUserDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documentId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type UnassignClientTagFromUserDocumentPayload = {
  readonly __typename?: 'UnassignClientTagFromUserDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
};

export type UnassignClientTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type UnassignClientTagPayload = {
  readonly __typename?: 'UnassignClientTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
};

export type UnassignTeamInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type UnassignTeamPayload = {
  readonly __typename?: 'UnassignTeamPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type UnbookCommunityEventMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly eventId: Scalars['UUID']['input'];
};

export type UnbookCommunityEventMutationPayload = {
  readonly __typename?: 'UnbookCommunityEventMutationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly event?: Maybe<CommunityEventNode>;
};

export type UnflagChecklistItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnflagChecklistItemPayload = {
  readonly __typename?: 'UnflagChecklistItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskChecklistItem?: Maybe<TaskChecklistItemNode>;
};

export type UnlabelConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly tags: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type UnlabelConversationPayload = {
  readonly __typename?: 'UnlabelConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UnlinkTaskFromAsanaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnlinkTaskFromAsanaPayload = {
  readonly __typename?: 'UnlinkTaskFromAsanaPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type UnlinkTaskFromFixfloInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnlinkTaskFromFixfloPayload = {
  readonly __typename?: 'UnlinkTaskFromFixfloPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type UnreadAllNotificationsOnTargetInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

export type UnreadAllNotificationsOnTargetPayload = {
  readonly __typename?: 'UnreadAllNotificationsOnTargetPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly notifications: NotificationNodeConnection;
};


export type UnreadAllNotificationsOnTargetPayloadNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UnreadNotificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnreadNotificationPayload = {
  readonly __typename?: 'UnreadNotificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly notification?: Maybe<NotificationNode>;
};

export type UnsnoozeConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type UnsnoozeConversationPayload = {
  readonly __typename?: 'UnsnoozeConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type UnsubscribeFromNotificationGroup = {
  readonly __typename?: 'UnsubscribeFromNotificationGroup';
  readonly unsubscribeNotificationGroup?: Maybe<UnsubscribeNotificationGroupNode>;
};

export type UnsubscribeNotificationGroupNode = {
  readonly __typename?: 'UnsubscribeNotificationGroupNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly type: PeopleUnsubscribeNotificationGroupTypeChoices;
  readonly users: ReadonlyArray<UserType>;
};

export type UnsubscribeNotificationGroupNodeConnection = {
  readonly __typename?: 'UnsubscribeNotificationGroupNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UnsubscribeNotificationGroupNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UnsubscribeNotificationGroupNode` and its cursor. */
export type UnsubscribeNotificationGroupNodeEdge = {
  readonly __typename?: 'UnsubscribeNotificationGroupNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UnsubscribeNotificationGroupNode>;
};

export type UpdateAmenityOperatingScheduleInput = {
  readonly amenityId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly schedule: ReadonlyArray<InputMaybe<OperatingTimeInput>>;
};

export type UpdateAmenityOperatingSchedulePayload = {
  readonly __typename?: 'UpdateAmenityOperatingSchedulePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAmenityTypeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAmenityTypePayload = {
  readonly __typename?: 'UpdateAmenityTypePayload';
  readonly amenity?: Maybe<AmenityNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateApplicationCommunity = {
  readonly __typename?: 'UpdateApplicationCommunity';
  readonly application?: Maybe<ApplicationNode>;
  readonly homes?: Maybe<ReadonlyArray<NewHomeOption>>;
  readonly status: Scalars['String']['output'];
};

export type UpdateApplicationCommunityInput = {
  readonly applicationId: Scalars['ID']['input'];
  readonly communityId: Scalars['ID']['input'];
};

export type UpdateApplicationHome = {
  readonly __typename?: 'UpdateApplicationHome';
  readonly application?: Maybe<ApplicationNode>;
};

export type UpdateApplicationHomeInput = {
  readonly applicationId: Scalars['ID']['input'];
  readonly homeId: Scalars['ID']['input'];
};

export type UpdateAttachmentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homeId: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAttachmentPayload = {
  readonly __typename?: 'UpdateAttachmentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly homeId?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type UpdateBlockHomesInput = {
  readonly blockId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homesToAdd: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
  readonly homesToRemove: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
};

export type UpdateBlockHomesPayload = {
  readonly __typename?: 'UpdateBlockHomesPayload';
  readonly block?: Maybe<BlockNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateBlockSafetyIdentityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly hrbReference?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly responsiblePersonName?: InputMaybe<Scalars['String']['input']>;
  readonly responsiblePersonRole?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlockSafetyIdentityPayload = {
  readonly __typename?: 'UpdateBlockSafetyIdentityPayload';
  readonly block?: Maybe<BlockNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateBlockSuggestionHomesInput = {
  readonly blockSuggestionId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homesToAdd: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
  readonly homesToRemove: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
};

export type UpdateBlockSuggestionHomesPayload = {
  readonly __typename?: 'UpdateBlockSuggestionHomesPayload';
  readonly blockSuggestion?: Maybe<BlockSuggestionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateChecklistInput = {
  readonly checklistId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly requiresSignOff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateChecklistPayload = {
  readonly __typename?: 'UpdateChecklistPayload';
  readonly checklist?: Maybe<TaskChecklistNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateChecklistStructureInput = {
  readonly checklistId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly expectedRevision: Scalars['Int']['input'];
  readonly sections: ReadonlyArray<ChecklistSectionInput>;
};

export type UpdateChecklistStructurePayload = {
  readonly __typename?: 'UpdateChecklistStructurePayload';
  readonly checklist?: Maybe<TaskChecklistNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateClientAdminInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
};

export type UpdateClientAdminPayload = {
  readonly __typename?: 'UpdateClientAdminPayload';
  readonly clientAdmin?: Maybe<ClientAdminNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateClientContractorCompanyCommunitiesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientContractorCompanyCommunitiesPayload = {
  readonly __typename?: 'UpdateClientContractorCompanyCommunitiesPayload';
  readonly clientContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateClientContractorCompanyContractorsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contractors?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientContractorCompanyContractorsPayload = {
  readonly __typename?: 'UpdateClientContractorCompanyContractorsPayload';
  readonly clientContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateClientContractorCompanyInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyType?: InputMaybe<Company_Type>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  readonly website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientContractorCompanyPayload = {
  readonly __typename?: 'UpdateClientContractorCompanyPayload';
  readonly clientContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateClientTagColorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly color?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientTagColorPayload = {
  readonly __typename?: 'UpdateClientTagColorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientTag?: Maybe<ClientTagNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateClientTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly color?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

export type UpdateClientTagPayload = {
  readonly __typename?: 'UpdateClientTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientTag?: Maybe<ClientTagNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateCommunityDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
  readonly viewers?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunityDocumentPayload = {
  readonly __typename?: 'UpdateCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateCommunityProductInput = {
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateCommunityProductPayload = {
  readonly __typename?: 'UpdateCommunityProductPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityProduct?: Maybe<CommunityProductNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

/** Set the Responsible Person details printed on EES PDFs. */
export type UpdateCommunityResponsiblePerson = {
  readonly __typename?: 'UpdateCommunityResponsiblePerson';
  readonly community?: Maybe<CommunityNode>;
};

export type UpdateCommunitySettingsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly commentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communityChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly marketplaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly officeHoursEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly openPeriods: ReadonlyArray<InputMaybe<CommunityOpenPeriodSerializerInput>>;
  readonly outOfOfficeMessage?: InputMaybe<Scalars['String']['input']>;
  readonly paymentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly status: Scalars['String']['input'];
};

export type UpdateCommunitySettingsPayload = {
  readonly __typename?: 'UpdateCommunitySettingsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly communityChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly marketplaceEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly officeHoursEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly openPeriods?: Maybe<ReadonlyArray<Maybe<CommunityOpenPeriodNode>>>;
  readonly outOfOfficeMessage?: Maybe<Scalars['String']['output']>;
  readonly paymentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
};

/** Toggle the annual SIB-pack review nudge and tweak the lead-time months. */
export type UpdateCommunitySibPackReviewSettings = {
  readonly __typename?: 'UpdateCommunitySibPackReviewSettings';
  readonly community?: Maybe<CommunityNode>;
};

export type UpdateCommunityTaskDefinitionInput = {
  readonly block?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly taskGroup?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunityTaskDefinitionPayload = {
  readonly __typename?: 'UpdateCommunityTaskDefinitionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityTaskDefinition?: Maybe<CommunityTaskDefinitionNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateContactGroupsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contactId: Scalars['String']['input'];
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type UpdateContactGroupsPayload = {
  readonly __typename?: 'UpdateContactGroupsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contact?: Maybe<ContactNode>;
};

export type UpdateContractorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractorPayload = {
  readonly __typename?: 'UpdateContractorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contractor?: Maybe<ContractorNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateConversationNoteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly text: Scalars['String']['input'];
};

export type UpdateConversationNotePayload = {
  readonly __typename?: 'UpdateConversationNotePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationNote?: Maybe<ConversationNoteNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateConversationParticipantTypeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly participantType: Participant_Type;
};

export type UpdateConversationParticipantTypePayload = {
  readonly __typename?: 'UpdateConversationParticipantTypePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateConversationTagInput = {
  readonly client?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConversationTagPayload = {
  readonly __typename?: 'UpdateConversationTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type UpdateConversationTitleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly subject: Scalars['String']['input'];
};

export type UpdateConversationTitlePayload = {
  readonly __typename?: 'UpdateConversationTitlePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateConversationUrgency = {
  readonly __typename?: 'UpdateConversationUrgency';
  readonly conversation?: Maybe<ConversationNode>;
};

export type UpdateConversationUrgencyInput = {
  readonly conversationId: Scalars['UUID']['input'];
  readonly urgency: Scalars['String']['input'];
};

export type UpdateEmployerReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployerReferencePayload = {
  readonly __typename?: 'UpdateEmployerReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
};

export type UpdateEmployerReferenceStepInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly step?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployerReferenceStepPayload = {
  readonly __typename?: 'UpdateEmployerReferenceStepPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<Scalars['String']['output']>;
};

export type UpdateGroupDescriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupDescriptionPayload = {
  readonly __typename?: 'UpdateGroupDescriptionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityGroup?: Maybe<CommunityGroupNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly users?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateGroupPayload = {
  readonly __typename?: 'UpdateGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly homes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly users?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
};

export type UpdateHomeAddressInput = {
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  readonly city?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly postcode: Scalars['String']['input'];
};

export type UpdateHomeAddressPayload = {
  readonly __typename?: 'UpdateHomeAddressPayload';
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly postcode?: Maybe<Scalars['String']['output']>;
};

export type UpdateHomeDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly furnishing?: InputMaybe<Scalars['String']['input']>;
  readonly garden?: InputMaybe<Scalars['Boolean']['input']>;
  readonly home: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly kitchen?: InputMaybe<Scalars['Boolean']['input']>;
  readonly numBathrooms?: InputMaybe<Scalars['Int']['input']>;
  readonly numBedrooms?: InputMaybe<Scalars['Int']['input']>;
  readonly numEnsuites?: InputMaybe<Scalars['Int']['input']>;
  readonly numLivingRooms?: InputMaybe<Scalars['Int']['input']>;
  readonly office?: InputMaybe<Scalars['Boolean']['input']>;
  readonly parking?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHomeDetailsPayload = {
  readonly __typename?: 'UpdateHomeDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly furnishing?: Maybe<Scalars['String']['output']>;
  readonly garden?: Maybe<Scalars['Boolean']['output']>;
  readonly home?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly kitchen?: Maybe<Scalars['Boolean']['output']>;
  readonly numBathrooms?: Maybe<Scalars['Int']['output']>;
  readonly numBedrooms?: Maybe<Scalars['Int']['output']>;
  readonly numEnsuites?: Maybe<Scalars['Int']['output']>;
  readonly numLivingRooms?: Maybe<Scalars['Int']['output']>;
  readonly office?: Maybe<Scalars['Boolean']['output']>;
  readonly parking?: Maybe<Scalars['String']['output']>;
};

export type UpdateHomeFloorNumberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly floorNumber?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHomeFloorNumberPayload = {
  readonly __typename?: 'UpdateHomeFloorNumberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly home?: Maybe<HomeType>;
};

export type UpdateKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateKeyholderPayload = {
  readonly __typename?: 'UpdateKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly company?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly endDate?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type UpdateLandlordInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly emailPreferences: Scalars['Boolean']['input'];
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
  readonly smsPreferences: Scalars['Boolean']['input'];
};

export type UpdateLandlordPayload = {
  readonly __typename?: 'UpdateLandlordPayload';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly emailPreferences?: Maybe<Scalars['Boolean']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly smsPreferences?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLandlordReferenceCommentsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comments?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLandlordReferenceCommentsPayload = {
  readonly __typename?: 'UpdateLandlordReferenceCommentsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comments?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type UpdateLandlordReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly landlordOrAgent: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile: Scalars['String']['input'];
  readonly tenantReference: Scalars['String']['input'];
};

export type UpdateLandlordReferencePayload = {
  readonly __typename?: 'UpdateLandlordReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly landlordOrAgent?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly tenantReference?: Maybe<Scalars['String']['output']>;
};

export type UpdateLandlordReferenceStepInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly step?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLandlordReferenceStepPayload = {
  readonly __typename?: 'UpdateLandlordReferenceStepPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<Scalars['String']['output']>;
};

export type UpdateManagerInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
};

export type UpdateManagerNotificationSettingsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly emailPreferences: Scalars['Boolean']['input'];
};

export type UpdateManagerNotificationSettingsPayload = {
  readonly __typename?: 'UpdateManagerNotificationSettingsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly manager?: Maybe<ManagerType>;
};

export type UpdateManagerPayload = {
  readonly __typename?: 'UpdateManagerPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly manager?: Maybe<ManagerType>;
};

export type UpdateNotificationPreferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly managerAmenityEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerAmenityPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerApplicationEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerApplicationMessageEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerApplicationMessagePushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerApplicationPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerCommunityEventEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerCommunityEventPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerCommunityProductEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerCommunityProductPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerCommunityUpdateEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerCommunityUpdatePushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerConversationAssignmentEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerConversationAssignmentPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerConversationEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerConversationPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerSurveysEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerSurveysPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerTaskAssignmentPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerTaskCommentPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerTaskUpdatePushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerTeamAssignmentEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerTeamAssignmentPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNotificationPreferencePayload = {
  readonly __typename?: 'UpdateNotificationPreferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly userNotificationPreference?: Maybe<UserNotificationPreferenceNode>;
};

export type UpdatePackageLocationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly location?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePackageLocationPayload = {
  readonly __typename?: 'UpdatePackageLocationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly package?: Maybe<PackageNode>;
};

export type UpdatePackageStatusInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly reason?: InputMaybe<Scalars['String']['input']>;
  readonly status: Scalars['String']['input'];
};

export type UpdatePackageStatusPayload = {
  readonly __typename?: 'UpdatePackageStatusPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly package: PackageNode;
};

export type UpdateReferenceAddressHistoryInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly historicalAddresses: ReadonlyArray<InputMaybe<ReferenceHistoricalAddressSerializerInput>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReferenceAddressHistoryPayload = {
  readonly __typename?: 'UpdateReferenceAddressHistoryPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly historicalAddresses?: Maybe<ReadonlyArray<Maybe<ReferenceHistoricalAddressNode>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type UpdateReferenceStartedOnInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReferenceStartedOnPayload = {
  readonly __typename?: 'UpdateReferenceStartedOnPayload';
  readonly client?: Maybe<ClientType>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum UpdateReportingCategory {
  Community = 'COMMUNITY',
  Events = 'EVENTS',
  Maintenance = 'MAINTENANCE',
  Offers = 'OFFERS',
  Other = 'OTHER',
  Urgent = 'URGENT'
}

export type UpdateReportingCategoryCountNode = {
  readonly __typename?: 'UpdateReportingCategoryCountNode';
  readonly category: UpdateReportingCategory;
  readonly count: Scalars['Int']['output'];
};

export type UpdateReportingConfigurationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly configuration?: InputMaybe<Scalars['JSONString']['input']>;
  readonly expectedRevision: Scalars['Int']['input'];
  readonly id: Scalars['UUID']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly schemaVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateReportingConfigurationPayload = {
  readonly __typename?: 'UpdateReportingConfigurationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly configuration: ReportingConfigurationNode;
  readonly conflict: Scalars['Boolean']['output'];
};

export type UpdateReportingContentMixNode = {
  readonly __typename?: 'UpdateReportingContentMixNode';
  readonly attachmentShare?: Maybe<Scalars['Float']['output']>;
  readonly imageShare?: Maybe<Scalars['Float']['output']>;
  readonly publishedCount: Scalars['Int']['output'];
  readonly withAttachmentCount: Scalars['Int']['output'];
  readonly withImageCount: Scalars['Int']['output'];
};

export type UpdateReportingCountNode = {
  readonly __typename?: 'UpdateReportingCountNode';
  readonly byDay: ReadonlyArray<UpdateReportingDayCountNode>;
  readonly byWeek: ReadonlyArray<UpdateReportingWeekCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type UpdateReportingDayCountNode = {
  readonly __typename?: 'UpdateReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type UpdateReportingEngagementNode = {
  readonly __typename?: 'UpdateReportingEngagementNode';
  readonly audienceSize: Scalars['Int']['output'];
  readonly byUpdate: ReadonlyArray<UpdateReportingUpdateEngagementNode>;
  readonly comments: Scalars['Int']['output'];
  readonly index?: Maybe<Scalars['Float']['output']>;
  readonly likes: Scalars['Int']['output'];
  readonly uniqueViews: Scalars['Int']['output'];
};

export type UpdateReportingNode = {
  readonly __typename?: 'UpdateReportingNode';
  readonly categories: ReadonlyArray<UpdateReportingCategoryCountNode>;
  readonly comments: UpdateReportingCountNode;
  readonly contentMix: UpdateReportingContentMixNode;
  readonly engagement: UpdateReportingEngagementNode;
  readonly likes: UpdateReportingCountNode;
  readonly published: UpdateReportingCountNode;
  readonly publishedByStaff: ReadonlyArray<UpdateReportingStaffCountNode>;
  readonly readRate: UpdateReportingReadRateNode;
  readonly scheduled: UpdateReportingScheduledNode;
  readonly topUpdates: ReadonlyArray<UpdateReportingTopUpdateNode>;
  readonly uniqueReaders: Scalars['Int']['output'];
};

export type UpdateReportingReadRateNode = {
  readonly __typename?: 'UpdateReportingReadRateNode';
  readonly audienceSize: Scalars['Int']['output'];
  readonly rate?: Maybe<Scalars['Float']['output']>;
  readonly readerCount: Scalars['Int']['output'];
  readonly updateCount: Scalars['Int']['output'];
};

export type UpdateReportingScheduledNode = {
  readonly __typename?: 'UpdateReportingScheduledNode';
  readonly publishedCount: Scalars['Int']['output'];
  readonly scheduledCount: Scalars['Int']['output'];
  readonly share?: Maybe<Scalars['Float']['output']>;
};

export type UpdateReportingStaffCountNode = {
  readonly __typename?: 'UpdateReportingStaffCountNode';
  readonly count: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly userId: Scalars['UUID']['output'];
};

export type UpdateReportingTopUpdateNode = {
  readonly __typename?: 'UpdateReportingTopUpdateNode';
  readonly readerCount: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
  readonly updateId: Scalars['UUID']['output'];
};

export type UpdateReportingUpdateEngagementNode = {
  readonly __typename?: 'UpdateReportingUpdateEngagementNode';
  readonly audienceSize: Scalars['Int']['output'];
  readonly comments: Scalars['Int']['output'];
  readonly engagementIndex?: Maybe<Scalars['Float']['output']>;
  readonly likes: Scalars['Int']['output'];
  readonly publishedAt: Scalars['DateTime']['output'];
  readonly title: Scalars['String']['output'];
  readonly uniqueViews: Scalars['Int']['output'];
  readonly updateId?: Maybe<Scalars['UUID']['output']>;
  readonly views: Scalars['Int']['output'];
};

export type UpdateReportingWeekCountNode = {
  readonly __typename?: 'UpdateReportingWeekCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly week: Scalars['Date']['output'];
};

export type UpdateResidencyAndResidents = {
  readonly __typename?: 'UpdateResidencyAndResidents';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateResidencyDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly residency?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResidencyDocumentPayload = {
  readonly __typename?: 'UpdateResidencyDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residencyDocument?: Maybe<ResidencyDocumentNode>;
};

export type UpdateResidentAppNotificationPreferencesInput = {
  readonly amenityEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly amenityPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityProductEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communityProductPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly conversationEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly conversationPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly environmentPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly eventEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly eventPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly groupChatEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly groupChatPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly keyEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly keyPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly marketplaceEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly marketplacePushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly newsfeedEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly newsfeedPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly packageEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly packagePushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateResidentAppNotificationPreferencesPayload = {
  readonly __typename?: 'UpdateResidentAppNotificationPreferencesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residentAppNotificationPreferences?: Maybe<ResidentAppNotificationPreferencesNode>;
};

export type UpdateResidentSafetyRecord = {
  readonly __typename?: 'UpdateResidentSafetyRecord';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type UpdateResidentSafetyRecordInput = {
  readonly braille?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communicationNeedDeclared?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communicationNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  readonly language?: InputMaybe<Scalars['String']['input']>;
  readonly largePrint?: InputMaybe<Scalars['Boolean']['input']>;
  readonly mobilityNeedDeclared?: InputMaybe<Scalars['Boolean']['input']>;
  readonly mobilityNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly textToSpeech?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRightToRentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document?: InputMaybe<Scalars['String']['input']>;
  readonly hasShareCode?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly shareCode?: InputMaybe<Scalars['String']['input']>;
  readonly tenantReference: Scalars['String']['input'];
};

export type UpdateRightToRentPayload = {
  readonly __typename?: 'UpdateRightToRentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly hasShareCode?: Maybe<Scalars['Boolean']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly shareCode?: Maybe<Scalars['String']['output']>;
  readonly tenantReference?: Maybe<Scalars['String']['output']>;
};

export type UpdateRuleCategoryContentTypes = {
  readonly __typename?: 'UpdateRuleCategoryContentTypes';
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly rule?: Maybe<RuleNode>;
};

export type UpdateRuleCategoryContentTypesInput = {
  readonly categoryContentTypes: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id: Scalars['UUID']['input'];
};

export type UpdateRuleCommunitiesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRuleCommunitiesPayload = {
  readonly __typename?: 'UpdateRuleCommunitiesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly rule?: Maybe<RuleNode>;
};

export type UpdateRuleConditionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly event: Event;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly objectId?: InputMaybe<Scalars['String']['input']>;
  readonly operator: Operator;
};

export type UpdateRuleConditionPayload = {
  readonly __typename?: 'UpdateRuleConditionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly ruleCondition?: Maybe<RuleConditionNode>;
};

export type UpdateRuleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

export type UpdateRulePayload = {
  readonly __typename?: 'UpdateRulePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly rule?: Maybe<RuleNode>;
};

export type UpdateSafetyCenterDocumentInput = {
  readonly block?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly includeInSibPack?: InputMaybe<Scalars['Boolean']['input']>;
  readonly showInSafetyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sibCategory?: InputMaybe<Sib_Category>;
  readonly sourceDocument?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

export type UpdateSafetyCenterDocumentPayload = {
  readonly __typename?: 'UpdateSafetyCenterDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
};

export type UpdateSafetyReviewInterval = {
  readonly __typename?: 'UpdateSafetyReviewInterval';
  readonly community?: Maybe<CommunityNode>;
};

export type UpdateScheduledMessage = {
  readonly __typename?: 'UpdateScheduledMessage';
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateScheduledMessageInput = {
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
  readonly sendAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateTaskDefinitionDescriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaskDefinitionDescriptionPayload = {
  readonly __typename?: 'UpdateTaskDefinitionDescriptionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type UpdateTaskDefinitionPriorityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly priority?: InputMaybe<Priority>;
};

export type UpdateTaskDefinitionPriorityPayload = {
  readonly __typename?: 'UpdateTaskDefinitionPriorityPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type UpdateTaskDefinitionVisibilityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly isVisibleToResidents?: InputMaybe<Scalars['Boolean']['input']>;
  readonly visibleToGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateTaskDefinitionVisibilityPayload = {
  readonly __typename?: 'UpdateTaskDefinitionVisibilityPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type UpdateTaskGroupInput = {
  readonly assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  readonly categoryId?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contractorCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  readonly contractorUserIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly generationHorizonDays?: InputMaybe<Scalars['Int']['input']>;
  readonly id: Scalars['UUID']['input'];
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly priority?: InputMaybe<Scalars['String']['input']>;
  readonly schedule?: InputMaybe<Scalars['JSONString']['input']>;
  readonly taskTemplateId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateTaskGroupPayload = {
  readonly __typename?: 'UpdateTaskGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly taskGroup?: Maybe<TaskGroupNode>;
};

export type UpdateTaskInput = {
  readonly category?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly scheduledFor?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateTaskPayload = {
  readonly __typename?: 'UpdateTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type UpdateTaskPriorityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly priority?: InputMaybe<Priority>;
};

export type UpdateTaskPriorityPayload = {
  readonly __typename?: 'UpdateTaskPriorityPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type UpdateTaskTemplateInput = {
  readonly autoCompleteTask?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
  readonly isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly pdfExportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly requiresSignOff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTaskTemplatePayload = {
  readonly __typename?: 'UpdateTaskTemplatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
};

export type UpdateTaskTemplateStructureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly expectedRevision: Scalars['Int']['input'];
  readonly sections: ReadonlyArray<TaskTemplateSectionInput>;
  readonly templateId: Scalars['UUID']['input'];
};

export type UpdateTaskTemplateStructurePayload = {
  readonly __typename?: 'UpdateTaskTemplateStructurePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
};

export type UpdateTeamCommunitiesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamCommunitiesPayload = {
  readonly __typename?: 'UpdateTeamCommunitiesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type UpdateTeamDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamDetailsPayload = {
  readonly __typename?: 'UpdateTeamDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type UpdateTeamIconInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly icon?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamIconPayload = {
  readonly __typename?: 'UpdateTeamIconPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type UpdateTeamMembersInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly users?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateTeamMembersPayload = {
  readonly __typename?: 'UpdateTeamMembersPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type UpdateTenantReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly creditCheckPermission?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantReferencePayload = {
  readonly __typename?: 'UpdateTenantReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly creditCheckPermission?: Maybe<Scalars['Boolean']['output']>;
  readonly dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type UpdateTenantReferenceStepInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly step?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantReferenceStepPayload = {
  readonly __typename?: 'UpdateTenantReferenceStepPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<Scalars['String']['output']>;
};

export type UpdateUserDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
  readonly users?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateUserDocumentPayload = {
  readonly __typename?: 'UpdateUserDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly userDocument?: Maybe<UserDocumentNode>;
};

export type UpdateUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
};

export type UpdateUserMobileNumberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly mobile: Scalars['String']['input'];
};

export type UpdateUserMobileNumberPayload = {
  readonly __typename?: 'UpdateUserMobileNumberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly error?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<UserType>;
};

export type UpdateUserPayload = {
  readonly __typename?: 'UpdateUserPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<UserType>;
};

export type UpdateUserProfileInput = {
  readonly biography?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly displayRole?: InputMaybe<Scalars['String']['input']>;
  readonly residentAppVisibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserProfilePayload = {
  readonly __typename?: 'UpdateUserProfilePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly userProfile?: Maybe<UserProfileNode>;
};

export type UpgradeLandlordToSubscriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly generatedAgreementUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpgradeLandlordToSubscriptionPayload = {
  readonly __typename?: 'UpgradeLandlordToSubscriptionPayload';
  readonly client?: Maybe<ClientType>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UserAppUseNode = {
  readonly __typename?: 'UserAppUseNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deviceBrand: Scalars['String']['output'];
  readonly deviceNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly deviceType: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly locale?: Maybe<Scalars['String']['output']>;
  readonly systemName: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};

export type UserAppUseNodeConnection = {
  readonly __typename?: 'UserAppUseNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserAppUseNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserAppUseNode` and its cursor. */
export type UserAppUseNodeEdge = {
  readonly __typename?: 'UserAppUseNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserAppUseNode>;
};

export type UserCommunityRestrictionNode = {
  readonly __typename?: 'UserCommunityRestrictionNode';
  readonly activatedDate: Scalars['DateTime']['output'];
  readonly appliedBy?: Maybe<UserType>;
  readonly community: CommunityNode;
  /** Leave blank for permanent restrictions */
  readonly endDate?: Maybe<Scalars['DateTime']['output']>;
  readonly featureType: PeopleUserCommunityRestrictionFeatureTypeChoices;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  /** Reason for applying the restriction */
  readonly reason: Scalars['String']['output'];
  readonly user: UserType;
};

export type UserCommunityRestrictionNodeConnection = {
  readonly __typename?: 'UserCommunityRestrictionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserCommunityRestrictionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserCommunityRestrictionNode` and its cursor. */
export type UserCommunityRestrictionNodeEdge = {
  readonly __typename?: 'UserCommunityRestrictionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserCommunityRestrictionNode>;
};

export type UserDocumentNode = {
  readonly __typename?: 'UserDocumentNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly availableClientTags?: Maybe<ClientTagNodeConnection>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<DocumentNode>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly tagAssignments?: Maybe<TagAssignmentNodeConnection>;
  readonly tags?: Maybe<TagNodeConnection>;
  readonly title: Scalars['String']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
  readonly users: ReadonlyArray<UserType>;
  readonly views: UserDocumentViewNodeConnection;
};


export type UserDocumentNodeAvailableClientTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type UserDocumentNodeTagAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserDocumentNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserDocumentNodeViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserDocumentViewNode = {
  readonly __typename?: 'UserDocumentViewNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly user: UserType;
};

export type UserDocumentViewNodeConnection = {
  readonly __typename?: 'UserDocumentViewNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserDocumentViewNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserDocumentViewNode` and its cursor. */
export type UserDocumentViewNodeEdge = {
  readonly __typename?: 'UserDocumentViewNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserDocumentViewNode>;
};

export type UserFeatureAnnouncementNode = {
  readonly __typename?: 'UserFeatureAnnouncementNode';
  readonly activatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly crossPlatform: Scalars['Boolean']['output'];
  readonly currentUserView?: Maybe<UserFeatureAnnouncementViewNode>;
  readonly featureAnnouncement: FeatureAnnouncementNode;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly platforms: ReadonlyArray<Scalars['String']['output']>;
};


export type UserFeatureAnnouncementNodeCurrentUserViewArgs = {
  platform: Scalars['String']['input'];
};

export type UserFeatureAnnouncementNodeConnection = {
  readonly __typename?: 'UserFeatureAnnouncementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserFeatureAnnouncementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserFeatureAnnouncementNode` and its cursor. */
export type UserFeatureAnnouncementNodeEdge = {
  readonly __typename?: 'UserFeatureAnnouncementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserFeatureAnnouncementNode>;
};

export type UserFeatureAnnouncementViewNode = {
  readonly __typename?: 'UserFeatureAnnouncementViewNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly platform: ResidentialManagementUserFeatureAnnouncementViewPlatformChoices;
  readonly userFeatureAnnouncement: UserFeatureAnnouncementNode;
  readonly viewedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly viewedBy: UserType;
};

export type UserNotificationPreferenceNode = {
  readonly __typename?: 'UserNotificationPreferenceNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly managerAmenityEmailEnabled: Scalars['Boolean']['output'];
  readonly managerAmenityPushEnabled: Scalars['Boolean']['output'];
  readonly managerApplicationEmailEnabled: Scalars['Boolean']['output'];
  readonly managerApplicationMessageEmailEnabled: Scalars['Boolean']['output'];
  readonly managerApplicationMessagePushEnabled: Scalars['Boolean']['output'];
  readonly managerApplicationPushEnabled: Scalars['Boolean']['output'];
  readonly managerCommunityEventEmailEnabled: Scalars['Boolean']['output'];
  readonly managerCommunityEventPushEnabled: Scalars['Boolean']['output'];
  readonly managerCommunityProductEmailEnabled: Scalars['Boolean']['output'];
  readonly managerCommunityProductPushEnabled: Scalars['Boolean']['output'];
  readonly managerCommunityUpdateEmailEnabled: Scalars['Boolean']['output'];
  readonly managerCommunityUpdatePushEnabled: Scalars['Boolean']['output'];
  readonly managerConversationAssignmentEmailEnabled: Scalars['Boolean']['output'];
  readonly managerConversationAssignmentPushEnabled: Scalars['Boolean']['output'];
  readonly managerConversationEmailEnabled: Scalars['Boolean']['output'];
  readonly managerConversationPushEnabled: Scalars['Boolean']['output'];
  readonly managerSurveysEmailEnabled: Scalars['Boolean']['output'];
  readonly managerSurveysPushEnabled: Scalars['Boolean']['output'];
  readonly managerTaskAssignmentPushEnabled: Scalars['Boolean']['output'];
  readonly managerTaskCommentPushEnabled: Scalars['Boolean']['output'];
  readonly managerTaskUpdatePushEnabled: Scalars['Boolean']['output'];
  readonly managerTeamAssignmentEmailEnabled: Scalars['Boolean']['output'];
  readonly managerTeamAssignmentPushEnabled: Scalars['Boolean']['output'];
};

export type UserNotificationPreferenceNodeConnection = {
  readonly __typename?: 'UserNotificationPreferenceNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserNotificationPreferenceNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `UserNotificationPreferenceNode` and its cursor. */
export type UserNotificationPreferenceNodeEdge = {
  readonly __typename?: 'UserNotificationPreferenceNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserNotificationPreferenceNode>;
};

export type UserPermissionType = {
  readonly __typename?: 'UserPermissionType';
  readonly actions: ReadonlyArray<Scalars['String']['output']>;
  readonly clientId: Scalars['UUID']['output'];
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly resource: Scalars['String']['output'];
};

export type UserProfileNode = {
  readonly __typename?: 'UserProfileNode';
  readonly biography?: Maybe<Scalars['String']['output']>;
  readonly displayPicture?: Maybe<Scalars['String']['output']>;
  readonly displayRole?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly residentAppVisibility: Scalars['Boolean']['output'];
};

export type UserSessionNode = {
  readonly __typename?: 'UserSessionNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly endTime?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly sessionTarget: PeopleUserSessionSessionTargetChoices;
  readonly startTime?: Maybe<Scalars['DateTime']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type UserSessionNodeConnection = {
  readonly __typename?: 'UserSessionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserSessionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserSessionNode` and its cursor. */
export type UserSessionNodeEdge = {
  readonly __typename?: 'UserSessionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserSessionNode>;
};

export type UserType = {
  readonly __typename?: 'UserType';
  readonly appUses?: Maybe<UserAppUseNodeConnection>;
  readonly applicant?: Maybe<ApplicantNode>;
  readonly appliedCommunityChatRestriction?: Maybe<UserCommunityRestrictionNode>;
  readonly appliedRestrictions?: Maybe<UserCommunityRestrictionNodeConnection>;
  readonly clientAdmin?: Maybe<ClientAdminNode>;
  readonly communityManager?: Maybe<CommunityManagerNode>;
  readonly concierge?: Maybe<ConciergeNode>;
  readonly dateJoined: Scalars['DateTime']['output'];
  readonly displayPicture?: Maybe<Scalars['String']['output']>;
  readonly email: Scalars['String']['output'];
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly hasUsedApp: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isDemo: Scalars['Boolean']['output'];
  readonly landlord?: Maybe<LandlordNode>;
  readonly lastAppUse?: Maybe<Scalars['DateTime']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly leaseholder?: Maybe<LeaseholderNode>;
  readonly manager?: Maybe<ManagerType>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly permissionSnapshot?: Maybe<PermissionSnapshotType>;
  readonly permissions: ReadonlyArray<Maybe<UserPermissionType>>;
  readonly profile?: Maybe<UserProfileNode>;
  readonly resident?: Maybe<ResidentType>;
  readonly restrictions?: Maybe<UserCommunityRestrictionNodeConnection>;
  readonly rmcDirector?: Maybe<RmcDirectorNode>;
  readonly teams?: Maybe<TeamNodeConnection>;
  readonly termsAndConditionsAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly unsubscribeNotificationGroups?: Maybe<UnsubscribeNotificationGroupNodeConnection>;
  readonly waivers: WaiverNodeConnection;
};


export type UserTypeAppUsesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeAppliedRestrictionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypePermissionSnapshotArgs = {
  clientId: Scalars['UUID']['input'];
};


export type UserTypeRestrictionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type UserTypeUnsubscribeNotificationGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type UserTypeWaiversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};

export type ViewFeatureAnnouncementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly featureAnnouncementId: Scalars['UUID']['input'];
};

export type ViewFeatureAnnouncementPayload = {
  readonly __typename?: 'ViewFeatureAnnouncementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly featureAnnouncementView?: Maybe<FeatureAnnouncementViewNode>;
};

export type ViewUserFeatureAnnouncementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly platform: Scalars['String']['input'];
  readonly userFeatureAnnouncementId: Scalars['UUID']['input'];
};

export type ViewUserFeatureAnnouncementPayload = {
  readonly __typename?: 'ViewUserFeatureAnnouncementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly userFeatureAnnouncementView?: Maybe<UserFeatureAnnouncementViewNode>;
};

export type VisitReportingAgeBucketNode = {
  readonly __typename?: 'VisitReportingAgeBucketNode';
  readonly count: Scalars['Int']['output'];
  readonly maxDays?: Maybe<Scalars['Int']['output']>;
  readonly minDays: Scalars['Int']['output'];
};

export type VisitReportingArrivalNode = {
  readonly __typename?: 'VisitReportingArrivalNode';
  readonly count: Scalars['Int']['output'];
  readonly hour: Scalars['Int']['output'];
  readonly weekday: Scalars['Int']['output'];
};

export type VisitReportingCompanyNode = {
  readonly __typename?: 'VisitReportingCompanyNode';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
};

export type VisitReportingCountNode = {
  readonly __typename?: 'VisitReportingCountNode';
  readonly byDay: ReadonlyArray<VisitReportingDayCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type VisitReportingDayCountNode = {
  readonly __typename?: 'VisitReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type VisitReportingDayDurationNode = {
  readonly __typename?: 'VisitReportingDayDurationNode';
  readonly day: Scalars['Date']['output'];
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type VisitReportingNode = {
  readonly __typename?: 'VisitReportingNode';
  readonly arrivals: ReadonlyArray<VisitReportingArrivalNode>;
  readonly companies: ReadonlyArray<VisitReportingCompanyNode>;
  readonly notSignedOut: VisitReportingNotSignedOutNode;
  readonly onSiteNow: Scalars['Int']['output'];
  readonly signIns: VisitReportingCountNode;
  readonly signOuts: VisitReportingCountNode;
  readonly timeOnSite: VisitReportingTimeOnSiteNode;
  readonly visitorTypes: ReadonlyArray<VisitReportingVisitorTypeNode>;
};

export type VisitReportingNotSignedOutNode = {
  readonly __typename?: 'VisitReportingNotSignedOutNode';
  readonly buckets: ReadonlyArray<VisitReportingAgeBucketNode>;
  readonly total: Scalars['Int']['output'];
};

export type VisitReportingTimeOnSiteNode = {
  readonly __typename?: 'VisitReportingTimeOnSiteNode';
  readonly byDay: ReadonlyArray<VisitReportingDayDurationNode>;
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

/** An enumeration. */
export enum VisitReportingVisitorType {
  Contractor = 'CONTRACTOR',
  Guest = 'GUEST'
}

export type VisitReportingVisitorTypeNode = {
  readonly __typename?: 'VisitReportingVisitorTypeNode';
  readonly count: Scalars['Int']['output'];
  readonly visitorType?: Maybe<VisitReportingVisitorType>;
};

export type VoidSafetyDeclaration = {
  readonly __typename?: 'VoidSafetyDeclaration';
  readonly residentSafetyDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type WaiverNode = {
  readonly __typename?: 'WaiverNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly type: ResidentialManagementWaiverTypeChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};

export type WaiverNodeConnection = {
  readonly __typename?: 'WaiverNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<WaiverNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `WaiverNode` and its cursor. */
export type WaiverNodeEdge = {
  readonly __typename?: 'WaiverNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<WaiverNode>;
};

export type WithdrawFireServiceConsent = {
  readonly __typename?: 'WithdrawFireServiceConsent';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

/** An enumeration. */
export enum Action {
  /** ASSIGN_TEAM */
  AssignTeam = 'ASSIGN_TEAM',
  /** ASSIGN_USER */
  AssignUser = 'ASSIGN_USER',
  /** NOTIFY_TEAM */
  NotifyTeam = 'NOTIFY_TEAM',
  /** NOTIFY_USER */
  NotifyUser = 'NOTIFY_USER'
}

/** An enumeration. */
export enum Company_Type {
  /** CARPENTRY */
  Carpentry = 'CARPENTRY',
  /** CLEANING */
  Cleaning = 'CLEANING',
  /** ELECTRICIAN */
  Electrician = 'ELECTRICIAN',
  /** FIRE_SAFETY */
  FireSafety = 'FIRE_SAFETY',
  /** GENERAL_MAINTENANCE */
  GeneralMaintenance = 'GENERAL_MAINTENANCE',
  /** HVAC */
  Hvac = 'HVAC',
  /** LANDSCAPING */
  Landscaping = 'LANDSCAPING',
  /** LOCKSMITH */
  Locksmith = 'LOCKSMITH',
  /** OTHER */
  Other = 'OTHER',
  /** PAINTING */
  Painting = 'PAINTING',
  /** PEST_CONTROL */
  PestControl = 'PEST_CONTROL',
  /** PLUMBER */
  Plumber = 'PLUMBER',
  /** ROOFING */
  Roofing = 'ROOFING',
  /** SECURITY */
  Security = 'SECURITY'
}

/** An enumeration. */
export enum Compliance_Type {
  /** Asbestos Survey */
  Asbestos = 'ASBESTOS',
  /** Electrical Installation Condition Report */
  Eicr = 'EICR',
  /** Emergency Lighting */
  EmergencyLighting = 'EMERGENCY_LIGHTING',
  /** External Wall System (FRAEW) */
  EwsFraew = 'EWS_FRAEW',
  /** Fire Alarm & Detection */
  FireAlarm = 'FIRE_ALARM',
  /** Fire Door Inspection */
  FireDoor = 'FIRE_DOOR',
  /** Fire Risk Assessment */
  Fra = 'FRA',
  /** Gas Safety */
  GasSafety = 'GAS_SAFETY',
  /** H&S Risk Assessment */
  HsRiskAssessment = 'HS_RISK_ASSESSMENT',
  /** Legionella / Water Hygiene */
  Legionella = 'LEGIONELLA',
  /** Lift LOLER Examination */
  LiftLoler = 'LIFT_LOLER',
  /** Lightning Protection */
  LightningProtection = 'LIGHTNING_PROTECTION',
  /** Other */
  Other = 'OTHER',
  /** Portable Appliance Testing */
  Pat = 'PAT',
  /** Smoke Control / AOV */
  SmokeControl = 'SMOKE_CONTROL',
  /** Sprinkler System */
  Sprinkler = 'SPRINKLER'
}

/** An enumeration. */
export enum Event {
  /** STATUS_CLOSED */
  StatusClosed = 'STATUS_CLOSED',
  /** STATUS_REOPENED */
  StatusReopened = 'STATUS_REOPENED',
  /** STATUS_SNOOZED */
  StatusSnoozed = 'STATUS_SNOOZED',
  /** TAG_ASSIGNMENT */
  TagAssignment = 'TAG_ASSIGNMENT'
}

/** An enumeration. */
export enum Operator {
  /** EQUALS */
  Equals = 'EQUALS',
  /** NOT_EQUALS */
  NotEquals = 'NOT_EQUALS'
}

/** An enumeration. */
export enum Participant_Type {
  /** CONTRACTOR */
  Contractor = 'CONTRACTOR',
  /** INTERNAL */
  Internal = 'INTERNAL',
  /** LEASEHOLDER */
  Leaseholder = 'LEASEHOLDER',
  /** RESIDENT */
  Resident = 'RESIDENT',
  /** UNKNOWN */
  Unknown = 'UNKNOWN'
}

/** An enumeration. */
export enum Priority {
  /** High */
  High = 'HIGH',
  /** Low */
  Low = 'LOW',
  /** Medium */
  Medium = 'MEDIUM',
  /** Urgent */
  Urgent = 'URGENT'
}

/** An enumeration. */
export enum Response_Choice {
  /** N/A */
  Na = 'NA',
  /** No */
  No = 'NO',
  /** Yes */
  Yes = 'YES'
}

/** An enumeration. */
export enum Sender {
  /** Concierge */
  Co = 'CO',
  /** Leaseholder */
  Le = 'LE',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum Session_Target {
  /** MANAGER_APP */
  ManagerApp = 'MANAGER_APP',
  /** MANAGER_DASHBOARD */
  ManagerDashboard = 'MANAGER_DASHBOARD',
  /** RESIDENT_APP */
  ResidentApp = 'RESIDENT_APP'
}

/** An enumeration. */
export enum Sib_Category {
  /** Access plan */
  AccessPlan = 'ACCESS_PLAN',
  /** Block plan */
  BlockPlan = 'BLOCK_PLAN',
  /** Contractor contacts */
  ContractorContacts = 'CONTRACTOR_CONTACTS',
  /** Fire strategy */
  FireStrategy = 'FIRE_STRATEGY',
  /** Floor plan */
  FloorPlan = 'FLOOR_PLAN',
  /** Hydrant map */
  HydrantMap = 'HYDRANT_MAP',
  /** Key holders */
  KeyHolders = 'KEY_HOLDERS',
  /** Other */
  Other = 'OTHER',
  /** Risk assessment */
  RiskAssessment = 'RISK_ASSESSMENT'
}

/** An enumeration. */
export enum Status {
  /** Archived */
  Archived = 'ARCHIVED',
  /** Blocked */
  Blocked = 'BLOCKED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Completed */
  Completed = 'COMPLETED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Pending */
  Pending = 'PENDING',
  /** Scheduled */
  Scheduled = 'SCHEDULED'
}

/** An enumeration. */
export enum Surface {
  /** App open */
  AppOpen = 'APP_OPEN',
  /** Banner */
  Banner = 'BANNER',
  /** Chat footer */
  ChatFooter = 'CHAT_FOOTER',
  /** Push */
  Push = 'PUSH'
}

export type UserCommunityItemFragment = { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly packageLocations?: ReadonlyArray<string | null> | null, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { readonly __typename?: 'DebugSchema', readonly getUser?: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly mobile?: string | null, readonly profile?: { readonly __typename?: 'UserProfileNode', readonly id: string, readonly displayPicture?: string | null, readonly biography?: string | null, readonly residentAppVisibility: boolean, readonly displayRole?: string | null } | null, readonly resident?: { readonly __typename?: 'ResidentType', readonly id: string } | null, readonly concierge?: { readonly __typename?: 'ConciergeNode', readonly id: string, readonly isActive?: boolean | null } | null, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly isActive?: boolean | null, readonly client?: { readonly __typename?: 'ClientType', readonly clientType: PeopleClientClientTypeChoices } | null } | null, readonly communityManager?: { readonly __typename?: 'CommunityManagerNode', readonly id: string, readonly isActive?: boolean | null, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null> } | null } | null, readonly clientAdmin?: { readonly __typename?: 'ClientAdminNode', readonly id: string } | null, readonly teams?: { readonly __typename?: 'TeamNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TeamNodeEdge', readonly node?: { readonly __typename?: 'TeamNode', readonly id: string } | null } | null> } | null } | null };

export type CommunitySelectQueryVariables = Exact<{
  manager?: InputMaybe<Scalars['UUID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunitySelectQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } | null };

export type ConversationListItemFragment = { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly snoozedUntil?: string | null, readonly latestUpdatedDate?: string | null, readonly closedAt?: string | null, readonly hasUnread: boolean, readonly currentUrgency?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string, readonly type?: string | null, readonly extra?: string | null } | { readonly __typename?: 'ConversationMediaType', readonly id: string, readonly createdAt: string, readonly mediaSender: ResidentialManagementConversationMediaSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string, readonly messageSender: ResidentialManagementConversationMessageSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string, readonly displayPicture?: string | null } } | null, readonly teamAssignment?: { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly team: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } } | null, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null };

export type AmenityOperatingTimesFragment = { readonly __typename?: 'AmenityOperatingTimesNode', readonly id: string, readonly weekDay: number, readonly startTime?: string | null, readonly endTime?: string | null, readonly isActivated: boolean };

export type ListConversationsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  residencyId?: InputMaybe<Scalars['UUID']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ListConversationsQuery = { readonly __typename?: 'DebugSchema', readonly conversations?: { readonly __typename?: 'ConversationNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationNodeEdge', readonly node?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly snoozedUntil?: string | null, readonly latestUpdatedDate?: string | null, readonly closedAt?: string | null, readonly hasUnread: boolean, readonly currentUrgency?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string, readonly type?: string | null, readonly extra?: string | null } | { readonly __typename?: 'ConversationMediaType', readonly id: string, readonly createdAt: string, readonly mediaSender: ResidentialManagementConversationMediaSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string, readonly messageSender: ResidentialManagementConversationMessageSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string, readonly displayPicture?: string | null } } | null, readonly teamAssignment?: { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly team: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } } | null, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | null } | null> } | null };

export type ListHomesForConversationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListHomesForConversationsQuery = { readonly __typename?: 'DebugSchema', readonly listHomes?: ReadonlyArray<{ readonly __typename?: 'HomeType', readonly id: string, readonly name: string }> | null };

export type CommunitySettingsFragment = { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } };

export type CommunitySettingsQueryVariables = Exact<{
  communityId: Scalars['UUID']['input'];
}>;


export type CommunitySettingsQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null };

export type ConciergeCommunitySettingsFragment = { readonly __typename?: 'ConciergeNode', readonly id: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null } | null> } | null };

export type LeaseholderCommunitySettingsFragment = { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeNode', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null } | null } | null } | null> } };

export type ManagerCommunitySettingsFragment = { readonly __typename?: 'ManagerType', readonly id: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null } | null> } | null };

export type ResidentNodeCommunitySettingsFragment = { readonly __typename?: 'ResidentNode', readonly id: string, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null } }> | null };

export type ResidentTypeCommunitySettingsFragment = { readonly __typename?: 'ResidentType', readonly id: string, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null } }> | null };

export type CommunitiesSettingsQueryVariables = Exact<{
  communityIds: ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type CommunitiesSettingsQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null } | null> } | null };

export type ContactCommunitySettingsQueryVariables = Exact<{
  contactId: Scalars['UUID']['input'];
}>;


export type ContactCommunitySettingsQuery = { readonly __typename?: 'DebugSchema', readonly contact?: { readonly __typename?: 'ContactNode', readonly id: string, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeNode', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null } | null } | null } | null> } } | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null } }> | null } | null } | null };

export type UserCommunitySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCommunitySettingsQuery = { readonly __typename?: 'DebugSchema', readonly getUser?: { readonly __typename?: 'UserType', readonly id: string, readonly concierge?: { readonly __typename?: 'ConciergeNode', readonly id: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null } | null> } | null } | null, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null } | null> } | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeNode', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null } | null } | null } | null> } } | null, readonly resident?: { readonly __typename?: 'ResidentType', readonly id: string, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly appointments: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean, readonly occupancySurvey: boolean, readonly serviceChargeWaiver: boolean, readonly termsAndConditions: boolean, readonly compliance: boolean, readonly packageLabels: boolean, readonly packages: boolean, readonly keys: boolean, readonly forms: boolean, readonly marketplaceBatchNotifications: boolean, readonly emailHeaderImageUrl?: string | null, readonly safetyCenter: boolean, readonly residentVisibleTasks: boolean, readonly mobileNumberRequired: boolean, readonly externalPortalUrls: ReadonlyArray<{ readonly __typename?: 'ExternalPortalUrlType', readonly id: string, readonly name: string, readonly url: string }> } } | null } }> | null } | null } | null };

export type CommunityFeatureItemFragment = { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly features: { readonly __typename?: 'CommunityFeatureNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityFeatureNodeEdge', readonly node?: { readonly __typename?: 'CommunityFeatureNode', readonly id: string, readonly name: string } | null } | null> } };

export type CommunityFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunityFeaturesQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly features: { readonly __typename?: 'CommunityFeatureNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityFeatureNodeEdge', readonly node?: { readonly __typename?: 'CommunityFeatureNode', readonly id: string, readonly name: string } | null } | null> } } | null } | null> } | null };

export type HomeCommunityFeaturesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type HomeCommunityFeaturesQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly features: { readonly __typename?: 'CommunityFeatureNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityFeatureNodeEdge', readonly node?: { readonly __typename?: 'CommunityFeatureNode', readonly id: string, readonly name: string } | null } | null> } } | null } | null };

export type GlobalFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalFeaturesQuery = { readonly __typename?: 'DebugSchema', readonly globalFeatures?: ReadonlyArray<{ readonly __typename?: 'GlobalFeatureType', readonly id: string, readonly name?: string | null } | null> | null };

export type PackageCollectorsFragment = { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null, readonly packages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly addressee?: string | null } | null } | null> } | null, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } }> } | null, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } } | null } | null> }, readonly leasehold?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly leaseholders: { readonly __typename?: 'LeaseholderNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholderNodeEdge', readonly node?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } } | null };

export type PackageCollectorsForHomeQueryVariables = Exact<{
  homeId: Scalars['UUID']['input'];
}>;


export type PackageCollectorsForHomeQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null, readonly packages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly addressee?: string | null } | null } | null> } | null, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } }> } | null, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } } | null } | null> }, readonly leasehold?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly leaseholders: { readonly __typename?: 'LeaseholderNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholderNodeEdge', readonly node?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } } | null } | null };

export type PackageCollectorsForPackageQueryVariables = Exact<{
  packageId: Scalars['UUID']['input'];
}>;


export type PackageCollectorsForPackageQuery = { readonly __typename?: 'DebugSchema', readonly package?: { readonly __typename?: 'PackageNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null, readonly packages: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly addressee?: string | null } | null } | null> }, readonly activeResidency?: { readonly __typename?: 'ResidencyType', readonly id: string, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } }> } | null, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } } | null } | null> }, readonly leasehold?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly leaseholders: { readonly __typename?: 'LeaseholderNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholderNodeEdge', readonly node?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } } | null } | null } | null };

export type UserFeatureAnnouncementsQueryVariables = Exact<{
  platform: Scalars['String']['input'];
}>;


export type UserFeatureAnnouncementsQuery = { readonly __typename?: 'DebugSchema', readonly userFeatureAnnouncements?: { readonly __typename?: 'UserFeatureAnnouncementNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'UserFeatureAnnouncementNodeEdge', readonly node?: { readonly __typename?: 'UserFeatureAnnouncementNode', readonly id: string, readonly platforms: ReadonlyArray<string>, readonly crossPlatform: boolean, readonly activatedAt?: string | null, readonly featureAnnouncement: { readonly __typename?: 'FeatureAnnouncementNode', readonly id: string, readonly title: string, readonly slug: string, readonly subtitle: string, readonly body: string, readonly image?: string | null }, readonly currentUserView?: { readonly __typename?: 'UserFeatureAnnouncementViewNode', readonly id: string, readonly viewedAt?: string | null } | null } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type ViewUserFeatureAnnouncementMutationVariables = Exact<{
  userFeatureAnnouncementId: Scalars['UUID']['input'];
  platform: Scalars['String']['input'];
}>;


export type ViewUserFeatureAnnouncementMutation = { readonly __typename?: 'Mutation', readonly viewUserFeatureAnnouncement?: { readonly __typename?: 'ViewUserFeatureAnnouncementPayload', readonly userFeatureAnnouncementView?: { readonly __typename?: 'UserFeatureAnnouncementViewNode', readonly id: string, readonly viewedAt?: string | null, readonly platform: ResidentialManagementUserFeatureAnnouncementViewPlatformChoices } | null } | null };

export const UserCommunityItemFragmentDoc = gql`
    fragment UserCommunityItem on CommunityNode {
  id
  name
  status
  settings {
    newsfeed
    messages
    surveys
    documents
    events
    facilities
    marketplace
    accounts
    products
  }
  packageLocations
}
    `;
export const ConversationListItemFragmentDoc = gql`
    fragment ConversationListItem on ConversationNode {
  id
  subject
  snoozedUntil
  latestUpdatedDate
  closedAt
  user {
    id
    name
  }
  home {
    id
    name
    community {
      id
      name
    }
  }
  community {
    id
    name
  }
  hasUnread
  currentUrgency
  latestEvent {
    ... on ConversationMessageType {
      id
      body
      createdAt
      messageSender: sender
      user {
        id
        name
      }
    }
    ... on ConversationMediaType {
      id
      createdAt
      mediaSender: sender
      user {
        id
        name
      }
    }
    ... on ConversationActionModelType {
      id
      createdAt
      type
      extra
    }
  }
  assignment {
    id
    assignedTo {
      id
      name
      firstName
      lastName
      email
      displayPicture
    }
  }
  teamAssignment {
    id
    team {
      id
      name
      icon
    }
  }
  tags {
    totalCount
    edges {
      node {
        id
        name
        color
      }
    }
  }
  tagAssignments {
    totalCount
    edges {
      node {
        id
        tag {
          id
          name
          color
        }
      }
    }
  }
}
    `;
export const AmenityOperatingTimesFragmentDoc = gql`
    fragment AmenityOperatingTimes on AmenityOperatingTimesNode {
  id
  weekDay
  startTime
  endTime
  isActivated
}
    `;
export const CommunitySettingsFragmentDoc = gql`
    fragment CommunitySettings on CommunityNode {
  id
  settings {
    newsfeed
    messages
    surveys
    documents
    events
    facilities
    appointments
    marketplace
    accounts
    products
    occupancySurvey
    serviceChargeWaiver
    termsAndConditions
    compliance
    packageLabels
    packages
    keys
    forms
    marketplaceBatchNotifications
    emailHeaderImageUrl
    safetyCenter
    residentVisibleTasks
    mobileNumberRequired
    externalPortalUrls {
      id
      name
      url
    }
  }
}
    `;
export const ConciergeCommunitySettingsFragmentDoc = gql`
    fragment ConciergeCommunitySettings on ConciergeNode {
  id
  communities {
    edges {
      node {
        ...CommunitySettings
      }
    }
  }
}
    ${CommunitySettingsFragmentDoc}`;
export const LeaseholderCommunitySettingsFragmentDoc = gql`
    fragment LeaseholderCommunitySettings on LeaseholderNode {
  id
  leaseholds {
    edges {
      node {
        id
        home {
          community {
            ...CommunitySettings
          }
        }
      }
    }
  }
}
    ${CommunitySettingsFragmentDoc}`;
export const ManagerCommunitySettingsFragmentDoc = gql`
    fragment ManagerCommunitySettings on ManagerType {
  id
  communities {
    edges {
      node {
        ...CommunitySettings
      }
    }
  }
}
    ${CommunitySettingsFragmentDoc}`;
export const ResidentNodeCommunitySettingsFragmentDoc = gql`
    fragment ResidentNodeCommunitySettings on ResidentNode {
  id
  currentResidencies {
    id
    home {
      community {
        ...CommunitySettings
      }
    }
  }
}
    ${CommunitySettingsFragmentDoc}`;
export const ResidentTypeCommunitySettingsFragmentDoc = gql`
    fragment ResidentTypeCommunitySettings on ResidentType {
  id
  currentResidencies {
    id
    home {
      community {
        ...CommunitySettings
      }
    }
  }
}
    ${CommunitySettingsFragmentDoc}`;
export const CommunityFeatureItemFragmentDoc = gql`
    fragment CommunityFeatureItem on CommunityNode {
  id
  name
  features {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;
export const PackageCollectorsFragmentDoc = gql`
    fragment PackageCollectors on HomeNode {
  id
  address
  community {
    id
  }
  packages(status: "DE") {
    totalCount
    edges {
      node {
        id
        addressee
      }
    }
  }
  activeResidency {
    id
    residents {
      id
      user {
        id
        name
      }
    }
  }
  applications(status: ["PE", "DS"]) {
    edges {
      node {
        applicant {
          id
          user {
            id
            name
          }
        }
      }
    }
  }
  leasehold {
    id
    leaseholders: leaseholder {
      edges {
        node {
          id
          user {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const GetUserDocument = gql`
    query GetUser {
  getUser {
    id
    email
    firstName
    lastName
    mobile
    profile {
      id
      displayPicture
      biography
      residentAppVisibility
      displayRole
    }
    resident {
      id
    }
    concierge {
      id
      isActive
    }
    manager {
      id
      client {
        clientType
      }
      isActive
    }
    communityManager {
      id
      isActive
      communities(includeDeactivated: true) {
        edges {
          node {
            id
          }
        }
      }
    }
    clientAdmin {
      id
    }
    teams {
      edges {
        node {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const CommunitySelectDocument = gql`
    query CommunitySelect($manager: UUID, $after: String, $search: String) {
  communities(
    manager: $manager
    after: $after
    search: $search
    orderBy: "name"
    includeDeactivated: true
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCommunitySelectQuery__
 *
 * To run a query within a React component, call `useCommunitySelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitySelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitySelectQuery({
 *   variables: {
 *      manager: // value for 'manager'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCommunitySelectQuery(baseOptions?: Apollo.QueryHookOptions<CommunitySelectQuery, CommunitySelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitySelectQuery, CommunitySelectQueryVariables>(CommunitySelectDocument, options);
      }
export function useCommunitySelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitySelectQuery, CommunitySelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitySelectQuery, CommunitySelectQueryVariables>(CommunitySelectDocument, options);
        }
export type CommunitySelectQueryHookResult = ReturnType<typeof useCommunitySelectQuery>;
export type CommunitySelectLazyQueryHookResult = ReturnType<typeof useCommunitySelectLazyQuery>;
export type CommunitySelectQueryResult = Apollo.QueryResult<CommunitySelectQuery, CommunitySelectQueryVariables>;
export const ListConversationsDocument = gql`
    query listConversations($communities: [ID], $home: UUID, $status: [String], $first: Int, $after: String, $search: String, $orderBy: String, $isUrgent: String, $date: Date, $dateFrom: Date, $dateTo: Date, $contactId: UUID, $clientId: UUID, $residencyId: UUID, $assignedTo: String, $unanswered: [String], $assignedUsers: [String]) {
  conversations(
    communities: $communities
    home: $home
    status: $status
    first: $first
    after: $after
    search: $search
    orderBy: $orderBy
    isUrgent: $isUrgent
    date: $date
    dateFrom: $dateFrom
    dateTo: $dateTo
    contact: $contactId
    client: $clientId
    residency: $residencyId
    assignedTo: $assignedTo
    unanswered: $unanswered
    assignedUsers: $assignedUsers
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...ConversationListItem
      }
    }
  }
}
    ${ConversationListItemFragmentDoc}`;

/**
 * __useListConversationsQuery__
 *
 * To run a query within a React component, call `useListConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConversationsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      home: // value for 'home'
 *      status: // value for 'status'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      isUrgent: // value for 'isUrgent'
 *      date: // value for 'date'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      contactId: // value for 'contactId'
 *      clientId: // value for 'clientId'
 *      residencyId: // value for 'residencyId'
 *      assignedTo: // value for 'assignedTo'
 *      unanswered: // value for 'unanswered'
 *      assignedUsers: // value for 'assignedUsers'
 *   },
 * });
 */
export function useListConversationsQuery(baseOptions?: Apollo.QueryHookOptions<ListConversationsQuery, ListConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConversationsQuery, ListConversationsQueryVariables>(ListConversationsDocument, options);
      }
export function useListConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConversationsQuery, ListConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConversationsQuery, ListConversationsQueryVariables>(ListConversationsDocument, options);
        }
export type ListConversationsQueryHookResult = ReturnType<typeof useListConversationsQuery>;
export type ListConversationsLazyQueryHookResult = ReturnType<typeof useListConversationsLazyQuery>;
export type ListConversationsQueryResult = Apollo.QueryResult<ListConversationsQuery, ListConversationsQueryVariables>;
export const ListHomesForConversationsDocument = gql`
    query ListHomesForConversations {
  listHomes {
    id
    name
  }
}
    `;

/**
 * __useListHomesForConversationsQuery__
 *
 * To run a query within a React component, call `useListHomesForConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHomesForConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomesForConversationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListHomesForConversationsQuery(baseOptions?: Apollo.QueryHookOptions<ListHomesForConversationsQuery, ListHomesForConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHomesForConversationsQuery, ListHomesForConversationsQueryVariables>(ListHomesForConversationsDocument, options);
      }
export function useListHomesForConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHomesForConversationsQuery, ListHomesForConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHomesForConversationsQuery, ListHomesForConversationsQueryVariables>(ListHomesForConversationsDocument, options);
        }
export type ListHomesForConversationsQueryHookResult = ReturnType<typeof useListHomesForConversationsQuery>;
export type ListHomesForConversationsLazyQueryHookResult = ReturnType<typeof useListHomesForConversationsLazyQuery>;
export type ListHomesForConversationsQueryResult = Apollo.QueryResult<ListHomesForConversationsQuery, ListHomesForConversationsQueryVariables>;
export const CommunitySettingsDocument = gql`
    query CommunitySettings($communityId: UUID!) {
  community(id: $communityId) {
    ...CommunitySettings
  }
}
    ${CommunitySettingsFragmentDoc}`;

/**
 * __useCommunitySettingsQuery__
 *
 * To run a query within a React component, call `useCommunitySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitySettingsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useCommunitySettingsQuery(baseOptions: Apollo.QueryHookOptions<CommunitySettingsQuery, CommunitySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitySettingsQuery, CommunitySettingsQueryVariables>(CommunitySettingsDocument, options);
      }
export function useCommunitySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitySettingsQuery, CommunitySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitySettingsQuery, CommunitySettingsQueryVariables>(CommunitySettingsDocument, options);
        }
export type CommunitySettingsQueryHookResult = ReturnType<typeof useCommunitySettingsQuery>;
export type CommunitySettingsLazyQueryHookResult = ReturnType<typeof useCommunitySettingsLazyQuery>;
export type CommunitySettingsQueryResult = Apollo.QueryResult<CommunitySettingsQuery, CommunitySettingsQueryVariables>;
export const CommunitiesSettingsDocument = gql`
    query CommunitiesSettings($communityIds: [ID]!) {
  communities(ids: $communityIds) {
    edges {
      node {
        ...CommunitySettings
      }
    }
  }
}
    ${CommunitySettingsFragmentDoc}`;

/**
 * __useCommunitiesSettingsQuery__
 *
 * To run a query within a React component, call `useCommunitiesSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesSettingsQuery({
 *   variables: {
 *      communityIds: // value for 'communityIds'
 *   },
 * });
 */
export function useCommunitiesSettingsQuery(baseOptions: Apollo.QueryHookOptions<CommunitiesSettingsQuery, CommunitiesSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitiesSettingsQuery, CommunitiesSettingsQueryVariables>(CommunitiesSettingsDocument, options);
      }
export function useCommunitiesSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitiesSettingsQuery, CommunitiesSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitiesSettingsQuery, CommunitiesSettingsQueryVariables>(CommunitiesSettingsDocument, options);
        }
export type CommunitiesSettingsQueryHookResult = ReturnType<typeof useCommunitiesSettingsQuery>;
export type CommunitiesSettingsLazyQueryHookResult = ReturnType<typeof useCommunitiesSettingsLazyQuery>;
export type CommunitiesSettingsQueryResult = Apollo.QueryResult<CommunitiesSettingsQuery, CommunitiesSettingsQueryVariables>;
export const ContactCommunitySettingsDocument = gql`
    query ContactCommunitySettings($contactId: UUID!) {
  contact(id: $contactId) {
    id
    leaseholder {
      id
      leaseholds {
        edges {
          node {
            id
            home {
              community {
                ...CommunitySettings
              }
            }
          }
        }
      }
    }
    resident {
      ...ResidentNodeCommunitySettings
    }
  }
}
    ${CommunitySettingsFragmentDoc}
${ResidentNodeCommunitySettingsFragmentDoc}`;

/**
 * __useContactCommunitySettingsQuery__
 *
 * To run a query within a React component, call `useContactCommunitySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCommunitySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCommunitySettingsQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useContactCommunitySettingsQuery(baseOptions: Apollo.QueryHookOptions<ContactCommunitySettingsQuery, ContactCommunitySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactCommunitySettingsQuery, ContactCommunitySettingsQueryVariables>(ContactCommunitySettingsDocument, options);
      }
export function useContactCommunitySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactCommunitySettingsQuery, ContactCommunitySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactCommunitySettingsQuery, ContactCommunitySettingsQueryVariables>(ContactCommunitySettingsDocument, options);
        }
export type ContactCommunitySettingsQueryHookResult = ReturnType<typeof useContactCommunitySettingsQuery>;
export type ContactCommunitySettingsLazyQueryHookResult = ReturnType<typeof useContactCommunitySettingsLazyQuery>;
export type ContactCommunitySettingsQueryResult = Apollo.QueryResult<ContactCommunitySettingsQuery, ContactCommunitySettingsQueryVariables>;
export const UserCommunitySettingsDocument = gql`
    query UserCommunitySettings {
  getUser {
    id
    concierge {
      ...ConciergeCommunitySettings
    }
    manager {
      ...ManagerCommunitySettings
    }
    leaseholder {
      id
      leaseholds {
        edges {
          node {
            id
            home {
              community {
                ...CommunitySettings
              }
            }
          }
        }
      }
    }
    resident {
      ...ResidentTypeCommunitySettings
    }
  }
}
    ${ConciergeCommunitySettingsFragmentDoc}
${ManagerCommunitySettingsFragmentDoc}
${CommunitySettingsFragmentDoc}
${ResidentTypeCommunitySettingsFragmentDoc}`;

/**
 * __useUserCommunitySettingsQuery__
 *
 * To run a query within a React component, call `useUserCommunitySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCommunitySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCommunitySettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCommunitySettingsQuery(baseOptions?: Apollo.QueryHookOptions<UserCommunitySettingsQuery, UserCommunitySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCommunitySettingsQuery, UserCommunitySettingsQueryVariables>(UserCommunitySettingsDocument, options);
      }
export function useUserCommunitySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCommunitySettingsQuery, UserCommunitySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCommunitySettingsQuery, UserCommunitySettingsQueryVariables>(UserCommunitySettingsDocument, options);
        }
export type UserCommunitySettingsQueryHookResult = ReturnType<typeof useUserCommunitySettingsQuery>;
export type UserCommunitySettingsLazyQueryHookResult = ReturnType<typeof useUserCommunitySettingsLazyQuery>;
export type UserCommunitySettingsQueryResult = Apollo.QueryResult<UserCommunitySettingsQuery, UserCommunitySettingsQueryVariables>;
export const CommunityFeaturesDocument = gql`
    query CommunityFeatures {
  communities {
    edges {
      node {
        ...CommunityFeatureItem
      }
    }
  }
}
    ${CommunityFeatureItemFragmentDoc}`;

/**
 * __useCommunityFeaturesQuery__
 *
 * To run a query within a React component, call `useCommunityFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunityFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<CommunityFeaturesQuery, CommunityFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityFeaturesQuery, CommunityFeaturesQueryVariables>(CommunityFeaturesDocument, options);
      }
export function useCommunityFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityFeaturesQuery, CommunityFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityFeaturesQuery, CommunityFeaturesQueryVariables>(CommunityFeaturesDocument, options);
        }
export type CommunityFeaturesQueryHookResult = ReturnType<typeof useCommunityFeaturesQuery>;
export type CommunityFeaturesLazyQueryHookResult = ReturnType<typeof useCommunityFeaturesLazyQuery>;
export type CommunityFeaturesQueryResult = Apollo.QueryResult<CommunityFeaturesQuery, CommunityFeaturesQueryVariables>;
export const HomeCommunityFeaturesDocument = gql`
    query HomeCommunityFeatures($id: UUID!) {
  home(id: $id) {
    id
    community {
      ...CommunityFeatureItem
    }
  }
}
    ${CommunityFeatureItemFragmentDoc}`;

/**
 * __useHomeCommunityFeaturesQuery__
 *
 * To run a query within a React component, call `useHomeCommunityFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeCommunityFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeCommunityFeaturesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomeCommunityFeaturesQuery(baseOptions: Apollo.QueryHookOptions<HomeCommunityFeaturesQuery, HomeCommunityFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeCommunityFeaturesQuery, HomeCommunityFeaturesQueryVariables>(HomeCommunityFeaturesDocument, options);
      }
export function useHomeCommunityFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeCommunityFeaturesQuery, HomeCommunityFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeCommunityFeaturesQuery, HomeCommunityFeaturesQueryVariables>(HomeCommunityFeaturesDocument, options);
        }
export type HomeCommunityFeaturesQueryHookResult = ReturnType<typeof useHomeCommunityFeaturesQuery>;
export type HomeCommunityFeaturesLazyQueryHookResult = ReturnType<typeof useHomeCommunityFeaturesLazyQuery>;
export type HomeCommunityFeaturesQueryResult = Apollo.QueryResult<HomeCommunityFeaturesQuery, HomeCommunityFeaturesQueryVariables>;
export const GlobalFeaturesDocument = gql`
    query GlobalFeatures {
  globalFeatures {
    id
    name
  }
}
    `;

/**
 * __useGlobalFeaturesQuery__
 *
 * To run a query within a React component, call `useGlobalFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GlobalFeaturesQuery, GlobalFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalFeaturesQuery, GlobalFeaturesQueryVariables>(GlobalFeaturesDocument, options);
      }
export function useGlobalFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalFeaturesQuery, GlobalFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalFeaturesQuery, GlobalFeaturesQueryVariables>(GlobalFeaturesDocument, options);
        }
export type GlobalFeaturesQueryHookResult = ReturnType<typeof useGlobalFeaturesQuery>;
export type GlobalFeaturesLazyQueryHookResult = ReturnType<typeof useGlobalFeaturesLazyQuery>;
export type GlobalFeaturesQueryResult = Apollo.QueryResult<GlobalFeaturesQuery, GlobalFeaturesQueryVariables>;
export const PackageCollectorsForHomeDocument = gql`
    query PackageCollectorsForHome($homeId: UUID!) {
  home(id: $homeId) {
    ...PackageCollectors
  }
}
    ${PackageCollectorsFragmentDoc}`;

/**
 * __usePackageCollectorsForHomeQuery__
 *
 * To run a query within a React component, call `usePackageCollectorsForHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageCollectorsForHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageCollectorsForHomeQuery({
 *   variables: {
 *      homeId: // value for 'homeId'
 *   },
 * });
 */
export function usePackageCollectorsForHomeQuery(baseOptions: Apollo.QueryHookOptions<PackageCollectorsForHomeQuery, PackageCollectorsForHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageCollectorsForHomeQuery, PackageCollectorsForHomeQueryVariables>(PackageCollectorsForHomeDocument, options);
      }
export function usePackageCollectorsForHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageCollectorsForHomeQuery, PackageCollectorsForHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageCollectorsForHomeQuery, PackageCollectorsForHomeQueryVariables>(PackageCollectorsForHomeDocument, options);
        }
export type PackageCollectorsForHomeQueryHookResult = ReturnType<typeof usePackageCollectorsForHomeQuery>;
export type PackageCollectorsForHomeLazyQueryHookResult = ReturnType<typeof usePackageCollectorsForHomeLazyQuery>;
export type PackageCollectorsForHomeQueryResult = Apollo.QueryResult<PackageCollectorsForHomeQuery, PackageCollectorsForHomeQueryVariables>;
export const PackageCollectorsForPackageDocument = gql`
    query PackageCollectorsForPackage($packageId: UUID!) {
  package(id: $packageId) {
    id
    home {
      id
      address
      community {
        id
      }
      packages(status: "DE") {
        totalCount
        edges {
          node {
            id
            addressee
          }
        }
      }
      activeResidency: currentResidency {
        id
        residents {
          id
          user {
            id
            name
          }
        }
      }
      applications(status: ["PE", "DS"]) {
        edges {
          node {
            applicant {
              id
              user {
                id
                name
              }
            }
          }
        }
      }
      leasehold {
        id
        leaseholders: leaseholder {
          edges {
            node {
              id
              user {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePackageCollectorsForPackageQuery__
 *
 * To run a query within a React component, call `usePackageCollectorsForPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageCollectorsForPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageCollectorsForPackageQuery({
 *   variables: {
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function usePackageCollectorsForPackageQuery(baseOptions: Apollo.QueryHookOptions<PackageCollectorsForPackageQuery, PackageCollectorsForPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageCollectorsForPackageQuery, PackageCollectorsForPackageQueryVariables>(PackageCollectorsForPackageDocument, options);
      }
export function usePackageCollectorsForPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageCollectorsForPackageQuery, PackageCollectorsForPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageCollectorsForPackageQuery, PackageCollectorsForPackageQueryVariables>(PackageCollectorsForPackageDocument, options);
        }
export type PackageCollectorsForPackageQueryHookResult = ReturnType<typeof usePackageCollectorsForPackageQuery>;
export type PackageCollectorsForPackageLazyQueryHookResult = ReturnType<typeof usePackageCollectorsForPackageLazyQuery>;
export type PackageCollectorsForPackageQueryResult = Apollo.QueryResult<PackageCollectorsForPackageQuery, PackageCollectorsForPackageQueryVariables>;
export const UserFeatureAnnouncementsDocument = gql`
    query UserFeatureAnnouncements($platform: String!) {
  userFeatureAnnouncements(platform: $platform) {
    edges {
      node {
        id
        platforms
        crossPlatform
        activatedAt
        featureAnnouncement {
          id
          title
          slug
          subtitle
          body
          image
        }
        currentUserView(platform: $platform) {
          id
          viewedAt
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useUserFeatureAnnouncementsQuery__
 *
 * To run a query within a React component, call `useUserFeatureAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFeatureAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFeatureAnnouncementsQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useUserFeatureAnnouncementsQuery(baseOptions: Apollo.QueryHookOptions<UserFeatureAnnouncementsQuery, UserFeatureAnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFeatureAnnouncementsQuery, UserFeatureAnnouncementsQueryVariables>(UserFeatureAnnouncementsDocument, options);
      }
export function useUserFeatureAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFeatureAnnouncementsQuery, UserFeatureAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFeatureAnnouncementsQuery, UserFeatureAnnouncementsQueryVariables>(UserFeatureAnnouncementsDocument, options);
        }
export type UserFeatureAnnouncementsQueryHookResult = ReturnType<typeof useUserFeatureAnnouncementsQuery>;
export type UserFeatureAnnouncementsLazyQueryHookResult = ReturnType<typeof useUserFeatureAnnouncementsLazyQuery>;
export type UserFeatureAnnouncementsQueryResult = Apollo.QueryResult<UserFeatureAnnouncementsQuery, UserFeatureAnnouncementsQueryVariables>;
export const ViewUserFeatureAnnouncementDocument = gql`
    mutation ViewUserFeatureAnnouncement($userFeatureAnnouncementId: UUID!, $platform: String!) {
  viewUserFeatureAnnouncement(
    input: {userFeatureAnnouncementId: $userFeatureAnnouncementId, platform: $platform}
  ) {
    userFeatureAnnouncementView {
      id
      viewedAt
      platform
    }
  }
}
    `;
export type ViewUserFeatureAnnouncementMutationFn = Apollo.MutationFunction<ViewUserFeatureAnnouncementMutation, ViewUserFeatureAnnouncementMutationVariables>;

/**
 * __useViewUserFeatureAnnouncementMutation__
 *
 * To run a mutation, you first call `useViewUserFeatureAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewUserFeatureAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewUserFeatureAnnouncementMutation, { data, loading, error }] = useViewUserFeatureAnnouncementMutation({
 *   variables: {
 *      userFeatureAnnouncementId: // value for 'userFeatureAnnouncementId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useViewUserFeatureAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<ViewUserFeatureAnnouncementMutation, ViewUserFeatureAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ViewUserFeatureAnnouncementMutation, ViewUserFeatureAnnouncementMutationVariables>(ViewUserFeatureAnnouncementDocument, options);
      }
export type ViewUserFeatureAnnouncementMutationHookResult = ReturnType<typeof useViewUserFeatureAnnouncementMutation>;
export type ViewUserFeatureAnnouncementMutationResult = Apollo.MutationResult<ViewUserFeatureAnnouncementMutation>;
export type ViewUserFeatureAnnouncementMutationOptions = Apollo.BaseMutationOptions<ViewUserFeatureAnnouncementMutation, ViewUserFeatureAnnouncementMutationVariables>;